import { ContainerLoadingStatus, ContainerStatusEnum, ErrorResponse, SoStatusEnum, StatusEnum, BlStatusEnum, PackingCategoryEnum, GlobalStatus, PmStatusEnum, SoProcessTypesEnum, UomEnum, ItemCategoriesEnum, GlobalResponseObject, RmEtd, FgStatusEnum, EmployeeRolesEnum, UnitRequest, InvoiceStatusEnum, SaleOrderStatusEnum, JobTypesEnum, MessageRequest, SoCountDetail, UserDateRequest, SoCountDetailResponse, SoQntDetail, SoQntDetailResponse, SoLongRunDetails, SoLongRunResponse, SoComparisonDetailsResponse, SoComparisonDetails, SoDeadStockDetailsResponse, SoDeadStockDetails, SoYearWisePlanningDetailsResponse, SoYearWisePlanningDetails, SoYearWiseShippedDetailsResponse, SoYearWiseShippedDetails, SoProductionStatusDetailsResponse, SoProductionStatusDetails, SoProductCompleteNotShippedResponse, SoProductCompleteNotShipped, PackingBOMStatusEnum, SoTopFiveResponse, SoTopFiveDetails, SoLifeCycleStatusEnum, InspectionStatusEnum, JobTypeEnum, stockTypeEnum, MessageParameters, ConversionType, GlobalVariableValues } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Double, getConnection, In, Not, LessThan, MoreThan, Raw, Repository, Any, getManager, TransactionManager, LessThanOrEqual, IsNull, createConnection } from 'typeorm';
import { AllSaleOrdersTrackResponseModel, SaleOrderDetailDto, SaleOrderDetailViewInfoDTO, SaleOrderDetailViewInfoResponseModel, SaleOrderDetailViewResponseModel, SaleOrderItemsDto, SaleOrderItemsDTO, SaleOrderTrackDto, AllSoItemsResponseModel, AllSaleOrdersResponseModel, SODto, SOItemsDto, SaleOrderFileUploadResponse, SaleOrderDropDownResponseModel, SaleOrderDropDownDto, SaleOrderFewDetailsDto, SoItemsDataModel, SaleOrderInfoResponseModel, SaleOrderInfo, SoNumbersResponseModel, SoNumbersModel, AllSaleOrdersDetailsResponseModel, CategoriesInput, SaleOrderItemsDropDownResponseModel, SaleOrderItemsDropDownDto, AllSaleOrdersItemsDetailsResponseModel, PackTypeCategory, PlantInvoiceDetailsResponse, PlantInvoiceDetailsModel, SaleOrderItemsDetails, BomUpdateRequest, ActiveSaleOrderWithItemDetailsResponseModel, GetAllInvoiceDetailsResponse, GetSaleOrderInformationResponseModel, FactoriesInput, SoRequest, SoTrackResponseModel, SoTrackModel, SoInspectionResponseModel, SoInspectionUpdateResponse, RmBomResponse, RmBomDto, SoAllInspectionsResponseModel, SoAllInspectionsDto, ItemsDetails, SaleOrderItemsForSoDropDownResponseModel, SaleOrderItemsBySoIdReaponseModel, SORmBomResponse, RmBomDetails, CommonResponse, SaleOrderItemInfo, SoItemVariantResponse, PoNumberDropDownResponse, HlPercentageInfo, BomWithCountAndQuantityResponse, BomWithCountAndQuantityModel, SoDropCntQtyResponse, SoDropCntQtyModel, SaleOrderItemsDropdownResponse, DummyPackBomItemsRequest, SoItemDataResponse, SaleOrderIdsRequest, PortOfEntryInput, BomTrackerForSoIdResponseModel, BomTrackerPackingItemsDto, UnitsOfWeightInput, SoReportResponseModel, SaleOrderReportDto, saleOrderItemIdRequest, SaleOrderItemsDetailsResponseModel, TransferredSosFilterDto, SubJobReviseRequest, SoTypeReq } from '@gtpl/shared-models/sale-management';
import { SaleOrderResponse } from './dto/sale-order-response';
import { SaleOrderAdapter } from './dto/sale-order.adapter';
import { SaleOrderDto } from './dto/sale-order.dto';
import { SaleOrderItemsInfo } from './dto/sale-order-items-info.model';
import { SaleOrder } from './sale-order.entitiy';
import { SaleOrderTrackAdapter } from './dto/sale-order-track.adapter';
import { SaleOrderTrackDTO, SaleOrderTrackFilters, } from './dto/sale-order-track.dto';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { SaleOrderItems } from './sale-order-items.entity';
import { SoItemsAdapter } from './dto/so-items-adapter';
import { SalePoDetails } from './so_po_details.entity';
import { SoInvoiceDetails } from './sale-invoice-details.entity';
// import { SaleOrderDetailsDTO } from './dto/sale-order-details.dto';
import { SoViewResponseModel } from '@gtpl/shared-models/sale-management';
import { SaleOrderDetailsDTO } from './dto/sale-order-details.dto';
import { CertificationsService, CurrencyService, CustomersService, DeliveryTermsService, DestinationService, EndCustomersService, GradeServices, ProductService, FoodTypeService, SkuService, UomsService, CountryService, ShippingTermsService, PaymentTermsService, SizesService, Type1Service, TypesOfValueAddition2Service, Type3Service, TypeofValueAddition4Service, TypeofValueAddition5Service, HrmsEmpDetService, HLpercentagesService, SuppliersService, UnitcodeService, HsnService, TaxesService, PackingMethodService, MasterBrandService, NotifyPartyService } from '@gtpl/shared-services/masters'
import { ProductionInventoryService } from '@gtpl/shared-services/production'
import { PurchaseOrderService, StockService } from '@gtpl/shared-services/procurement'
import { SaleOrderDetailViewDTO } from './dto/sale-order-detail-view.dto';
import { SaleOrderIdRequest, SaleOrderItemRequest, SaleOrderItemsCasesRequest, SaleOrderNumberRequest, SolifeCycleCategoryReq, } from './dto/sale-order-id.request';
import { SoRepository } from './repository/so-repository';
import { ItemCategoryService, ItemsService, VendorsService, TrimsMappingService } from '@gtpl/shared-services/masters';
import { BomItemRequest, BrandsRequest, CertificationsRequest, CommonResponseArr, CountryRequest, HlPercentageRangeRequest, InvoiceCustomerDetailsModel, ItemCategoryNameRequest, ItemRequest, ItemsDto, NotifypartyRequest, NotifyPartyResponse, PlantIdRequest, ProductRequest, RackZoneRequest, RmBomItemRequest, SizesDropDownDto, TrimsMappingRequset, UnitcodeDto, } from '@gtpl/shared-models/masters';

import { SkuDataRequest } from '@gtpl/shared-models/masters';
import { SoItemRepository } from './repository/so-items-repository';
import { BomDetails } from './bom-calculation.entity';
import { BomRepository } from './repository/bom-calculation.repository';
import { EtdWiseDTO, ProductConversionReq, QtyRequest, StocktemRequest } from '@gtpl/shared-models/procurement-management';
import { AllSaleOrdersDto } from 'libs/shared-models/sale-management/src/lib/sale-order/all-sale-orders.dto';
import { SoTrackRepository } from './repository/so-track-repository';
import { AllContainerStatusInfo, ContainerStatusInfo, SoContainerStatusUpdate, BlStatusInfo, AllBlStatusInfo, DispatchedToPlant, ContainerDispatchedToPlantResponse, } from '@gtpl/shared-models/logistics';
import { SaleOrderTrack } from './so-track.entity';
import { PlantInvoiceDetailsRequest } from './dto/plant-invoice-details.request';
import { SoCustomerInvoice } from './customer-invoice.entity';
import { CustomerInvoiceRepository } from './repository/customer-invoice-repository';
import { ContainerRegisterService } from '@gtpl/shared-services/logistics';
import { RepackingDtoRequest, ReProcessingDtoReq, SoIdRequest } from '@gtpl/shared-models/warehouse-management';
import { FGStockService } from '@gtpl/shared-services/warehouse-management'
import { IndentService } from '@gtpl/shared-services/raw-material-procurement'
import { RmBomLog } from './rm-bom-log.entity';
import { RmBomLogRepository } from './repository/rm-bom-log.repository';
import { SoInspectionDTO } from './dto/so-inspection.dto';
import { SaleInspectionDetails } from './so-inspections.entity';
import { SoInspectionAdapter } from './dto/so-inspection.adapter';
import { UpdateSoInspectionInfo } from './dto/so-inspection-update.dto';
import { SaleInspectionDetailsRepository } from './repository/so-inspection.repository';
import { RmBomData } from 'libs/shared-models/sale-management/src/lib/bom/rmBomData';
import { PlantInputRequest } from './dto/plant-input.request';
import { SoItemDetailsBySoIdDTO } from 'libs/shared-models/sale-management/src/lib/sale-order/dto/so-item-details-by-so-id.dto';
import { IndentQuantityRequest, RMFiltersRequest } from '@gtpl/shared-models/raw-material-procurement';
import { SoItemRequest } from './dto/so-item.request';
import { SaleOrderRequest } from './dto/sale-order.request';
import { repeat } from 'rxjs/operators';
import { SoInvoiceRepository } from './repository/so-inv-details-repository';
import { PONumbersDropDownDto } from 'libs/shared-models/sale-management/src/lib/sale-order/po-number-dropdown.dto';
import { CountRequest } from './dto/count.request';
import { PoInfo } from 'libs/shared-models/sale-management/src/lib/bom/po-info';
import { CountryInfo } from 'libs/shared-models/sale-management/src/lib/bom/country-info';
import { RatingInfo } from 'libs/shared-models/sale-management/src/lib/bom/rating-info';
import { countRangeWiseInfo } from 'libs/shared-models/sale-management/src/lib/bom/product-count-wise-bom-info';
import { seriesInfo } from 'libs/shared-models/sale-management/src/lib/bom/series-info';
import { DrilldownInfo } from 'libs/shared-models/sale-management/src/lib/bom/drill-down-info';
import { BomIndentInfo } from 'libs/shared-models/sale-management/src/lib/bom/bom-indent-info';
import { ProductIdRequest } from './dto/product-id.request';
import { SaleOrderProductIdRequest } from './dto/sale-order-product.request';
import { SaleOrderUploadDto } from './dto/sale-order-file-uploa.dto';
import { SaleOrderGrossWeightRequest } from './dto/gross-weight-request';
import { DocumentsApprovalRepository } from './repository/documents-approval.repository';
import { RmBomLogUpdateRequset } from './dto/rmbomlog-update-req';
import appSettings from 'apps/services/config';
import { saleOrder } from '@gtpl/shared-services/sale-management';
import { SgsTuvData } from './dto/sgs-tuv.dto';
import { SOTransferDto } from './dto/so-transfer.dto';
import { SOTransferLog } from './so-transfer-log.entity';
import { SOTransferLogRepository } from './repository/so-transfer-log.repository';
import { NotContains, NotEquals } from 'class-validator';
import { GradePatternRequest } from './dto/grade-pattern-request';
import { isNull } from 'util';
import { SoLogRepository } from './repository/so-log-repository';
import { SaleOrderLog } from './so-log.entity';
import { SaleOrderItemsLog } from './so-items-log.entity';
import { SoItemsLogRepository } from './repository/so-items-log.repository';
import { BomDetailsLog } from './bom-details-log.entity';
import { BomDetailsLogRepository } from './repository/bom-log.repository';
import { ConstraintMetadata } from 'class-validator/types/metadata/ConstraintMetadata';
import { PackingBomLog } from './packing-bom-log.entity';
import { PackingBomLogRepository } from './repository/packing-bom-log-repository';
import { UpdateCasesRequest } from './dto/upade-cases.request';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { Cron } from '@nestjs/schedule';
import { whatsApp } from '../../../../whatsapp'
import { SoReportAdapter } from './dto/so-report-adapter';
import { async } from 'rxjs/internal/scheduler/async';
import { truncate } from 'fs';
import { EndCustomerReq } from './dto/end-customer-req';
import { SubJobRequest } from './dto/sub-job-request';
import { UserDateReq } from './dto/user-date-request';
import { EndCustomerIdReq } from './dto/end-customer-id-req';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { BroadCastMessageRequest, WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { ProductBarcodeRequest } from './dto/product-barcode-request';
import { TrimsRequest } from './dto/trimsRequest';
import { TrimsItemsRequest } from './dto/trimsItemsRequest';
import { SoProcessTypeReq } from './dto/so-type-req';
import { SubJobSoRequest } from './dto/subjob-so.request';

import { CodeListMainService } from '@gtpl/shared-services/planning';
import { SubJobCodeListRequest } from '@gtpl/shared-models/planning';
import { TreeStructureData } from '@gtpl/shared-models/production-management';
import axios from 'axios';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
const util = require('util');
// import { notEqual } from 'assert';
const countRangesTable = appSettings.rm_procure_db + '.count_ranges';
let moment = require('moment');
moment().format();
// import { count } from 'console';

@Injectable()
export class SaleorderService {
  constructor(
    private logService:LogsService,

    @InjectRepository(SaleOrderItems)
    private saleOrderItemsRepository: Repository<SaleOrderItems>,
    @InjectRepository(SalePoDetails)
    private salePoDetails: Repository<SalePoDetails>,
    @InjectRepository(SoInvoiceDetails)
    private soInvoiceDetails: Repository<SoInvoiceDetails>,
    private soRepo: SoRepository,
    private soInvRepo: SoInvoiceRepository,
    private saleOrderAdapter: SaleOrderAdapter,
    private soItemsAdapter: SoItemsAdapter,
    private saleOrderTrackAdapter: SaleOrderTrackAdapter,
    private customerRepository: CustomersService,
    private endCustomerRepository: EndCustomersService,
    private certificationsRepository: CertificationsService,
    private productRepository: ProductService,
    private taxesService: TaxesService,
    private trimsmappingService: TrimsMappingService,
    private packingMethodService: PackingMethodService,
    private gradesRepository: GradeServices,
    private currencyRepository: CurrencyService,
    private indentService: IndentService,
    private deliveryTermsRepository: DeliveryTermsService,
    private destinationRepository: DestinationService,
    private uomRepository: UomsService,
    private foodTypeRepository: FoodTypeService,
    private skuCodesRepository: SkuService,
    private sizesService: SizesService,
    private countryRepository: CountryService,
    private shippingRepository: ShippingTermsService,
    private paymentTermsRepository: PaymentTermsService,
    private soItemRepo: SoItemRepository,
    private itemService: ItemsService,
    private itemCategoryService: ItemCategoryService,
    private bomRepo: BomRepository,
    private rmbomRepo: RmBomLogRepository,
    private packingbomRepo: PackingBomLogRepository,
    private stockService: StockService,
    private fgService: FGStockService,
    private supplierService: SuppliersService,
    private purchaseOrderService: PurchaseOrderService,
    private soTrackRepo: SoTrackRepository,
    private customerInvoiceRepo: CustomerInvoiceRepository,
    private docApprovalRepo: DocumentsApprovalRepository,
    private valueAddition1TypeService: Type1Service,
    private valueAddition2TypeService: TypesOfValueAddition2Service,
    private valueAddition3TypeService: Type3Service,
    private valueAddition4TypeService: TypeofValueAddition4Service,
    private valueAddition5TypeService: TypeofValueAddition5Service,
    private containerService: ContainerRegisterService,
    private empDetService: HrmsEmpDetService,
    private hlPerService: HLpercentagesService,
    private productionInvService: ProductionInventoryService,
    @InjectRepository(SaleInspectionDetails)
    private saleInspectionRepository: Repository<SaleInspectionDetails>,
    private saleInspectionAdapter: SoInspectionAdapter,
    private unitcodeService: UnitcodeService,
    private hsnCodeService: HsnService,
    private masterBrandsService: MasterBrandService,
    private wpService: WhatsAppNotificationService,
    private soreportAdapter: SoReportAdapter,
    private wtsAppBroadCatService: WhatsappBroadCastService,
    private codeListService: CodeListMainService,
    private notifypartyservice: NotifyPartyService

  ) { }

  //     async createSaleOrder(saleOrderDto:SaleOrderDto, isUpdate: boolean,request:Request): Promise<SaleOrderResponse> {
  //         try {
  //       const manager = new GenericTransactionManager();
  //   private saleOrderAdapter: SaleOrderAdapter,
  // ) { }
  async getSaleOrderWithoutRelations(saleOrderId: number): Promise<SaleOrder> {
    const SaleOrderResponse = await this.soRepo.findOne({
      where: {
        saleOrderId: Raw((alias) => `sale_order_id = '${saleOrderId}'`),
      },
    });
    if (SaleOrderResponse) {
      return SaleOrderResponse;
    } else {
      return null;
    }
  }

  async createSubSaleOrder(
    saleOrderDto: SaleOrderDto,
    isUpdate: boolean
  ): Promise<SaleOrderResponse> {
    const manager = new GenericTransactionManager();
    try {
      let saleorderId = saleOrderDto.saleOrderId;
      saleOrderDto.saleOrderId = undefined;
      let count;
      let today = new Date();
      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let fromDate = 0;
      let toDate = 0;
      let finYear = '';
      if (CurrentMonth < 4) {
        toDate = (CurrentYear);
      } else {
        toDate = (CurrentYear + 1);
      }
      finYear = toDate.toString().substr(-2)
      count = await this.soRepo.count();
      count = count + 1;

      var refNo = count + "";
      while (refNo.length < 4) refNo = "0" + refNo;


      // console.log(count);
      const SaleOrderPONumberCheck = await this.soInvRepo.findOne({ poNumber: saleOrderDto.soInvDetailsInfo.poNumber });
      const SaleOrderBuyerPoCheck = await this.soInvRepo.findOne({ buyerPoNumber: saleOrderDto.soInvDetailsInfo.buyerPoNumber });
      if (!SaleOrderPONumberCheck || !SaleOrderBuyerPoCheck) {
        throw new ErrorResponse(11104, 'Sale Order not exists with Same Po number OR Buyer PO Number to create sub saleorder');
      }
      const unitData = await this.unitcodeService.getPlantDetailsById({ unitcodeId: saleOrderDto.soInvDetailsInfo.unit })

      const customerId = await this.customerRepository.getCustomerDataById({
        custId: saleOrderDto.soInvDetailsInfo.customerId,
      });
      const endCustomerId = await this.endCustomerRepository.getEndCustomerDataById(
        { endCustomerId: saleOrderDto.soInvDetailsInfo.endCustomerId }
      );
      let dummyCode = '';
      if (saleOrderDto.soProcessType == SoProcessTypesEnum.MTS) {
        dummyCode = 'D'
      }
      const soNumber = "SA" + dummyCode + finYear + "/" + unitData.data.shortKey + "/" + refNo;
      if (!(customerId || endCustomerId)) {
        throw new ErrorResponse(
          11106,
          'Something Went wrong in getting Customers'
        );
      }
      //saving of SO
      const soItemsArray = JSON.parse(JSON.stringify(saleOrderDto.saleOrderItemsInfo));
      console.log('soItemsArray')
      // console.log(saleOrderDto.saleOrderItemsInfo[0].subJobCodeListData)

      const samePoQtyMap = new Map<number, number>()
      const samePonetWeightMap = new Map<number, number>()

      for (const existiongSoItem of soItemsArray) {
        const samePodata = await this.soItemRepo.findOne(existiongSoItem.saleOrderItemId);
        console.log('samepodatall')
        console.log(samePodata)
        samePoQtyMap.set(existiongSoItem.saleOrderItemId, samePodata.cases)
        samePonetWeightMap.set(existiongSoItem.saleOrderItemId, samePodata.netWeight)
      }
      let totSoItemsCount
      totSoItemsCount = await this.soItemRepo.count();
      totSoItemsCount = totSoItemsCount + 1


      const operation = 'SUB JOB CREATE'
      const convertedSaleOrderEntity: SaleOrder = await this.saleOrderAdapter.convertDtoToEntity(
        saleOrderDto,
        isUpdate,
        soNumber,
        // await customerId,
        // await endCustomerId,
        samePoQtyMap,
        samePonetWeightMap,
        operation,
        totSoItemsCount
      );
      await manager.startTransaction();
      const savedSoEntity: SaleOrder = await manager
        .getCustomRepository(SoRepository)
        .save(convertedSaleOrderEntity);

      const savedSaleOrderDto: SaleOrderDto = await this.saleOrderAdapter.convertEntityToDto(
        savedSoEntity
      );
      let flagMap = new Set<boolean>()
      for (const soitem of soItemsArray) {
        console.log('soitem')
        console.log(soitem)
        const updateSaleqty = await manager.getCustomRepository(SoItemRepository).update({ saleOrderItemId: soitem.saleOrderItemId }, { jobCases: () => `job_cases-${soitem.cases}` })
        if (updateSaleqty.affected) {
          flagMap.add(true)
        } else {
          flagMap.add(false)
        }
        // if(!flagMap.has(false)){
        //   // manager.completeTransaction();
        // }else{
        //   throw new ErrorResponse(99998, 'Something went wrong in updation');
        // }

      }


      //BOM saving in RM
      const soItems = await manager
        .getCustomRepository(SoItemRepository)
        .find({ where: { saleOrderId: savedSaleOrderDto.saleOrderId } });
      let rmbomLogflagMap = new Set<boolean>()

      for (const soItem of soItems) {
        let gmsMinWeight
        let gmsMaxWeight
        //weight calculation 
        const uom = soItem.uomId;
        // if(uom == 1 || uom == 4){
        //   gmsMinWeight = 1000/soItem.minGrade;
        //   gmsMaxWeight = 1000/soItem.maxGrade;
        // }else{
        //Grade in SO is per LB.1 LB = 454Gms
        gmsMinWeight = 454 / soItem.minGrade;
        gmsMaxWeight = 454 / soItem.maxGrade;
        // }
        //RM ratio calcualtaion per kg
        const yieldPercentage = soItem.finalPercentage;
        const hlPercentagedata = await this.hlPerService.getHlPercentageByRange(
          new HlPercentageRangeRequest(
            soItem.maxGrade,
          )
        );
        let hlPercentage;
        if (hlPercentagedata.status && hlPercentagedata.data.hlPercentage > 0) {

          hlPercentage = hlPercentagedata.data.hlPercentage;
        } else {
          throw new ErrorResponse(99998, 'No HL percentages found for selected Grade Range.');
        }

        // const hlPercentage = 70;
        const productPercentageafterhl = 1000 * hlPercentage / 100;
        const productPercentageafterSoaking = productPercentageafterhl * yieldPercentage / 100;
        const rmRatioPerKg = 1000 / productPercentageafterSoaking;


        //outputproduct count and quamtity calculation
        let outputMinWeight
        let outputMaxWeight
        if (yieldPercentage != 0 && hlPercentage != 0) {
          outputMinWeight = gmsMinWeight / ((yieldPercentage / 100) * (hlPercentage / 100));
          outputMaxWeight = gmsMaxWeight / ((yieldPercentage / 100) * (hlPercentage / 100));

        } else {
          throw new ErrorResponse(99999, 'loss/Gain or HL percentage should more than zero for SKU');
          // outputMinWeight = 0
          // outputMaxWeight = 0
        }

        const productMinCount = 1000 / outputMinWeight;
        const productMaxCount = 1000 / outputMaxWeight;
        const avgCount = (productMinCount + productMaxCount) / 2;
        const requiredCount = soItem.requiredCount
        let countRangeId = 0
        //for count range id 
        if (requiredCount > 0) {

          const countRangesData = await this.getRmCountRanges(requiredCount);
          if (countRangesData.status) {
            countRangeId = countRangesData.data[0].countRangeId
          } else {
            throw new ErrorResponse(99999, 'No count ranges found');
          }
        }

        const count = Math.ceil(avgCount);

        let caseWeight = soItem.pouches * soItem.shrimpWeight;
        //conversion of case weight into Kg if UOM in SO is LB 
        if (uom == 2) {
          caseWeight = caseWeight * 0.453592
        }
        if (uom == 3) {
          caseWeight = caseWeight * 0.0283495
        }
        if (uom == 4) {
          caseWeight = caseWeight * 0.001
        }

        const reqQtyPercase = caseWeight * rmRatioPerKg;
        const totalRequiredQty = soItem.cases * reqQtyPercase;




        //insertion into bom_log against soItem id
        const bomLogModel = new RmBomLog();
        bomLogModel.saleOrderId = soItem.saleOrderId;
        bomLogModel.saleOrderItemId = soItem.saleOrderItemId;
        bomLogModel.productId = soItem.itemId;
        bomLogModel.minGrade = soItem.minGrade;
        bomLogModel.maxGrade = soItem.maxGrade;
        bomLogModel.uomId = soItem.uomId;
        bomLogModel.hlPercentage = hlPercentage;
        bomLogModel.finalPercentage = soItem.finalPercentage;
        bomLogModel.ratio = rmRatioPerKg;
        bomLogModel.cases = soItem.cases;
        bomLogModel.caseWeight = caseWeight;
        bomLogModel.oupPutMinWeight = outputMinWeight;
        bomLogModel.oupPutMaxWeight = outputMaxWeight;
        bomLogModel.minCount = productMinCount;
        bomLogModel.maxCount = productMaxCount;
        bomLogModel.count = count;
        bomLogModel.requiredCount = requiredCount;
        bomLogModel.countRangeId = countRangeId;
        bomLogModel.quantity = totalRequiredQty;
        const bomLog = await manager.getCustomRepository(RmBomLogRepository).save(bomLogModel);
        if (bomLog) {
          const updateRmBomLog = await manager.getCustomRepository(RmBomLogRepository).update({ saleOrderItemId: soItem.saleOrderItemId }, { quantity: () => `quantity-${totalRequiredQty}` })
          if (updateRmBomLog.affected) {
            rmbomLogflagMap.add(true)
          } else {
            rmbomLogflagMap.add(false)
            break
          }
        } else {
          throw new ErrorResponse(1111, 'SOmething went wrong in BOM log insertion')
        }

      }
      if (rmbomLogflagMap.has(false)) {
        throw new ErrorResponse(1111, 'Something went wrong in BOM log updation')
      }

      //bomlog updation for subsaleorder PO

      //Raw material BOM insertion into BOM details against sale order,product and count
      const bomLogItems = await manager.getCustomRepository(RmBomLogRepository).getBomLogItemCombData(savedSaleOrderDto.saleOrderId);
      let savedrmBomEntity
      let bomDetailsSet = new Set<boolean>();
      for (const bomLogItem of bomLogItems) {
        const rmItemDto = new ItemsDto(
          undefined,
          undefined,
          undefined,//need to get id by category name
          'RM/' + bomLogItem.productId + '/' + bomLogItem.count,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          true,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          null,
          ItemCategoriesEnum.RAW_MATERIAL,
          bomLogItem.productId,
          bomLogItem.count,

        );
        const rmItemRes = await this.itemService.createItem(rmItemDto);
        console.log(rmItemRes);

        //getting rm item against count and product to save bom against item
        const rmItemsData = await this.itemService.getRmItemForBom(
          new RmBomItemRequest(
            bomLogItem.productId, bomLogItem.count
          )
        );
        // let excessRmQty = 0;
        // let excessRmQty = Math.ceil(Number(bomLogItem.quantity) * (3 / 100));
        let excessRmBomQty =
          Math.ceil(Number(bomLogItem.quantity) * (3 / 100)) + Number(bomLogItem.quantity);
        if (rmItemsData) {
          const rmBomObj = new BomDetails();
          rmBomObj.itemId = rmItemsData.data.itemId;
          rmBomObj.saleOrderId = savedSaleOrderDto.saleOrderId;
          rmBomObj.itemCategoryId = rmItemsData.data.itemCategoryInfo.itemCategoryId;
          rmBomObj.itemSubCategoryId = rmItemsData.data.itemSubCategory.itemSubCategoryId;
          rmBomObj.quantity = bomLogItem.quantity;
          rmBomObj.requiredQuantity = excessRmBomQty;
          savedrmBomEntity = await manager
            .getCustomRepository(BomRepository)
            .save(rmBomObj);
          if (savedrmBomEntity) {
            //bom saving for raw material
            const bomUpdate = await manager.getCustomRepository(BomRepository).update({ saleOrderId: saleorderId, itemId: rmItemsData.data.itemId }, { requiredQuantity: () => `required_qty-${excessRmBomQty}` })
            if (bomUpdate) {
              bomDetailsSet.add(true)
            } else {
              bomDetailsSet.add(false)
              break
            }
          } else {
            throw new ErrorResponse(
              1205,
              'BOM items not saved'
            );
          }

        } else {
          throw new ErrorResponse(
            1205,
            'Some raw material  mapping  in items was missed with selected product.'
          );
        }


      }

      console.log('soItemsArraykkkkk')
      console.log('here data')
      console.log(saleOrderDto.subJobCodeListData)
      const subSoItemId = await manager.getCustomRepository(SoItemRepository).findOne({ where: { saleOrderItemId: saleOrderDto.subJobCodeListData.saleOrderItemId, mainSoItemId: Not(saleOrderDto.subJobCodeListData.saleOrderItemId) } })
      console.log('here data subso')
      console.log(subSoItemId)
      console.log('savedSaleOrderDtokkk')
      console.log(savedSaleOrderDto)
      let nwSubJobData = []
      for (const record of saleOrderDto.subJobCodeListData) {
        const soItem = (savedSaleOrderDto.saleOrderItemsInfo).find(item => (item.saleOrderItemId != record.saleOrderItemId && item.mainSoItemId == record.saleOrderItemId))
        console.log('soItemlll')
        console.log(soItem)
        console.log('noosales', savedSaleOrderDto.saleOrderId)
        const subCodeListInfo = new SubJobCodeListRequest(record.codeListInfo, record.operation, record.saleOrderItemId, soItem.saleOrderItemId, savedSaleOrderDto.saleOrderId, null, saleOrderDto.soInvDetailsInfo.processingUnit, soItem.jobCases, saleOrderDto.createdUser)
        // record.push({record,subSaleOrderItemId:soItem.saleOrderItemId})
        nwSubJobData.push(subCodeListInfo)
        // (saleOrderDto.subJobCodeListData).push({subSoItemId:soItem.saleOrderItemId})
      }
      console.log('yesssonee')
      console.log(nwSubJobData)
      console.log(util.inspect(nwSubJobData, false, null, true));
      const codeListUpdate = await this.codeListService.updateCodeListForSubJob(nwSubJobData);
      console.log(codeListUpdate)
      if (codeListUpdate.status) {
        bomDetailsSet.add(true)
      } else {
        bomDetailsSet.add(false)
      }

      if (bomDetailsSet.has(false)) {
        throw new ErrorResponse(
          1205,
          'Something went wrong in RM BOM updation OR codelist Updation'
        );
      }
      await manager.completeTransaction();
      const response = new SaleOrderResponse(
        true,
        11101,
        'Sub Sale order Created Successfully',
        savedSaleOrderDto
      );
      return response;
    } catch (err) {
      await manager.releaseTransaction();
      return err
    }

    return
  }





  async createSaleOrder(
    saleOrderDto: SaleOrderDto,
    isUpdate: boolean
  ): Promise<SaleOrderResponse> {
    const manager = new GenericTransactionManager();

    try {
      let count;
      let today = new Date();
      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let fromDate = 0;
      let toDate = 0;
      let finYear = '';
      if (!isUpdate || (isUpdate && saleOrderDto.operation && saleOrderDto.operation == 'Clone')) {
        if (CurrentMonth < 4) {
          toDate = (CurrentYear);
        } else {
          toDate = (CurrentYear + 1);
        }
        finYear = toDate.toString().substr(-2)
        count = await this.soRepo.count();
        count = count + 1;

        var refNo = count + "";
        while (refNo.length < 4) refNo = "0" + refNo;
        console.log(refNo);

        // console.log(count);
        const SaleOrderPONumberCheck = await this.soInvRepo.findOne({ poNumber: saleOrderDto.soInvDetailsInfo.poNumber });
        const SaleOrderBuyerPoCheck = await this.soInvRepo.findOne({ poNumber: saleOrderDto.soInvDetailsInfo.buyerPoNumber });
        if ((saleOrderDto.soProcessType == SoProcessTypesEnum.MTO) && (SaleOrderPONumberCheck || SaleOrderBuyerPoCheck)) {
          throw new ErrorResponse(11104, 'Sale Order already exists with Same Po number OR Buyer PO Number');
        }
      }
      let samePodata
      let operation = 'CREATE'
      if (saleOrderDto.operation && saleOrderDto.operation == 'Clone') {
        operation = 'CLONE'
      }
      if (isUpdate) {
        samePodata = await this.soInvRepo.count({ where: { poNumber: saleOrderDto.soInvDetailsInfo.poNumber } });
        if (samePodata > 1) {
          operation = 'SUB JOB EDIT'
        } else {
          operation = 'EDIT'
        }

      }
      console.log('operation')
      console.log(operation)

      const unitData = await this.unitcodeService.getPlantDetailsById({ unitcodeId: saleOrderDto.soInvDetailsInfo.unit })

      const customerId = await this.customerRepository.getCustomerDataById({
        custId: saleOrderDto.soInvDetailsInfo.customerId,
      });
      const endCustomerId = await this.endCustomerRepository.getEndCustomerDataById(
        { endCustomerId: saleOrderDto.soInvDetailsInfo.endCustomerId }
      );
      let dummyCode = '';
      if (saleOrderDto.soProcessType == SoProcessTypesEnum.MTS) {
        dummyCode = 'D'
      }
      const soNumber = "SA" + dummyCode + finYear + "/" + unitData.data.shortKey + "/" + refNo;
      if (!(customerId || endCustomerId)) {
        throw new ErrorResponse(
          11106,
          'Something Went wrong in getting Customers'
        );
      }

      // console.log(customerId);
      // console.log(endCustomerId);
      // const percentageMap = new Map<number, Map<String, number>>();
      // for (const soItem of saleOrderDto.saleOrderItemsInfo) {
      //   const yieldPercentages = await this.skuCodesRepository.getSkuPercentages(
      //     new SkuDataRequest(
      //       soItem.varientId,
      //       soItem.foodTypeId,
      //       soItem.soakingStyle
      //     )
      //   );
      //   if (yieldPercentages.status) {

      //     if (!percentageMap.has(soItem.varientId)) {
      //       percentageMap.set(soItem.varientId, new Map<String, number>());
      //       // if (!percentageMap.get(soItem.varientId).has(soItem.foodTypeId)) {
      //       //   percentageMap.get(soItem.varientId).set(soItem.foodTypeId,new Map<String, number>());
      //       if (!percentageMap.get(soItem.varientId).has(soItem.soakingStyle)) {
      //         percentageMap
      //           .get(soItem.varientId)
      //           .set(soItem.soakingStyle, yieldPercentages.data.finalPercentage);
      //       }

      //       // }
      //     } else {
      //       if (!percentageMap.get(soItem.varientId).has(soItem.soakingStyle)) {
      //         percentageMap
      //           .get(soItem.varientId)
      //           .set(soItem.soakingStyle, yieldPercentages.data.finalPercentage);
      //       }
      //     }
      //   } else {
      //     throw new ErrorResponse(99998, 'No soaking percentages found for selected varient.');

      //   }
      //   // console.log(yieldPercentages.data.finalPercentage);
      //   // res[itemId][itemcatId]
      // }
      let totSoItemsCount
      totSoItemsCount = await this.soItemRepo.count();
      totSoItemsCount = totSoItemsCount + 1
      // var SoItemRefNumber = totSoItemsCount + "";
      // while (refNumber.length < 4) refNumber = "0" + refNumber;


      const convertedSaleOrderEntity: SaleOrder = this.saleOrderAdapter.convertDtoToEntity(
        saleOrderDto,
        isUpdate,
        soNumber,
        // await customerId,
        // await endCustomerId,
        undefined,
        undefined,
        operation, totSoItemsCount,
      );
      const prevSoData = await this.soRepo.findOne({
        where: { saleOrderId: saleOrderDto.saleOrderId },
        relations: ["SoInvDetailsInfo", "SoPoDetailsInfo"],
        order: { saleOrderId: 'ASC' }
      }
      );


      await manager.startTransaction();
      if (isUpdate) {
        console.log('saleOrderDto')
        console.log(saleOrderDto)
        const savedPreviousDto: SaleOrderLog = this.saleOrderAdapter.saveExistingSOData(
          prevSoData, soNumber
        );
        const savedSOData: SaleOrderLog = await manager.getCustomRepository(SoLogRepository).save(savedPreviousDto)
        if (!savedSOData) {
          throw new ErrorResponse(5555, 'something went wrong in Log saving')
        }
        const updateflag = new Set<boolean>()
        const prevSOItemsData = await this.soItemRepo.find({ where: { saleOrderId: saleOrderDto.saleOrderId } })
        for (const saleOrderItem of prevSOItemsData) {
          if (saleOrderItem.saleOrderItemId) {
            const savedPreviousSoItemsDto: SaleOrderItemsLog = this.saleOrderAdapter.saveExistingSOitemsData(
              saleOrderItem
            );
            const savedSOItemData: SaleOrderItemsLog = await manager.getCustomRepository(SoItemsLogRepository).save(savedPreviousSoItemsDto)
            if (savedSOItemData) {
              updateflag.add(true)
            } else {
              updateflag.add(false)
            }

          }
        }

        if (updateflag.has(false)) {
          throw new ErrorResponse(5555, 'something went wrong in SO item Log saving')
        }
        const createbomData = await this.bomRepo.find({ where: { saleOrderId: saleOrderDto.saleOrderId } })
        if (createbomData) {
          const bomflag = new Set<boolean>()
          for (const bomdataItem of createbomData) {
            const savedPreviousBomItemDtoDto: BomDetailsLog = this.saleOrderAdapter.saveExistingBomLog(
              bomdataItem
            );
            const savedSOItemData: BomDetailsLog = await manager.getCustomRepository(BomDetailsLogRepository).save(savedPreviousBomItemDtoDto)
            if (savedSOItemData) {
              bomflag.add(true)
            } else {
              bomflag.add(false)
            }
          }
          if (bomflag.has(false)) {
            throw new ErrorResponse(5555, 'something went wrong in BOM Log saving')
          }
        }

      }
      if (isUpdate && saleOrderDto.status == SoStatusEnum.OPEN) {
        const deletedInspection = await manager
          .getCustomRepository(SaleInspectionDetailsRepository)
          .delete({ saleOrderId: saleOrderDto.saleOrderId });
      }
      const savedSoEntity: SaleOrder = await manager
        .getCustomRepository(SoRepository)
        .save(convertedSaleOrderEntity);

      const savedSaleOrderDto: SaleOrderDto = await this.saleOrderAdapter.convertEntityToDto(
        savedSoEntity
      );


      if (isUpdate && saleOrderDto.status == SoStatusEnum.OPEN) {
        console.log('delete')
        const deletedBom = await manager
          .getCustomRepository(BomRepository)
          .delete({ saleOrderId: savedSaleOrderDto.saleOrderId });
        const deletedRmBomLog = await manager
          .getCustomRepository(RmBomLogRepository)
          .delete({ saleOrderId: savedSaleOrderDto.saleOrderId });
      }
      if (isUpdate && saleOrderDto.soInvDetailsInfo.jobType != 'Sub Job' && saleOrderDto.status == SoStatusEnum.OPEN) {
        const deletedPackingBom = await manager
          .getCustomRepository(PackingBomLogRepository)
          .delete({ saleOrderId: savedSaleOrderDto.saleOrderId });
        if (!deletedPackingBom.affected) {
          throw new ErrorResponse(
            5555,
            'Something went wrong in BOM deletion'
          );
        }
      }
      let existingBOMItems = []
      let existingpackingBOMLogItems = []
      let allExistingBOMItems = []
      let presentBOMitems = []
      let presentPackingBOMLogitems = []

      let presentRMBOMitems = []
      let existingRMBOMitems = []

      if (isUpdate) {
        const existingRMItemsData = await manager.getCustomRepository(BomRepository).find({ where: { saleOrderId: savedSaleOrderDto.saleOrderId, status: StatusEnum.OPEN, packingCategory: (IsNull()) } })
        if (existingRMItemsData.length > 0) {
          for (const bomItem of existingRMItemsData) {
            existingRMBOMitems.push(bomItem.itemId)
          }
        }
      }



      if (saleOrderDto.status == SoStatusEnum.OPEN || saleOrderDto.status == SoStatusEnum.IN_PROGRESS) {

        //raw material BOM for so Items
        const soItems = await manager
          .getCustomRepository(SoItemRepository)
          .find({ where: { saleOrderId: savedSaleOrderDto.saleOrderId } });
        for (const soItem of soItems) {
          if (!isUpdate) {
            const mainsoitemIdupdate = await manager.getCustomRepository(SoItemRepository).update({ saleOrderItemId: soItem.saleOrderItemId }, { mainSoItemId: soItem.saleOrderItemId })
            if (!mainsoitemIdupdate.affected) {
              throw new ErrorResponse(99998, 'something went wrong in so item updation');

            }
          }
          let samePoDetails
          if (operation == 'SUB JOB EDIT') {
            samePoDetails = await this.soItemRepo.createQueryBuilder('soi')
              .select('job_cases as prevCases,cases')
              .where('sale_order_item_id =' + soItem.saleOrderItemId)
              .getRawOne()
            // const subJobSosUpdate =await manager.getCustomRepository(SoItemRepository).update({})
            let totalmaincases
            if (samePoDetails.prevCases > soItem.jobCases) {
              totalmaincases = samePoDetails.cases - ((soItem.jobCases > samePoDetails.prevCases) ? (soItem.jobCases - samePoDetails.prevCases) : (samePoDetails.prevCases - soItem.jobCases))
            }
            if (samePoDetails.prevCases < soItem.jobCases) {
              totalmaincases = samePoDetails.cases + ((soItem.jobCases > samePoDetails.prevCases) ? (soItem.jobCases - samePoDetails.prevCases) : (samePoDetails.prevCases - soItem.jobCases))
            }
            if (totalmaincases > 0) {
              const totalcasesUpdate = await manager.getCustomRepository(SoItemRepository).update({ mainSoItemId: soItem.saleOrderItemId }, { cases: totalmaincases })
            }
          }
          let gmsMinWeight
          let gmsMaxWeight
          //weight calculation 
          const uom = soItem.uomId;
          // if(uom == 1 || uom == 4){
          //   gmsMinWeight = 1000/soItem.minGrade;
          //   gmsMaxWeight = 1000/soItem.maxGrade;
          // }else{
          //Grade in SO is per LB.1 LB = 454Gms
          //no RM BOM generation for 0 required count of variant
          if (soItem.requiredCount > 0) {

            gmsMinWeight = 454 / soItem.minGrade;
            gmsMaxWeight = 454 / soItem.maxGrade;
            // }
            //RM ratio calcualtaion per kg
            const yieldPercentage = soItem.finalPercentage;
            const hlPercentagedata = await this.hlPerService.getHlPercentageByRange(
              new HlPercentageRangeRequest(
                soItem.maxGrade,
              )
            );
            let hlPercentage;
            if (hlPercentagedata.status && hlPercentagedata.data.hlPercentage > 0) {

              hlPercentage = hlPercentagedata.data.hlPercentage;
            } else {
              throw new ErrorResponse(99998, 'No HL percentages found for selected Grade Range.');
            }

            // const hlPercentage = 70;
            const productPercentageafterhl = 1000 * hlPercentage / 100;
            const productPercentageafterSoaking = productPercentageafterhl * yieldPercentage / 100;
            const rmRatioPerKg = 1000 / productPercentageafterSoaking;


            //outputproduct count and quamtity calculation
            let outputMinWeight
            let outputMaxWeight
            if (yieldPercentage != 0 && hlPercentage != 0) {
              outputMinWeight = gmsMinWeight / ((yieldPercentage / 100) * (hlPercentage / 100));
              outputMaxWeight = gmsMaxWeight / ((yieldPercentage / 100) * (hlPercentage / 100));

            } else {
              throw new ErrorResponse(99999, 'loss/Gain or HL percentage should more than zero for SKU');
              // outputMinWeight = 0
              // outputMaxWeight = 0
            }

            const productMinCount = 1000 / outputMinWeight;
            const productMaxCount = 1000 / outputMaxWeight;
            const avgCount = (productMinCount + productMaxCount) / 2;
            const requiredCount = soItem.requiredCount
            let countRangeId
            //for count range id 
            if (requiredCount > 0) {
              const countRangesData = await this.getRmCountRanges(requiredCount);
              if (countRangesData.status) {
                countRangeId = countRangesData.data[0].countRangeId
              } else {
                throw new ErrorResponse(99999, 'No count ranges found');
              }
            }

            const count = Math.ceil(avgCount);

            let caseWeight = soItem.pouches * soItem.shrimpWeight;
            //conversion of case weight into Kg if UOM in SO is LB 
            if (uom == 2) {
              caseWeight = caseWeight * 0.453592
            }
            if (uom == 3) {
              caseWeight = caseWeight * 0.0283495
            }
            if (uom == 4) {
              caseWeight = caseWeight * 0.001
            }

            const reqQtyPercase = caseWeight * rmRatioPerKg;
            const totalRequiredQty = soItem.cases * reqQtyPercase;

            let rmBomLogData
            let rmBomLogId

            if (isUpdate) {
              rmBomLogData = await manager.getCustomRepository(RmBomLogRepository).findOne({ where: { saleOrderItemId: soItem.saleOrderItemId } })
              if (rmBomLogData) {
                rmBomLogId = rmBomLogData.bomLogId;
              }
            }

            //insertion into bom_log against soItem id
            const bomLogModel = new RmBomLog();
            if (isUpdate) {
              bomLogModel.bomLogId = rmBomLogId;
            }
            bomLogModel.saleOrderId = soItem.saleOrderId;
            bomLogModel.saleOrderItemId = soItem.saleOrderItemId;
            bomLogModel.productId = soItem.itemId;
            bomLogModel.minGrade = soItem.minGrade;
            bomLogModel.maxGrade = soItem.maxGrade;
            bomLogModel.uomId = soItem.uomId;
            bomLogModel.hlPercentage = hlPercentage;
            bomLogModel.finalPercentage = soItem.finalPercentage;
            bomLogModel.ratio = rmRatioPerKg;
            bomLogModel.cases = soItem.cases;
            bomLogModel.caseWeight = caseWeight;
            bomLogModel.oupPutMinWeight = outputMinWeight;
            bomLogModel.oupPutMaxWeight = outputMaxWeight;
            bomLogModel.minCount = productMinCount;
            bomLogModel.maxCount = productMaxCount;
            bomLogModel.count = count;
            bomLogModel.requiredCount = requiredCount;
            bomLogModel.countRangeId = countRangeId;
            bomLogModel.quantity = totalRequiredQty;
            console.log(bomLogModel)
            const bomLog = await manager.getCustomRepository(RmBomLogRepository).save(bomLogModel);
          } else {
            throw new ErrorResponse(
              1205,
              'Count not exist to calculate RM BOM.Make sure to have count for the selected variant'
            );
          }

        }



        //Raw material BOM insertion into BOM details against sale order,product and count
        const bomLogItems = await manager.getCustomRepository(RmBomLogRepository).getBomLogItemCombData(savedSaleOrderDto.saleOrderId);
        let savedrmBomEntity
        if (bomLogItems.length > 0) {
          for (const bomLogItem of bomLogItems) {
            const rmItemDto = new ItemsDto(
              undefined,
              undefined,
              undefined,//need to get id by category name
              'RM/' + bomLogItem.productId + '/' + bomLogItem.count,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              true,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              null,
              ItemCategoriesEnum.RAW_MATERIAL,
              bomLogItem.productId,
              bomLogItem.count,

            );
            const rmItemRes = await this.itemService.createItem(rmItemDto);
            console.log('567890-');
            console.log(rmItemRes);

            //getting rm item against count and product to save bom against item
            const rmItemsData = await this.itemService.getRmItemForBom(
              new RmBomItemRequest(
                bomLogItem.productId, bomLogItem.count
              )
            );
            presentRMBOMitems.push(rmItemsData.data.itemId)
            console.log('presentRMBOMitemsrm')
            console.log(presentRMBOMitems)
            let rmbomdata
            if (
              isUpdate &&
              saleOrderDto.status == SoStatusEnum.IN_PROGRESS
            ) {
              rmbomdata = await manager
                .getCustomRepository(BomRepository)
                .findOne({
                  where: {
                    itemId: rmItemsData.data.itemId,
                    saleOrderId: savedSaleOrderDto.saleOrderId,
                  },
                });
            }


            // let excessRmQty = 0;
            // let excessRmQty = Math.ceil(Number(bomLogItem.quantity) * (3 / 100));
            let excessRmBomQty =
              Math.ceil(Number(bomLogItem.quantity) * (3 / 100)) + Number(bomLogItem.quantity);
            if (rmItemsData) {
              const rmBomObj = new BomDetails();
              if (rmbomdata) {
                rmBomObj.packingMaterialId = rmbomdata.packingMaterialId;
                rmBomObj.isQtyRevised = GlobalStatus.YES;
              }
              rmBomObj.itemId = rmItemsData.data.itemId;
              rmBomObj.saleOrderId = savedSaleOrderDto.saleOrderId;
              rmBomObj.itemCategoryId = rmItemsData.data.itemCategoryInfo.itemCategoryId;
              rmBomObj.itemSubCategoryId = rmItemsData.data.itemSubCategory.itemSubCategoryId;
              rmBomObj.quantity = bomLogItem.quantity;
              rmBomObj.requiredQuantity = excessRmBomQty;
              savedrmBomEntity = await manager
                .getCustomRepository(BomRepository)
                .save(rmBomObj);
            } else {
              throw new ErrorResponse(
                1205,
                'Some raw material  mapping  in items was missed with selected product.'
              );
            }

            //bom saving for raw material

          }
        }

        //*************** */
      }
      let rmItemIdDiffIds = []
      if (existingBOMItems.length > 0 && saleOrderDto.status == SoStatusEnum.IN_PROGRESS) {
        rmItemIdDiffIds = existingRMBOMitems.filter(x => presentRMBOMitems.indexOf(x) === -1);
        if (rmItemIdDiffIds.length > 0) {
          const BomdataUpdate = await manager.getCustomRepository(BomRepository).update({ saleOrderId: savedSaleOrderDto.saleOrderId, itemId: In(rmItemIdDiffIds) }, { isActive: false, isActiveRevised: GlobalStatus.YES })
          if (BomdataUpdate.affected) {
            const BomInactivedataUpdate = await manager.getCustomRepository(BomRepository).update({ saleOrderId: savedSaleOrderDto.saleOrderId, itemId: In(presentRMBOMitems), isActive: false }, { isActive: true, isActiveRevised: GlobalStatus.YES })
            // if(!BomInactivedataUpdate.affected){
            //   throw new ErrorResponse(11106, 'BOM not activated for revised items!');
            // }
          } else {
            throw new ErrorResponse(11106, 'RM BOM not deactivated for revised items!');
          }
        }
        let revisedRMItemIds = []
        revisedRMItemIds = existingBOMItems.filter(x => rmItemIdDiffIds.indexOf(x) === -1);
        if (revisedRMItemIds.length > 0) {
          const BomdataReviseItemUpdate = await manager.getCustomRepository(BomRepository).update({ saleOrderId: savedSaleOrderDto.saleOrderId, itemId: In(revisedRMItemIds) }, { isQtyRevised: GlobalStatus.YES })
          if (!BomdataReviseItemUpdate.affected) {
            throw new ErrorResponse(11106, 'BOM revised status not updated for revised items!');
          }
        }
      }





      //  if(savedSoEntity){
      // console.log(savedSaleOrderDto);

      //getting data from so items against varient,brand,grade,packstyle and category to map these with item masters and to save the required qty of material in BomDetails for any packing category

      //888888
      //get existing items of BOM for inactive no needed items while update

      if (isUpdate) {
        const allExistingItems = await manager.getCustomRepository(BomRepository).find({ where: { saleOrderId: savedSaleOrderDto.saleOrderId, packingCategory: Not(IsNull()) } })
        if (allExistingItems.length > 0) {
          for (const bomItem of allExistingItems) {
            allExistingBOMItems.push(bomItem.itemId)
          }
        }
        console.log('allExistingBOMItems')
        console.log(allExistingBOMItems)
        const existingBOMItemsdata = await manager.getCustomRepository(BomRepository).find({ where: { saleOrderId: savedSaleOrderDto.saleOrderId, status: StatusEnum.OPEN, packingCategory: Not(IsNull()) } })
        if (existingBOMItemsdata.length > 0) {
          for (const bomItem of existingBOMItemsdata) {
            existingBOMItems.push(bomItem.itemId)
          }
        }

        //getting existing packing bom log items
        const existingpackingBOMLogItemsdata = await manager.getCustomRepository(PackingBomLogRepository).find({ where: { saleOrderId: savedSaleOrderDto.saleOrderId, status: StatusEnum.OPEN } })
        existingpackingBOMLogItems
        if (existingpackingBOMLogItemsdata.length > 0) {
          for (const bomlogItem of existingpackingBOMLogItemsdata) {
            existingpackingBOMLogItems.push(bomlogItem.bomLogId)
          }
        }

      }
      console.log('existingBOMItems');
      console.log(existingBOMItems);


      const soitemBrandsData = await manager
        .getCustomRepository(SoItemRepository)
        .getSoItemBrandsData(savedSaleOrderDto.saleOrderId);
      if (soitemBrandsData.length > 0) {
        let savedSkewerBomEntity
        let savedBomEntity
        let brandPouchdepparameters = ''
        let brandCartondepparameters = ''
        let brandSkewerdepparameters = ''
        let brandPouchString
        let brandBapString
        let brandVariantString
        const soItemsPouchCombinations = await manager
          .getCustomRepository(SoItemRepository)
          .getSoItemBrandCombData(savedSaleOrderDto.saleOrderId, undefined);
        let bomqty
        let actualBomquantity

        const bomDetails: BomDetails[] = [];
        let index = 0
        let existingReqQty = 0
        let actualreqQty = 0
        let actualTrimreqQty = 0
        let existingBomQty = new Map<number, number>();
        let existingTrimBomQty = new Map<number, number>();
        let existingCartonBomQty = 0;
        let poCartonBomQty = 0;
        for (const soItemPouchdata of soItemsPouchCombinations) {


          index = index + 1;
          const brandsData = await this.masterBrandsService.getMasterBrandById({ brandId: soItemPouchdata.brandId })
          let itemPackingCategory = soItemPouchdata.category;
          if (
            soItemPouchdata.category ==
            PackTypeCategory.POUCH ||
            soItemPouchdata.category ==
            PackTypeCategory.SKEWERS
          ) {
            itemPackingCategory = PackingCategoryEnum.POUCH;
          }
          if (
            soItemPouchdata.category == PackTypeCategory.RING
          ) {
            itemPackingCategory = PackingCategoryEnum.RING;
          }
          if (
            soItemPouchdata.category == PackTypeCategory.PLATTER
          ) {
            itemPackingCategory = PackingCategoryEnum.PLATTER;
          }
          let pouchBapNo = undefined
          let pouchMinGrade = undefined
          let pouchMaxGrade = undefined
          let pouchvariant = undefined
          let pouchProduct = undefined
          let pouchFoodType = undefined
          let pouchvalAddOne = undefined
          let pouchvalAddTwo = undefined
          let pouchvalAddThree = undefined
          let pouchvalAddFour = undefined
          let pouchvalAddFive = undefined
          let pouchBrand = undefined
          let pouches = undefined
          let pouchWeight = undefined
          let RingOrPlattersize = undefined
          let pouchuomId = undefined

          if (soItemPouchdata.category ==
            PackTypeCategory.RING ||
            soItemPouchdata.category ==
            PackTypeCategory.PLATTER) {
            RingOrPlattersize = soItemPouchdata.sizeId
          }
          if (soItemPouchdata.category ==
            PackTypeCategory.POUCH ||
            soItemPouchdata.category ==
            PackTypeCategory.SKEWERS) {
            pouchBrand = soItemPouchdata.brandId
            pouches = soItemPouchdata.pouches
            pouchWeight = soItemPouchdata.pouchWeight
            pouchuomId = soItemPouchdata.uomId

            if (brandsData.isPouchBapNoConsider) {
              pouchBapNo = unitData.data.bapNo
            }

            if (brandsData.isPouchGradeConsider) {
              pouchMinGrade = soItemPouchdata.minGrade
              pouchMaxGrade = soItemPouchdata.maxGrade
            }
            if (brandsData.isPouchProductConsider) {
              pouchProduct = soItemPouchdata.productId
            } if (brandsData.isPouchFoodTypeConsider) {
              pouchFoodType = soItemPouchdata.foodTypeId
            } if (brandsData.isPouchValAddOneConsider) {
              pouchvalAddOne = soItemPouchdata.valAddOneId
            } if (brandsData.isPouchValAddTwoConsider) {
              pouchvalAddTwo = soItemPouchdata.valAddTwoId
            } if (brandsData.isPouchValAddThreeConsider) {
              pouchvalAddThree = soItemPouchdata.valAddThreeId
            } if (brandsData.isPouchValAddFourConsider) {
              pouchvalAddFour = soItemPouchdata.valAddFourId
            } if (brandsData.isPouchValAddFiveConsider) {
              pouchvalAddFive = soItemPouchdata.valAddFiveId
            }
          }
          let pouchitemResponse;
          const pouchItemDto = new ItemsDto(
            undefined,
            undefined,
            6,
            '',
            undefined,
            itemPackingCategory,
            pouchBrand,
            pouchvariant,
            pouchMinGrade,
            pouchMaxGrade,
            pouches,
            pouchWeight,
            RingOrPlattersize,
            undefined,
            undefined,
            true,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            pouchuomId,
            null,
            ItemCategoriesEnum.PACKING,
            pouchProduct,
            undefined,
            undefined,
            pouchBapNo,
            pouchFoodType,
            pouchvalAddOne,
            pouchvalAddTwo, pouchvalAddThree, pouchvalAddFour, pouchvalAddFive

          );
          console.log(pouchItemDto)
          pouchitemResponse = await this.itemService.createItem(pouchItemDto);
          const eachItem = await this.itemService.getPouchItemForBom(
            new BomItemRequest(
              itemPackingCategory,
              pouchMinGrade,
              pouchMaxGrade,
              soItemPouchdata.brandId,
              pouchvariant,
              soItemPouchdata.pouches,
              soItemPouchdata.pouchWeight,
              soItemPouchdata.uomId, RingOrPlattersize, brandsData, pouchFoodType, pouchvalAddOne, pouchvalAddTwo, pouchvalAddThree, pouchvalAddFour, pouchvalAddFive, pouchProduct, pouchBapNo
            )
          );

          //updating existing packing bom log item in SO update
          const existingBomLogPouchData = await manager.getCustomRepository(PackingBomLogRepository).findOne({ where: { saleOrderId: savedSaleOrderDto.saleOrderId, saleOrderItemId: soItemPouchdata.saleOrderItemId, itemId: eachItem.data.itemId } });
          let totCount
          totCount = await manager.getCustomRepository(PackingBomLogRepository).count()
          totCount = totCount + 1
          var refNumber = totCount + "";
          while (refNumber.length < 4) refNumber = "0" + refNumber;

          if (eachItem) {
            // SO item wise packing BOM log insertion
            const packingBomLogObj = new PackingBomLog();
            if (existingBomLogPouchData) {
              packingBomLogObj.bomLogId = existingBomLogPouchData.bomLogId;
            } else {
              packingBomLogObj.refNumber = totCount
              packingBomLogObj.barcode = 'productBarcode/' + refNumber
            }
            packingBomLogObj.saleOrderId = savedSaleOrderDto.saleOrderId
            packingBomLogObj.saleOrderItemId = soItemPouchdata.saleOrderItemId
            packingBomLogObj.itemId = eachItem.data.itemId
            packingBomLogObj.itemSubCategoryId = eachItem.data.itemSubCategoryId
            packingBomLogObj.quantity = soItemPouchdata.pouchQty
            const packBomLogSave = await manager.getCustomRepository(PackingBomLogRepository).save(packingBomLogObj);
            if (!packBomLogSave) {
              throw new ErrorResponse(
                5555,
                'Some thing went wrong in packing BOM saving'
              );
            }

            //getting existing stock for an item
            const stockData = await this.stockService.getInventoryStockQty(
              new StocktemRequest(undefined, eachItem.data.itemCategoryId, eachItem.data.itemId)
            );
            let existingQty = 0;
            if (stockData.status) {
              if (stockData.data.physicalQuantity > 0) {
                existingQty = stockData.data.physicalQuantity;
              }
            }
            console.log(soItemPouchdata)


            bomqty = soItemPouchdata.pouchQty;
            let isGrnBom = false;
            let isPoBom = false;
            let isQtyChanged = false
            let Grnbomqty = 0;
            const existingPouchData = await manager.getCustomRepository(BomRepository).findOne({ where: { saleOrderId: savedSaleOrderDto.saleOrderId, itemId: eachItem.data.itemId } });
            console.log('existingPouchDatafffffffffff')
            console.log(existingPouchData)
            let bomdata;
            let createbomdata;
            console.log('index')
            console.log(index)

            // if ((!isUpdate) ) {
            //   console.log('yesssssssss in')
            //   console.log(index)
            //   console.log(existingBOMItems)
            //   createbomdata = await manager
            //     .getCustomRepository(BomRepository)
            //     .findOne({
            //       where: {
            //         itemId: eachItem.data.itemId,
            //         saleOrderId: savedSaleOrderDto.saleOrderId,
            //         packingCategory: itemPackingCategory
            //       },
            //     });
            // }
            // if (!isUpdate ||
            //   (isUpdate &&
            //   saleOrderDto.status == SoStatusEnum.IN_PROGRESS)
            // ) {
            bomdata = await manager
              .getCustomRepository(BomRepository)
              .findOne({
                where: {
                  itemId: eachItem.data.itemId,
                  saleOrderId: savedSaleOrderDto.saleOrderId,
                },
              });
            // }
            const bomObj = new BomDetails();
            if (bomdata) {
              bomObj.packingMaterialId = bomdata.packingMaterialId;
            }
            presentBOMitems.push(eachItem.data.itemId)
            presentPackingBOMLogitems.push(packingBomLogObj.bomLogId)

            console.log('presentBOMitemsoooo')
            console.log(presentBOMitems)
            // let excessQty = Math.ceil(Number(bomqty) * (2 / 100))
            let excessQty = 0
            let excessBomQty = excessQty + (isGrnBom ? Number(Grnbomqty) : Number(bomqty));
            if (existingPouchData) {
              if (Number(bomqty < existingPouchData.quantity) || Number(bomqty > existingPouchData.quantity)) {
                isQtyChanged = true
              }
              console.log(existingReqQty)
              // existingReqQty = existingBomQty.get(eachItem.data.itemId)
              existingBomQty.set(eachItem.data.itemId, existingBomQty.get(eachItem.data.itemId) ? existingBomQty.get(eachItem.data.itemId) : 0)
              actualreqQty = excessQty + existingBomQty.get(eachItem.data.itemId) + Number(bomqty);
              existingBomQty.set(eachItem.data.itemId, actualreqQty)
              // existingReqQty = existingReqQty+actualreqQty
              console.log('existingBomQtyttkkkk')
              console.log(existingBomQty)
              console.log(existingReqQty)


              actualBomquantity = actualreqQty
              excessBomQty = actualreqQty
            } else {
              existingBomQty.set(eachItem.data.itemId, (excessQty + Number(bomqty)))
              // existingReqQty = existingBomQty.get(eachItem.data.itemId)+Number(bomqty)
              // actualreqQty = Number(existingBomQty.get(eachItem.data.itemId))+Number(bomqty)
              console.log('existingBomQty')
              console.log(existingBomQty)
              actualBomquantity = excessQty + Number(bomqty)
              excessBomQty = excessQty + Number(bomqty);
            }
            // if(saleOrderDto.status == SoStatusEnum.OPEN){
            //   actualBomquantity = excessQty + Number(bomqty)
            //   excessBomQty = excessQty +Number(bomqty);
            // }
            console.log(actualBomquantity)
            console.log(excessBomQty)


            // if (createbomdata) {
            //   bomObj.packingMaterialId = createbomdata.packingMaterialId
            //   excessBomQty = Number(createbomdata.quantity) + (excessBomQty);
            //   actualBomquantity = Number(createbomdata.quantity) + (actualBomquantity)
            // }
            if (isQtyChanged && saleOrderDto.status == SoStatusEnum.IN_PROGRESS) {
              bomObj.isQtyRevised = GlobalStatus.YES;
            }

            bomObj.saleOrderId = savedSaleOrderDto.saleOrderId;
            bomObj.itemId = eachItem.data.itemId;
            bomObj.itemCategoryId =
              eachItem.data.itemCategoryId;
            bomObj.itemSubCategoryId =
              eachItem.data.itemSubCategoryId;
            bomObj.size = eachItem.data.sizeId;
            bomObj.packingCategory = eachItem.data.packingCategory;
            bomObj.quantity = actualBomquantity;
            bomObj.avilableQuantity = existingQty;
            bomObj.requiredQuantity = excessBomQty;
            bomObj.isRequired = GlobalStatus.YES;
            savedBomEntity = await manager
              .getCustomRepository(BomRepository)
              .save(bomObj);
            bomDetails.push(bomObj);
          } else {
            throw new ErrorResponse(
              5555,
              'No packing material size mapping found in items with selected product propertiesss.'
            );
          }

          //carton item saving
          const soItemCartondata = soItemPouchdata
          let cartonBapNo = undefined
          let cartonMinGrade = undefined
          let cartonMaxGrade = undefined
          let cartonvariant = undefined
          let cartonProduct = undefined
          let cartonFoodType = undefined
          let cartonValAddOne = undefined
          let cartonValAddFive = undefined
          let cartonValAddTwo = undefined
          let cartonValAddThree = undefined
          let cartonValAddFour = undefined
          if (brandsData.isCartonBapNoConsider) {
            cartonBapNo = unitData.data.bapNo
          }
          if (brandsData.isCartonGradeConsider) {
            cartonMinGrade = soItemCartondata.minGrade
            cartonMaxGrade = soItemCartondata.maxGrade
          }
          if (brandsData.isCartonValAddOneConsider) {
            cartonValAddOne = soItemCartondata.valAddOneId
          }
          if (brandsData.isCartonValAddTwoConsider) {
            cartonValAddTwo = soItemCartondata.valAddTwoId
          }
          if (brandsData.isCartonValAddThreeConsider) {
            cartonValAddThree = soItemCartondata.valAddThreeId
          }
          if (brandsData.isCartonValAddFourConsider) {
            cartonValAddFour = soItemCartondata.valAddFourId
          }
          if (brandsData.isCartonValAddFiveConsider) {
            cartonValAddFive = soItemCartondata.valAddFiveId
          }
          if (brandsData.isCartonFoodTypeConsider) {
            cartonFoodType = soItemCartondata.foodTypeId
          }
          if (brandsData.isCartonProductConsider) {
            cartonProduct = soItemCartondata.productId
          }
          // if(brandsData.isCartonVariantConsider){
          //   cartonvariant = soItemCartondata.varientId
          // }
          let cartonItemResponse
          const catonItemDto = new ItemsDto(
            undefined,
            undefined,
            undefined,
            '',
            undefined,
            PackingCategoryEnum.CARTON,
            soItemCartondata.brandId,
            cartonvariant,
            cartonMinGrade,
            cartonMaxGrade,
            soItemCartondata.pouches,
            soItemCartondata.pouchWeight,
            undefined,
            undefined,
            undefined,
            true,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            soItemCartondata.uomId,
            null,
            ItemCategoriesEnum.PACKING, cartonProduct, undefined, undefined, cartonBapNo, cartonFoodType, cartonValAddOne, cartonValAddTwo, cartonValAddThree, cartonValAddFour, cartonValAddFive
          );
          cartonItemResponse = await this.itemService.createItem(catonItemDto);
          console.log('cartonItemResponse')
          console.log(cartonItemResponse)

          //getting bom pouch item
          // const eachItem = cartonItemResponse.data 
          const eachCartonItem = await this.itemService.getPouchItemForBom(
            new BomItemRequest(
              PackingCategoryEnum.CARTON,
              cartonMinGrade,
              cartonMaxGrade,
              soItemCartondata.brandId,
              cartonvariant,
              soItemCartondata.pouches,
              soItemCartondata.pouchWeight,
              soItemCartondata.uomId, undefined, brandsData, cartonFoodType, cartonValAddOne, cartonValAddTwo, cartonValAddThree, cartonValAddFour, cartonValAddFive, cartonProduct, cartonBapNo
            )
          );
          console.log('eachCartonItem')
          console.log(eachCartonItem)

          const existingBomLogCartonData = await manager.getCustomRepository(PackingBomLogRepository).findOne({ where: { saleOrderId: savedSaleOrderDto.saleOrderId, saleOrderItemId: soItemCartondata.saleOrderItemId, itemId: eachCartonItem.data.itemId } });
          let totCartonCount
          totCartonCount = await manager.getCustomRepository(PackingBomLogRepository).count()
          totCartonCount = totCartonCount + 1
          var refNumber = totCartonCount + "";
          while (refNumber.length < 4) refNumber = "0" + refNumber;

          if (eachCartonItem) {
            //saving so item wise carton item in packing bom log
            const packingCartonBomLogObj = new PackingBomLog();
            if (existingBomLogCartonData) {
              packingCartonBomLogObj.bomLogId = existingBomLogCartonData.bomLogId
            } else {
              packingCartonBomLogObj.refNumber = totCartonCount
              packingCartonBomLogObj.barcode = 'productBarcode/' + refNumber
            }
            packingCartonBomLogObj.saleOrderId = savedSaleOrderDto.saleOrderId
            packingCartonBomLogObj.saleOrderItemId = soItemCartondata.saleOrderItemId
            packingCartonBomLogObj.itemId = eachCartonItem.data.itemId
            packingCartonBomLogObj.itemSubCategoryId = eachCartonItem.data.itemSubCategoryId
            packingCartonBomLogObj.quantity = soItemCartondata.caseQty
            const packCartonBomLogSave = await manager.getCustomRepository(PackingBomLogRepository).save(packingCartonBomLogObj);
            if (!packCartonBomLogSave) {
              throw new ErrorResponse(
                5555,
                'Some thing went wrong in packing Carton BOM saving'
              );
            }
            //getting existing stock for an item
            const stockData = await this.stockService.getInventoryStockQty(
              new StocktemRequest(undefined, eachCartonItem.data.itemCategoryId, eachCartonItem.data.itemId)
            );
            let existingQty = 0;
            if (stockData.status) {
              if (stockData.data.physicalQuantity > 0) {
                existingQty = stockData.data.physicalQuantity;
              }
            }
            let Grncartonbomqty
            let iscartonGrnBom = false
            let isCartonPoBom = false
            let iscartonQtyChanged = false

            bomqty = soItemCartondata.caseQty;
            const existingCartonData = await manager.getCustomRepository(BomRepository).findOne({ where: { saleOrderId: savedSaleOrderDto.saleOrderId, itemId: eachCartonItem.data.itemId } });
            // if(existingCartonData){
            //   if(Number(bomqty) < Number(existingCartonData.quantity) || Number(bomqty) > Number(existingCartonData.quantity)){
            //     iscartonQtyChanged = true
            //   }
            //   if(Number(existingCartonData.receivedQuantity) > 0 && Number(existingCartonData.receivedQuantity) > Number(bomqty)){
            //     Grncartonbomqty = 0;
            //     iscartonGrnBom = true
            //   }
            //   console.log(Number(existingCartonData.receivedQuantity))
            //   console.log(Number(existingCartonData.receivedQuantity))
            //   console.log(Number(bomqty))

            //   if(Number(existingCartonData.receivedQuantity) > 0 && (Number(existingCartonData.receivedQuantity) <= Number(bomqty))){
            //     console.log('receiveee')
            //     Grncartonbomqty = Number(bomqty)-Number(existingCartonData.receivedQuantity);
            //     iscartonGrnBom = true
            //   }
            //   if(existingCartonData.status == StatusEnum.PO && eachItem.data.packingCategory == PackingCategoryEnum.CARTON){
            //     poCartonBomQty = Number(poCartonBomQty)+Number(bomqty);
            //     isCartonPoBom = true
            //   }
            // }
            console.log(Grncartonbomqty)


            let bomdata;
            let createcartonbomdata;
            console.log('existingBOMItemdddddddddddds')
            console.log(existingBOMItems)
            console.log(eachCartonItem.data.itemId)
            console.log(bomqty)
            // console.log(existingCartonData.quantity)

            // if ((!isUpdate)) {
            //   console.log('yes in')
            //   createcartonbomdata = await manager
            //     .getCustomRepository(BomRepository)
            //     .findOne({
            //       where: {
            //         itemId: eachCartonItem.data.itemId,
            //         saleOrderId: savedSaleOrderDto.saleOrderId,
            //         packingCategory: PackingCategoryEnum.CARTON
            //       },
            //     });
            // }
            // if (
            //   isUpdate &&
            //   saleOrderDto.status == SoStatusEnum.IN_PROGRESS
            // ) {
            bomdata = await manager
              .getCustomRepository(BomRepository)
              .findOne({
                where: {
                  itemId: eachCartonItem.data.itemId,
                  saleOrderId: savedSaleOrderDto.saleOrderId,
                },
              });
            // }
            presentBOMitems.push(eachCartonItem.data.itemId)
            presentPackingBOMLogitems.push(packingCartonBomLogObj.bomLogId)
            const bomObj = new BomDetails();
            if (bomdata) {
              bomObj.packingMaterialId = bomdata.packingMaterialId;
            }


            // let excessQty = Math.ceil(Number(bomqty) * (2 / 100))
            let excessQty = 0
            actualBomquantity = excessQty + Number(bomqty)
            let excessBomQty = excessQty + (iscartonGrnBom ? Number(Grncartonbomqty) : Number(bomqty));
            if (existingCartonData) {
              if (Number(bomqty < existingCartonData.quantity) || Number(bomqty > existingCartonData.quantity)) {
                iscartonQtyChanged = true
              }
              existingBomQty.set(eachCartonItem.data.itemId, existingBomQty.get(eachCartonItem.data.itemId) ? existingBomQty.get(eachCartonItem.data.itemId) : 0)
              console.log(existingBomQty);
              console.log('existingBomQtyffffffffffff');
              actualreqQty = excessQty + existingBomQty.get(eachCartonItem.data.itemId) + Number(bomqty);
              existingBomQty.set(eachCartonItem.data.itemId, actualreqQty)
              console.log(existingBomQty);


              actualBomquantity = actualreqQty
              excessBomQty = actualreqQty
            } else {
              existingBomQty.set(eachCartonItem.data.itemId, (excessQty + Number(bomqty)))
              // existingReqQty = existingBomQty.get(eachItem.data.itemId)+Number(bomqty)
              // actualreqQty = Number(existingBomQty.get(eachItem.data.itemId))+Number(bomqty)
              console.log('existingBomQty')
              console.log(existingBomQty)
              // existingCartonBomQty =  excessQty + Number(bomqty)
              actualBomquantity = excessQty + Number(bomqty)
              excessBomQty = excessQty + Number(bomqty);
            }
            // if(saleOrderDto.status == SoStatusEnum.OPEN){
            //   actualBomquantity = excessQty + Number(bomqty)
            //   excessBomQty = excessQty +Number(bomqty);
            // }
            // if (createcartonbomdata) {
            //   console.log('yes for carton')
            //   bomObj.packingMaterialId = createcartonbomdata.packingMaterialId
            //   excessBomQty = Number(createcartonbomdata.quantity) + (excessQty + (iscartonGrnBom? Number(Grncartonbomqty):Number(bomqty)))
            //   actualBomquantity = Number(createcartonbomdata.quantity) + (excessQty + Number(bomqty))

            // }
            if (iscartonQtyChanged && saleOrderDto.status == SoStatusEnum.IN_PROGRESS) {
              bomObj.isQtyRevised = GlobalStatus.YES;
            }

            bomObj.saleOrderId = savedSaleOrderDto.saleOrderId;
            bomObj.itemId = eachCartonItem.data.itemId;
            bomObj.itemCategoryId =
              eachCartonItem.data.itemCategoryId;
            bomObj.itemSubCategoryId =
              eachCartonItem.data.itemSubCategoryId;
            bomObj.size = eachCartonItem.data.sizeId;
            bomObj.packingCategory = eachCartonItem.data.packingCategory;
            bomObj.quantity = actualBomquantity;
            bomObj.avilableQuantity = existingQty;
            bomObj.requiredQuantity = excessBomQty;
            bomObj.isRequired = GlobalStatus.YES;
            // if(existingQty < excessBomQty){
            //   bomObj.requiredQuantity = excessBomQty - existingQty;
            // }else{
            //   bomObj.requiredQuantity = 0;
            // }
            savedBomEntity = await manager
              .getCustomRepository(BomRepository)
              .save(bomObj);
            bomDetails.push(bomObj);
          } else {
            throw new ErrorResponse(
              5555,
              'No packing material size mapping found in items with selected product properties.'
            );
          }

          //skewer saving
          if (soItemPouchdata.category == PackTypeCategory.SKEWERS) {
            const skewerItem = soItemPouchdata;
            let skewerBapNo = undefined
            let skewerMinGrade = undefined
            let skewerMaxGrade = undefined
            let skewervariant = undefined
            let skewerProduct = undefined
            let skewerFoodType = undefined
            let skewerValaddOne = undefined
            let skewerValaddTwo = undefined
            let skewerValaddThree = undefined
            let skewerValaddFour = undefined
            let skewerValaddFive = undefined
            // if (brandsData.isPouchBapNoConsider) {
            //   skewerBapNo = unitData.data.fdaRegNumber
            // }
            // if (brandsData.isPouchGradeConsider) {
            //   skewerMinGrade = skewerItem.minGrade
            //   skewerMaxGrade = skewerItem.maxGrade
            // }
            console.log('bappp')
            console.log(skewerBapNo)
            // if (brandsData.isPouchProductConsider) {
            //   skewerProduct = skewerItem.productId
            // } if (brandsData.isPouchFoodTypeConsider) {
            //   skewerFoodType = skewerItem.foodTypeId
            // } if (brandsData.isPouchValAddOneConsider) {
            //   skewerValaddOne = skewerItem.valAddOneId
            // } if (brandsData.isPouchValAddTwoConsider) {
            //   skewerValaddTwo = skewerItem.valAddTwoId
            // } if (brandsData.isPouchValAddThreeConsider) {
            //   skewerValaddThree = skewerItem.valAddThreeId
            // } if (brandsData.isPouchValAddFourConsider) {
            //   skewerValaddFour = skewerItem.valAddFourId
            // } if (brandsData.isPouchValAddFiveConsider) {
            //   skewerValaddFive = skewerItem.valAddFiveId
            // }
            // if(brandsData.isPouchVariantConsider){
            //   skewervariant = skewerItem.varientId
            // }
            // console.log(skewerItem.itemId)
            const skewerItemDto = new ItemsDto(
              undefined,
              undefined,
              undefined,
              '',
              undefined,
              PackingCategoryEnum.SKEWER,
              undefined,
              skewervariant,
              skewerMinGrade,
              skewerMaxGrade,
              undefined,
              undefined,
              skewerItem.sizeId,
              undefined,
              undefined,
              true,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              null,
              ItemCategoriesEnum.PACKING, skewerProduct, undefined, undefined, skewerBapNo, skewerFoodType, skewerValaddOne, skewerValaddTwo, skewerValaddThree, skewerValaddFour, skewerValaddFive
            );
            const skewerItemResponse = await this.itemService.createItem(skewerItemDto);
            const itemDetails = await this.itemService.getPouchItemForBom(
              new BomItemRequest(
                PackingCategoryEnum.SKEWER,
                skewerMinGrade,
                skewerMaxGrade,
                skewerItem.brandId,
                skewervariant,
                skewerItem.pouches,
                skewerItem.pouchWeight,
                skewerItem.uomId,
                skewerItem.sizeId,
                brandsData, skewerFoodType, skewerValaddOne, skewerValaddTwo, skewerValaddThree, skewerValaddFour, skewerValaddFive, skewerProduct
              )
            );
            console.log('itemsssss' + itemDetails);

            const existingBomLogSkwerData = await manager.getCustomRepository(PackingBomLogRepository).findOne({ where: { saleOrderId: savedSaleOrderDto.saleOrderId, saleOrderItemId: skewerItem.saleOrderItemId, itemId: itemDetails.data.itemId } });
            let totskewerCount
            totskewerCount = await manager.getCustomRepository(PackingBomLogRepository).count()
            totskewerCount = totskewerCount + 1
            var refNumber = totskewerCount + "";
            while (refNumber.length < 4) refNumber = "0" + refNumber;
            if (itemDetails) {
              //saving so item wise carton item in packing bom log
              const packingSkewerBomLogObj = new PackingBomLog();
              if (existingBomLogSkwerData) {
                packingSkewerBomLogObj.bomLogId = existingBomLogSkwerData.bomLogId
              } else {
                packingSkewerBomLogObj.refNumber = totskewerCount
                packingSkewerBomLogObj.barcode = 'productBarcode/' + refNumber
              }
              packingSkewerBomLogObj.saleOrderId = savedSaleOrderDto.saleOrderId
              packingSkewerBomLogObj.saleOrderItemId = skewerItem.saleOrderItemId
              packingSkewerBomLogObj.itemId = itemDetails.data.itemId
              packingSkewerBomLogObj.itemSubCategoryId = itemDetails.data.itemSubCategoryId
              packingSkewerBomLogObj.quantity = skewerItem.skewerQty
              const packCartonBomLogSave = await manager.getCustomRepository(PackingBomLogRepository).save(packingSkewerBomLogObj);
              if (!packCartonBomLogSave) {
                throw new ErrorResponse(
                  5555,
                  'Some thing went wrong in packing Skewer BOM saving'
                );
              }
              const stockData = await this.stockService.getInventoryStockQty(
                new StocktemRequest(
                  // itemDetails.data.saleOrderId,
                  undefined,
                  itemDetails.data.itemCategoryId,
                  itemDetails.data.itemId
                )
              );
              let skewerBomData;
              let Grnskewerbomqty
              let createskewerbomdata;
              let isSkewerQtyChanged
              const existingSkewerData = await manager.getCustomRepository(BomRepository).findOne({ where: { saleOrderId: saleOrderDto.saleOrderId, itemId: itemDetails.data.itemId } });
              let isSkewerReducedQty = false;
              let isSkewerIncreasedQty = false;
              let excessSkwrQty = 0
              let excessQty = 0
              let actualSkewerQty
              skewerBomData = await manager
                .getCustomRepository(BomRepository)
                .findOne({
                  itemId: itemDetails.data.itemId,
                  saleOrderId: savedSaleOrderDto.saleOrderId,
                });
              // }
              let SkewerexistingQty = 0;
              if (stockData.status) {
                // console.log(stockData)
                if (stockData.data.physicalQuantity > 0) {
                  SkewerexistingQty = stockData.data.physicalQuantity;
                }
              }
              presentBOMitems.push(itemDetails.data.itemId)
              presentPackingBOMLogitems.push(packingSkewerBomLogObj.bomLogId)


              // let excessSkwrQty = Math.ceil((Number(skewerItem.skewerQty) * 2) / 100)
              actualSkewerQty = excessSkwrQty + Number(skewerItem.skewerQty);
              let excessSkewerQty =
                excessSkwrQty + Number(skewerItem.skewerQty);
              console.log('itemsssssabc' + itemDetails.data);

              const bomSkewerObj = new BomDetails();
              if (skewerBomData) {
                bomSkewerObj.packingMaterialId =
                  skewerBomData.packingMaterialId;
              }
              if (existingSkewerData) {
                if (Number(skewerItem.skewerQty < existingSkewerData.quantity) || Number(skewerItem.skewerQty > existingSkewerData.quantity)) {
                  isSkewerQtyChanged = true
                }
                existingBomQty.set(itemDetails.data.itemId, existingBomQty.get(itemDetails.data.itemId) ? existingBomQty.get(itemDetails.data.itemId) : 0)
                actualreqQty = excessSkwrQty + existingBomQty.get(itemDetails.data.itemId) + Number(skewerItem.skewerQty);
                existingBomQty.set(itemDetails.data.itemId, actualreqQty)
                actualSkewerQty = actualreqQty
                excessSkewerQty = actualreqQty
              } else {
                existingBomQty.set(itemDetails.data.itemId, (excessQty + Number(skewerItem.skewerQty)))
                console.log('existingBomQty')
                console.log(existingBomQty)
                actualSkewerQty = excessSkwrQty + Number(skewerItem.skewerQty)
                excessSkewerQty = excessSkwrQty + Number(skewerItem.skewerQty);
              }

              if (isSkewerQtyChanged && saleOrderDto.status == SoStatusEnum.IN_PROGRESS) {
                bomSkewerObj.isQtyRevised = GlobalStatus.YES;
              }
              bomSkewerObj.saleOrderId = savedSaleOrderDto.saleOrderId;
              bomSkewerObj.itemId = itemDetails.data.itemId;
              bomSkewerObj.itemCategoryId =
                itemDetails.data.itemCategoryId;
              bomSkewerObj.itemSubCategoryId =
                itemDetails.data.itemSubCategoryId;
              bomSkewerObj.size = itemDetails.data.sizeId;
              bomSkewerObj.packingCategory = itemDetails.data.packingCategory;
              bomSkewerObj.quantity = actualSkewerQty;
              bomSkewerObj.avilableQuantity = SkewerexistingQty;
              bomSkewerObj.requiredQuantity = excessSkewerQty;
              bomSkewerObj.isRequired = GlobalStatus.YES;
              savedSkewerBomEntity = await manager
                .getCustomRepository(BomRepository)
                .save(bomSkewerObj);
            } else {
              throw new ErrorResponse(
                5555,
                'No skewer size mapped packing materials found in Items.'
              );
            }
          }
          //Trims BOM generation
          console.log('trimsstarts')
          const trimsData = await this.trimsmappingService.getTrimsData(new TrimsMappingRequset(soItemPouchdata.brandId, soItemPouchdata.packStyleId, soItemPouchdata.varientId, saleOrderDto.soInvDetailsInfo.endCustomerId))
          console.log('trimsData')
          console.log(trimsData)
          if (trimsData.status) {
            const BOMGeneration = await this.TrimsBOMGenaration(trimsData.data, savedSaleOrderDto.saleOrderId, soItemPouchdata.saleOrderItemId, soItemPouchdata.pouchQty, soItemPouchdata.caseQty, manager, isUpdate, actualTrimreqQty, existingTrimBomQty, soItemPouchdata.skewerQty, soItemPouchdata.category)
            console.log(BOMGeneration)
          }
          // else{
          //   throw new ErrorResponse(
          //     5555,
          //     'No Trims Found.'
          //   );
          // }


        }



        if (isUpdate) {
          const bomdata = await manager.getCustomRepository(BomRepository).find({ where: { saleOrderId: savedSaleOrderDto.saleOrderId, packingCategory: Not(IsNull()) } })
          if (bomdata) {
            let updateflagSet = new Set<boolean>()
            for (const bomItem of bomdata) {
              if (bomItem.receivedQuantity > 0) {
                const reqQuantity = (Number(bomItem.quantity) > (Number(bomItem.receivedQuantity) - Number(bomItem.avilableQuantity))) ? Number(bomItem.quantity) - (Number(bomItem.receivedQuantity) - Number(bomItem.avilableQuantity)) : 0
                let bomstatus = bomItem.status
                if (bomItem.status == StatusEnum.CLOSED && bomItem.quantity > bomItem.receivedQuantity) {
                  bomstatus = StatusEnum.OPEN
                  if (bomItem.poQty > 0 && bomItem.receivedQuantity > 0) {
                    bomstatus = StatusEnum.GRN
                  }
                  if (bomItem.poQty > 0 && bomItem.receivedQuantity <= 0) {
                    bomstatus = StatusEnum.PO
                  }
                }
                if (bomItem.status != StatusEnum.CLOSED && bomItem.quantity <= bomItem.receivedQuantity) {
                  bomstatus = StatusEnum.CLOSED
                }
                const updateReqQty = await manager.getCustomRepository(BomRepository).update({ saleOrderId: bomItem.saleOrderId, itemId: bomItem.itemId }, { requiredQuantity: reqQuantity, status: bomstatus })
                if (updateReqQty.affected) {
                  updateflagSet.add(true)
                } else {
                  updateflagSet.add(false)
                }
              } else {
                updateflagSet.add(true)
              }
            }
            if (!updateflagSet) {
              throw new ErrorResponse(1111, 'Something went wrong in BOM required Quantity updation')
            }
          }

          //packing bom log quantities and status updation while update SO
          const packingbomlogdata = await manager.getCustomRepository(PackingBomLogRepository).find({ where: { saleOrderId: savedSaleOrderDto.saleOrderId } })
          if (bomdata) {
            let packingbomlogflagSet = new Set<boolean>()
            for (const packingBomItem of packingbomlogdata) {
              if ((packingBomItem.grnQuantity + packingBomItem.assignedQuantity) > 0) {
                const reqQuantity = (Number(packingBomItem.quantity) > (Number(packingBomItem.grnQuantity) + Number(packingBomItem.assignedQuantity))) ? Number(packingBomItem.quantity) - ((Number(packingBomItem.grnQuantity) - Number(packingBomItem.assignedQuantity))) : 0
                let packingbomslogtatus = packingBomItem.status
                if (packingBomItem.quantity > (packingBomItem.grnQuantity + packingBomItem.assignedQuantity)) {

                  if (packingBomItem.assignedQuantity > 0 && packingBomItem.poQuantity <= 0 && packingBomItem.grnQuantity > 0) {
                    packingbomslogtatus = PackingBOMStatusEnum.BULK
                  }
                  if (packingBomItem.poQuantity > 0 && packingBomItem.grnQuantity > 0 && packingBomItem.assignedQuantity <= 0) {
                    packingbomslogtatus = PackingBOMStatusEnum.GRN
                  }
                  if (packingBomItem.poQuantity > 0 && packingBomItem.grnQuantity <= 0 && packingBomItem.assignedQuantity <= 0) {
                    packingbomslogtatus = PackingBOMStatusEnum.PO
                  }
                  if (packingBomItem.poQuantity > 0 && packingBomItem.grnQuantity > 0 && packingBomItem.assignedQuantity > 0) {
                    packingbomslogtatus = PackingBOMStatusEnum.BULK
                  }
                }
                if (packingBomItem.quantity <= (packingBomItem.grnQuantity + packingBomItem.assignedQuantity)) {
                  packingbomslogtatus = PackingBOMStatusEnum.BULK
                }
                const updatepackingbomLogReqQty = await manager.getCustomRepository(PackingBomLogRepository).update({ saleOrderId: packingBomItem.saleOrderId, itemId: packingBomItem.itemId, saleOrderItemId: packingBomItem.saleOrderItemId }, { status: packingbomslogtatus })
                if (updatepackingbomLogReqQty.affected) {
                  packingbomlogflagSet.add(true)
                } else {
                  packingbomlogflagSet.add(false)
                }
              } else {
                packingbomlogflagSet.add(true)
              }
            }
            if (!packingbomlogflagSet) {
              throw new ErrorResponse(1111, 'Something went wrong in BOM required Quantity updation')
            }
          }
        }

        //   const soItemsCartonCombinations = await manager
        //   .getCustomRepository(SoItemRepository)
        //   .getSoItemBrandCombData(savedSaleOrderDto.saleOrderId,brandCartondepparameters);
        //   for(const soItemCartondata of soItemsCartonCombinations){

        // }

        // const brandSkewerdepparameters = 'pack_style,skewer_size_item_id';
        // if (saleOrderDto.soInvDetailsInfo.category == PackTypeCategory.SKEWERS) {
        //   const soItemsSkewerCombinations = await manager
        //   .getCustomRepository(SoItemRepository)
        //   .getSoItemBrandCombData(savedSaleOrderDto.saleOrderId,brandSkewerdepparameters);
        //   savedSkewerBomEntity;

        //   for (const skewerItem of soItemsSkewerCombinations) {

        //   }


        // }




        // }
        let itemIdDiffIds = []
        if (existingBOMItems.length > 0) {
          itemIdDiffIds = existingBOMItems.filter(x => presentBOMitems.indexOf(x) === -1);
          if (itemIdDiffIds.length > 0) {
            const BomdataUpdate = await manager.getCustomRepository(BomRepository).update({ saleOrderId: savedSaleOrderDto.saleOrderId, itemId: In(itemIdDiffIds) }, { isActive: false, isActiveRevised: GlobalStatus.YES, isRequired: GlobalStatus.NO })
            if (BomdataUpdate.affected) {
              const BomInactivedataUpdate = await manager.getCustomRepository(BomRepository).update({ saleOrderId: savedSaleOrderDto.saleOrderId, itemId: In(presentBOMitems), isActive: false }, { isActive: true, isActiveRevised: GlobalStatus.YES, isRequired: GlobalStatus.YES })
              // if(!BomInactivedataUpdate.affected){
              //   throw new ErrorResponse(11106, 'BOM not activated for revised items!');
              // }
            } else {
              throw new ErrorResponse(11106, 'BOM not deactivated for revised items!');
            }
          }
          // let revisedItemIds = []
          // revisedItemIds = existingBOMItems.filter(x => itemIdDiffIds.indexOf(x) === -1);
          // if(revisedItemIds.length > 0){
          //   const BomdataReviseItemUpdate = await manager.getCustomRepository(BomRepository).update({saleOrderId:savedSaleOrderDto.saleOrderId,itemId:In(revisedItemIds)},{isQtyRevised:GlobalStatus.YES})
          //   if(!BomdataReviseItemUpdate.affected){
          //     throw new ErrorResponse(11106, 'BOM revised status not updated for revised items!');
          //   }
          // }
        }

        let packingBomlogitemIdDiffIds;
        if (existingpackingBOMLogItems.length > 0) {
          console.log('yes greater')
          packingBomlogitemIdDiffIds = existingpackingBOMLogItems.filter(x => presentPackingBOMLogitems.indexOf(x) === -1);
          console.log(packingBomlogitemIdDiffIds)

          if (packingBomlogitemIdDiffIds.length > 0) {
            const BomdataUpdate = await manager.getCustomRepository(PackingBomLogRepository).update({ saleOrderId: savedSaleOrderDto.saleOrderId, bomLogId: In(packingBomlogitemIdDiffIds) }, { isActive: false })
            if (BomdataUpdate.affected) {
              const BomLogInactivedataUpdate = await manager.getCustomRepository(PackingBomLogRepository).update({ bomLogId: In(presentPackingBOMLogitems), isActive: false }, { isActive: true })
            } else {
              throw new ErrorResponse(11106, 'Packing BOM Log not deactivated for revised items!');
            }
          }
        }

        console.log('presentBOMitems');
        console.log(presentBOMitems);
        console.log('itemIdDiffIds');
        console.log(itemIdDiffIds);
        //8888888888
        //getting data from so items against item id for category skewer  to map these with item masters and to save the required qty of material in BomDetails for only skewer  packing category

        if (savedSkewerBomEntity || savedBomEntity) {
          console.log(savedBomEntity.sale_order_id+'999999999999')
          await manager.completeTransaction();
          const response = new SaleOrderResponse(
            true,
            isUpdate ? 11100 : 11101,
            isUpdate
              ? 'Sale order Updated Successfully'
              : 'Sale order Created Successfully',
            savedSaleOrderDto
          );

          const name=isUpdate?'updated':'created'
            // const newLogDto = new LogsDto(1,name, 'SaleOrder', savedBomEntity.saleOrderId, true, '','','', savedBomEntity.createdUser)
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
          return response;
        } else {
          throw new ErrorResponse(11106, 'Something Went wrong!');
        }
      } else {
        throw new ErrorResponse(11106, 'Brands Not found');
      }
    } catch (error) {
      await manager.releaseTransaction();

      throw error;
    }
  }

  async TrimsBOMGenaration(trimsdata: TrimsItemsRequest[], soId: number, soItemId: number, soItemPouchQty: number, soItemCartonQty: number, manager, isUpdate: boolean, actualTrimreqQty: number, existingTrimBomQty, soItemSkewerQty: number, category: string) {
    let actualTrimBomquantity
    const saveFlag = new Set<boolean>()
    for (const trimsdataRecord of trimsdata) {
      console.log('trimsdataRecord')
      console.log(trimsdataRecord)
      const packingBomLogObj = new PackingBomLog();
      const getExistingpackingBomTrim = await manager.getCustomRepository(PackingBomLogRepository).findOne({ where: { saleOrderId: soId, saleOrderItemId: soItemId, itemId: trimsdataRecord.itemId } })
      let totTrimCount
      totTrimCount = await manager.getCustomRepository(PackingBomLogRepository).count()
      totTrimCount = totTrimCount + 1
      var refNumber = totTrimCount + "";
      while (refNumber.length < 4) refNumber = "0" + refNumber;
      if (getExistingpackingBomTrim) {
        packingBomLogObj.bomLogId = getExistingpackingBomTrim.bomLogId
      } else {
        packingBomLogObj.refNumber = totTrimCount
        packingBomLogObj.barcode = 'productBarcode/' + refNumber
      }
      packingBomLogObj.saleOrderId = soId
      packingBomLogObj.saleOrderItemId = soItemId
      packingBomLogObj.itemId = trimsdataRecord.itemId
      packingBomLogObj.itemSubCategoryId = trimsdataRecord.subcategoryId
      let trimsBomquantity
      if (trimsdataRecord.AgainstTo == 'Pouch' && category == PackTypeCategory.POUCH) {
        trimsBomquantity = trimsdataRecord.numberOfTrims * soItemPouchQty
      }
      if (trimsdataRecord.AgainstTo == 'Ring' && category == PackTypeCategory.RING) {
        trimsBomquantity = trimsdataRecord.numberOfTrims * soItemPouchQty
      }
      if (trimsdataRecord.AgainstTo == 'Carton') {
        trimsBomquantity = trimsdataRecord.numberOfTrims * soItemCartonQty
      }
      if (trimsdataRecord.AgainstTo == 'Skewer' && category == PackTypeCategory.SKEWERS) {
        trimsBomquantity = trimsdataRecord.numberOfTrims * soItemSkewerQty
      }
      if (trimsBomquantity > 0) {
        packingBomLogObj.quantity = trimsBomquantity
        const trimsave1 = await manager.getCustomRepository(PackingBomLogRepository).save(packingBomLogObj);
        if (trimsave1) {
          let excessTrimQty = 0
          const getExistingTrim = await manager.getCustomRepository(BomRepository).findOne({ where: { saleOrderId: soId, itemId: trimsdataRecord.itemId } })

          const trimBomObj = new BomDetails();
          if (getExistingTrim) {
            trimBomObj.packingMaterialId = getExistingTrim.packingMaterialId;
            existingTrimBomQty.set(trimsdataRecord.itemId, existingTrimBomQty.get(trimsdataRecord.itemId) ? existingTrimBomQty.get(trimsdataRecord.itemId) : 0)
            actualTrimreqQty = excessTrimQty + existingTrimBomQty.get(trimsdataRecord.itemId) + Number(trimsBomquantity);
            existingTrimBomQty.set(trimsdataRecord.itemId, actualTrimreqQty)
            actualTrimBomquantity = actualTrimreqQty
            let excessTrimBomQty = actualTrimreqQty
            trimsBomquantity = Number(trimsBomquantity) + Number(getExistingTrim.quantity)
          } else {
            existingTrimBomQty.set(trimsdataRecord.itemId, (excessTrimQty + Number(trimsBomquantity)))
            actualTrimBomquantity = excessTrimQty + Number(trimsBomquantity)
            let excessTrimBomQty = excessTrimQty + Number(trimsBomquantity);
          }
          trimBomObj.saleOrderId = soId;
          trimBomObj.itemId = trimsdataRecord.itemId;
          trimBomObj.itemCategoryId =
            6;
          trimBomObj.itemSubCategoryId =
            trimsdataRecord.subcategoryId;
          trimBomObj.size = 8;
          trimBomObj.packingCategory = PackingCategoryEnum.TRIM;
          trimBomObj.quantity = actualTrimBomquantity;
          // trimBomObj.avilableQuantity = existingQty;
          trimBomObj.requiredQuantity = actualTrimBomquantity;
          trimBomObj.isRequired = GlobalStatus.YES;
          const savedBomEntity = await manager
            .getCustomRepository(BomRepository)
            .save(trimBomObj);
          if (savedBomEntity) {
            saveFlag.add(true)
          } else {
            saveFlag.add(false)
          }

        } else {
          throw new ErrorResponse(11106, 'Something Went wrong!');
        }
      }
    }
    if (!saveFlag.has(false)) {
      return new CommonResponse(true, 1111, 'data saved', undefined);
    } else {
      throw new ErrorResponse(11106, 'Something Went wrong in Trim BOM insertion!');
    }
  }

  /**
   *
   * @param filePath
   * @param saleOrderId
   * @returns
   */
  async updatePath(
    filePath: string,
    saleOrderId: number
  ): Promise<SaleOrderFileUploadResponse> {
    const filePathUpdate = await this.soRepo.update(
      { saleOrderId: saleOrderId },
      { filePath: filePath }
    );
    if (filePathUpdate.affected > 0) {
      return new SaleOrderFileUploadResponse(
        true,
        11,
        'uploaded successfully',
        filePath
      );
    }
  }

  async getSaleOrdersDropDownList(): Promise<SaleOrderDropDownResponseModel> {
    try {
      // const saleOrderDropDownDto: SaleOrderDropDownDto[] = [];
      //retrieves all companies
      const SaleOrder: SaleOrderDropDownDto[] = await this.soRepo
        .createQueryBuilder('SaleOrder')
        .select('SaleOrder.sale_order_id as saleOrderId, SaleOrder.sale_order_no as saleOrderNumber,SoInvDetailsInfo.po_number as poNumber')
        .leftJoin('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .where(`SoInvDetailsInfo.is_sub_contract='${GlobalStatus.NO}' and SoInvDetailsInfo.job_type!='${JobTypesEnum.SUB_JOB}'`)
        .orderBy('SoInvDetailsInfo.po_number', 'ASC')
        .getRawMany();
      // console.log(SaleOrder);
      if (SaleOrder) {
        // saleOrderDropDownDto.push(SaleOrder);
        const response = new SaleOrderDropDownResponseModel(
          true,
          1,
          'Sale orders retrieved successfully',
          SaleOrder
        );
        // const newLogDto = new LogsDto(1,'view Sale Orders in Bomb Tracker', 'SaleOrder', 0, true, '','')
        // let res = await this.logService.createLog(newLogDto);
        // console.log(res);
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
  async getAllSaleOrdersDetails(): Promise<AllSaleOrdersDetailsResponseModel> {
    try {
      const saleOrderDto: AllSaleOrdersDto[] = [];
      const SaleOrder = this.soRepo
        .createQueryBuilder('SaleOrder')
        // .leftJoinAndSelect('SaleOrder.saleOrderItemsInfo', 'saleOrderItemsInfo')
        .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .leftJoinAndSelect('SaleOrder.SoPoDetailsInfo', 'SoPoDetailsInfo')
        .leftJoinAndSelect('SaleOrder.soTrackData', 'soTrackData')
        .orderBy("SoInvDetailsInfo.edlDate", "ASC");
      // .leftJoinAndSelect('SaleOrder.BomDetailsInfo', 'BomDetailsInfo')
      const saleOrderDetails = await SaleOrder.getMany();
      if (saleOrderDetails) {
        for (const saleOrder of saleOrderDetails) {
          const promiseArray = [];
          promiseArray.push(
            this.customerRepository.getCustomerDataById({
              custId: saleOrder.SoInvDetailsInfo.customerId,
            })
          );
          promiseArray.push(
            this.destinationRepository.getDestinationById({
              destinationId: saleOrder.SoInvDetailsInfo.destination,
            })
          );
          promiseArray.push(
            this.endCustomerRepository.getEndCustomerDataById({
              endCustomerId: saleOrder.SoInvDetailsInfo.endCustomerId,
            })
          );
          await Promise.all([...promiseArray])
            .then((res) => {
              const customerName = res[0].status
                ? res[0].data.clientName
                : null;
              const destination = res[1].status
                ? res[1].data.destinationName
                : null;
              const endCustomerName = res[2].status
                ? res[2].data.endCustomerName
                : null;

              // let styleWeightment = '';
              // let totWeight = 0;
              // let totAmount = 0;

              const SaleObject = new AllSaleOrdersDto(
                saleOrder.saleOrderId,
                saleOrder.saleOrderNumber,
                saleOrder.SoInvDetailsInfo.invoiceDate,
                customerName,
                saleOrder.SoInvDetailsInfo.poNumber,
                endCustomerName,
                // saleOrder.SoInvDetailsInfo.cusAddress,
                destination,
                saleOrder.SoPoDetailsInfo.isBrandApproved,
                saleOrder.SoPoDetailsInfo.additionalNote,
                saleOrder.SoPoDetailsInfo.brandDesignType,
                saleOrder.SoInvDetailsInfo.edaDate,
                saleOrder.SoInvDetailsInfo.edlDate,
                saleOrder.SoInvDetailsInfo.category,
                saleOrder.status,
                saleOrder.soTrackData.pmStatus
              );
              saleOrderDto.push(SaleObject);
            })
            .catch((err) => {
              console.log(err.response);
            });
        }
        const response = new AllSaleOrdersDetailsResponseModel(
          true,
          1,
          'Sale orders retrieved successfully',
          saleOrderDto
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async getAllNotClosedSaleOrdersDetails(): Promise<AllSaleOrdersDetailsResponseModel> {
    try {
      const saleOrderDto: AllSaleOrdersDto[] = [];
      const SaleOrder = this.soRepo
        .createQueryBuilder('SaleOrder')
        // .leftJoinAndSelect('SaleOrder.saleOrderItemsInfo', 'saleOrderItemsInfo')
        .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .leftJoinAndSelect('SaleOrder.SoPoDetailsInfo', 'SoPoDetailsInfo')
        .leftJoinAndSelect('SaleOrder.soTrackData', 'soTrackData')
        .leftJoinAndSelect('SaleOrder.BomDetailsInfo', 'BomDetailsInfo')
        .where('soTrackData.pmStatus IN (:...status)', { status: [`${PmStatusEnum.OPEN}`, `${PmStatusEnum.IN_PROGRESS}`] })
        .orderBy("SoInvDetailsInfo.edlDate", "ASC");
      // .leftJoinAndSelect('SaleOrder.BomDetailsInfo', 'BomDetailsInfo')
      const saleOrderDetails = await SaleOrder.getMany();
      if (saleOrderDetails) {
        for (const saleOrder of saleOrderDetails) {
          const promiseArray = [];
          promiseArray.push(
            this.customerRepository.getCustomerDataById({
              custId: saleOrder.SoInvDetailsInfo.customerId,
            })
          );
          promiseArray.push(
            this.destinationRepository.getDestinationById({
              destinationId: saleOrder.SoInvDetailsInfo.destination,
            })
          );
          promiseArray.push(
            this.endCustomerRepository.getEndCustomerDataById({
              endCustomerId: saleOrder.SoInvDetailsInfo.endCustomerId,
            })
          );

          promiseArray.push(
            this.unitcodeService.getPlantDetailsById({ unitcodeId: saleOrder.SoInvDetailsInfo.unit })
          );

          await Promise.all([...promiseArray])
            .then((res) => {
              const customerName = res[0].status
                ? res[0].data.clientName
                : null;
              const destination = res[1].status
                ? res[1].data.destinationName
                : null;
              const endCustomerName = res[2].status
                ? res[2].data.endCustomerName
                : null;

              const fromPlant = res[3].status
                ? res[3].data.unitcodeName
                : null;
              // let styleWeightment = '';
              // let totWeight = 0;
              // let totAmount = 0;
              let pMstatus = saleOrder.soTrackData.pmStatus;
              if (saleOrder.soTrackData.pmStatus === PmStatusEnum.IN_PROGRESS) {
                const pos = saleOrder.BomDetailsInfo.filter((item) => item.status == StatusEnum.PO)
                const grnS = saleOrder.BomDetailsInfo.filter((item) => item.status == StatusEnum.GRN)
                const closed = saleOrder.BomDetailsInfo.filter((item) => item.status == StatusEnum.CLOSED)
                const bomItems = saleOrder.BomDetailsInfo.filter((item) => {
                  if (item.packingCategory) {
                    return item;
                  }
                })

                if (pos && pos.length) {
                  if (bomItems.length != (pos.length + grnS.length + closed.length)) {
                    pMstatus = PmStatusEnum.PARTIAL_PO;
                  }
                }
              }

              const SaleObject = new AllSaleOrdersDto(
                saleOrder.saleOrderId,
                saleOrder.saleOrderNumber,
                saleOrder.SoInvDetailsInfo.invoiceDate,
                customerName,
                saleOrder.SoInvDetailsInfo.poNumber,
                endCustomerName,
                // saleOrder.SoInvDetailsInfo.cusAddress,
                destination,
                saleOrder.SoPoDetailsInfo.isBrandApproved,
                saleOrder.SoPoDetailsInfo.additionalNote,
                saleOrder.SoPoDetailsInfo.brandDesignType,
                saleOrder.SoInvDetailsInfo.edaDate,
                saleOrder.SoInvDetailsInfo.edlDate,
                saleOrder.SoInvDetailsInfo.category,
                saleOrder.status,
                pMstatus,
                fromPlant
              );
              saleOrderDto.push(SaleObject);
            })
            .catch((err) => {
              console.log(err.response);
            });
        }
        const response = new AllSaleOrdersDetailsResponseModel(
          true,
          1,
          'Sale orders retrieved successfully',
          saleOrderDto
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      console.log(err);
      return err;
    }
  }

  async getAllBomTrackerInfo(req: UnitRequest): Promise<AllSaleOrdersDetailsResponseModel> {
    try {
      const manager = getManager();
      let trackerQuery = `SELECT soPo.additional_note as additionalNote, soPo.brandType as brandDesignType, inv.category, c.client_name as customer, d.destination_name as  destinationAddress, e.end_customer_name as endCustomer,DATE_FORMAT(inv.eda_date, "%Y-%m-%d") as eta, DATE_FORMAT(inv.edl_date, "%Y-%m-%d") as etd, inv.invoice_date as invDate, soPo.is_brand_approved as isBrandApproved, soTrk.pm_status as pmStatus, so.sale_order_no as saleOrder, so.sale_order_id as saleOrderId, soTrk.pm_status as status, u.unit_name as unit, u.plant_code as unitCode, GROUP_CONCAT(soBom.status) as packingStatus, SUM(quantity) as totalBomQty, SUM(po_qty) as totalPoQty, inv.processing_unit as unitId ,so.status as soStatus,CONCAT(inv.po_number ,'-',mb.brand_name,' ', sk.variant_code,' ',pm.packing_method_name) AS poNo FROM ` + appSettings.sales_db + `.sale_order so 
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.sale_order_track soTrk ON soTrk.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.so_po_details soPo ON soPo.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.bom_details soBom ON soBom.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.masters_db + `.end_customers e ON e.end_customer_id=inv.end_customer_id
      LEFT JOIN ` + appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id
      LEFT JOIN ` + appSettings.masters_db + `.destination d ON d.destination_id=inv.destination
      LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=inv.processing_unit 
      LEFT JOIN ` + appSettings.sales_db + `.sale_order_items soi ON soi.sale_order_id = so.sale_order_id
      LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = soi.varient_id
      LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = soi.pack_style_id
      LEFT JOIN ` + appSettings.masters_db + `.master_brands mb ON mb.master_brand_id = soi.master_brand_id
      where soBom.packing_category IS NOT NULL and soTrk.pm_status!='${PmStatusEnum.CLOSE}'`;

      const roles: string[] = [EmployeeRolesEnum.ADMIN,
      EmployeeRolesEnum.HO_PACKAGING_MANAGER];

      if (((roles.indexOf(req.role)) === -1)) {
        trackerQuery += ` and inv.processing_unit= ${req.unitId}`;
      }
      if (req.unitId && req.unitId != 5) {
        trackerQuery += ` and inv.processing_unit=` + req.unitId;
      }
      trackerQuery += ` group by so.sale_order_id`;
      const saleOrderDto = await manager.query(trackerQuery);
      if (saleOrderDto.length > 0) {
    const result = new AllSaleOrdersDetailsResponseModel(
          true,
          1,
          'Sale orders retrieved successfully',
          saleOrderDto
        )
        // const newLogDto = new LogsDto(1,'view bomb tracker', 'sale order', 0, true, '','')
        //     let res = await this.logService.createLog(newLogDto);
        //     console.log(res);
        return result
      }
      else {
        throw new ErrorResponse(9999, 'No Data Found');
      }

    } catch (error) {
      return error;
    }
  }


  async getBomItemsForSoId(saleOrderId: number): Promise<BomTrackerForSoIdResponseModel> {
    try {
      const manager = getManager();
      const trackerQuery = `SELECT i.item_name as item,bom.item_category_id as itemCategoryId,bom.item_id as itemId,bom.item_sub_category_id as subcategoryId, si.size_name size, round(bom.quantity) as quantity, round(bom.receiced_qty) as grnQuantity, round(bom.po_qty) as poQuantity, round(bom.existing_qty) as existingQuantity, bom.status, bom.packing_material_id as packingMaterialId, bom.created_user as createdUser, bom.sale_order_id as saleOrderId, bom.updated_user as updatedUser, round(bom.required_qty) as requiredQuantity, bom.packing_category as packingCategory, bom.is_active as isActive, round(assigned_qty) as AssignedQuantity, s.sale_order_no as saleOrderNumber, is_qty_revised as isQtyRevised,sinv.processing_unit as unitId, is_active_revised as isActiveRevised, is_required as isRequired from ` + appSettings.sales_db + `.bom_details bom 
      LEFT JOIN ` + appSettings.sales_db + `.sale_order s ON s.sale_order_id=bom.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sinv ON sinv.sale_order_id=bom.sale_order_id 
      LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id=bom.item_id 
      LEFT JOIN ` + appSettings.masters_db + `.sizes si ON si.size_id=i.size_id 
      where bom.packing_category IS NOT NULL and bom.sale_order_id=${saleOrderId}`;
      const bomItems = await manager.query(trackerQuery);
      for (const [index, bomitem] of bomItems.entries()) {
        const req = new QtyRequest(bomitem.itemCategoryId, bomitem.subcategoryId, bomitem.itemId, 0, bomitem.unitId);
        const existingStock = await this.stockService.getAvailableTransferStockQty(req);
        console.log('existingStockaa')
        console.log(existingStock)
        if (existingStock.status) {
          bomItems[index].existingQuantity = existingStock.data.physicalQuantity
        } else {
          bomItems[index].existingQuantity = 0
        }
      }
      if (bomItems) {
        return new BomTrackerForSoIdResponseModel(true, 1111, 'Bom Details Retrieved Successfully', bomItems);
      } else {
        return new BomTrackerForSoIdResponseModel(false, 9999, 'No Data Found');
      }
    } catch (error) {
      return error;
    }

  }

  async getAllClosedSaleOrdersDetails(req: UnitRequest): Promise<AllSaleOrdersDetailsResponseModel> {
    try {
      const manager = getManager();
      let trackerQuery = `SELECT soPo.additional_note as additionalNote, soPo.brandType as brandDesignType, inv.category, c.client_name as customer, d.destination_name as  destinationAddress, e.end_customer_name as endCustomer,DATE_FORMAT(inv.eda_date, "%Y-%m-%d") as eta, DATE_FORMAT(inv.edl_date, "%Y-%m-%d") as etd, inv.invoice_date as invDate, soPo.is_brand_approved as isBrandApproved, soTrk.pm_status as pmStatus, inv.po_number as poNumber, so.sale_order_no as saleOrder, so.sale_order_id as saleOrderId, soTrk.pm_status as status, u.unit_name as unit, u.plant_code as unitCode, GROUP_CONCAT(soBom.status) as packingStatus, SUM(quantity) as totalBomQty, SUM(po_qty) as totalPoQty,so.status as soStatus, inv.processing_unit as unitId,mb.brand_name,sk.variant_code,pm.packing_method_name,CONCAT(inv.po_number ,'-',mb.brand_name,' ', sk.variant_code,' ',pm.packing_method_name) as poNo  FROM ` + appSettings.sales_db + `.sale_order so 
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.sale_order_track soTrk ON soTrk.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.so_po_details soPo ON soPo.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.bom_details soBom ON soBom.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.sale_order_items soi ON soi.sale_order_id = so.sale_order_id
      LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = soi.varient_id
      LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON pm.packing_method_id = soi.pack_style_id
      LEFT JOIN ` + appSettings.masters_db + `.master_brands mb ON mb.master_brand_id = soi.master_brand_id
      LEFT JOIN ` + appSettings.masters_db + `.end_customers e ON e.end_customer_id=inv.end_customer_id
      LEFT JOIN ` + appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id
      LEFT JOIN ` + appSettings.masters_db + `.destination d ON d.destination_id=inv.destination
      LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=inv.processing_unit where soBom.packing_category IS NOT NULL and soTrk.pm_status='${PmStatusEnum.CLOSE}'`;
      const roles: string[] = [EmployeeRolesEnum.ADMIN,
      EmployeeRolesEnum.HO_PACKAGING_MANAGER];

      if (((roles.indexOf(req.role)) === -1)) {
        trackerQuery += ` and inv.processing_unit= ${req.unitId}`;
      }
      if (req.unitId && req.unitId != 5) {
        trackerQuery += ` and inv.processing_unit=` + req.unitId;
      }
      trackerQuery += ` group by so.sale_order_id`;
      console.log(trackerQuery);
      const saleOrderDto = await manager.query(trackerQuery);
      if (saleOrderDto.length > 0) {
        return new AllSaleOrdersDetailsResponseModel(
          true,
          1,
          'Sale orders retrieved successfully',
          saleOrderDto
        )
      } else {
        throw new ErrorResponse(9999, 'No Data Found');
      }

    } catch (error) {
      return error;
    }
  }

  async getAllSaleOrdersFHDashbard(req: UnitRequest): Promise<AllSaleOrdersDetailsResponseModel> {
    let manager = getManager();
    let soQuery = `SELECT so.sale_order_id AS saleOrderId,so.sale_order_no AS saleOrder,c.client_name AS customer,inv.invoice_date AS orderedDate,inv.end_customer_id as endCustomerId,SUM(si.net_weight) AS orderQty,SUM(si.net_amount) AS cost,d.destination_name AS destinationAddress,so.status AS status,st.pm_status AS packing,st.qc_status AS qualityAssurance,st. container_status AS logistics,st.doc_status AS doc,0 AS fgStock,inv.factoryId AS unit, inv.invoice_date AS poDate,inv.po_number AS poNo,inv.buyer_po_number AS buyerPONo,e.end_customer_name AS endCustomer,SUM(si.net_weight) AS totnetWeight, IF(count(si.sale_order_item_id)>1, 0, 1) AS loadType, cur.currency_id AS currencyId,cur.currency_name AS currency,si.uom_id AS uom,so.is_invoiced AS isInvoiced,so.so_type AS soType,so.so_process_type AS soProcessType,cn.country_name as country,inv.category as product,uc.unit_name as unit, st.production_status AS prodStatus,inv.processing_unit as processingUnitId,inv.factoryId as unitId, pu.unit_name as processingUnitName, inv.job_type as jobType,inv.cus_address as customerAddress,inv.eda_date as eta,inv.act_edl_date as etd,inv.port_of_entry as portOfEntry,sopo.is_brand_approved as isBrandApproved,sopo.additional_note as additionalNote,inv.currency_id as currencyId , st.container_status as containerStatus, ct.container_number as containerNumber 
      FROM `+ appSettings.sales_db + `.so_invoice_details inv
      LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON so.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id
      LEFT JOIN `+ appSettings.masters_db + `.destination d ON d.destination_id=inv.destination
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_track st ON st.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.sales_db + `.so_po_details sopo ON sopo.sale_order_id=so.sale_order_id
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_items si ON si.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.end_customers e ON e.end_customer_id=inv.end_customer_id
      LEFT JOIN `+ appSettings.masters_db + `.countries cn ON cn.country_id=inv.country_id
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=inv.factoryId
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes pu ON pu.unit_code_id=inv.processing_unit
      LEFT JOIN `+ appSettings.masters_db + `.currencies cur ON cur.currency_id=inv.currency_id 
      LEFT JOIN `+ appSettings.logistics_db + `.container ct ON ct.sale_order_id=inv.sale_order_id 
      where so.sale_order_id>0 `;
    if (req.unitId && req.unitId != 5) {
      soQuery += ` and inv.processing_unit=` + req.unitId;
    }
    soQuery = soQuery + ` GROUP BY so.sale_order_id ORDER By inv.act_edl_date`;
    console.log(soQuery)
    let soData = await manager.query(soQuery);

    const response = new AllSaleOrdersDetailsResponseModel(true, 11108, 'Sale Order Details retrieved successfully', soData);
    return response
  }


  async getAllSaleOrders(): Promise<AllSaleOrdersResponseModel> {
    // const page: number = 1;
    try {
      const saleOrderDto: SODto[] = [];
      //retrieves all companies
      const SaleOrder = this.soRepo
        .createQueryBuilder('SaleOrder')
        .leftJoinAndSelect('SaleOrder.saleOrderItemsInfo', 'saleOrderItemsInfo')
        .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .leftJoinAndSelect('SaleOrder.SoPoDetailsInfo', 'SoPoDetailsInfo')
        .leftJoinAndSelect('SaleOrder.BomDetailsInfo', 'BomDetailsInfo');
      const saleOrderDetails = await SaleOrder.getMany();
      console.log(saleOrderDetails);

      if (saleOrderDetails?.length > 0) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        let totAmount = 0;
        let totWeight = 0;
        for (const saleOrder of saleOrderDetails) {
          for (const subOrder of saleOrder.saleOrderItemsInfo) {
            const promiseArray = [];

            promiseArray.push(
              this.customerRepository.getCustomerDataById({
                custId: saleOrder.SoInvDetailsInfo.customerId,
              })
            );

            promiseArray.push(
              this.destinationRepository.getDestinationById({
                destinationId: saleOrder.SoInvDetailsInfo.destination,
              })
            );
            // promiseArray.push(this.employeeDetailsRepository.getActiveEmployeesById({ employeeId: saleOrder.SoInvDetailsInfo.salePersonId }))
            promiseArray.push(
              this.skuCodesRepository.getSkuDataById({
                skuCodeId: subOrder.varientId,
              })
            );
            promiseArray.push(
              this.countryRepository.getCountryById({
                countryId: saleOrder.SoInvDetailsInfo.country,
              })
            );

            promiseArray.push(
              this.shippingRepository.getShippingTermsById({
                shippingTermsId: saleOrder.SoInvDetailsInfo.shipmentTerms,
              })
            );
            promiseArray.push(
              this.paymentTermsRepository.getPaymentById({
                paymentTermsId: saleOrder.SoInvDetailsInfo.payTermId,
              })
            );
            // const deliveryTermsId = this.deliveryTermsRepository.getDeliveryTermsById({ deliveryTermsId: saleOrder.SoInvDetailsInfo.deliveryTerms })
            promiseArray.push(
              this.uomRepository.getActiveUomById({ uomId: subOrder.uomId })
            );

            promiseArray.push(
              this.currencyRepository.getCurrencyById({
                currencyId: saleOrder.SoInvDetailsInfo.currency,
              })
            );
            promiseArray.push(
              this.endCustomerRepository.getEndCustomerDataById({
                endCustomerId: saleOrder.SoInvDetailsInfo.endCustomerId,
              })
            );
            promiseArray.push(
              this.foodTypeRepository.getFoodTypeDataById({
                foodTypeId: subOrder.foodTypeId,
              })
            );

            promiseArray.push(
              this.gradesRepository.getGradeById({ gradeId: subOrder.minGrade })
            );
            promiseArray.push(
              this.gradesRepository.getGradeById({ gradeId: subOrder.maxGrade })
            );

            promiseArray.push(
              this.skuCodesRepository.getSkuDataById({
                skuCodeId: subOrder.brandId,
              })
            );
            promiseArray.push(
              this.destinationRepository.getDestinationById({
                destinationId: saleOrder.SoInvDetailsInfo.destination,
              })
            );
            totAmount += subOrder.netAmount;
            totWeight += subOrder.netWeight;
            await Promise.all([...promiseArray])
              .then((res) => {
                const customerName = res[0].status
                  ? res[0].data.clientName
                  : null;
                const destination = res[1].status
                  ? res[1].data.destinationName
                  : null;
                const variety = res[2].status ? res[2].data.variantCode : null;
                const country = res[3].status ? res[3].data.countryName : null;
                const shipmentTerms = res[4].status
                  ? res[4].data.shippingTermsName
                  : null;
                const paymentTerms = res[5].status
                  ? res[5].data.paymentTermsName
                  : null;
                const unitOfWeight = res[6].status ? res[6].data.uomName : null;
                const unitOfCurrency = res[7].status
                  ? res[7].data.currencyName
                  : null;
                const endCustomerName = res[8].status
                  ? res[8].data.endCustomerName
                  : null;
                const foodType = res[9].status ? res[9].data.foodType : null;

                let customerAccountType = '';
                // let subOrder = '';
                let deliveryTerms = '';
                let salePerson = '';
                let brand = '';
                let minGrade = '';
                let maxGrade = '';
                let foodStyle = '';
                // let variety = '';
                let Freeze = '';
                let itemCase = '';
                let itemWeight = '';
                // let unitOfWeight = '';
                let TotalCase = '';
                let pricePerUnit = '';
                let netUnits = '';
                let netAmount = '';
                let totalUnits = '';
                let totalWeight = '';
                let packagingDesign = '';
                let approved = '';
                let weighmentStyle = '';
                let bapCertification = '';
                let ascCertification = '';
                let soakingTime = '';
                let soakingTimemin = '';
                let specSheetUpload = '';
                let glazzing = '';
                let inspection = '';
                let tuvInspection = '';

                const SaleObject = new SODto(
                  saleOrder.saleOrderId,
                  saleOrder.createdAt,
                  saleOrder.createdUser,
                  customerAccountType,
                  salePerson,
                  saleOrder.saleOrderNumber,
                  saleOrder.SoInvDetailsInfo.poNumber,
                  customerName,
                  endCustomerName,
                  saleOrder.SoInvDetailsInfo.cusAddress,
                  saleOrder.SoInvDetailsInfo.edaDate,
                  saleOrder.SoInvDetailsInfo.edlDate,
                  destination,
                  saleOrder.SoInvDetailsInfo.portOfEntry,
                  country,
                  shipmentTerms,
                  deliveryTerms,
                  paymentTerms,
                  saleOrder.SoInvDetailsInfo.unit,
                  subOrder.createdUser,
                  brand,
                  minGrade,
                  maxGrade,
                  saleOrder.SoInvDetailsInfo.category,
                  foodType,
                  foodStyle,
                  variety,
                  Freeze,
                  subOrder.cases,
                  itemWeight,
                  unitOfWeight,
                  TotalCase,
                  unitOfCurrency,
                  subOrder.unitPrice,
                  netUnits,
                  subOrder.netAmount,
                  totalUnits,
                  totWeight,
                  totAmount,
                  packagingDesign,
                  saleOrder.SoPoDetailsInfo.isBrandApproved,
                  subOrder.styleWeighment,
                  bapCertification,
                  ascCertification,
                  subOrder.soakingTime,
                  subOrder.soakingTime,
                  specSheetUpload,
                  glazzing,
                  saleOrder.SoPoDetailsInfo.labInspection,
                  tuvInspection,
                  saleOrder.status
                  // isActive: boolean,
                  // updatedAt,
                  // updatedUser,
                  // versionFlag,
                );
                saleOrderDto.push(SaleObject);
                // console.log(SaleObject);
              })
              .catch((err) => {
                console.log(err.response);
              });
          }
        }
        // }
        //generated response
        const response = new AllSaleOrdersResponseModel(
          true,
          1,
          'Sale orders retrieved successfully',
          saleOrderDto
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
  // async updateSaleOrderStatus(saleOrdersDto:SaleOrderDto):Promise<AllSaleOrdersResponseModel>{
  //   try{
  //      await this.soRepo.update(saleOrdersDto.saleOrderId,saleOrdersDto);
  //      const saleOrdersDtos:SaleOrderDto[] = [];
  //      //retrieves all companies
  //     //  await this.statesRepository.save();
  //      const saleOrderEntities: SaleOrder[] = await this.soRepo.find({
  //        where: { status: 1 },
  //        order: { createdAt: 'DESC' }
  //      });
  //      if (saleOrderEntities) {
  //        // converts the data fetched from the database which of type companies array to type StateDto array.
  //        saleOrderEntities.forEach(saleOrderEntity => {
  //          const convertedsaleOrdersDto: SaleOrderDto = this.saleOrderAdapter.convertEntityToDto(saleOrderEntity);
  //          saleOrdersDtos.push(convertedsaleOrdersDto);
  //        });
  //        //generated response
  //  const response = new AllSaleOrdersResponseModel(true,1,'Sale Order updated successfully',saleOrdersDtos);
  //  return response;
  //      } else {
  //        throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
  //      }
  //      const chat_ids=[36475226];
  //     // this.botService.botMessage(chat_ids,'State updated');

  //   }catch (error) {
  //     // tslint:disable-next-line: typedef
  //     throw error;
  //   }

  // }

  async getAllSaleOrderItems(): Promise<AllSoItemsResponseModel> {
    // const page: number = 1;
    try {
      const saleOrderItemDto: SOItemsDto[] = [];

      //retrieves all companies
      const saleOrderItemEntities = await this.soRepo.find({
        relations: ["saleOrderItemsInfo", "SoInvDetailsInfo", 'BomDetailsInfo'],
        order: { saleOrderId: 'ASC' }
      }
      );
      //console.log(statesEntities);
      console.log(saleOrderItemEntities)
      if (saleOrderItemEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        for (const eachData of saleOrderItemEntities) {
          let currencyId = eachData.SoInvDetailsInfo.currency;
          for (const eachItem of eachData.saleOrderItemsInfo) {
            const foodTypeId = this.foodTypeRepository.getFoodTypeDataById({
              foodTypeId: eachItem.foodTypeId,
            });
            const productId = this.productRepository.getActiveProductById({
              productId: eachItem.itemId,
            });
            const variantId = this.skuCodesRepository.getSkuDataById({
              skuCodeId: eachItem.varientId,
            });
            // const uomId = this.uomRepository.getActiveUomById({ uomId: eachItem.uomId });
            const brandId = this.endCustomerRepository.getBrandsById({
              brandId: eachItem.brandId,
            });

            const convVariantsdata = await this.skuCodesRepository.getSkuConversions({ skuCodeId: eachItem.varientId })

            const reProcess = new ReProcessingDtoReq();
            reProcess.brand = eachItem.brandId
            reProcess.product = eachItem.itemId
            reProcess.minGrade = eachItem.minGrade
            reProcess.maxGrade = eachItem.maxGrade
            reProcess.finalPercentage = eachItem.finalPercentage
            const reproceesedVarients = convVariantsdata.data
            reProcess.variantId = reproceesedVarients
            const reProcessingQty = await this.fgService.getReProcessingStock(reProcess);
            // const profitReprocessQty = reProcessingQtyData.data.profitReproceeQty
            // const lossReprocessQty = reProcessingQtyData.data.lossReproceeQty
            // const reProcessingQty = profitReprocessQty+lossReprocessQty


            const rePack = new RepackingDtoRequest();
            rePack.brand = eachItem.brandId
            rePack.product = eachItem.itemId
            rePack.minGrade = eachItem.minGrade
            rePack.maxGrade = eachItem.maxGrade
            rePack.category = eachItem.categoryId
            rePack.varient = eachItem.varientId
            rePack.soakingStyle = eachItem.soakingStyle
            rePack.soakingTime = eachItem.soakingTime
            const rePackingQty = this.fgService.getRePackingStock(rePack);

            let uom = '';
            if (eachItem.uomId === 1) {
              uom = 'KG';
            }
            if (eachItem.uomId === 2) {
              uom = 'LB';
            }
            if (eachItem.uomId === 3) {
              uom = 'OZ';
            }
            if (eachItem.uomId === 4) {
              uom = 'Gms';
            }
            await Promise.all([foodTypeId, productId, variantId, brandId, reProcessingQty, rePackingQty]).then(
              (res) => {
                const foodTypeId = res[0].status ? res[0].data.foodType : null;
                const productId = res[1].status ? res[1].data.productName : null;
                const variantId = res[2].status ? res[2].data.variantCode : null;
                // const uomId = res[3].status ? res[3].data.uomName : null;
                const brand = res[3].status ? res[3].data.brandName : null;
                const reProcessQty = res[4].status ? (res[4].data.profitReproceeQty + res[4].data.lossReproceeQty) : 0;
                const rePackQty = res[5].status ? (res[5].data.profitReproceeQty) : 0;

                const SaleObject = new SOItemsDto(
                  eachItem.saleOrderItemId,
                  eachItem.saleOrderId,
                  productId,
                  eachItem.minGrade,
                  eachItem.maxGrade,
                  foodTypeId,
                  variantId,
                  //  eachItem.valueAdditionOneId,
                  //  eachItem.valueAdditionTwoId,
                  //  eachItem.valueAdditionThreeId,
                  //  eachItem.valueAdditionFourId,
                  eachItem.cases,
                  eachItem.netAmount,
                  eachItem.unitPrice,
                  eachItem.pouches,
                  eachItem.pouchWeight,
                  eachItem.caseWeight,
                  eachItem.categoryId,
                  eachItem.netWeight,
                  uom,
                  //  eachItem.freezeStle,
                  eachItem.minGlaze,
                  eachItem.MaxGlaze,
                  eachItem.soakingTime,
                  eachItem.soakingStyle,
                  eachItem.styleWeighment,

                  //  eachItem.isActive,
                  //  eachItem.createdAt,
                  //  eachItem.createdUser,
                  eachItem.brandId,
                  //  eachItem.brandId,
                  brand,
                  eachItem.dispatchedQty,
                  eachItem.invoiceAmount,
                  currencyId,
                  reProcessQty,
                  rePackQty,
                  eachItem.itemId,
                  eachItem.shrimpWeight,
                  0,
                  eachItem.varientId,
                  eachItem.hlPercentage,
                  eachItem.finalPercentage,
                  undefined,
                  reproceesedVarients
                  //  eachItem.updatedAt,
                  //  eachItem.updatedUser,
                  //  eachItem.versionFlag,
                );
                // console.log(SaleObject);
                saleOrderItemDto.push(SaleObject);
              })

          }
          // console.log(saleOrderItemDto)

        } //generated response
        const response = new AllSoItemsResponseModel(
          true,
          11108,
          'Sale Orders retrieved successfully',
          saleOrderItemDto
        );
        return response;
      }
      else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
  // async getSaleOrderItems(saleOrderIdRequest:SaleOrderIdRequest):Promise<AllSoItemsResponseModel>{
  //   try{}catch(error){
  //     return error;
  //   }
  // }
  // async getAllSoItems(): Promise<AllSoItemsResponseModel> {
  //   // const page: number = 1;
  //   try {
  //     const saleOrderItemDto: SOItemsDto[] = [];

  //     //retrieves all companies
  //     const saleOrderItemEntities = await this.soRepo.find({
  //       relations: ["saleOrderItemsInfo", "SoInvDetailsInfo", 'BomDetailsInfo'],
  //       order: { saleOrderId: 'ASC' }
  //     }
  //     );

  //     //console.log(statesEntities);
  //     if (saleOrderItemEntities) {
  //       // converts the data fetched from the database which of type companies array to type StateDto array.
  //       for (const eachData of saleOrderItemEntities) {
  //         let currencyId = eachData.SoInvDetailsInfo.currency;
  //         for (const eachItem of eachData.saleOrderItemsInfo) {
  //           // const foodTypeId = this.foodTypeRepository.getFoodTypeDataById({
  //           //   foodTypeId: eachItem.foodTypeId,
  //           // });
  //           // const productId = this.productRepository.getActiveProductById({
  //           //   productId: eachItem.itemId,
  //           // });
  //           // const variantId = this.skuCodesRepository.getSkuDataById({
  //           //   skuCodeId: eachItem.varientId,
  //           // });
  //           // // const uomId = this.uomRepository.getActiveUomById({ uomId: eachItem.uomId });
  //           // const brandId = this.endCustomerRepository.getBrandsById({
  //           //   brandId: eachItem.brandId,
  //           // });

  //           // const reProcess = new ReProcessingDtoReq();
  //           // reProcess.brand = eachItem.brandId
  //           // reProcess.product = eachItem.itemId
  //           // reProcess.minGrade = eachItem.minGrade
  //           // reProcess.maxGrade = eachItem.maxGrade
  //           // reProcess.finalPercentage = eachItem.finalPercentage
  //           // const reProcessingQty = this.fgService.getReProcessingStock(reProcess);

  //           // const rePack = new RepackingDtoRequest();
  //           // rePack.brand = eachItem.brandId
  //           // rePack.product = eachItem.itemId
  //           // rePack.minGrade = eachItem.minGrade
  //           // rePack.maxGrade = eachItem.maxGrade
  //           // rePack.category = eachItem.categoryId
  //           // rePack.varient = eachItem.varientId
  //           // rePack.soakingStyle = eachItem.soakingStyle
  //           // rePack.soakingTime = eachItem.soakingTime
  //           // const rePackingQty = this.fgService.getRePackingStock(rePack);

  //           let uom = '';
  //           if (eachItem.uomId === 1) {
  //             uom = 'KG';
  //           }
  //           if (eachItem.uomId === 2) {
  //             uom = 'LB';
  //           }
  //           if (eachItem.uomId === 3) {
  //             uom = 'OZ';
  //           }
  //           if (eachItem.uomId === 4) {
  //             uom = 'Gms';
  //           }
  //           await Promise.all([]).then(
  //             (res) => {
  //               // const foodTypeId = res[0].status ? res[0].data.foodType : null;
  //               // const productId = res[1].status ? res[1].data.productName : null;
  //               // const variantId = res[2].status ? res[2].data.variantCode : null;
  //               // // const uomId = res[3].status ? res[3].data.uomName : null;
  //               // const brand = res[3].status ? res[3].data.brandName : null;
  //               // const reProcessQty = res[4].status ? res[4].data : 0;
  //               // const rePackQty = res[5].status ? res[5].data : 0;

  //               const SaleObject = new SOItemsDto(
  //                 eachItem.saleOrderItemId,
  //                 eachItem.saleOrderId,
  //                 'productId',
  //                 eachItem.minGrade,
  //                 eachItem.maxGrade,
  //                 'foodTypeId',
  //                 'variantId',
  //                 //  eachItem.valueAdditionOneId,
  //                 //  eachItem.valueAdditionTwoId,
  //                 //  eachItem.valueAdditionThreeId,
  //                 //  eachItem.valueAdditionFourId,
  //                 eachItem.cases,
  //                 eachItem.netAmount,
  //                 eachItem.unitPrice,
  //                 eachItem.pouches,
  //                 eachItem.pouchWeight,
  //                 eachItem.caseWeight,
  //                 eachItem.categoryId,
  //                 eachItem.netWeight,
  //                 'uom',
  //                 //  eachItem.freezeStle,
  //                 eachItem.minGlaze,
  //                 eachItem.MaxGlaze,
  //                 eachItem.soakingTime,
  //                 eachItem.soakingStyle,
  //                 eachItem.styleWeighment,

  //                 //  eachItem.isActive,
  //                 //  eachItem.createdAt,
  //                 //  eachItem.createdUser,
  //                 eachItem.brandId,
  //                 //  eachItem.brandId,
  //                 'brand',//brand,
  //                 eachItem.dispatchedQty,
  //                 eachItem.invoiceAmount,
  //                 currencyId,
  //                 0,// reProcessQty,
  //                 0,//rePackQty,
  //                 eachItem.itemId,
  //                 eachItem.shrimpWeight,
  //                 0,
  //                 eachItem.varientId
  //                 //  eachItem.updatedAt,
  //                 //  eachItem.updatedUser,
  //                 //  eachItem.versionFlag,
  //               );
  //               // console.log(SaleObject);
  //               saleOrderItemDto.push(SaleObject);
  //             })

  //         }
  //         // console.log(saleOrderItemDto)

  //       } //generated response
  //       const response = new AllSoItemsResponseModel(
  //         true,
  //         11108,
  //         'Sale Orders retrieved successfully',
  //         saleOrderItemDto
  //       );
  //       return response;
  //     }
  //     else {
  //       throw new ErrorResponse(99998, 'Data not found');
  //     }
  //   } catch (err) {
  //     return err;
  //   }
  // }
  // async getAllSoTrackData(saleOrderTrackFilters: SaleOrderTrackFilters, request: Request): Promise<AllSaleOrdersTrackResponseModel> {
  //   try {

  //     const status = saleOrderTrackFilters.saleOrderStatus;
  //     const fromDate = saleOrderTrackFilters.selectedEstimatedFromDate;
  //     const toDate = saleOrderTrackFilters.selectedEstimatedToDate;
  //     const endCustomer = saleOrderTrackFilters.selectedEndCustomer;
  //     const unit = saleOrderTrackFilters.unit;
  //     const destinations = saleOrderTrackFilters.destinations;
  //     // console.log('**************************');
  //     const SaleOrder = this.soRepo
  //       .createQueryBuilder('SaleOrder')
  //       .select("SaleOrder.sale_order_id as saleOrderId,SaleOrder.sale_order_no as saleOrderNumber, SaleOrder.status as status,SaleOrder.is_invoiced as isInvoiced, SaleOrder.so_process_type as soProcessType, SoInvDetailsInfo.edl_date as edlDate, SoInvDetailsInfo.end_customer_id as endCustomerId,SoInvDetailsInfo.factoryId as unit,SoInvDetailsInfo.edl_date as edlDate,SoInvDetailsInfo.destination as destination,SoInvDetailsInfo.currency_id as currency,SoInvDetailsInfo.country_id as country,SoInvDetailsInfo.customer_id as customerId,SoInvDetailsInfo.destination as  destination,SoInvDetailsInfo.category as category,SoInvDetailsInfo.invoice_date as invoiceDate,SoInvDetailsInfo.po_number as poNumber, SoInvDetailsInfo.buyer_po_number as buyerPoNumber,soTrackData.pm_status as pmStatus, soTrackData.qc_status as qualityCheckStatus, soTrackData.container_status as containerStatus, soTrackData.doc_status as DocStatus, soTrackData.rm_status as RmStatus, so_type as soType, SoInvDetailsInfo.act_edl_date as actEdlDate")

  //       .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
  //       .leftJoin("so_po_details", "SoPoDetailsInfo", "SoPoDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
  //       .leftJoin("customer_invoice", "CustomerInvDetailsInfo", "CustomerInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
  //       .leftJoin("sale_order_track", "soTrackData", "soTrackData.sale_order_id = SaleOrder.sale_order_id")
  //     // if (status === null) {SaleOrder.andWhere("SaleOrder.status IN ('OPEN','INPROGRESS')");}
  //     // if (status != undefined) {SaleOrder.andWhere("SaleOrder.status = '" + status + "'");}
  //     // if (fromDate != undefined || toDate != undefined) {SaleOrder.andWhere('SoInvDetailsInfo.edlDate >= "' + fromDate + '"').andWhere('SoInvDetailsInfo.edlDate <= "' + toDate + '"');}
  //     // if (endCustomer != 0 && endCustomer != null) {SaleOrder.andWhere('SoInvDetailsInfo.endCustomerId = ' + endCustomer);}
  //     // if (unit != 0 && unit != null) {SaleOrder.andWhere('SoInvDetailsInfo.unit = ' + unit);}
  //     // if (destinations.length > 0) {SaleOrder.andWhere('SoInvDetailsInfo.destination in (' + destinations + ')');}
  //     const saleOrderDetails = await SaleOrder.orderBy('SoInvDetailsInfo.edlDate','ASC').getRawMany();
  //     const saleOrderDto: SaleOrderTrackDTO[] = [];

  //     if (saleOrderDetails) {

  //       for (const eachItem of saleOrderDetails) {
  //         // console.log('***********************' + eachItem);

  //         const SaleObject = new SaleOrderTrackDto(
  //           eachItem.saleOrderId,
  //           eachItem.saleOrderNumber,
  //           'destination',
  //           'customer',
  //           eachItem.category,
  //           eachItem.invoiceDate,
  //           eachItem.edlDate,
  //           100,
  //           20,
  //           eachItem.status,
  //           50,
  //           'process',
  //           'packing',
  //           'qualityAssurance',
  //           'logistics',
  //           'doc',
  //           100,
  //           1,
  //           eachItem.invoiceDate,
  //           eachItem.poNumber,
  //           'endCustomername',
  //           'country',
  //           1000,
  //           eachItem.currency,
  //           'currency',
  //           1,
  //           eachItem.isInvoiced,
  //           eachItem.buyerPoNumber,
  //           eachItem.soType,
  //           eachItem.soProcessType,
  //           eachItem.actEdlDate
  //         );
  //         saleOrderDto.push(SaleObject);
  //       }
  //       // console.log(saleOrderDto);

  //       const response = new AllSaleOrdersTrackResponseModel(
  //         true,
  //         11108,
  //         'Sale Order Details retrieved successfully',
  //         saleOrderDto
  //       );
  //       return response;
  //     } else {
  //       throw new ErrorResponse(99998, 'Data not found');
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }
  async getAllSaleOrdersTrackData(saleOrderTrackFilters: SaleOrderTrackFilters, request: Request): Promise<AllSaleOrdersTrackResponseModel> {
    try {
      // console.log(
      //   'saleOrderTrackFilters' +
      //     saleOrderTrackFilters.selectedEstimatedFromDate
      // );
      // console.log(
      //   'saleOrderTrackFilters' + saleOrderTrackFilters.selectedEstimatedToDate
      // );
      // console.log(
      //   'saleOrderTrackFilters' + saleOrderTrackFilters.selectedEndCustomer
      // );
      // console.log('saleOrderTrackFilters' + saleOrderTrackFilters.unit);

      const status = saleOrderTrackFilters.saleOrderStatus;
      const fromDate = saleOrderTrackFilters.selectedEstimatedFromDate;
      const toDate = saleOrderTrackFilters.selectedEstimatedToDate;
      const endCustomer = saleOrderTrackFilters.selectedEndCustomer;
      const unit = saleOrderTrackFilters.unit;
      const destinations = saleOrderTrackFilters.destinations;

      const SaleOrder = this.soRepo
        .createQueryBuilder('SaleOrder')
        .select("SaleOrder.sale_order_id as saleOrderId,SaleOrder.sale_order_no as saleOrderNumber, SaleOrder.status as status,SaleOrder.is_invoiced as isInvoiced, SaleOrder.so_process_type as soProcessType, SoInvDetailsInfo.edl_date as edlDate, SoInvDetailsInfo.end_customer_id as endCustomerId,SoInvDetailsInfo.factoryId as unit,SoInvDetailsInfo.edl_date as edlDate,SoInvDetailsInfo.destination as destination,SoInvDetailsInfo.currency_id as currency,SoInvDetailsInfo.country_id as country,SoInvDetailsInfo.customer_id as customerId,SoInvDetailsInfo.destination as  destination,SoInvDetailsInfo.category as category,SoInvDetailsInfo.invoice_date as invoiceDate,SoInvDetailsInfo.po_number as poNumber, SoInvDetailsInfo.buyer_po_number as buyerPoNumber,soTrackData.pm_status as pmStatus, soTrackData.qc_status as qualityCheckStatus, soTrackData.container_status as containerStatus, soTrackData.doc_status as DocStatus, soTrackData.rm_status as RmStatus, so_type as soType, SoInvDetailsInfo.act_edl_date as actEdlDate")
        .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
        .leftJoin("so_po_details", "SoPoDetailsInfo", "SoPoDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
        .leftJoin("customer_invoice", "CustomerInvDetailsInfo", "CustomerInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
        .leftJoin("sale_order_track", "soTrackData", "soTrackData.sale_order_id = SaleOrder.sale_order_id")
      // .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
      // .leftJoinAndSelect('SaleOrder.SoPoDetailsInfo', 'SoPoDetailsInfo')
      // .leftJoinAndSelect('SaleOrder.CustomerInvDetailsInfo', 'CustomerInvDetailsInfo')
      // .leftJoinAndSelect('SaleOrder.soTrackData', 'soTrackData')
      // .where("SaleOrder.soProcessType = 'MTO'");

      if (status === null) {
        SaleOrder.andWhere("SaleOrder.status IN ('OPEN','INPROGRESS')");
      }
      if (status != undefined) {
        SaleOrder.andWhere("SaleOrder.status = '" + status + "'");
      }

      if (fromDate != undefined || toDate != undefined) {
        SaleOrder.andWhere(
          'SoInvDetailsInfo.edlDate >= "' + fromDate + '"'
        ).andWhere('SoInvDetailsInfo.edlDate <= "' + toDate + '"');
      }
      if (endCustomer != 0 && endCustomer != null) {
        SaleOrder.andWhere('SoInvDetailsInfo.endCustomerId = ' + endCustomer);
      }

      if (unit != 0 && unit != null) {
        SaleOrder.andWhere('SoInvDetailsInfo.unit = ' + unit);
      }
      if (destinations.length > 0) {
        SaleOrder.andWhere('SoInvDetailsInfo.destination in (' + destinations + ')');
      }
      const saleOrderDetails = await SaleOrder.orderBy(
        'SoInvDetailsInfo.edlDate',
        'ASC'
      ).getRawMany();
      console.log(saleOrderDetails);
      const saleOrderDto: SaleOrderTrackDTO[] = [];

      if (saleOrderDetails) {
        let destinationMap = new Map<number, String>();
        let customerMap = new Map<number, String>();
        let endCustomerMap = new Map<number, String>();
        let countryMap = new Map<number, String>();
        let plantMap = new Map<number, String>();
        let currencyMap = new Map<number, String>();


        for (const eachItem of saleOrderDetails) {
          console.log('***********************' + eachItem);
          // const itemData = this.soItemRepo
          //   .createQueryBuilder('SaleOrderItems')
          //   .select("count(SaleOrderItems.sale_order_item_id) as cnt")
          //   .where('SaleOrderItems.sale_order_id =' + eachItem.saleOrderId)
          //   .groupBy('saleOrderItemsInfo.itemId');
          // const loadTypeData = await itemData.getRawOne();
          // console.log('loadTypeData' + loadTypeData);

          const totals = this.soItemRepo
            .createQueryBuilder('SaleOrderItems')
            .select(
              'SUM(SaleOrderItems.cases) as orderedQty,SUM(SaleOrderItems.netAmount) as orderPrice,SUM(SaleOrderItems.netWeight) as orderweight,uom_id as uomId'
            )
            .where('SaleOrderItems.sale_order_id =' + eachItem.saleOrderId)
          const totalsData = await totals.getRawOne();

          console.log('totalsDatatotalsData' + totalsData);
          let destination;
          let customer;
          let endCustomername;
          let country;
          let plant;
          let currency;

          if (!(currencyMap.has(eachItem.currency))) {
            const currencyId = await this.currencyRepository.getCurrencyById({
              currencyId: eachItem.currency,
            });
            currencyMap.set(currencyId.data.currencyId, currencyId.data.currencyName)
          }
          currency = currencyMap.get(eachItem.currency)

          if (!(customerMap.has(eachItem.customerId))) {
            const customerId = await this.customerRepository.getCustomerDataById({
              custId: eachItem.customerId,
            });
            customerMap.set(customerId.data.custId, customerId.data.clientName)
          }
          customer = customerMap.get(eachItem.customerId)


          if (!(destinationMap.has(eachItem.destination))) {
            const destination = await this.destinationRepository.getDestinationById({
              destinationId: eachItem.destination,
            });
            destinationMap.set(destination.data.destinationId, destination.data.destinationName)
          }
          destination = destinationMap.get(eachItem.destination)

          if (!(endCustomerMap.has(eachItem.endCustomerId))) {
            const endCustomer = await this.endCustomerRepository.getEndCustomerDataById(
              { endCustomerId: eachItem.endCustomerId }
            );
            endCustomerMap.set(endCustomer.data.endCustomerId, endCustomer.data.endCustomerName)
          }
          endCustomername = endCustomerMap.get(eachItem.endCustomerId)

          if (!(countryMap.has(eachItem.country))) {
            const countriesData = await this.countryRepository.getCountryById({
              countryId: eachItem.country,
            });
            countryMap.set(countriesData.data.countryId, countriesData.data.countryName)
          }
          country = countryMap.get(eachItem.country)
          if (!(plantMap.has(eachItem.unit))) {
            const unitData = await this.unitcodeService.getPlantDetailsById({ unitcodeId: eachItem.unit })
            plantMap.set(unitData.data.unitcodeId, unitData.data.unitcodeName)
          }
          plant = plantMap.get(eachItem.unit)

          console.log('endCustomer' + endCustomer);

          const fgStockQty = await this.fgService.getStockQtyForSo({ saleOrderId: eachItem.saleOrderId });
          let fgStock = 0;
          if (fgStockQty.status) {
            fgStock = fgStockQty.data.physicalQuantity;
          }
          else {
            fgStock = 0;
          }
          const rmStockQty = await this.stockService.getAvailableStockForSO({ saleOrderId: eachItem.saleOrderId, plantId: eachItem.unit });
          let rmStock = 0;
          if (rmStockQty.status) {
            rmStock = rmStockQty.data.physicalQuantity;
          }
          else {
            rmStock = 0;
          }
          const process = eachItem.RmStatus;
          const prodStatus = eachItem.prodStatus;
          const packing = eachItem.pmStatus;
          const qualityAssurance = eachItem.qualityCheckStatus;
          const logistics = eachItem.containerStatus;
          const doc = eachItem.DocStatus;
          const SaleObject = new SaleOrderTrackDto(
            eachItem.saleOrderId,
            eachItem.saleOrderNumber,
            destination,
            customer,
            eachItem.category,
            eachItem.invoiceDate,
            eachItem.edlDate,
            totalsData.orderedQty,
            totalsData.orderPrice,
            eachItem.status,
            rmStock,
            process,
            packing,
            qualityAssurance,
            logistics,
            doc,
            fgStock,
            plant,
            eachItem.invoiceDate,
            eachItem.poNumber,
            endCustomername,
            country,
            totalsData.orderweight,
            false,
            eachItem.currency,
            currency,
            totalsData.uomId,
            eachItem.isInvoiced,
            eachItem.buyerPoNumber,
            eachItem.soType,
            eachItem.soProcessType,
            eachItem.actEdlDate, prodStatus
          );
          saleOrderDto.push(SaleObject);
        }
        // console.log(saleOrderDto);

        const response = new AllSaleOrdersTrackResponseModel(
          true,
          11108,
          'Sale Order Details retrieved successfully',
          saleOrderDto
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async totalSoData(saleOrderTrackFilters: SaleOrderTrackFilters): Promise<SoReportResponseModel> {
    try {
      console.log(saleOrderTrackFilters);
      var manager = getManager();
      let soQuery = `SELECT so.so_process_type soProcessType,so.so_type as soType,so.life_cycle_status as lifeCycleStatus,soin.is_sub_contract as isSubContract,so.sale_order_no as soNo,ed.end_customer_id,so.sale_order_id,soi.sale_order_item_id
      ,cst.client_name as customer,ed.end_customer_name as endCustomer,ed.end_customer_code as endCustomerCode ,soin.po_number as poNo,soin.buyer_po_number as buyerPoNo,soin.cus_address as cusAddress,soin.del_address as delAddress,
      soin.port_of_entry as portOfEntry,
      c.country_name as country, de.destination_name as destinationAddress, soin.act_edl_date as etd,soin.eda_date as eta,dt.delivery_terms_name as delTerm,pt.payment_terms_name as payTerm,sht.shipping_term_name as shipmentTerm,b.brand_name as brand, CONCAT(soi.min_grade_id,'/',soi.max_grade_id) as Grade , CONCAT(p.name,' ',ft.food_type,' ',vl1.name,' ',vl2.name,' ',vl3.name,' ',vl4.name) AS variety,sk.variant_code as productSku,uc.unit_name as manUnit, soi.soaking_style as soakStyle,soi.soaking_time as soakTime,
       soi.job_cases as jobCases , soi.cases,CONCAT(soi.pouches,'*',soi.pouch_weight,' ',um.uom_name) AS packStyle,sopo.brandType,sopo.is_brand_approved as isBrandApproved,sopo.additional_note as addNote,ct.certificate_name as certification,sopo.certification_id,sopo.is_certified as isCertified,sopo.rating,sopo.lotCode,sopo.labInspection,sopo.laod_inpection as loadInspection,puc.unit_name as processingUnit,soi.pouches,soi.pouch_weight as pouchWeight,soi.uom_id as uomId,soi.net_weight as netWeight,soi.net_amount as netAmount,soi.unitPrice as unitPrice,soin.currency_id as currencyId,so.status as soStatus,soin.invoice_date as invDate,soi.case_weight as caseWeight,soi.style_weighment as styleWeighment,soin.factoryId,soin.processing_unit,soi.shrimp_weight as shrimpWeight,soi.category, soin.job_type as jobType,soi.created_at as createdDate, soi.reported_cases as reportingCases,uc.unit_code_id,si.inspection, IF(si.inspection='SGS Inspection',si.is_checked,'') as sgsInspection , IF(si.inspection='TUV Inspection',si.is_checked,'') as tuvInspection,st.production_completed AS productionCompleted,st.prod_completed_date AS  productionCompletedDate,spd.lotCode,ROUND((soi.reported_cases/soi.job_cases)*100,2) AS completionPercentage,ROUND(st.production_percentage) AS productionPercent,soi.reported_date as reportedDate,
       IF(con.container_number!=NULL,con.container_number,'No') AS containerStatus,si.inspection_status AS inspectionStatus FROM `+ appSettings.sales_db + `.sale_order_items soi
      LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON soi.sale_order_id = so.sale_order_id 
      LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soin ON soin.sale_order_id = soi.sale_order_id 
      LEFT JOIN `+ appSettings.sales_db + `.so_po_details sopo ON sopo.sale_order_id = soi.sale_order_id 
      LEFT JOIN `+ appSettings.masters_db + `.master_brands b ON b.master_brand_id = soi.master_brand_id
      LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id = soi.item_id 
      LEFT JOIN `+ appSettings.masters_db + `.end_customers ed ON soin.end_customer_id = ed.end_customer_id 
      LEFT JOIN `+ appSettings.masters_db + `.food_types ft ON ft.food_type_id = soi.food_type_id 
      LEFT JOIN `+ appSettings.masters_db + `.value_addition_one_types vl1 ON vl1.value_addition_one_id = soi.value_addition_one_id 
      LEFT JOIN `+ appSettings.masters_db + `.value_addition_two_types vl2 ON vl2.value_addition_two_id = soi.value_addition_two_id 
      LEFT JOIN `+ appSettings.masters_db + `.value_addition_three_types vl3 ON vl3.value_addition_three_id = soi.value_addition_three_id 
      LEFT JOIN `+ appSettings.masters_db + `.value_addition_four_types vl4 ON vl4.value_addition_four_id = soi.value_addition_four_id 
      LEFT JOIN `+ appSettings.masters_db + `.value_addition_five_types vl5 ON vl5.value_addition_five_id = soi.value_addition_five_id 
      LEFT JOIN `+ appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = soi.varient_id 
      LEFT JOIN `+ appSettings.masters_db + `.delivery_terms dt ON dt.delivery_terms_id = soin.del_terms 
      LEFT JOIN `+ appSettings.masters_db + `.payment_terms pt ON pt.payment_terms_id = soin.pay_terms_id 
      LEFT JOIN `+ appSettings.masters_db + `.shipping_terms sht ON sht.shipping_term_id = soin.shipment_terms
      LEFT JOIN `+ appSettings.masters_db + `.customers cst ON cst.cust_id = soin.customer_id 
      LEFT JOIN `+ appSettings.masters_db + `.countries c ON c.country_id = soin.country_id 
      LEFT JOIN `+ appSettings.masters_db + `.destination de ON de.destination_id = soin.destination 
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = soin.factoryId
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes puc ON puc.unit_code_id = soin.processing_unit
      LEFT JOIN `+ appSettings.masters_db + `.currencies cr ON cr.currency_id = soin.currency_id
      LEFT JOIN `+ appSettings.masters_db + `.uoms um ON um.uom_id = soi.uom_id
      LEFT JOIN `+ appSettings.masters_db + `.certificates ct ON ct.certificate_id = sopo.certification_id
      LEFT JOIN `+ appSettings.sales_db + `.so_inspection si ON si.sale_order_id = soi.sale_order_id
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_track st ON st.sale_order_id = soi.sale_order_id
      LEFT JOIN `+ appSettings.sales_db + `.so_po_details spd ON spd.sale_order_id=soi.sale_order_id
      LEFT JOIN `+ appSettings.logistics_db + `.container con ON con.sale_order_id=soi.sale_order_id
       where so.sale_order_id>0 and so.so_process_type = 'MTO' ` ;
      if (saleOrderTrackFilters.unit > 0) {
        soQuery = soQuery + ' and soin.factoryId = ' + saleOrderTrackFilters.unit;
      }
      if (saleOrderTrackFilters.prodUnit > 0 && saleOrderTrackFilters.prodUnit != 5) {
        soQuery = soQuery + ' and soin.processing_unit = ' + saleOrderTrackFilters.prodUnit;
      }
      if (saleOrderTrackFilters.selectedEndCustomer > 0) {
        soQuery = soQuery + ' and soin.end_customer_id = ' + saleOrderTrackFilters.selectedEndCustomer;
      }     
     
      if(saleOrderTrackFilters.mainCategory != undefined && saleOrderTrackFilters.lifeCycleStatus == undefined){
        var quotedAndCommaSeparated = "'" + saleOrderTrackFilters.mainCategory.join("','") + "'";   
        let category =`SELECT group_concat(CONCAT("'",sub_category,"'")) AS subCategory FROM life_cycle_categories WHERE main_category IN (`+quotedAndCommaSeparated+`)`;
        let lifecylceData = await manager.query(category)
        console.log(lifecylceData,'lifecylceData')
        soQuery = soQuery + ' and so.life_cycle_status in('+lifecylceData[0].subCategory+')'
      }
       if(saleOrderTrackFilters.mainCategory != undefined && saleOrderTrackFilters.lifeCycleStatus != undefined){
        soQuery = soQuery + ' and so.life_cycle_status in  ("' + saleOrderTrackFilters.lifeCycleStatus + '")';
      }
      if (saleOrderTrackFilters.mainCategory == undefined && saleOrderTrackFilters.lifeCycleStatus != undefined) {
        if (saleOrderTrackFilters.lifeCycleStatus == SoLifeCycleStatusEnum.LOADED_AND_SEALED) {
          let indexValue = Object.values(SoLifeCycleStatusEnum).indexOf(saleOrderTrackFilters.lifeCycleStatus as unknown as SoLifeCycleStatusEnum);
          const lifeCycleStatues = "'" + Object.values(SoLifeCycleStatusEnum).slice(0, indexValue + 1).join("','") + "'";
          soQuery = soQuery + ' and so.life_cycle_status in  ("' + lifeCycleStatues + '")';
        } 
        else {
          soQuery = soQuery + ' and so.life_cycle_status = "' + saleOrderTrackFilters.lifeCycleStatus + '"';
        }
      }

      if (saleOrderTrackFilters.countryId > 0) {
        soQuery = soQuery + ' and soin.country_id = ' + saleOrderTrackFilters.countryId;
      }
      if (saleOrderTrackFilters.saleOrderStatus != undefined) {
        var quotedAndCommaSeparated = "'" + saleOrderTrackFilters.saleOrderStatus.join("','") + "'";
        soQuery = soQuery + ' and so.status in (' + quotedAndCommaSeparated + ')';
      }
      if (saleOrderTrackFilters.destinations.length > 0) {
        soQuery = soQuery + ' and soin.destination in (' + saleOrderTrackFilters.destinations + ')';
      }
      if (saleOrderTrackFilters.selectedEstimatedFromDate != undefined) {
        soQuery = soQuery + ' and soin.invoice_date >= "' + saleOrderTrackFilters.selectedEstimatedFromDate + '" and  soin.invoice_date <= "' + saleOrderTrackFilters.selectedEstimatedToDate + '"';
      }
      if (saleOrderTrackFilters.selectedCreatedFromDate != undefined) {
        soQuery = soQuery + ' and DATE(soi.created_at)  >= "' + saleOrderTrackFilters.selectedCreatedFromDate + '" and DATE(soi.created_at) <="' + saleOrderTrackFilters.selectedCreatedToDate + '"';
      }
      if (saleOrderTrackFilters.masterBrandId > 0) {
        soQuery = soQuery + ' and soi.master_brand_id = ' + saleOrderTrackFilters.masterBrandId;
      }
      if (saleOrderTrackFilters.varientCode > 0) {
        soQuery = soQuery + ' and soi.varient_id = ' + saleOrderTrackFilters.varientCode;
      }
      if (saleOrderTrackFilters.readyForShipment) {
        soQuery = soQuery + '  and st.container_status != "SHIPPED" and st.production_percentage > 70';
      }
      if (!saleOrderTrackFilters.saleOrderStatus) {
        soQuery = soQuery + ` and so.status IN ('OPEN','INPROGRESS') `
      }
      `GROUP BY soi.sale_order_item_id ORDER By soin.act_edl_date,soin.po_number `;

      let soData = await manager.query(soQuery);

      let SoItemDataResponse = [];
      if (soData && soData.length > 0) {
        let counter = 1;
        const so_data = new SaleOrderReportDto();
        const stockDataMap = new Map<number, number>();
        const cartonStockDataMap = new Map<number, number>();
        for (const [index, soDataitem] of soData.entries()) {



          let bomLogDataQry = 'SELECT STATUS,quantity,po_quantity as poQty,grn_quantity as grnQty,assigned_quantity as assignedQty,item_id as itemId FROM packing_bom_log WHERE sale_order_item_id=' + soDataitem.sale_order_item_id + ' AND item_sub_category_id=2';
          let bomLogData = await manager.query(bomLogDataQry);
          if (bomLogData.length > 0) {
            soData[index].pouchStatus = bomLogData[0].STATUS;
            soData[index].Qty = bomLogData[0].quantity;
            soData[index].pouchPoQty = bomLogData[0].poQty;
            soData[index].pouchGrnQty = bomLogData[0].grnQty;
            soData[index].pouchAssignedQty = bomLogData[0].assignedQty;

            let stockData
            let availableQty
            if ((!stockDataMap.has(bomLogData[0].itemId) && soDataitem.soStatus != SoStatusEnum.CLOSED)) {
              const stockQry = 'select physical_quantity as bulkQty from ' + appSettings.procure_db + '.stock where saleorder_id = 0 and item_id = ' + bomLogData[0].itemId;
              stockData = await manager.query(stockQry)
              if (stockData.length > 0) {
                availableQty = stockData[0].bulkQty
              } else {
                availableQty = 0;
              }
            } else {
              availableQty = stockDataMap.get(bomLogData[0].itemId)
            }
            if (availableQty > 0 && Number(availableQty) >= Number(bomLogData[0].quantity)) {
              soData[index].pouchAvailableQty = bomLogData[0].quantity;
              availableQty = availableQty - bomLogData[0].quantity
              stockDataMap.set(bomLogData[0].itemId, availableQty)
            } else {
              soData[index].pouchAvailableQty = availableQty;
              availableQty = 0;
              stockDataMap.set(bomLogData[0].itemId, availableQty)
            }
          } else {
            soData[index].pouchStatus = '';
            soData[index].grnQty = 0;
            soData[index].poQty = 0;
            soData[index].assignedQty = 0;
            soData[index].Qty = 0;
          }



          // console.log('bomLogDatassyy')
          // console.log(bomLogData)
          // console.log(bomLogData[0])
          // console.log(bomLogData[0].STATUS)
          // console.log(bomLogData[0].quantity)
          // console.log(bomLogData[0]['status'])

          let bomLogCartonDataQry = 'SELECT STATUS,quantity,po_quantity as poQty,grn_quantity as grnQty,assigned_quantity as assignedQty,item_id as itemId FROM packing_bom_log WHERE sale_order_item_id=' + soDataitem.sale_order_item_id + ' AND item_sub_category_id=3';
          let bomLogCartonData = await manager.query(bomLogCartonDataQry);
          if (bomLogCartonData.length > 0) {
            soData[index].cartonStatus = bomLogCartonData[0].STATUS;
            soData[index].cartons = bomLogCartonData[0].quantity;
            soData[index].cartonPoQty = bomLogCartonData[0].poQty;
            soData[index].cartonGrnQty = bomLogCartonData[0].grnQty;
            soData[index].cartonAssignedQty = bomLogCartonData[0].assignedQty;
            let cartonStockData
            let availableStock
            if ((!cartonStockDataMap.has(bomLogCartonData[0].itemId) && soDataitem.soStatus != SoStatusEnum.CLOSED)) {
              const cartonstockQry = 'select physical_quantity as bulkQty from ' + appSettings.procure_db + '.stock where saleorder_id = 0 and item_id = ' + bomLogCartonData[0].itemId;
              cartonStockData = await manager.query(cartonstockQry)
              if (cartonStockData.length > 0) {
                availableStock = cartonStockData[0].bulkQty
              } else {
                availableStock = 0;
              }
            } else {
              availableStock = cartonStockDataMap.get(bomLogCartonData[0].itemId)
            }
            if (availableStock > 0 && Number(availableStock) >= Number(bomLogCartonData[0].quantity)) {
              soData[index].cartonAvailableQty = bomLogCartonData[0].quantity;
              availableStock = availableStock - bomLogCartonData[0].quantity
              cartonStockDataMap.set(bomLogCartonData[0].itemId, availableStock)
            } else {
              soData[index].cartonAvailableQty = availableStock;
              availableStock = 0;
              cartonStockDataMap.set(bomLogCartonData[0].itemId, availableStock)
            }
          } else {
            soData[index].cartonStatus = 'Error';
            soData[index].cartons = 0;
            soData[index].cartonPoQty = 0;
            soData[index].cartonGrnQty = 0;
            soData[index].cartonAssignedQty = 0;
          }



        }


        // soData.forEach(async sodata => {
        //    let pouchQuery='SELECT status,quantity FROM packing_bom_log WHERE sale_order_item_id=3154 AND item_sub_category_id=2';
        //   let pouchData = await manager.query(pouchQuery);
        //   console.log(pouchData+'bbbbb');

        // //   sodata.pouches=pouchData.quantity;
        // //   console.log('sodata.pouches= ');
        // //  await pouchData.forEach(async pouch_data =>{
        // //     sodata.pouches=pouch_data.status;

        // //   })
        //   // let cartonQuery='SELECT status,quantity FROM packing_bom_log WHERE sale_order_item_id='+sodata.sale_order_item_id+' AND item_sub_category_id=3 GROUP BY sale_order_item_id';
        //   // let cartonData =await manager.query(cartonQuery);
        //   // sodata.cartons=cartonData.quantity;
        //   // sodata.cartonStatus=cartonData.status;
        //   const so_data: SaleOrderReportDto = this.soreportAdapter.convertEntityToDto(sodata);
        //    SoItemDataResponse.push(so_data);
        // });
        return new CommonResponse(true, 98999, 'data retrived', soData)
      } else {
        return new CommonResponse(false, 18111, 'No data found', undefined)
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async getEndCustDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT ed.end_customer_id AS endCustomerId , ed.end_customer_name AS endCustomerName , soin.processing_unit FROM  ` + appSettings.sales_db + `.sale_order_items soi
    LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON soi.sale_order_id = so.sale_order_id
    LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soin ON soin.sale_order_id = soi.sale_order_id 
    LEFT JOIN `+ appSettings.masters_db + `.end_customers ed ON soin.end_customer_id = ed.end_customer_id
    WHERE ed.end_customer_id>0 and so.sale_order_id> 0 and so.so_process_type = 'MTO' `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and soin.processing_unit = ' + req.unitId;
    }
    query = query + ` GROUP BY ed.end_customer_name ORDER BY endCustomerName `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1141, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1121, 'No data')
    }
  }
  async getCountryDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT soin.country_id AS countryId , c.country_name AS countryName , soin.processing_unit FROM ` + appSettings.sales_db + `.sale_order_items soi
  LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON soi.sale_order_id = so.sale_order_id
  LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soin ON soin.sale_order_id = soi.sale_order_id 
  LEFT JOIN `+ appSettings.masters_db + `.countries c ON c.country_id = soin.country_id 
  WHERE soin.country_id>0 and so.sale_order_id> 0 and so.so_process_type = 'MTO' `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and soin.processing_unit = ' + req.unitId;
    }
    query = query + ` GROUP BY c.country_name ORDER BY countryName `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1141, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1121, 'No data')
    }
  }
  async getManfUintDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT soi.sale_order_id , soin.factoryId AS factoryId , uc.unit_name AS manUnit,soin.processing_unit FROM ` + appSettings.sales_db + `.sale_order_items soi
  LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON soi.sale_order_id = so.sale_order_id
  LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soin ON soin.sale_order_id = soi.sale_order_id 
  LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = soin.factoryId
  WHERE soin.sale_order_id>0 and so.sale_order_id> 0 and so.so_process_type = 'MTO' `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and soin.processing_unit = ' + req.unitId;
    }
    query = query + ` GROUP BY uc.unit_name ORDER BY manUnit `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1141, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1121, 'No data')
    }
  }

  async getDestinationDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT soin.destination AS destinationId , de.destination_name AS destinationName , soin.processing_unit FROM ` + appSettings.sales_db + `.sale_order_items soi
  LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON soi.sale_order_id = so.sale_order_id
  LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soin ON soin.sale_order_id = soi.sale_order_id 
  LEFT JOIN `+ appSettings.masters_db + `.destination de ON de.destination_id = soin.destination 
  WHERE soin.destination>0 and so.sale_order_id> 0 and so.so_process_type = 'MTO' `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and soin.processing_unit = ' + req.unitId;
    }
    query = query + ` GROUP BY de.destination_name ORDER BY destinationName `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1141, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1121, 'No data')
    }
  }
  async getBrandDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT soi.master_brand_id AS masterBrandId , b.brand_name AS masterBrandName, soin.processing_unit FROM ` + appSettings.sales_db + `.sale_order_items soi
  LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON soi.sale_order_id = so.sale_order_id
  LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soin ON soin.sale_order_id = soi.sale_order_id 
  LEFT JOIN `+ appSettings.masters_db + `.master_brands b ON b.master_brand_id = soi.master_brand_id 
  WHERE soi.master_brand_id>0 and so.sale_order_id> 0 and so.so_process_type = 'MTO' `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and soin.processing_unit = ' + req.unitId;
    }
    query = query + ` GROUP BY b.brand_name ORDER BY masterBrandName `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1141, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1121, 'No data')
    }
  }
  async getVariantDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT soi.varient_id AS skuCodeId , sk.variant_code AS variantCode , soin.processing_unit FROM ` + appSettings.sales_db + `.sale_order_items soi
  LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON soi.sale_order_id = so.sale_order_id
  LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soin ON soin.sale_order_id = soi.sale_order_id 
  LEFT JOIN `+ appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = soi.varient_id 
  WHERE soi.varient_id>0 and so.sale_order_id> 0 and so.so_process_type = 'MTO' `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and soin.processing_unit = ' + req.unitId;
    }
    query = query + ` GROUP BY sk.variant_code ORDER BY variantCode `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1141, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1121, 'No data')
    }
  }

  async soReport(): Promise<CommonResponse> {
    try {
      // console.log(saleOrderTrackFilters);
      let manager = getManager();
      let soQuery = `SELECT so.sale_order_id AS saleOrderId,so.sale_order_no AS saleOrderNumber,c.client_name AS customer,inv.invoice_date AS orderedDate,inv.end_customer_id as endCustomerId,inv.act_edl_date AS etd,SUM(si.net_weight) AS orderQty,SUM(si.net_amount) AS cost,d.destination_name AS destinationAddress,so.status AS status,st.pm_status AS packing,st.qc_status AS qualityAssurance,st.container_status AS logistics,st.doc_status AS doc,0 AS fgStock,inv.factoryId AS unit, inv.invoice_date AS poDate,inv.po_number AS poNo,inv.buyer_po_number AS buyerPONo,e.end_customer_name AS endCustomer,SUM(si.net_weight) AS totnetWeight, IF(count(si.sale_order_item_id)>1, 0, 1) AS loadType, cur.currency_id AS currencyId,cur.currency_name AS currency,si.uom_id AS uom,so.is_invoiced AS isInvoiced,so.so_type AS soType,so.so_process_type AS soProcessType,inv.act_edl_date AS actualEtd,inv.eda_date as eta,cn.country_name as countryName,inv.category as product,uc.unit_name as unit, st.production_status AS prodStatus,inv.processing_unit as processingUnitId,inv.factoryId as unitId, pu.unit_name as processingUnitName, inv.job_type as jobType,inv.is_sub_contract as isSubContract,inv.job_type as jobType,em.employee_name as salePerson,inv.cus_address as customerAddress,inv.del_address as deladdress,port_of_entry as portOfEntry,pt.payment_terms_name as payTerms,dt.delivery_terms_name as deliveryTerm
      FROM `+ appSettings.sales_db + `.so_invoice_details inv
      LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON so.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id
      LEFT JOIN `+ appSettings.masters_db + `.destination d ON d.destination_id=inv.destination
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_track st ON st.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_items si ON si.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.end_customers e ON e.end_customer_id=inv.end_customer_id
      LEFT JOIN `+ appSettings.masters_db + `.countries cn ON cn.country_id=inv.country_id
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=inv.factoryId
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes pu ON pu.unit_code_id=inv.processing_unit
      LEFT JOIN `+ appSettings.masters_db + `.delivery_terms on dt dt.delivery_terms_id=inv.del_terms
      LEFT JOIN `+ appSettings.masters_db + `.payment_terms pt pt.payment_terms_id=inv.pay_terms_id
      LEFT JOIN `+ appSettings.masters_db + `.employee_details em ON em.employee_id=inv.emp_id
      LEFT JOIN `+ appSettings.masters_db + `.currencies cur ON cur.currency_id=inv.currency_id
      where so.sale_order_id>0 `;
      soQuery = soQuery + ` GROUP BY so.sale_order_id ORDER By inv.act_edl_date`;
      console.log(soQuery)
      let soData = await manager.query(soQuery);

      const response = new CommonResponse(true, 11108, 'Sale Order Details retrieved successfully', soData);
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getAllSaleOrdersTrackData_new
    (saleOrderTrackFilters: SaleOrderTrackFilters): Promise<AllSaleOrdersTrackResponseModel> {
    try {
      let manager = getManager();
      let soQuery = `SELECT so.sale_order_id AS saleOrderId,ROUND(sot.production_percentage) AS productionPercentage,so.sale_order_no AS saleOrderNumber,c.client_name AS customer,inv.invoice_date AS orderedDate,inv.end_customer_id as endCustomerId,inv.act_edl_date AS expectedEndDate,SUM(si.net_weight) AS orderQty,SUM(si.net_amount) AS cost,d.destination_name AS destination,so.status AS status,so.life_cycle_status as lifeCyclestatus,st.pm_status AS packing,st.qc_status AS qualityAssurance,st.container_status AS logistics,st.doc_status AS doc,inv.factoryId AS unit, inv.invoice_date AS poDate,inv.po_number AS poNumber,inv.buyer_po_number AS buyerPONo,e.end_customer_name AS endCustomername,SUM(si.net_weight) AS totnetWeight, IF(count(si.sale_order_item_id)>1, 0, 1) AS loadType, cur.currency_id AS currencyId,cur.currency_name AS currency,si.uom_id AS uom,so.is_invoiced AS isInvoiced,so.so_type AS soType,so.so_process_type AS soProcessType,inv.act_edl_date AS actualEtd,cn.country_name as countryName,inv.category as product,uc.unit_name as unit, st.production_status AS prodStatus,inv.processing_unit as processingUnitId,inv.factoryId as unitId, pu.unit_name as processingUnitName, inv.job_type as jobType,st.is_dispatched AS dispatchStatus,SUM(si.reported_cases) as fgStock,inv.is_sub_contract as isSubContract,sot.production_status AS productionStatus,sot.fg_status AS fgStatus,sot.rm_status AS rmStatus,sot.container_status AS containerStatus
      FROM `+ appSettings.sales_db + `.so_invoice_details inv
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_track sot ON sot.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON so.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id
      LEFT JOIN `+ appSettings.masters_db + `.destination d ON d.destination_id=inv.destination
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_track st ON st.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_items si ON si.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.end_customers e ON e.end_customer_id=inv.end_customer_id
      LEFT JOIN `+ appSettings.masters_db + `.countries cn ON cn.country_id=inv.country_id
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=inv.factoryId
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes pu ON pu.unit_code_id=inv.processing_unit
      LEFT JOIN `+ appSettings.masters_db + `.currencies cur ON cur.currency_id=inv.currency_id where so.sale_order_id>0 `;
      if (saleOrderTrackFilters.unit > 0) {
        soQuery = soQuery + ' and inv.factoryId = ' + saleOrderTrackFilters.unit;
      }
      if (saleOrderTrackFilters.selectedEndCustomer > 0) {
        soQuery = soQuery + ' and inv.end_customer_id = ' + saleOrderTrackFilters.selectedEndCustomer;
      }
      if (saleOrderTrackFilters.saleOrderStatus != undefined && (saleOrderTrackFilters.saleOrderStatus).length > 0) {
        soQuery = soQuery + ' and so.status IN (' + saleOrderTrackFilters.saleOrderStatus + ')';
      }
      if (saleOrderTrackFilters.selectedEndCustomer > 0) {
        soQuery = soQuery + ' and inv.end_customer_id = ' + saleOrderTrackFilters.selectedEndCustomer;
      }
      if (saleOrderTrackFilters.selectedEstimatedFromDate != undefined) {
        soQuery = soQuery + ' and inv.act_edl_date between "' + saleOrderTrackFilters.selectedEstimatedFromDate + '" and "' + saleOrderTrackFilters.selectedEstimatedToDate + '"';
      }
      soQuery = soQuery + ` GROUP BY so.sale_order_id ORDER By inv.act_edl_date`;
      console.log(soQuery)
      let soData = await manager.query(soQuery);

      const response = new AllSaleOrdersTrackResponseModel(true, 11108, 'Sale Order Details retrieved successfully', soData);
      
      // const newLogDto = new LogsDto(1,'view all sale order track data', 'Sale order', saleOrderTrackFilters.saleOrderId, true, '',saleOrderTrackFilters.createdUser)
      //       let res = await this.logService.createLog(newLogDto);
      //       console.log(res);
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }

  }
  async getSaleOrderDataById(
    saleOrderIdRequest: SaleOrderIdRequest
  ): Promise<SaleOrderResponse> {
    try {
      const inputSaleOrderId = saleOrderIdRequest.saleOrderId;

      const saleOrderEntities = await this.soRepo.findOne({
        relations: [
          'saleOrderItemsInfo',
          'SoInvDetailsInfo',
          'SoPoDetailsInfo',
        ],
        where: { saleOrderId: inputSaleOrderId },
      });
      // console.log(saleOrderEntities);
      if (saleOrderEntities) {
        const convertedSaleOrderEntity: SaleOrderDto = this.saleOrderAdapter.convertEntityToDto(
          saleOrderEntities
        );
        const response = new SaleOrderResponse(
          true,
          11102,
          'saleOrder retrived successfully',
          convertedSaleOrderEntity
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (error) {
      return error;
    }
  }

  async updateReportingCases(saleOrderItemsCasesRequest: SaleOrderItemsCasesRequest): Promise<boolean> {
    try {
      let reportingCases;
      const getReportedcases = await this.soItemRepo.findOne({ where: { saleOrderItemId: saleOrderItemsCasesRequest.saleOrderItemId } });
      if (getReportedcases.reportedCases != null) {
        reportingCases = Number(getReportedcases.reportedCases) + Number(saleOrderItemsCasesRequest.reportingCases);
      }
      else {
        reportingCases = Number(saleOrderItemsCasesRequest.reportingCases);
      }
      const reportingCasesUpdate = await getConnection()
        .createQueryBuilder()
        .update(SaleOrderItems)
        .set({ reportedCases: reportingCases, reportedDate: saleOrderItemsCasesRequest.reportedDate })
        .where(
          'saleOrderItemId = ' + saleOrderItemsCasesRequest.saleOrderItemId
        ).execute();
      if (reportingCasesUpdate.affected > 0) {
        const reportingCasesUpdate = await getConnection()
          .createQueryBuilder()
          .update(SoInvoiceDetails)
          .set({ stockreportedDate: saleOrderItemsCasesRequest.reportedDate })
          .where(
            'saleOrderId = ' + saleOrderItemsCasesRequest.saleOrderId
          ).execute();
        const response = reportingCasesUpdate.affected === 1 ? true : false;
        return response;
      }
    }
    catch (error) {
      console.log(error);
      throw error;
    }
  }
  async getActiveSaleOrdersWithItemDetails(): Promise<ActiveSaleOrderWithItemDetailsResponseModel> {
    try {
      const saleOrderEntities = await this.soRepo.createQueryBuilder("SaleOrder")
        .leftJoinAndSelect('SaleOrder.saleOrderItemsInfo', 'saleOrderItemsInfo')
        .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .leftJoinAndSelect('SaleOrder.SoPoDetailsInfo', 'SoPoDetailsInfo')
        .where("SaleOrder.status IN ('OPEN','INPROGRESS')").orderBy("SaleOrder.sale_order_no", "ASC").getMany();

      if (saleOrderEntities) {

        const data: SaleOrderDetailViewInfoDTO[] = [];
        for (const eachData of saleOrderEntities) {
          const currencyId = this.currencyRepository.getCurrencyById({ currencyId: eachData.SoInvDetailsInfo.currency });
          const countryId = this.countryRepository.getCountryById({ countryId: eachData.SoInvDetailsInfo.country });
          const paymentId = this.paymentTermsRepository.getPaymentById({ paymentTermsId: eachData.SoInvDetailsInfo.payTermId });
          const shippingTermsId = this.shippingRepository.getShippingTermsById({ shippingTermsId: eachData.SoInvDetailsInfo.shipmentTerms });
          // const factoryId = this.customerRepository.getCustomerDataById({custId:eachData.factoryId});
          const customerId = this.customerRepository.getCustomerDataById({ custId: eachData.SoInvDetailsInfo.customerId });
          const endCustomerId = this.endCustomerRepository.getEndCustomerDataById({ endCustomerId: eachData.SoInvDetailsInfo.endCustomerId });

          let deliveryTermsData = this.deliveryTermsRepository.getDeliveryTermsById({ deliveryTermsId: eachData.SoInvDetailsInfo.deliveryTerms });
          let certificationData = this.certificationsRepository.getCertificationById({ certificateId: eachData.SoPoDetailsInfo.certificationId });
          const destination = this.destinationRepository.getDestinationById({ destinationId: eachData.SoInvDetailsInfo.destination });
          const salePerson = this.empDetService.getActiveEmployeesById({ employeeId: eachData.SoInvDetailsInfo.salePersonId });
          const saleOrderItems: SaleOrderItemsDTO[] = [];
          let totAmount = 0;
          let noOfCartone = '';
          let noOfPouches = '';
          const totals = this.soRepo.createQueryBuilder("SaleOrder")
            .select("SUM(saleOrderItemsInfo.cases) as orderedQty,SUM(saleOrderItemsInfo.netAmount) as orderPrice,SUM(saleOrderItemsInfo.netWeight) as orderweight,SUM(saleOrderItemsInfo.pouches) as totPouches,SUM(saleOrderItemsInfo.cases) as totCases")
            .leftJoinAndSelect('SaleOrder.saleOrderItemsInfo', 'saleOrderItemsInfo')
            .where("saleOrderItemsInfo.saleOrderId =" + eachData.saleOrderId)
          const totalsData = await totals.getRawOne();
          let uomId = "";
          for (const eachItem of eachData.saleOrderItemsInfo) {
            let uom = '';
            if (eachItem.uomId === 1) {
              uom = 'KG';
            }
            if (eachItem.uomId === 2) {
              uom = 'LB';
            }
            if (eachItem.uomId === 3) {
              uom = 'OZ';
            }
            if (eachItem.uomId === 4) {
              uom = 'Gms';
            }
            uomId = uom;
            const minGrade = this.gradesRepository.getGradeById({ gradeId: eachItem.minGrade });
            const maxGrade = this.gradesRepository.getGradeById({ gradeId: eachItem.maxGrade });
            const brandId = this.endCustomerRepository.getBrandsById({ brandId: eachItem.brandId });
            const productId = this.productRepository.getActiveProductById({ productId: eachItem.itemId });
            console.log('brandIdbrandIdbrandId' + brandId);
            const variantId = this.skuCodesRepository.getSkuDataById({ skuCodeId: eachItem.varientId });
            let innerBagSizeId;
            if (eachData.SoInvDetailsInfo.category === "Skewers") {
              innerBagSizeId = this.sizesService.getSizeDataById({ sizeId: eachItem.innerBagSizeId != null ? eachItem.innerBagSizeId : 0 });
            }
            noOfCartone += eachItem.cases;
            noOfPouches += eachItem.pouches;
            await Promise.all([uom, minGrade, maxGrade, brandId, variantId, innerBagSizeId, productId]).then(res => {
              const brand: string = res[3].status ? res[3].data.brandName : null;
              const varient: string = res[4].status ? res[4].data.variantCode : null;
              const innerBagSize: string = res[5] === undefined ? "-" : res[5].sizeName;
              const product: string = res[6].status ? res[6].data.productCode : null;

              const packstyle = eachItem.pouches + " * " + eachItem.pouchWeight;
              const itemObject = new SaleOrderItemsDTO(eachItem.saleOrderItemId, eachItem.minGrade, eachItem.maxGrade, eachItem.brandId, brand, eachItem.varientId, varient, packstyle, eachItem.cases, eachItem.caseWeight, eachItem.unitPrice, eachItem.netWeight, eachItem.netAmount, uom, eachItem.styleWeighment, eachItem.minGlaze, eachItem.MaxGlaze, eachItem.soakingTime, eachItem.soakingStyle, eachItem.shrimpWeight, eachItem.innerBags, innerBagSize, eachItem.itemId, product, eachItem.pouches, eachItem.pouchWeight, eachItem.dispatchedQty, eachItem.invoiceAmount, eachItem.reportedCases, eachItem.categoryId, eachItem.jobCases);
              console.log(itemObject);
              saleOrderItems.push(itemObject);
            })
          }
          await Promise.all([currencyId, customerId, endCustomerId, deliveryTermsData, certificationData, countryId, paymentId, shippingTermsId, destination, salePerson]).then(res => {
            let currency = res[0].status ? res[0].data.currencyName : null;
            let customer = res[1].status ? res[1].data.clientName : null;
            let customerAddress = res[1].status ? res[1].data.cusAddressInfo[0].addLineOne + ", " + res[1].data.cusAddressInfo[0].addLineTwo + ", " + res[1].data.cusAddressInfo[0].addLineThree + ", " + res[1].data.cusAddressInfo[0].addLineFour : null;
            let endCustomer = res[2].status ? res[2].data.endCustomerName : null;
            let deliveryTerms = res[3].status ? res[3].data.deliveryTermsName : null;
            let sockingStyleId = res[3].status ? res[3].data.deliveryTermsName : null;
            let certification = res[4].status ? res[4].data.certificateName : null;
            let country = res[5].status ? res[5].data.countryName : null;
            let shippingTerms = res[7].status ? res[7].data.shippingTermsName : null;
            let payTermId = res[6].status ? res[6].data.paymentTermsName : null;
            let destinationAddress = res[8].status ? res[8].data.destinationName : null;
            let salePerson = res[9].status ? res[9].data.employeeName : null;
            let sgsInspection = eachData.SoPoDetailsInfo.labInspection;
            let brand = ''
            let styleWeighmentId = ''
            let soakingTime = ''
            let loadInspection = ''
            let tuvInspection = ''
            let unit = ''
            if (eachData.SoInvDetailsInfo.unit == 1) {
              unit = 'Unit1';
            }
            else if (eachData.SoInvDetailsInfo.unit == 2) {
              unit = 'Unit2';
            }
            else if (eachData.SoInvDetailsInfo.unit == 3) {
              unit = 'Kakinada';
            }
            const SaleObject = new SaleOrderDetailViewInfoDTO(
              eachData.saleOrderId,
              eachData.saleOrderNumber,
              eachData.SoInvDetailsInfo.invoiceDate,
              customer,
              eachData.SoInvDetailsInfo.customerId,
              eachData.SoInvDetailsInfo.poNumber,
              endCustomer,
              eachData.SoInvDetailsInfo.endCustomerId,
              brand,
              eachData.SoInvDetailsInfo.cusAddress,
              destinationAddress,
              deliveryTerms,
              payTermId,
              eachData.SoInvDetailsInfo.payTermId,
              totalsData.orderweight,
              totalsData.orderPrice,
              styleWeighmentId,
              certification,
              soakingTime,
              sockingStyleId,
              eachData.SoPoDetailsInfo.isBrandApproved,
              noOfPouches, noOfCartone,
              eachData.SoPoDetailsInfo.additionalNote,
              sgsInspection, tuvInspection,
              eachData.SoPoDetailsInfo.rating,
              eachData.SoPoDetailsInfo.iscertification,
              eachData.SoPoDetailsInfo.brandDesignType,
              eachData.SoInvDetailsInfo.edaDate,
              eachData.SoInvDetailsInfo.edlDate,
              eachData.SoInvDetailsInfo.actualEdldate,
              eachData.SoInvDetailsInfo.portOfEntry === 1 ? "Vizag" : "Kakinada",
              eachData.SoInvDetailsInfo.portOfEntry,
              country,
              shippingTerms,
              loadInspection,
              eachData.SoInvDetailsInfo.category,
              eachData.SoPoDetailsInfo.lotCode,
              eachData.SoInvDetailsInfo.currency,
              currency,
              eachData.SoInvDetailsInfo.unit,
              unit,
              uomId,
              eachData.filePath === undefined ? null : eachData.filePath,
              totalsData.totPouches,
              totalsData.totCases,
              salePerson,
              eachData.isInvoiced, destinationAddress, eachData.SoInvDetailsInfo.destination, eachData.SoInvDetailsInfo.buyerPoNumber,
              saleOrderItems, eachData.status);
            console.log('SaleObject' + SaleObject);
            data.push(SaleObject);
          })
        }
        const response = new ActiveSaleOrderWithItemDetailsResponseModel(true, 11108, "Sale Order Details retrieved successfully", data);
        return response;
      }
      else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    }
    catch (error) {
      console.log(error);
      throw error;
    }
  }
  async getSaleOrderInformationById(saleOrderIdRequest: SaleOrderIdRequest): Promise<GetSaleOrderInformationResponseModel> {
    try {
      const manager = getManager();
      const trackerQuery = `SELECT so.sale_order_id as saleOrderId, so.sale_order_no as saleOrder, DATE_FORMAT(inv.invoice_date, "%Y-%m-%d") as invDate, c.client_name as customer, inv.customer_id as customerId, inv.po_number as poNo, e.end_customer_name as endCustomer, inv.end_customer_id as endCustomerId, inv.cus_address as address, d.destination_name as  destinationAddress, dTerm.delivery_terms_name as deliveryTerms, pTerm.payment_terms_name as paymentTerms, pTerm.payment_terms_id as paymentTermsId, cert.certificate_name as certfication, soPo.is_brand_approved as isBrandApproved, soPo.additional_note as additionalNote, soPo.labInspection as sgsInspection, soPo.rating, soPo.is_certified as isCertified, soPo.brandType as brandDesignType, DATE_FORMAT(inv.eda_date, "%Y-%m-%d") as eta, DATE_FORMAT(inv.edl_date, "%Y-%m-%d") as etd, DATE_FORMAT(inv.act_edl_date, "%Y-%m-%d") as actualEtd, inv.port_of_entry as portOfEntry, inv.port_of_entry as portOfEntryId, con.country_name as country, sTerm. shipping_term_name as shippingTerms, inv.category, soPo.lotCode as lotCode, cur.currency_id as currencyId, cur.currency_name as currency, inv.factoryId as unitId, u.unit_name as unit, so.filePath as filePath, emp.employee_name as salePerson, so.is_invoiced as isInvoiced, inv.destination as finalDestinationId, inv.buyer_po_number as buyerPoNo, so.status as soStatus,pu.unit_name as processingUnit  FROM ` + appSettings.sales_db + `.sale_order so 
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.sale_order_track soTrk ON soTrk.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.so_po_details soPo ON soPo.sale_order_id=so.sale_order_id 
      LEFT JOIN ` + appSettings.masters_db + `.certificates cert ON cert.certificate_id=soPo.certification_id 
      LEFT JOIN ` + appSettings.masters_db + `.end_customers e ON e.end_customer_id=inv.end_customer_id
      LEFT JOIN ` + appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id
      LEFT JOIN ` + appSettings.masters_db + `.destination d ON d.destination_id=inv.destination
      LEFT JOIN ` + appSettings.masters_db + `.delivery_terms dTerm ON dTerm.delivery_terms_id=inv.del_terms
      LEFT JOIN ` + appSettings.masters_db + `.payment_terms pTerm ON pTerm.payment_terms_id=inv.pay_terms_id
      LEFT JOIN ` + appSettings.masters_db + `.shipping_terms sTerm ON sTerm.shipping_term_id=inv.shipment_terms
      LEFT JOIN ` + appSettings.masters_db + `.countries con ON con.country_id=inv.country_id
      LEFT JOIN ` + appSettings.masters_db + `.currencies cur ON cur.currency_id=inv.currency_id
      LEFT JOIN ` + appSettings.masters_db + `.employee_details emp ON emp.employee_id=inv.emp_id
      LEFT JOIN ` + appSettings.masters_db + `.unitcodes pu ON pu.unit_code_id=inv.processing_unit
      LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=inv.factoryId where so.sale_order_id=${saleOrderIdRequest.saleOrderId}`;

      const saleOrderDto = await manager.query(trackerQuery);

      // const saleOrderEntities = await this.soRepo.createQueryBuilder("SaleOrder")
      //   .leftJoinAndSelect('SaleOrder.saleOrderItemsInfo', 'saleOrderItemsInfo')
      //   .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
      //   .leftJoinAndSelect('SaleOrder.SoPoDetailsInfo', 'SoPoDetailsInfo')
      //   .where("SaleOrder.sale_order_id = " + saleOrderIdRequest.saleOrderId)
      //   .orderBy("SaleOrder.sale_order_no", "ASC").getOne();

      if (saleOrderDto && saleOrderDto.length) {
        const items: SaleOrderItemsDTO[] = [];
        const data: SaleOrderDetailViewInfoDTO = saleOrderDto.find((val) => val.saleOrderId == saleOrderIdRequest.saleOrderId);

        data.brand = ''
        data.styleWeightment = ''
        data.soakingTime = ''
        data.loadInspection = ''
        data.tuvInspection = ''
        data.noOfCartone = '';
        data.noOfPouches = '';
        data.uom = "";
        data.filePath = data.filePath ? null : data.filePath
        data.itemData = items;

        // const currencyId = this.currencyRepository.getCurrencyById({ currencyId: saleOrderEntities.SoInvDetailsInfo.currency });
        // const countryId = this.countryRepository.getCountryById({ countryId: saleOrderEntities.SoInvDetailsInfo.country });
        // const paymentId = this.paymentTermsRepository.getPaymentById({ paymentTermsId: saleOrderEntities.SoInvDetailsInfo.payTermId });
        // const shippingTermsId = this.shippingRepository.getShippingTermsById({ shippingTermsId: saleOrderEntities.SoInvDetailsInfo.shipmentTerms });
        // // const factoryId = this.customerRepository.getCustomerDataById({custId:saleOrderEntities.factoryId});
        // const customerId = this.customerRepository.getCustomerDataById({ custId: saleOrderEntities.SoInvDetailsInfo.customerId });
        // const endCustomerId = this.endCustomerRepository.getEndCustomerDataById({ endCustomerId: saleOrderEntities.SoInvDetailsInfo.endCustomerId });

        // let deliveryTermsData = this.deliveryTermsRepository.getDeliveryTermsById({ deliveryTermsId: saleOrderEntities.SoInvDetailsInfo.deliveryTerms });
        // let certificationData = this.certificationsRepository.getCertificationById({ certificateId: saleOrderEntities.SoPoDetailsInfo.certificationId });
        // const destination = this.destinationRepository.getDestinationById({ destinationId: saleOrderEntities.SoInvDetailsInfo.destination });
        // const salePerson = this.empDetService.getActiveEmployeesById({ employeeId: saleOrderEntities.SoInvDetailsInfo.salePersonId });
        // const saleOrderItems: SaleOrderItemsDTO[] = [];
        // let totAmount = 0;

        // // const totals = this.soRepo.createQueryBuilder("SaleOrder")
        // // .select("SUM(saleOrderItemsInfo.cases) as orderedQty,SUM(saleOrderItemsInfo.netAmount) as orderPrice,SUM(saleOrderItemsInfo.netWeight) as orderweight,SUM(saleOrderItemsInfo.pouches) as totPouches,SUM(saleOrderItemsInfo.cases) as totCases")
        // // .leftJoinAndSelect('SaleOrder.saleOrderItemsInfo', 'saleOrderItemsInfo')
        // // .where("saleOrderItemsInfo.saleOrderId ="+ saleOrderEntities.saleOrderId )
        // // const totalsData = await totals.getRawOne();
        // return await Promise.all([currencyId, customerId, endCustomerId, deliveryTermsData, certificationData, countryId, paymentId, shippingTermsId, destination, salePerson]).then(res => {
        //   let currency = res[0].status ? res[0].data.currencyName : null;
        //   let customer = res[1].status ? res[1].data.clientName : null;
        //   let customerAddress = res[1].status ? res[1].data.cusAddressInfo[0].addLineOne + ", " + res[1].data.cusAddressInfo[0].addLineTwo + ", " + res[1].data.cusAddressInfo[0].addLineThree + ", " + res[1].data.cusAddressInfo[0].addLineFour : null;
        //   let endCustomer = res[2].status ? res[2].data.endCustomerName : null;
        //   let deliveryTerms = res[3].status ? res[3].data.deliveryTermsName : null;
        //   let sockingStyleId = res[3].status ? res[3].data.deliveryTermsName : null;
        //   let certification = res[4].status ? res[4].data.certificateName : null;
        //   let country = res[5].status ? res[5].data.countryName : null;
        //   let shippingTerms = res[7].status ? res[7].data.shippingTermsName : null;
        //   let payTermId = res[6].status ? res[6].data.paymentTermsName : null;
        //   let destinationAddress = res[8].status ? res[8].data.destinationName : null;
        //   let salePerson = res[9].status ? res[9].data.employeeName : null;
        //   let sgsInspection = saleOrderEntities.SoPoDetailsInfo.labInspection;


        //   const SaleObject = new SaleOrderDetailViewInfoDTO(
        //     saleOrderEntities.saleOrderId,
        //     saleOrderEntities.saleOrderNumber,
        //     saleOrderEntities.SoInvDetailsInfo.invoiceDate,
        //     customer,
        //     saleOrderEntities.SoInvDetailsInfo.customerId,
        //     saleOrderEntities.SoInvDetailsInfo.poNumber,
        //     endCustomer,
        //     saleOrderEntities.SoInvDetailsInfo.endCustomerId,
        //     brand,
        //     saleOrderEntities.SoInvDetailsInfo.cusAddress,
        //     destinationAddress,
        //     deliveryTerms,
        //     payTermId,
        //     saleOrderEntities.SoInvDetailsInfo.payTermId,
        //     // totalsData.orderweight,
        //     // totalsData.orderPrice,
        //     0, 0,
        //     styleWeighmentId,
        //     certification,
        //     soakingTime,
        //     sockingStyleId,
        //     saleOrderEntities.SoPoDetailsInfo.isBrandApproved,
        //     noOfPouches, noOfCartone,
        //     saleOrderEntities.SoPoDetailsInfo.additionalNote,
        //     sgsInspection, tuvInspection,
        //     saleOrderEntities.SoPoDetailsInfo.rating,
        //     saleOrderEntities.SoPoDetailsInfo.iscertification,
        //     saleOrderEntities.SoPoDetailsInfo.brandDesignType,
        //     saleOrderEntities.SoInvDetailsInfo.edaDate,
        //     saleOrderEntities.SoInvDetailsInfo.edlDate,
        //     saleOrderEntities.SoInvDetailsInfo.actualEdldate,
        //     saleOrderEntities.SoInvDetailsInfo.portOfEntry === 1 ? "Vizag" : "Kakinada",
        //     saleOrderEntities.SoInvDetailsInfo.portOfEntry,
        //     country,
        //     shippingTerms,
        //     loadInspection,
        //     saleOrderEntities.SoInvDetailsInfo.category,
        //     saleOrderEntities.SoPoDetailsInfo.lotCode,
        //     saleOrderEntities.SoInvDetailsInfo.currency,
        //     currency,
        //     saleOrderEntities.SoInvDetailsInfo.unit,
        //     unit,
        //     uomId,
        //     saleOrderEntities.filePath === undefined ? null : saleOrderEntities.filePath,
        //     // totalsData.totPouches,
        //     // totalsData.totCases,
        //     0, 0,
        //     salePerson,
        //     saleOrderEntities.isInvoiced, destinationAddress, saleOrderEntities.SoInvDetailsInfo.destination, saleOrderEntities.SoInvDetailsInfo.buyerPoNumber,
        //     saleOrderItems, saleOrderEntities.status);
        //   console.log('SaleObject' + SaleObject);
        //   // data.push(SaleObject);

        // })
        const response = new GetSaleOrderInformationResponseModel(true, 11108, "Sale Order Details retrieved successfully", data);
        return response;
      }
      else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    }
    catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getSaleOrderDetailsById(
    saleOrderIdRequest: SaleOrderIdRequest,
    request: Request

  ): Promise<SaleOrderDetailViewInfoResponseModel> {
    try {
      const saleOrderId = saleOrderIdRequest.saleOrderId;
      const poNo = saleOrderIdRequest.poNumber;

      const saleOrderEntities = await this.soRepo.findOne({
        relations: [
          'saleOrderItemsInfo',
          'SoInvDetailsInfo',
          'SoPoDetailsInfo',
        ],
        where: { saleOrderId: saleOrderId },
      });
      // console.log(saleOrderEntities);
      if (saleOrderEntities) {
        // const convertedsaleOrderDto: SaleOrderDetailViewInfoDTO = this.convertEntityToDto(saleOrderEntities);
        const saleOrderItems: SaleOrderItemsDTO[] = [];
        let totAmount = 0;
        let noOfCartone = '';
        let noOfPouches = '';
        let soId: number[] = [];
        let saleorderId = this.soInvRepo
          .createQueryBuilder('so_invoice_details')
          .select('sale_order_id')
          .where(`po_number = '${poNo}'`);
        const saleorderIds = await saleorderId.getRawMany();
        let saleId
        for (const resp of saleorderIds) {
          saleId = resp.sale_order_id
          soId.push(saleId)
        }
        const totals = this.soRepo
          .createQueryBuilder('SaleOrder')
          .select(
            'SUM(saleOrderItemsInfo.cases) as orderedQty,SUM(saleOrderItemsInfo.netAmount) as orderPrice,SUM(saleOrderItemsInfo.netWeight) as orderweight,SUM(saleOrderItemsInfo.pouches*saleOrderItemsInfo.cases) as totPouches,SUM(saleOrderItemsInfo.cases) as totCases,SUM(saleOrderItemsInfo.jobCases) as jobCases,saleOrderItemsInfo.category as category,saleOrderItemsInfo.requiredCount as requiredCount'
          )
          .leftJoinAndSelect(
            'SaleOrder.saleOrderItemsInfo',
            'saleOrderItemsInfo'
          )
          .where(
            'saleOrderItemsInfo.saleOrderId =' + saleOrderIdRequest.saleOrderId
          );
        const totalsData = await totals.getRawOne();
        let uomId = '';
        // let totWeight = 0;
        for (const eachItem of saleOrderEntities.saleOrderItemsInfo) {
          console.log('eachItem' + eachItem.requiredCount);
          // const uom = this.uomRepository.getActiveUomById({uomId:eachItem.uomId});
          // let totWeightConversion = 0;

          let uom = '';

          if (eachItem.uomId === 1) {
            uom = 'KG';
            // totWeightConversion = eachItem.netWeight * 2.20462;
          }
          if (eachItem.uomId === 2) {
            uom = 'LB';
            // totWeightConversion = eachItem.netWeight;
          }
          if (eachItem.uomId === 3) {
            uom = 'OZ';
            // totWeightConversion = eachItem.netWeight * 0.0625;
          }
          if (eachItem.uomId === 4) {
            uom = 'Gms';
            // totWeightConversion = eachItem.netWeight * 0.00220462;
          }
          // totWeightConversion += Number(totWeightConversion) ? Number(totWeightConversion) : 0;
          // console.log('totWeightConversion'+totWeightConversion);
          // uomId = uom;
          // totWeight = totWeightConversion;
          const taxDetails = this.taxesService.getTaxForId({ taxId: eachItem.taxId });
          const minGrade = this.gradesRepository.getGradeById({
            gradeId: eachItem.minGrade,
          });
          const maxGrade = this.gradesRepository.getGradeById({
            gradeId: eachItem.maxGrade,
          });
          const brandId = this.endCustomerRepository.getBrandsById({
            brandId: eachItem.brandId,
          });
          const productId = this.productRepository.getActiveProductById({
            productId: eachItem.itemId,
          });

          const variantId = this.skuCodesRepository.getSkuDataById({
            skuCodeId: eachItem.varientId,
          });
          const wipQuantity = this.productionInvService.getWipQuantityAgainstsoandsoitem({ saleOrderId: eachItem.saleOrderId, saleOrderItemId: eachItem.saleOrderItemId })
          console.log(wipQuantity, '##')
          let innerBagSizeId;
          if (eachItem.category === 'Skewers' || eachItem.category === 'Ring') {
            innerBagSizeId = this.sizesService.getSizeDataById({
              sizeId:
                eachItem.innerBagSizeId != null ? eachItem.innerBagSizeId : 0,
            });
          }

          // totAmount += eachItem.netAmount;
          // totWeight += eachItem.netWeight;
          noOfCartone += eachItem.cases;
          noOfPouches += eachItem.pouches;

          await Promise.all([
            uom,
            minGrade,
            maxGrade,
            brandId,
            variantId,
            innerBagSizeId,
            productId,
            taxDetails,
            wipQuantity

          ]).then((res) => {
            console.log()
            // console.log('res[5]res[5]'+res[5].sizeName);
            // const uom:string = res[0].status?res[0].data.uomName:null;
            console.log(res[8], '897')
            console.log(res[8].data, '89700')

            const brand: string = res[3].status ? res[3].data.brandName : null;
            const varient: string = res[4].status
              ? res[4].data.variantCode
              : null;
            const innerBagSize: string =
              res[5] === undefined ? '-' : res[5].sizeName;
            const product: string = res[6].status
              ? res[6].data.productName
              : null;
            const taxName: string = res[7].taxName
              ? res[7].taxName
              : null;
            const taxPer = res[7].taxName
              ? res[7].taxPercentage
              : null;

            const wipQuantity = res[8].status ? res[8].data.wipQuantity : null;
            console.log(wipQuantity, '@@')
            const packstyle = eachItem.pouches + ' * ' + eachItem.pouchWeight;
            const itemObject = new SaleOrderItemsDTO(
              eachItem.saleOrderItemId,
              eachItem.minGrade,
              eachItem.maxGrade,
              eachItem.brandId,
              brand,
              eachItem.varientId,
              varient,
              packstyle,
              eachItem.cases,
              eachItem.caseWeight,
              eachItem.unitPrice,
              eachItem.netWeight,
              eachItem.netAmount,
              uom,
              eachItem.styleWeighment,
              eachItem.minGlaze,
              eachItem.MaxGlaze,
              eachItem.soakingTime,
              eachItem.soakingStyle,
              eachItem.shrimpWeight,
              eachItem.innerBags,
              innerBagSize,
              eachItem.itemId,
              product,
              eachItem.pouches,
              eachItem.pouchWeight,
              eachItem.dispatchedQty,
              eachItem.invoiceAmount,
              eachItem.reportedCases,
              eachItem.categoryId, 0, eachItem.uomId, eachItem.grossWeightPerKg, eachItem.totalGrossWeight, eachItem.createdAt, eachItem.taxId, taxName, taxPer, eachItem.foodTypeId, eachItem.valueAdditionOneId, eachItem.valueAdditionTwoId, eachItem.valueAdditionThreeId, eachItem.valueAdditionFourId, eachItem.valueAdditionFiveId, eachItem.masterBrandId, eachItem.invoicedCases, eachItem.category, eachItem.jobCases, eachItem.packStyleId, 0, eachItem.requiredCount, eachItem.mainSoItemId, "", 0, 0, eachItem.invoicedQty, wipQuantity ,eachItem.revisedUnitPrice
            );
            console.log(itemObject, '132');
            saleOrderItems.push(itemObject);
            console.log('----------saleOrderItems----',saleOrderItems)
          });
        }

        const currencyId = this.currencyRepository.getCurrencyById({
          currencyId: saleOrderEntities.SoInvDetailsInfo.currency,
        });
        const countryId = this.countryRepository.getCountryById({
          countryId: saleOrderEntities.SoInvDetailsInfo.country,
        });
        const paymentId = this.paymentTermsRepository.getPaymentById({
          paymentTermsId: saleOrderEntities.SoInvDetailsInfo.payTermId,
        });

        const shippingTermsId = this.shippingRepository.getShippingTermsById({
          shippingTermsId: saleOrderEntities.SoInvDetailsInfo.shipmentTerms,
        });
        // const factoryId = this.customerRepository.getCustomerDataById({custId:saleOrderEntities.factoryId});
        const customerId = this.customerRepository.getCustomerDataById({ custId: saleOrderEntities.SoInvDetailsInfo.customerId });
        const endCustomerId = this.endCustomerRepository.getEndCustomerDataById({ endCustomerId: saleOrderEntities.SoInvDetailsInfo.endCustomerId });

        let deliveryTermsData = this.deliveryTermsRepository.getDeliveryTermsById({ deliveryTermsId: saleOrderEntities.SoInvDetailsInfo.deliveryTerms });
        let certificationData = this.certificationsRepository.getCertificationById({ certificateId: saleOrderEntities.SoPoDetailsInfo.certificationId });
        const destination = this.destinationRepository.getDestinationById({ destinationId: saleOrderEntities.SoInvDetailsInfo.destination });
        const salePerson = this.empDetService.getActiveEmployeesById({ employeeId: saleOrderEntities.SoInvDetailsInfo.salePersonId });
        const unitData = await this.unitcodeService.getPlantDetailsById({ unitcodeId: saleOrderEntities.SoInvDetailsInfo.unit });
        const processingunitData = await this.unitcodeService.getPlantDetailsById({ unitcodeId: saleOrderEntities.SoInvDetailsInfo.processingUnit });

        // const inspectionId = this.customerRepository.getCustomerDataById({custId:saleOrderObject.factoryId});
        let currency = '';
        let customer = '';
        let customerAddress = '-';
        let endCustomer = '';
        let deliveryTerms = '';
        let sockingStyleId = '';
        let certification = '';
        let country = '';
        let countryIdData = null;
        let brand = '';
        let factory: string = '';
        let styleWeighmentId: string = '';
        let payTermId: string = '';
        let sgsInspection: string = '';
        let tuvInspection: string = '';
        let soakingTime: string = '';
        let shippingTerms: string = '';
        let loadInspection: string = '';
        let destinationAddress: string = '';
        let unit = '';
        let processingunit = '';


        return await Promise.all([currencyId, customerId, endCustomerId, deliveryTermsData, certificationData, countryId, paymentId, shippingTermsId, destination, salePerson]).then(res => {
          currency = res[0].status ? res[0].data.currencyName : null;
          customer = res[1].status ? res[1].data.clientName : null;
          res[1].data.cusAddressInfo[0] ?
            customerAddress = res[1].status
              ? res[1].data.cusAddressInfo[0].addLineOne +
              ', ' +
              res[1].data.cusAddressInfo[0].addLineTwo +
              ', ' +
              res[1].data.cusAddressInfo[0].addLineThree +
              ', ' +
              res[1].data.cusAddressInfo[0].addLineFour
              : null
            : null;
          endCustomer = res[2].status ? res[2].data.endCustomerName : null;
          // endCustomer = '';
          deliveryTerms = res[3].status ? res[3].data.deliveryTermsName : null;
          sockingStyleId = res[3].status ? res[3].data.deliveryTermsName : null;
          certification = res[4].status ? res[4].data.certificateName : null;
          country = res[5].status ? res[5].data.countryName : null;
          countryIdData = res[5].status ? res[5].data.countryId : null;
          shippingTerms = res[7].status ? res[7].data.shippingTermsName : null;
          brand = '';
          factory = '';
          styleWeighmentId = '';
          payTermId = res[6].status ? res[6].data.paymentTermsName : null;
          destinationAddress = res[8].status ? res[8].data.destinationName : null;
          let salePerson = res[9].status ? res[9].data.employeeName : null;
          sgsInspection = saleOrderEntities.SoPoDetailsInfo.labInspection;
          tuvInspection = '';
          loadInspection = saleOrderEntities.SoPoDetailsInfo.loadInspection === true ? "YES" : "NO";
          unit = unitData.status ? unitData.data.unitcodeName : "";
          processingunit = processingunitData.status ? processingunitData.data.unitcodeName : "";
          // if (saleOrderEntities.SoInvDetailsInfo.unit == 1) {
          //   unit = 'Unit1';
          // } else if (saleOrderEntities.SoInvDetailsInfo.unit == 2) {
          //   unit = 'Unit2';
          // } else if (saleOrderEntities.SoInvDetailsInfo.unit == 3) {
          //   unit = 'Kakinada';
          // }
          const SaleObject = new SaleOrderDetailViewInfoDTO(
            saleOrderEntities.saleOrderId,
            saleOrderEntities.saleOrderNumber,
            saleOrderEntities.SoInvDetailsInfo.invoiceDate,
            customer,
            saleOrderEntities.SoInvDetailsInfo.customerId,
            saleOrderEntities.SoInvDetailsInfo.poNumber,
            endCustomer,
            saleOrderEntities.SoInvDetailsInfo.endCustomerId,
            brand,
            saleOrderEntities.SoInvDetailsInfo.cusAddress,
            saleOrderEntities.SoInvDetailsInfo.delAddress,
            deliveryTerms,
            payTermId,
            saleOrderEntities.SoInvDetailsInfo.payTermId,
            totalsData.orderweight,
            totalsData.orderPrice,
            styleWeighmentId,
            certification,
            soakingTime,
            sockingStyleId,
            saleOrderEntities.SoPoDetailsInfo.isBrandApproved,
            noOfPouches,
            noOfCartone,
            saleOrderEntities.SoPoDetailsInfo.additionalNote,
            sgsInspection,
            tuvInspection,
            saleOrderEntities.SoPoDetailsInfo.rating,
            saleOrderEntities.SoPoDetailsInfo.iscertification,
            saleOrderEntities.SoPoDetailsInfo.brandDesignType,
            saleOrderEntities.SoInvDetailsInfo.edaDate,
            saleOrderEntities.SoInvDetailsInfo.edlDate,
            saleOrderEntities.SoInvDetailsInfo.actualEdldate,
            saleOrderEntities.SoInvDetailsInfo.portOfEntry === 1
              ? 'Vizag'
              : 'Kakinada', saleOrderEntities.SoInvDetailsInfo.portOfEntry,
            country,
            shippingTerms,
            loadInspection,
            saleOrderEntities.SoInvDetailsInfo.category,
            saleOrderEntities.SoPoDetailsInfo.lotCode,
            saleOrderEntities.SoInvDetailsInfo.currency,
            currency,
            saleOrderEntities.SoInvDetailsInfo.unit,
            unit,
            uomId,
            saleOrderEntities.filePath === undefined
              ? null
              : saleOrderEntities.filePath,
            totalsData.totPouches,
            totalsData.totCases, salePerson,
            saleOrderEntities.isInvoiced, destinationAddress, saleOrderEntities.SoInvDetailsInfo.destination,
            saleOrderEntities.SoInvDetailsInfo.buyerPoNumber,
            saleOrderItems, saleOrderEntities.status, countryIdData, saleOrderEntities.SoInvDetailsInfo.processingUnit, processingunit);
          console.log(SaleObject);

          const response = new SaleOrderDetailViewInfoResponseModel(
            true,
            11108,
            'Sale Order Details retrieved successfully',
            SaleObject
          );
          return response;
        });
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (error) {
      console.log(error);

      throw error;
    }
  }

  async getSoViewDetails(
    selectedCustomer: number,
    selectedEndCustomer: number,
    selectedSaleOrder: number,
    selectedStatus: number,
    selectedExpectedDate: any
  ): Promise<SoViewResponseModel> {
    try {
      // console.log('So-View'+selectedCustomer, selectedEndCustomer,selectedSaleOrder,selectedStatus, selectedExpectedDate);
      const customerId = selectedCustomer;
      const endCustomerId = selectedEndCustomer;
      const saleOrderId = selectedSaleOrder;
      const status = selectedStatus;
      const getSoView = this.soRepo
        .createQueryBuilder('SaleOrder')
        .select([
          'SaleOrder.sale_order_id as saleOrderId,SaleOrder.sale_order_no as saleOrderNumber,saleInvDetails.customer_id as customer,saleInvDetails.end_customer_id as endCustomer, SaleOrder.status as status',
        ])
        .leftJoin(
          'sale_order_items',
          'saleOrderItems',
          'saleOrderItems.sale_order_id = SaleOrder.sale_order_id'
        )
        .leftJoin(
          'so_invoice_details',
          'saleInvDetails',
          'saleInvDetails.sale_order_id = SaleOrder.sale_order_id'
        );
      if (selectedCustomer > 0) {
        getSoView.andWhere('saleInvDetails.customer_id = :customerId', {
          customerId,
        });
      }
      if (selectedEndCustomer > 0) {
        getSoView.andWhere('saleInvDetails.end_customer_id = :endCustomerId', {
          endCustomerId,
        });
      }
      if (selectedSaleOrder != null) {
        getSoView.andWhere('SaleOrder.sale_order_id = :saleOrderId', {
          saleOrderId,
        });
      }
      if (selectedStatus > 0) {
        getSoView.andWhere('SaleOrder.status = :status', { status });
      }
      getSoView
        .groupBy('SaleOrder.sale_order_id')
        .orderBy('SaleOrder.saleOrderNumber', 'ASC');
      const soViewData = await getSoView.getRawMany();
      if (soViewData) {
        const soViewResponseModel = new SoViewResponseModel(
          true,
          11108,
          'Sale Order View',
          soViewData
        );
        return soViewResponseModel;
      }
    } catch (error) {
      // console.log(error);
      return error;
    }
  }

  /**
   *
   * @param saleOrderId
   * @returns
   */
  async getSaleOrderDetailsForId(saleOrderId: number) {
    const saleOrder = this.soRepo
      .createQueryBuilder('SaleOrder')
      .select([
        'SaleOrder.sale_order_id as saleOrderId,SaleOrder.sale_order_no as saleOrderNumber,so_process_type as soProcessType, SoInvDetailsInfo.invoice_date as soDate,SoInvDetailsInfo.po_number as poNumber,SoInvDetailsInfo.buyer_po_number as buyerPoNumber'
      ])
      .leftJoin('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
      .where('SaleOrder.sale_order_id = :saleOrderId', { saleOrderId })
      .getRawOne();
    if (saleOrder) {
      return saleOrder;
    } else {
      throw new ErrorResponse(9999, 'No Data Found');
    }
  }

  /**
  *
  * @param saleOrderId
  * @returns
  */
  async getPmStatus(saleOrderId: number): Promise<SoTrackResponseModel> {
    const saleOrderTrack = await this.soTrackRepo.findOne({ select: ['pmStatus'], where: { saleOrderInfo: { saleOrderId: saleOrderId } } });
    console.log(saleOrderTrack)
    const soTrackModel = new SoTrackModel(saleOrderTrack.pmStatus)

    if (saleOrderTrack) {
      return new SoTrackResponseModel(true, 5555, 'track Status retrived', soTrackModel);
    } else {
      throw new SoTrackResponseModel(false, 9999, 'No Data Found');
    }
  }

  async updateGrossWeight(soItems: SaleOrderGrossWeightRequest[]): Promise<CommonResponse> {
    try {
      const updateFlagSet = new Set<boolean>();
      console.log(soItems);
      for (const soItem of soItems) {
        console.log('soItem' + soItem.grossWeight);
        const soItemUpdate = await this.soItemRepo.update({ saleOrderItemId: soItem.saleOrderItemId }, { grossWeightPerKg: soItem.grossWeight, totalGrossWeight: soItem.totalGrossWeight });
        console.log(soItemUpdate);
        if (soItemUpdate) {
          console.log()
          updateFlagSet.add(true)
        } else {
          updateFlagSet.add(false)
          break;
        }
      }
      if (!(updateFlagSet.has(false))) {
        return new CommonResponse(true, 1001, "Gross Weight updated successfully. ",)

      } else {
        return new CommonResponse(false, 1010, "Gross Weight update failed. ",)
      }
    } catch (err) {
      return err
    }
  }



  /**
   *
   * @param saleOrderId
   * @returns
   */
  async getSaleOrderInformation(
    saleOrderId: number
  ): Promise<SaleOrderInfoResponseModel> {





    const saleOrderInfo = await this.soRepo.findOne({
      relations: ['SoInvDetailsInfo', 'saleOrderItemsInfo', 'SoPoDetailsInfo'],
      where: { saleOrderId: saleOrderId },
    });

    if (saleOrderInfo) {
      let noOfCases = 0;
      let noOfPouches = 0;
      let noOfInnerBags = 0;
      for (const item of saleOrderInfo.saleOrderItemsInfo) {
        noOfCases += item.cases;
        noOfPouches += item.cases * item.pouches;
        noOfInnerBags += 0;
      }
      const saleOrderInfoDto = new SaleOrderInfo(
        saleOrderInfo.saleOrderId,
        saleOrderInfo.saleOrderNumber,
        saleOrderInfo.SoInvDetailsInfo.category,
        saleOrderInfo.SoInvDetailsInfo.poNumber,
        noOfCases,
        noOfPouches,
        noOfInnerBags,
        saleOrderInfo.SoPoDetailsInfo.additionalNote
      );
      return new SaleOrderInfoResponseModel(
        true,
        1111,
        'Sale Order Information Found',
        saleOrderInfoDto
      );
    } else {
      throw new ErrorResponse(9999, 'No Data Found');
    }
  }

  async getSoNumbers(): Promise<SoNumbersResponseModel> {
    try {
      const soDTO: SoNumbersModel[] = [];
      const itemCategoryEntities: SaleOrderDropDownDto[] = await this.soRepo
        .createQueryBuilder('SaleOrder')
        .select('SaleOrder.sale_order_id as saleOrderId, SaleOrder.sale_order_no as saleOrderNumber,SoInvDetailsInfo.po_number as poNumber')
        .leftJoin('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .where('SaleOrder.status in ("OPEN","INPROGRESS")')
        .andWhere('SaleOrder.soProcessType not in("' + SoProcessTypesEnum.MTS + '")')
        .orderBy('SaleOrder.createdAt', 'DESC')
        .getRawMany();
      // const itemCategoryEntities: SoNumbersModel[] = await this.soRepo.find({
      //   select: ['saleOrderId', 'saleOrderNumber'],
      //   where: { status: In(["OPEN", "INPROGRESS"]), soProcessType: Not(SoProcessTypesEnum.MTS) },
      //   order: { createdAt: 'DESC' },
      // });
      if (itemCategoryEntities && itemCategoryEntities.length > 0) {
        itemCategoryEntities.forEach((itemCatEntity) => {
          soDTO.push(
            new SoNumbersModel(
              itemCatEntity.saleOrderId,
              itemCatEntity.saleOrderNumber,
              itemCatEntity.poNumber,
            )
          );
        });
        const response = new SoNumbersResponseModel(
          true,
          11108,
          'SO Numbers retrieved successfully',
          soDTO
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
  async getSoNumbersForInvoice(): Promise<SoNumbersResponseModel> {
    try {
      const soDTO: SoNumbersModel[] = [];
      const itemCategoryEntities: SaleOrderDropDownDto[] = await this.soRepo
        .createQueryBuilder('SaleOrder')
        .select('SaleOrder.sale_order_id as saleOrderId, SaleOrder.sale_order_no as saleOrderNumber,SoInvDetailsInfo.po_number as poNumber')
        .leftJoin('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .where('SaleOrder.status in ("OPEN","INPROGRESS")')
        .andWhere('SaleOrder.isInvoiced ="NO" ')
        .andWhere('SaleOrder.soProcessType not in("' + SoProcessTypesEnum.MTS + '")')
        .andWhere('SoInvDetailsInfo.jobType ="' + JobTypesEnum.MAIN_JOB + '"')
        .orderBy('SaleOrder.createdAt', 'DESC')
        .getRawMany();
      // const itemCategoryEntities: SoNumbersModel[] = await this.soRepo.find({
      //   select: ['saleOrderId', 'saleOrderNumber'],
      //   where: { status: In(["OPEN", "INPROGRESS"]), soProcessType: Not(SoProcessTypesEnum.MTS) },
      //   order: { createdAt: 'DESC' },
      // });
      if (itemCategoryEntities && itemCategoryEntities.length > 0) {
        itemCategoryEntities.forEach((itemCatEntity) => {
          soDTO.push(
            new SoNumbersModel(
              itemCatEntity.saleOrderId,
              itemCatEntity.saleOrderNumber,
              itemCatEntity.poNumber,
            )
          );
        });
        const response = new SoNumbersResponseModel(
          true,
          11108,
          'SO Numbers retrieved successfully',
          soDTO
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
  async getSoNumbersForDummyPackAssignment(req: BrandsRequest): Promise<SoItemDataResponse> {
    try {
      const soDTO: SaleOrderItemInfo[] = [];
      const soItemsData = await this.soItemRepo.getSoItemsInfo(req.brandId)
      // const soItemData = await this.saleOrderItemsRepository.find({
      //   select: ['saleOrderId','saleOrderItemId','brandId','varientId'],
      //   relations:['saleOrderInfo'],
      //   order: { createdAt: 'DESC' },
      // });
      console.log(soItemsData);
      if (soItemsData && soItemsData.length > 0) {
        for (const soItem of soItemsData) {
          const brandData = await this.endCustomerRepository.getBrandsById({
            brandId: soItem.brandId,
          });
          const productData = await this.productRepository.getActiveProductById({
            productId: soItem.productId,
          });
          const variantData = await this.skuCodesRepository.getSkuDataById({
            skuCodeId: soItem.variantId,
          });
          console.log(variantData)
          soDTO.push(
            new SaleOrderItemInfo(
              soItem.saleOrderNo,
              soItem.variantId,
              undefined, undefined, undefined, undefined, variantData.data.variantCode, undefined, undefined, productData.data.productName, soItem.saleOrderId, brandData.data.brandName, soItem.minGrade, soItem.maxGrade, soItem.pouches, soItem.pouchWeight, soItem.poNumber
            )
          );
        };
        const response = new SoItemDataResponse(
          true,
          11108,
          'SO Numbers retrieved successfully',
          soDTO
        );
        console.log(response)
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }

  async getSaleOrdersForTransfers(req?: UnitRequest): Promise<SoNumbersResponseModel> {
    try{
      const manager = getManager();
      let query;
      if(req.state === "StockTransferForPrepMaterial"){
        query = "SELECT si.sale_order_item_id AS saleOrderItemId, inv.po_number AS poNumber,inv.processing_unit AS processingUnit,inv.job_type AS jobType, inv.sale_order_id AS saleOrderId, CONCAT(s.sale_order_no, ' - ', inv.po_number, '/', mb.brand_name, '/', pm.packing_method_name , ' / ' , sk.variant_code) AS saleOrderNumber,s.status from "+appSettings.sales_db+".sale_order_items si left join "+appSettings.sales_db+".so_invoice_details inv on inv.sale_order_id = si.sale_order_id LEFT JOIN "+appSettings.masters_db+".sku_codes sk on sk.sku_code_id = si.varient_id LEFT JOIN "+appSettings.masters_db+".master_brands mb on mb.master_brand_id = si.master_brand_id LEFT JOIN "+ appSettings.sales_db + ".sale_order s ON s.sale_order_id = inv.sale_order_id LEFT JOIN "+appSettings.masters_db+".packing_methods pm on pm.packing_method_id = si.pack_style_id group by si.sale_order_id order by inv.sale_order_id desc";
      }
      else{
        query = "SELECT 0 AS saleOrderItemId,inv.po_number AS poNumber,inv.processing_unit AS processingUnit,inv.job_type AS jobType, inv.sale_order_id AS saleOrderId, CONCAT(s.sale_order_no, ' - ', inv.po_number) AS saleOrderNumber,s.status from "+appSettings.sales_db+".so_invoice_details inv LEFT JOIN "+ appSettings.sales_db + ".sale_order s ON s.sale_order_id = inv.sale_order_id GROUP BY inv.sale_order_id order by inv.sale_order_id desc";
      }
      const queryResult = await manager.query(query);
      if(queryResult.length > 0){
        const response = new SoNumbersResponseModel(true,11108,'SO Numbers retrieved successfully',queryResult);
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    }catch (err) {
      return err;
    }
  }

  async getSoNumbersForPo(req?: UnitRequest): Promise<SoNumbersResponseModel> {
    console.log(req);
    try {
      const soDTO: SoNumbersModel[] = [];
      // const soEntities: SoNumbersModel[] = await this.soRepo.find({
      //   select: ['saleOrderId', 'saleOrderNumber'],
      //   where: { status: In(["OPEN", "INPROGRESS"]) },
      //   order: { 'createdAt': 'DESC' }
      // });

      // const soEntities: SoNumbersModel[] = await this.soRepo.createQueryBuilder('so')
      //   .select(`so.sale_order_id as saleOrderId, CONCAT(sale_order_no, " - ", po_number) AS saleOrderNumber`)
      //   .leftJoin('so.SoInvDetailsInfo', 'SoInvDetailsInfo')
      //   .leftJoin('so.soTrackData', 'soTrackData')
      //   .where(`soTrackData.pm_status IN('OPEN', 'IN_PROGRESS', 'PARTIAL_PO') `)
      //   .orderBy('soTrackData.pm_status', 'DESC')
      //   .getRawMany();


      const manager = getManager();
      let query = `SELECT bom.sale_order_id AS saleOrderId, CONCAT(s.sale_order_no, " - ", inv.po_number) AS saleOrderNumber,s.status
           FROM `+ appSettings.sales_db + `.bom_details bom 
           LEFT JOIN `+ appSettings.sales_db + `.sale_order s ON s.sale_order_id = bom.sale_order_id
           LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id = s.sale_order_id WHERE packing_category IS NOT NULL`;
      if (req.state != "StockTransfer") {
        query += ` AND (quantity - (po_qty+assigned_qty)) > 0 AND bom.status!='CLOSED'`;
      }
      // AND (quantity - (po_qty+assigned_qty)) > 0 AND bom.status!='CLOSED'`;
      if (req?.unitId) {
        query += ` AND inv.processing_unit=${req.unitId}`;
      }
      query += ` GROUP BY bom.sale_order_id order by bom.sale_order_id desc`;

      const queryResult = await manager.query(query);
      // const response = await this.soRepo.createQueryBuilder('so')
      //   .select('saleOrderId, saleOrderNumber')
      //   .leftJoinAndSelect("so.SoInvDetailsInfo", 'SoInvDetailsInfo')
      //   .where(`SoInvDetailsInfo.factoryId = ${req.plantId} and status in("OPEN", "INPROGRESS")`)
      //   .getMany();


      if (queryResult?.length > 0) {
        const response = new SoNumbersResponseModel(
          true,
          11108,
          'SO Numbers retrieved successfully',
          queryResult
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }


  async getSoNumbersForPoFormUpdate(req?: PlantInputRequest): Promise<SoNumbersResponseModel> {
    try {
      const soDTO: SoNumbersModel[] = [];
      const soEntities: SoNumbersModel[] = await this.soRepo.createQueryBuilder('so')
        .select(`so.sale_order_id as saleOrderId, CONCAT(sale_order_no, " - ", po_number) AS saleOrderNumber`)
        .leftJoin('so.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .leftJoin('so.soTrackData', 'soTrackData')
        // .where('so.status in ("OPEN","INPROGRESS")')
        .orderBy('soTrackData.pm_status', 'DESC')
        .getRawMany();

      if (soEntities && soEntities.length > 0) {
        const response = new SoNumbersResponseModel(
          true,
          11108,
          'SO Numbers retrieved successfully',
          soEntities
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }

  async getSaleOrdersForProduct(inputReq: ProductIdRequest): Promise<SoNumbersResponseModel> {
    try {
      const soEntities: SoNumbersModel[] = await this.soRepo.getSaleOrdersForProduct(inputReq);

      if (soEntities && soEntities.length > 0) {
        const response = new SoNumbersResponseModel(
          true,
          11108,
          'SO Numbers retrieved successfully',
          soEntities
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }


  async getSaleOrderDataForSoId(
    saleOrderId: number
  ): Promise<SaleOrderDropDownDto> {
    const saleOrderInfo = await this.soRepo.findOne({
      select: ['saleOrderId', 'saleOrderNumber'],
      where: { saleOrderId: saleOrderId },
    });

    if (saleOrderInfo) {
      return saleOrderInfo;
    } else {
      return null;
    }
  }

  async getPoNumberForSoId(
    saleOrderId: number
  ): Promise<CommonResponse> {
    const saleOrderInfo = await this.soRepo.findOne({
      select: ['saleOrderId', 'saleOrderNumber'],
      relations:['SoInvDetailsInfo'],
      where: { saleOrderId: saleOrderId },
    });

    if (saleOrderInfo) {
      return new CommonResponse(true,5555,'data found',saleOrderInfo) ;
    } else {
      return null;
    }
  }

  async getSaleOrderFewDetailsForSoId(saleOrderId: number): Promise<SaleOrderFewDetailsDto> {
    const saleOrderInfo = await this.soRepo.getSaleOrderFewDetailsForSoId(saleOrderId);
    if (saleOrderInfo) {
      const soData = new SaleOrderFewDetailsDto(saleOrderInfo.saleOrderId, saleOrderInfo.saleOrderNumber, saleOrderInfo.SoInvDetailsInfo.poNumber, saleOrderInfo.SoInvDetailsInfo.category, saleOrderInfo.SoInvDetailsInfo.edaDate, saleOrderInfo.status)
      return soData;
    } else {
      return null;
    }

  }

  async getSoTrackInfo(): Promise<AllContainerStatusInfo> {
    const soTrackInfo: SaleOrderTrack[] = await this.soTrackRepo.find({
      where: {
        containerStatus: In([
          ContainerStatusEnum.NOT_READY,
          ContainerStatusEnum.READY_TO_BOOK,
        ]),
      },
      relations: ['saleOrderInfo'],
    });
    console.log(soTrackInfo);
    if (soTrackInfo.length) {
      const containersInfo: ContainerStatusInfo[] = [];

      for (const container of soTrackInfo) {
        const getSaleOrderItemDetails = await this.soItemRepo.find({ where: { saleOrderId: container.saleOrderInfo.saleOrderId } });
        let grossWeight = false;
        for (const item of getSaleOrderItemDetails) {
          if (item.grossWeightPerKg > 0) {
            grossWeight = true;
          }
          else {
            grossWeight = false;
          }
        }
        const saleOrderDetails = await this.getSaleOrderInformationById({ saleOrderId: container.saleOrderInfo.saleOrderId });
        const saleOrder = new SaleOrderDropDownDto(
          container.saleOrderInfo.saleOrderId,
          container.saleOrderInfo.saleOrderNumber
        );
        const containerData = new ContainerStatusInfo(
          null,
          container.containerStatus,
          saleOrder,
          ContainerLoadingStatus.OPEN,
          '',
          0,
          '',
          saleOrder.saleOrderNumber, '', '', saleOrderDetails.data.poNo, saleOrderDetails.data.buyerPoNo, saleOrderDetails.data.customer, saleOrderDetails.data.etd, saleOrderDetails.data.endCustomer, saleOrderDetails.data.finalDestination, grossWeight, saleOrderDetails.data.unit
        );
        containersInfo.push(containerData);
      }
      return new AllContainerStatusInfo(
        true,
        1111,
        'Container Status Info Found Successfully',
        containersInfo
      );
    } else {
      return new AllContainerStatusInfo(false, 9999, 'No Data Found');
    }
  }

  async getSoTrackBlStatusInfo(): Promise<AllBlStatusInfo> {
    const soTrackInfo: SaleOrderTrack[] = await this.soTrackRepo.find({
      where: {
        blStatus: In([
          BlStatusEnum.NOT_RECEIVED,
          BlStatusEnum.DRAFT_RECEIVED,
          BlStatusEnum.OBL_RECEIVED,
          BlStatusEnum.RECEIVED_AND_SHARED,
        ]),
      },
      relations: ['saleOrderInfo'],
    });

    if (soTrackInfo.length) {
      const containersInfo: BlStatusInfo[] = [];

      for (const container of soTrackInfo) {
        const saleOrder = new SaleOrderDropDownDto(
          container.saleOrderInfo.saleOrderId,
          container.saleOrderInfo.saleOrderNumber
        );
        const containerData = new BlStatusInfo(
          null,
          container.blStatus,
          saleOrder,
          saleOrder.saleOrderNumber
        );
        containersInfo.push(containerData);
      }
      return new AllBlStatusInfo(
        true,
        1111,
        'Container BL Status Info Found Successfully',
        containersInfo
      );
    } else {
      return new AllBlStatusInfo(false, 9999, 'No Data Found');
    }
  }


  async updateBlStatus(soBlStatus: SoContainerStatusUpdate) {
    const updateStatus = await this.soTrackRepo.update(
      {
        saleOrderInfo: Raw(
          (alias) => `sale_order_id = '${soBlStatus.saleOrderId}'`
        ),
      },
      { blStatus: soBlStatus.blStatus, saleOrderStatus: soBlStatus.soStatus }
    );
  }

  async updateSoStatusForBl(soContainerStatusForBl: SoContainerStatusUpdate) {
    console.log(soContainerStatusForBl);
    const updateSoStatus = await this.soRepo.update(
      {
        saleOrderId: Raw(
          (alias) => `sale_order_id = '${soContainerStatusForBl.saleOrderId}'`
        ),
      },
      { status: soContainerStatusForBl.soStatus },
    )
  }

  /**
   * Warehouse API
   * @returns All OPEN & INPROGRESS Sale Order Numbers
   */
  async getAllActiveSaleOrders(unitId: number): Promise<SaleOrderDropDownResponseModel> {
    try {
      const saleOrderDropDownDto: SaleOrderDropDownDto[] = [];

      const SaleOrder = this.soRepo
        .createQueryBuilder('SaleOrder')
        .select([
          'SaleOrder.sale_order_id AS saleOrderId',
          'sale_order_no AS saleOrderNumber',
          'SoInvDetailsInfo.po_number AS poNumber'
        ])
        .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
        .where('SaleOrder.status IN ("OPEN","INPROGRESS")')
        .andWhere('so_process_type !=  "MTS"')
        .andWhere('SoInvDetailsInfo.unit =' + unitId)
        .orderBy('sale_order_no', 'ASC');
      const saleOrderData = await SaleOrder.getRawMany();

      for (const eachItem of saleOrderData) {
        const data = new SaleOrderDropDownDto(
          eachItem.saleOrderId,
          eachItem.poNumber,
          eachItem.poNumber,
        );
        saleOrderDropDownDto.push(data);
      }

      console.log(saleOrderData);
      if (SaleOrder) {
        // saleOrderDropDownDto.push(SaleOrder);
        const response = new SaleOrderDropDownResponseModel(
          true,
          1,
          'Sale orders retrieved successfully',
          saleOrderDropDownDto
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }

  async getDummySaleOrders(unitId: number): Promise<SaleOrderDropDownResponseModel> {
    try {
      const saleOrderDropDownDto: SaleOrderDropDownDto[] = [];

      const SaleOrder = this.soRepo
        .createQueryBuilder('SaleOrder')
        .select([
          'SaleOrder.sale_order_id AS saleOrderId',
          'sale_order_no AS saleOrderNumber',
          'po_number AS poNumber'
        ])
        .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
        .where('SaleOrder.status IN ("OPEN","INPROGRESS")')
        .andWhere('SoInvDetailsInfo.unit =' + unitId)
        .andWhere('SaleOrder.soProcessType = "' + SoProcessTypesEnum.MTS + '"')
        .orderBy('sale_order_no', 'ASC');
      const saleOrderData = await SaleOrder.getRawMany();

      for (const eachItem of saleOrderData) {
        const data = new SaleOrderDropDownDto(
          eachItem.saleOrderId,
          eachItem.saleOrderNumber + "--" + eachItem.poNumber,
          eachItem.poNumber
        );
        saleOrderDropDownDto.push(data);
      }

      console.log(saleOrderData);
      if (SaleOrder) {
        // saleOrderDropDownDto.push(SaleOrder);
        const response = new SaleOrderDropDownResponseModel(
          true,
          1,
          'Sale orders retrieved successfully',
          saleOrderDropDownDto
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
  async getMTOSaleOrders(unitId: number): Promise<SaleOrderDropDownResponseModel> {
    try {
      const saleOrderDropDownDto: SaleOrderDropDownDto[] = [];

      const SaleOrder = this.soRepo
        .createQueryBuilder('SaleOrder')
        .select([
          'SaleOrder.sale_order_id AS saleOrderId',
          // 'sale_order_no AS saleOrderNumber',
          'po_number AS saleOrderNumber '
        ])
        .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
        .where('SaleOrder.status IN ("OPEN","INPROGRESS")')
        .andWhere('SoInvDetailsInfo.processing_unit =' + unitId)
        .andWhere('SaleOrder.soProcessType != "' + SoProcessTypesEnum.MTS + '"')
        .orderBy('sale_order_no', 'ASC');
      const saleOrderData = await SaleOrder.getRawMany();

      for (const eachItem of saleOrderData) {
        const data = new SaleOrderDropDownDto(
          eachItem.saleOrderId,
          eachItem.saleOrderNumber,
        );
        saleOrderDropDownDto.push(data);
      }

      console.log(saleOrderData);
      if (SaleOrder) {
        // saleOrderDropDownDto.push(SaleOrder);
        const response = new SaleOrderDropDownResponseModel(
          true,
          1,
          'Sale orders retrieved successfully',
          saleOrderDropDownDto
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }

  /**
   * Warehouse API
   * @param saleOrderIdRequest
   * @returns Sale Order Items Dropdown
   */
  async getSaleOrderItemsForSo(saleOrderIdRequest: SaleOrderIdRequest): Promise<SaleOrderItemsForSoDropDownResponseModel> {
    try {
      const itemsDetails: ItemsDetails[] = [];

      const itemData = this.soRepo
        .createQueryBuilder('SaleOrder')
        .select([
          'SaleOrder.sale_order_id AS saleOrderId',
          'SaleOrder.sale_order_no AS saleOrderNumber',
          'SoInvDetailsInfo.po_number AS poNumber',
          'saleOrderItems.sale_order_item_id AS saleOrderItemId',
          'saleOrderItems.item_id AS itemId',
          'saleOrderItems.brand_id AS brandId',
          'saleOrderItems.min_grade_id AS minGrade',
          'saleOrderItems.max_grade_id AS maxGrade',
          'saleOrderItems.varient_id AS varientId',
        ])
        .leftJoin(
          'sale_order_items',
          'saleOrderItems',
          'saleOrderItems.sale_order_id = SaleOrder.sale_order_id'
        )
        .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
        .where(
          'saleOrderItems.sale_order_id =' + saleOrderIdRequest.saleOrderId
        )
      if (saleOrderIdRequest.plantId != undefined && saleOrderIdRequest.plantId != 0) {
        itemData.andWhere('SoInvDetailsInfo.unit = ' + saleOrderIdRequest.plantId);
      }
      const saleOrderItems = await itemData.getRawMany();

      for (const eachItem of saleOrderItems) {
        const brandId = await this.endCustomerRepository.getBrandsById({
          brandId: eachItem.brandId,
        });
        const productId = await this.skuCodesRepository.getSkuDataById({
          skuCodeId: eachItem.varientId,
        });
        const itemName =
          brandId.data.brandName +
          '/' +
          productId.data.variantCode;
        // '/' +
        // eachItem.minGrade +
        // '-' +
        // eachItem.maxGrade;
        const itemdata = new ItemsDetails(eachItem.saleOrderItemId,
          itemName);
        itemsDetails.push(itemdata);

      }
      const data = new SaleOrderItemsDropDownDto(
        saleOrderItems[0].saleOrderId,
        saleOrderItems[0].saleOrderNumber,
        saleOrderItems[0].poNumber,
        itemsDetails
      );

      if (saleOrderItems.length > 0) {
        // saleOrderDropDownDto.push(SaleOrder);
        const response = new SaleOrderItemsForSoDropDownResponseModel(
          true,
          1101,
          'Sale Order Items  retrieved successfully',
          data
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
  async getSaleOrderItemsForSoId(saleOrderIdRequest: SaleOrderIdRequest): Promise<SaleOrderItemsDropdownResponse> {
    try {
      const connection = getManager();
      const itemsDetails: ItemsDetails[] = [];
      let soProcessType = await this.soRepo.findOne({where:{saleOrderId:saleOrderIdRequest.saleOrderId}});
      // const itemData = this.soRepo
      //   .createQueryBuilder('SaleOrder')
      //   .select([
      //     'SaleOrder.sale_order_no AS saleOrderNumber',
      //     'saleOrderItems.sale_order_item_id AS saleOrderItemId',
      //     'saleOrderItems.item_id AS itemId',
      //     'saleOrderItems.brand_id AS brandId',
      //     'saleOrderItems.min_grade_id AS minGrade',
      //     'saleOrderItems.max_grade_id AS maxGrade',
      //     'saleOrderItems.varient_id AS varientId',
      //     'SoInvDetailsInfo.end_customer_id AS endCustomerId',
      //     'saleOrderItems.pack_style_id AS packStyleId',
      //     'saleOrderItems.uom_id AS uomId'
      //   ])
      //   .leftJoin(
      //     'sale_order_items',
      //     'saleOrderItems',
      //     'saleOrderItems.sale_order_id = SaleOrder.sale_order_id'
      //   )
      //   .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
      //   .where(
      //     'saleOrderItems.sale_order_id =' + saleOrderIdRequest.saleOrderId
      //   )
      // if (saleOrderIdRequest.plantId != undefined && saleOrderIdRequest.plantId != 0) {
      //   itemData.andWhere('SoInvDetailsInfo.unit = ' + saleOrderIdRequest.plantId);
      // }
      // const saleOrderItems = await itemData.getRawMany();


      let saleorderItemsQuery = "Select si.sale_order_item_id AS saleOrderItemId,concat(mb.brand_name , '/' ,pd.name , '/' ,si.min_grade_id ,'-' , si.max_grade_id , '/' ,pm.packing_method_name) AS item, concat(pm.packing_method_name , '/' ,sku.variant_code , '/' , si.requiredCount) AS varientCode, concat(pm.packing_method_name , '/' ,sku.variant_code) AS varient, sku.sku_code_id AS variantId, sid.end_customer_id AS endCustomerId, si.pack_style_id AS packStyleId from " + appSettings.sales_db + ".sale_order_items si left join " + appSettings.sales_db + ".sale_order so on so.sale_order_id = si.sale_order_id ";
      if(soProcessType.soProcessType === SoProcessTypesEnum.MTS){
        saleorderItemsQuery = saleorderItemsQuery + " left join " + appSettings.masters_db + ".sku_codes sku on sku.sku_code_id = si.varient_id and sku.is_active = 1 ";
      }
      else{
        saleorderItemsQuery = saleorderItemsQuery + " left join " + appSettings.masters_db + ".sku_codes sku on sku.sku_code_id = si.varient_id ";
      }
      saleorderItemsQuery = saleorderItemsQuery + " left join " + appSettings.masters_db + ".master_brands mb on mb.master_brand_id = si.master_brand_id left join " + appSettings.masters_db + ".products pd on pd.product_id = si.item_id left join " + appSettings.masters_db + ".packing_methods pm on pm.packing_method_id = si.pack_style_id  left join " + appSettings.masters_db + ".uoms u on u.uom_id = si.uom_id left join " + appSettings.sales_db + ".so_invoice_details sid on sid.sale_order_id = si.sale_order_id where si.sale_order_id = " + saleOrderIdRequest.saleOrderId;
      if (saleOrderIdRequest.plantId != undefined && saleOrderIdRequest.plantId != 0) {
        saleorderItemsQuery = saleorderItemsQuery + " and sid.processing_unit = " + saleOrderIdRequest.plantId;
      }
      const itemDetails = await connection.query(saleorderItemsQuery);
      // itemsDetails.push(itemDetails);
      // let varientCodeMap = new Map<number, String>();
      // let countryMap = new Map<number, String>();
      // for (const eachItem of saleOrderItems) {
      //   console.log('eachItem.varientId ' + eachItem.varientId);
      //   const varientCode = await this.skuCodesRepository.getSkuDataById({ skuCodeId: eachItem.varientId });
      //   console.log('ghjkl;')
      //   console.log(varientCode)
      //   const brandId = await this.endCustomerRepository.getBrandsById({
      //     brandId: eachItem.brandId,
      //   });
      //   const productId = await this.productRepository.getActiveProductById({
      //     productId: eachItem.itemId,
      //   });
      //   const packStyle = await this.packingMethodService.getPalletCapacityById({
      //     noOfPouches: 0, pouchesPerRow: 0, uomId: 0, packingMethodId: eachItem.packStyleId
      //   });

      //   const uomDetails = await this.uomRepository.getActiveUomById({
      //     uomId: eachItem.uomId,
      //   });
      //   const varient = varientCode.status && packStyle.status ? packStyle.data.packingMethodName + '/' + varientCode.data.variantCode : ""
      //   const itemName =
      //     brandId.data.brandName +
      //     '/' +
      //     productId.data.productName +
      //     '/' +
      //     eachItem.minGrade +
      //     '-' +
      //     eachItem.maxGrade + '/' + packStyle.data?.packingMethodName;
      //   const itemdata = new ItemsDetails(eachItem.saleOrderItemId,
      //     itemName, varient, eachItem.varientId, eachItem.endCustomerId, eachItem.packStyleId);
      //   itemsDetails.push(itemdata);

      // }
      if (itemDetails.length > 0) {
        // saleOrderDropDownDto.push(SaleOrder);
        const response = new SaleOrderItemsDropdownResponse(
          true,
          1101,
          'Sale Order Items  retrieved successfully',
          itemDetails
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  }


  async getSaleOrderItemsForSoAndProduct(saleOrderIdRequest: SaleOrderProductIdRequest): Promise<SaleOrderItemsForSoDropDownResponseModel> {
    try {

      const itemsDetails: ItemsDetails[] = [];
      const itemData = this.soRepo
        .createQueryBuilder('SaleOrder')
        .select([
          'SaleOrder.sale_order_id AS saleOrderId',
          'SaleOrder.sale_order_no AS saleOrderNumber',
          'SoInvDetailsInfo.po_number AS poNumber',
          'saleOrderItems.sale_order_item_id AS saleOrderItemId',
          'saleOrderItems.item_id AS itemId',
          'saleOrderItems.brand_id AS brandId',
          'saleOrderItems.min_grade_id AS minGrade',
          'saleOrderItems.max_grade_id AS maxGrade',
          'rmBomLog.min_count AS minCount',
          'rmBomLog.max_count AS maxCount',
        ])
        .leftJoin(
          'sale_order_items',
          'saleOrderItems',
          'saleOrderItems.sale_order_id = SaleOrder.sale_order_id'
        )
        .leftJoin(
          'rm_bom_log',
          'rmBomLog',
          'rmBomLog.sale_order_id = SaleOrder.sale_order_id'
        )
        .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
        .where(
          'saleOrderItems.sale_order_id =' + saleOrderIdRequest.saleOrderId
        )
        .andWhere(
          'saleOrderItems.item_id =' + saleOrderIdRequest.productId
        )
      if (saleOrderIdRequest.plantId != undefined && saleOrderIdRequest.plantId != 0) {
        itemData.andWhere('SoInvDetailsInfo.processing_unit = ' + saleOrderIdRequest.plantId);
      }

      const saleOrderItems = await itemData.getRawMany();
      console.log('saleOrderItems' + saleOrderItems);
      for (const eachItem of saleOrderItems) {
        const rmHeadOnMinCount = eachItem.minCount
        const rmHeadOnMaxCount = eachItem.maxCount
        const avgCount = (rmHeadOnMinCount + rmHeadOnMaxCount) / 2
        console.log('********************');
        console.log(avgCount);
        console.log(saleOrderIdRequest.count);
        console.log(rmHeadOnMaxCount);
        if (saleOrderIdRequest.count >= Number(avgCount) && saleOrderIdRequest.count <= Number(rmHeadOnMaxCount)) {
          console.log('satisfied')
          const brandId = await this.endCustomerRepository.getBrandsById({
            brandId: eachItem.brandId,
          });
          const productId = await this.productRepository.getActiveProductById({
            productId: eachItem.itemId,
          });
          const itemName =
            brandId.data.brandName +
            '/' +
            productId.data.productName +
            '/' +
            eachItem.minGrade +
            '-' +
            eachItem.maxGrade;
          const itemdata = new ItemsDetails(eachItem.saleOrderItemId,
            itemName);
          itemsDetails.push(itemdata);
        }


      }


      if (saleOrderItems.length > 0) {
        const data = new SaleOrderItemsDropDownDto(
          saleOrderItems[0].saleOrderId,
          saleOrderItems[0].saleOrderNumber,
          saleOrderItems[0].poNumber,
          itemsDetails
        );
        // saleOrderDropDownDto.push(SaleOrder);
        const response = new SaleOrderItemsForSoDropDownResponseModel(
          true,
          1101,
          'Sale Order Items  retrieved successfully',
          data
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }

  /**
   * Warehouse API
   */
  async getSaleOrdersAndItemsData(plantInputRequest: PlantInputRequest): Promise<SaleOrderItemsDropDownResponseModel> {
    try {
      const saleOrderItemsDropDownDto: SaleOrderItemsDropDownDto[] = [];
      const SaleOrder = this.soRepo
        .createQueryBuilder('SaleOrder')
        .leftJoinAndSelect('SaleOrder.saleOrderItemsInfo', 'saleOrderItemsInfo')
        .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
        .where('SoInvDetailsInfo.unit =' + plantInputRequest.plantId)
        .orderBy("SaleOrder.saleOrderId", "ASC");
      const saleOrderDetails = await SaleOrder.getMany();
      console.log(saleOrderDetails);
      for (const eachItem of saleOrderDetails) {
        const itemsDetails: ItemsDetails[] = [];
        for (const eachData of eachItem.saleOrderItemsInfo) {
          const brandId = await this.endCustomerRepository.getBrandsById({
            brandId: eachData.brandId,
          });
          const productId = await this.productRepository.getActiveProductById({
            productId: eachData.itemId,
          });
          const itemName =
            brandId.data.brandName +
            '/' +
            productId.data.productName +
            '/' +
            eachData.minGrade +
            '-' +
            eachData.maxGrade;
          const itemDetails = new ItemsDetails(eachData.saleOrderItemId,
            itemName);
          itemsDetails.push(itemDetails);
        }
        const data = new SaleOrderItemsDropDownDto(
          eachItem.saleOrderId,
          eachItem.saleOrderNumber,
          eachItem.SoInvDetailsInfo.poNumber,
          itemsDetails
        );
        saleOrderItemsDropDownDto.push(data);
      }
      if (saleOrderDetails.length > 0) {
        const response = new SaleOrderItemsDropDownResponseModel(
          true,
          1101,
          'Sale Order Items  retrieved successfully',
          saleOrderItemsDropDownDto
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }

  async getSaleOrderItemDetailsForSoItemId(saleOrderItemRequest: SaleOrderItemRequest): Promise<CommonResponse> {
    try {
      console.log("jjjjjjjjjj" + saleOrderItemRequest);
      const saleOrderItemId = saleOrderItemRequest.saleOrderItemId;
      const saleOrderId = saleOrderItemRequest.saleOrderId;
      const unit = saleOrderItemRequest.plantId;
      const itemData = this.saleOrderItemsRepository
        .createQueryBuilder('SaleOrderItems')
        .leftJoin('sale_order', 'SaleOrder', 'SaleOrder.sale_order_id = SaleOrderItems.sale_order_id')
        .leftJoin('so_invoice_details', 'saleInvDetails', 'saleInvDetails.sale_order_id = SaleOrder.sale_order_id')
        .where('SaleOrderItems.saleOrderItemId = :saleOrderItemId', {
          saleOrderItemId: saleOrderItemId,
        });
      if (saleOrderId) {
        itemData.andWhere('SaleOrderItems.saleOrderId = :saleOrderId', {
          saleOrderId: saleOrderId
        })
      }

      if (unit) {
        itemData.andWhere('saleInvDetails.unit = :unit', {
          unit: unit,
        })
      }
      const saleOrderItems = await itemData.getOne();

      console.log(saleOrderItems);
      if (saleOrderItems.saleOrderItemId > 0) {
        return new CommonResponse(true, 1001, "Item data retrived successfully. ", saleOrderItems);
      }
      else {
        return new CommonResponse(false, 1010, "No data found. ",);
      }
    }
    catch (err) {
      return err;
    }
  }



  /**
   * Warehouse API
   * @param saleOrderItemRequest 
   * @returns 
   */
  async getSaleOrderItemDetailsBySoItemId(saleOrderItemRequest: SaleOrderItemRequest): Promise<SaleOrderItemsBySoIdReaponseModel> {
    try {
      const saleOrderItemId = saleOrderItemRequest.saleOrderItemId;
      const saleOrderId = saleOrderItemRequest.saleOrderId;
      const unit = saleOrderItemRequest.plantId;
      const itemData = this.saleOrderItemsRepository
        .createQueryBuilder('SaleOrderItems')
        .leftJoin('sale_order', 'SaleOrder', 'SaleOrder.sale_order_id = SaleOrderItems.sale_order_id')
        .leftJoin('so_invoice_details', 'saleInvDetails', 'saleInvDetails.sale_order_id = SaleOrder.sale_order_id')
        .where('SaleOrderItems.saleOrderItemId = :saleOrderItemId', {
          saleOrderItemId: saleOrderItemId,
        });
      if (saleOrderId) {
        itemData.andWhere('SaleOrderItems.saleOrderId = :saleOrderId', {
          saleOrderId: saleOrderId
        })
      }

      if (unit) {
        itemData.andWhere('saleInvDetails.unit = :unit', {
          unit: unit,
        })
      }
      const saleOrderItems = await itemData.getOne();

      console.log(saleOrderItems);
      if (saleOrderItems) {
        const brandId = this.endCustomerRepository.getBrandsById({
          brandId: saleOrderItems.brandId,
        });
        const productId = this.productRepository.getActiveProductById({
          productId: saleOrderItems.itemId,
        });
        const variantId = this.skuCodesRepository.getSkuDataById({
          skuCodeId: saleOrderItems.varientId,
        });
        const valueAddition4Type = this.valueAddition4TypeService.getValAddDetails({
          valueAdditionId: saleOrderItems.valueAdditionFourId,
        });
        const valueAddition1Type = this.valueAddition1TypeService.getValAddDetails({
          valueAdditionId: saleOrderItems.valueAdditionOneId,
        });
        const foodType = this.foodTypeRepository.getFoodTypeDataById({
          foodTypeId: saleOrderItems.foodTypeId,
        });
        const uomId = saleOrderItems.uomId;
        let unitOfWeights = UnitsOfWeightInput;
        const selectedUom = unitOfWeights.find(item => item.value == uomId).name;

        return await Promise.all([brandId, variantId, productId, valueAddition4Type, foodType, valueAddition1Type]).then((res) => {
          const brand: string = res[0].status ? res[0].data.brandName : null;
          const varient: string = res[1].status
            ? res[1].data.variantCode
            : null;
          const product: string = res[2].status
            ? res[2].data.productCode : null;

          const productName: string = res[2].status ? res[2].data.productName
            : null;
          const packstyle = saleOrderItems.pouches + ' * ' + Number(saleOrderItems.pouchWeight);
          const grade = saleOrderItems.minGrade + '/' + saleOrderItems.maxGrade;
          const freezingType = res[3].status ? res[3].data.valueAdditionIdName : null;
          const foodTypeData = res[4].status ? res[4].data.foodType : null;
          const valueAdditionOneCode = res[5].status ? res[5].data.valueAdditionCode : null;
          console.log("saleOrderItems" + saleOrderItems.packStyleId);
          const itemObject = new SoItemDetailsBySoIdDTO(
            unit,
            brand,
            product,
            varient, foodTypeData, freezingType, packstyle, grade, valueAdditionOneCode, saleOrderItems.pouches, saleOrderItems.pouchWeight, productName, undefined, selectedUom, saleOrderItems.packStyleId, saleOrderItems.varientId,"", saleOrderItems.barcode
          );
          console.log(itemObject);
          const response = new SaleOrderItemsBySoIdReaponseModel(
            true,
            11108,
            'Sale Order Item Details retrieved successfully',
            itemObject
          );
          return response;
        }
        );
      } else {
        const response = new SaleOrderItemsBySoIdReaponseModel(
          false,
          1001,
          'No Data Found'
        );
        return response;
        // throw new ErrorResponse(9999, 'No Data Found');
      }
    } catch (err) {
      return err;
    }
  }

  async UpdateBomQty(req: BomUpdateRequest): Promise<boolean> {
    return await this.bomRepo.updateBomReceivedQty(req);
  }

  async updateSoTrackProdStatus(req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      const connection = getManager();
      if (req.stockType != "dummy") {
        let getProductionPer = await connection.query('SELECT production_percentage as productionPer from ' + appSettings.sales_db + '.sale_order_track where sale_order_id =' + req.saleOrderId);
        const getOrderCases = await connection.query('SELECT SUM(job_cases) as totCases from ' + appSettings.sales_db + '.sale_order_items where sale_order_id =' + req.saleOrderId);
        console.log("getOrderCases" + getOrderCases[0]);
        const getStockCases = await connection.query('SELECT SUM(stockin_qunatity) as stockInQty, SUM(total_cartons) as totalCartons from ' + appSettings.warehouse_db + '.stock where sale_order_id =' + req.saleOrderId + ' and status = "StockIn"');
        console.log("getStockCases" + getStockCases[0]);
        let productionPer = Math.floor(Number((Number(getStockCases[0].stockInQty) / Number(getOrderCases[0].totCases)) * 100)).toFixed(2);
        console.log("productionPer" + productionPer);
        let productionStatus = false;
        if (Number(productionPer) >= 100) {
          productionStatus = true;
        }
        if (Number(getProductionPer[0].productionPer) < 100) {
          const updateStatus = await this.soTrackRepo.update({ saleOrderInfo: Raw(alias => `sale_order_id = '${req.saleOrderId}'`) }, { productionStatus: InvoiceStatusEnum.IN_PROGRESS, prodCompletedDate: new Date(), productionCompleted: productionStatus, productionPercentage: Number(productionPer) });
          console.log(updateStatus);
          if (updateStatus.affected) {
            return new CommonResponse(true, 1001, "Production Status updated successfully. ");
          } else {
            throw new CommonResponse(false, 9999, 'Something Went Wrong');
          }
        }
        else {
          const updateStatus = await this.soTrackRepo.update({ saleOrderInfo: Raw(alias => `sale_order_id = '${req.saleOrderId}'`) }, { productionStatus: InvoiceStatusEnum.IN_PROGRESS, productionCompleted: productionStatus, productionPercentage: Number(productionPer) });
          console.log(updateStatus);
          if (updateStatus.affected) {
            return new CommonResponse(true, 1001, "Production Status updated successfully. ");
          } else {
            throw new CommonResponse(false, 9999, 'Something Went Wrong');
          }
        }
      }
      else {
        return new CommonResponse(true, 1001, "Production Status not updated for dummy. ");
      }
    } catch (error) {
      return error
    }

  }
  async updateSoTrackPmStatus(req: SoRequest): Promise<boolean> {

    const bomData = await this.bomRepo.find({ select: ['status'], where: { saleOrderId: req.saleOrderId, itemCategoryId: req.itemCategoryId } })
    const qtyFlagSet = new Set<boolean>();

    for (const bomDataItem of bomData) {
      if (bomDataItem.status == StatusEnum.CLOSED) {
        qtyFlagSet.add(true)
      } else {
        qtyFlagSet.add(false)
        break;
      }
    }
    let statusVal = PmStatusEnum.IN_PROGRESS;
    if (!(qtyFlagSet.has(false))) {
      statusVal = PmStatusEnum.CLOSE
      //  await this.soTrackRepo.update({});
    }
    await this.soTrackRepo.update({ saleOrderInfo: { saleOrderId: req.saleOrderId } }, { pmStatus: statusVal })
    return true;

  }



  async UpdateAssignedQty(req: BomUpdateRequest): Promise<boolean> {
    console.log(req);
    if (req) {
      const response = await this.bomRepo.updateBomAssignedQty(req);

      if (response) {
        return await this.UpdateSoTrackerStatus(req);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  async UpdateSoTrackerStatus(req: BomUpdateRequest): Promise<boolean> {
    const bomData = await this.bomRepo.find({ select: ['status'], where: { saleOrderId: req.saleOrderId, packingCategory: Raw(alias => `packing_category IS NOT NULL`), isActive: true } });
    console.log(bomData);
    const qtyFlagSet = new Set<boolean>();
    for (const bomDataItem of bomData) {
      if (bomDataItem.status == StatusEnum.CLOSED) {
        qtyFlagSet.add(true)
      } else {
        qtyFlagSet.add(false)
        break;
      }
    }

    let statusVal = (bomData.length === bomData.filter((item) => item.status === StatusEnum.OPEN).length) ? PmStatusEnum.OPEN : PmStatusEnum.IN_PROGRESS;
    if (!(qtyFlagSet.has(false))) {
      statusVal = PmStatusEnum.CLOSE
    }

    const response = await this.soTrackRepo.update({ saleOrderInfo: { saleOrderId: req.saleOrderId } }, { pmStatus: statusVal })
    return response.affected ? true : false;
  }

  async saveDummyPackmaterial(req: DummyPackBomItemsRequest): Promise<boolean> {
    const manager = new GenericTransactionManager();
    try {
      await manager.startTransaction();

      const existedBom = await this.bomRepo.findOne({ select: ['requiredQuantity', 'receivedQuantity'], where: { saleOrderId: req.saleOrderId, itemId: req.itemId } })
      let savedBomEntity;
      if (existedBom) {

        savedBomEntity = await manager.getCustomRepository(BomRepository).update({ saleOrderId: req.saleOrderId, itemId: req.itemId }, { AssignedQuantity: () => `assigned_qty+${req.acceptedQuantity}`, quantity: () => `quantity+${req.acceptedQuantity}` })
      } else {
        const rmBomObj = new BomDetails();
        rmBomObj.itemId = req.itemId;
        rmBomObj.saleOrderId = req.saleOrderId;
        rmBomObj.itemCategoryId = req.itemCategoryId;
        rmBomObj.itemSubCategoryId = req.itemSubCategoryId;
        rmBomObj.quantity = req.acceptedQuantity;
        rmBomObj.AssignedQuantity = req.acceptedQuantity;
        rmBomObj.requiredQuantity = 0;

        savedBomEntity = await manager
          .getCustomRepository(BomRepository)
          .save(rmBomObj);

      }

      if (savedBomEntity) {
        manager.completeTransaction();
        return true
      } else {
        manager.releaseTransaction();
        return false
      }
    } catch (err) {
      manager.releaseTransaction();
      return false
    }
  }


  /**
   * * Get the details for plant invoce grid and detailed view
   * @param PlantInvoiceDetailsRequest
   */
  async getPlantInvoiceDetails(plantInvoiceDetailsRequest: PlantInvoiceDetailsRequest): Promise<PlantInvoiceDetailsResponse> {
    try {

      const soId = plantInvoiceDetailsRequest.saleOrderId;
      const SaleOrderResponse = await this.soRepo.findOne({ relations: ["SoInvDetailsInfo", 'SoPoDetailsInfo'], where: { saleOrderId: soId } });
      const isInvoiced = SaleOrderResponse.isInvoiced;
      const blNoData = await this.containerService.getContainerDeatils({ saleOrderId: plantInvoiceDetailsRequest.saleOrderId });
      const blNo = blNoData.status ? blNoData.data.blNo : "";
      const buyerPo = SaleOrderResponse.status ? SaleOrderResponse.SoInvDetailsInfo.buyerPoNumber : "";
      const custPo = SaleOrderResponse.status ? SaleOrderResponse.SoInvDetailsInfo.poNumber : "";
      const edl = SaleOrderResponse.status ? SaleOrderResponse.SoInvDetailsInfo.edlDate : null;
      const actualEdl = SaleOrderResponse.status ? SaleOrderResponse.SoInvDetailsInfo.actualEdldate : null;
      const unitId = SaleOrderResponse.status ? SaleOrderResponse.SoInvDetailsInfo.unit : null;
      const lotNo = SaleOrderResponse.status ? SaleOrderResponse.SoPoDetailsInfo.lotCode : null;
      let portofloadingId = SaleOrderResponse.status ? SaleOrderResponse.SoInvDetailsInfo.portOfEntry : null;
      let portofloading = '';
      for (const port of PortOfEntryInput) {
        if (port.value === portofloadingId) {
          portofloading = port.name
        }
      }
      let unitdata: UnitcodeDto;
      if (unitId) {
        const unitData = await this.unitcodeService.getPlantDetailsById({ unitcodeId: unitId })
        unitdata = unitData.data
      } else {
        unitdata = undefined
      }

      // console.log(isInvoiced);
      if (SaleOrderResponse) {
        if (isInvoiced === GlobalStatus.YES) {
          const plantInvoiceData: SoCustomerInvoice[] = await this.customerInvoiceRepo.find({ where: { saleOrderId: soId } });

          if (plantInvoiceData.length) {
            for (const data of plantInvoiceData) {
              const invoicedPlant = (await this.unitcodeService.getPlantDetailsById({ unitcodeId: data.unitId }))?.data;
              const salOrderarray: SaleOrderItemsDetails[] = [];
              let saleOrderNo = '';
              let shippingTerms = '';
              const customerDetails = await this.customerRepository.getCustomerDataById({ custId: data.customerId });
              const endCustomerDetails = await this.endCustomerRepository.getEndCustomerDataById({ endCustomerId: data.endCustomerId });
              const endCustomerCode = endCustomerDetails.data.endCustomerCode;
              const endCustomerName = endCustomerDetails.data.endCustomerName;
              const consignee = endCustomerDetails.data.consignee;
              const notifyPartyOneReq = new NotifypartyRequest(data.notifyPartyOne)
              const notifyPartyOnee: NotifyPartyResponse = await this.notifypartyservice.getNotifyPartyInfoById(notifyPartyOneReq);
              const notifyPartyTwoReq = new NotifypartyRequest(data.notifyPartyTwo)
              const notifypartytwo: NotifyPartyResponse = await this.notifypartyservice.getNotifyPartyInfoById(notifyPartyTwoReq)
              const notifyPartyThreeReq = new NotifypartyRequest(data.notifyPartyThree)
              const notifypartythree: NotifyPartyResponse = await this.notifypartyservice.getNotifyPartyInfoById(notifyPartyThreeReq)
              const notifyPartyFourReq = new NotifypartyRequest(data.notifyPartyFour)
              const notifypartyfour: NotifyPartyResponse = await this.notifypartyservice.getNotifyPartyInfoById(notifyPartyFourReq)
              const notifypartynameone = notifyPartyOnee.data?.notifyPartyName ? notifyPartyOnee?.data?.notifyPartyName : "";
              const notifypartynametwo = notifypartytwo.data?.notifyPartyName ? notifypartytwo?.data?.notifyPartyName : " ";
              const notifypartynamethree = notifypartythree.data?.notifyPartyName ? notifypartythree?.data?.notifyPartyName : " ";
              const notifypartynamefour = notifypartyfour.data?.notifyPartyName ? notifypartyfour?.data?.notifyPartyName : " ";
              let refNo = "";
              let trackingNo
              let vesselName
              let portOfTranshipment;
              // let portOfDischarge = data.portOfDischarge;
              let portOfDischarge;
              let importingVesselName
              let dateOfTranshipment
              let shippedOnboardDate
              let dischargeDate
              let destinationDate
              let notifyPartyOne = data.notifyPartyOne;
              let notifyPartyTwo = data.notifyPartyTwo;
              let notifyPartyThree = data.notifyPartyThree;
              let epcgLicenseNumber = data.epcgLicenseNumber;
              let epcgLicenseDate = data.epcgLicenseDate;
              let epcgFobValue = data.epcgFobValue;
              let exportObligation = data.exportObligation;
              let remarks = data.remarks



              //To get country Details
              const countryDetails = this.countryRepository.getCountryById({ countryId: SaleOrderResponse.SoInvDetailsInfo.country });
              const countryName = (await countryDetails).data.countryName;


              if (plantInvoiceDetailsRequest.saleOrderId > 0) {
                const soId = plantInvoiceDetailsRequest.saleOrderId;
                //To get saleordernumber
                saleOrderNo = await this.soRepo.getSaleOrderNo(soId);
                //To get paymenterms Details
                const getPaymnetsId = await this.soInvoiceDetails.findOne({ where: { saleOrderId: soId } });
                // console.log("getPaymnetsIdgetPaymnetsId" + getPaymnetsId.saleOrderId);
                const getPaymentDetails = await this.paymentTermsRepository.getPaymentById({ paymentTermsId: getPaymnetsId.payTermId });
                const customerAddress = getPaymnetsId.cusAddress;
                const deliveryAddress = getPaymnetsId.delAddress;
                const paymentTermsName = getPaymentDetails.data.paymentTermsName;
                //To get destination
                const getdestinationDetails = this.destinationRepository.getDestinationById({ destinationId: getPaymnetsId.destination });
                const destinationDetails = (await getdestinationDetails).data.destinationName;
                const getPortOfDischargeDetails = await this.destinationRepository.getDestinationById({ destinationId: data.portOfDischarge });
                // console.log(getPortOfDischargeDetails.status);
                portOfDischarge = getPortOfDischargeDetails.status ? getPortOfDischargeDetails.data.destinationName : null;

                const containerDetails = await this.containerService.getContainerDeatils({ saleOrderId: soId });
                let containerNo
                let linesealNo
                let eseal
                let scac
                let blNo
                let bookingNo

                if (containerDetails.status) {
                  containerNo = containerDetails.data.containerNumber;
                  linesealNo = containerDetails.data.lineSeal;
                  eseal = containerDetails.data.eSeal;
                  scac = containerDetails.data.scac;
                  blNo = containerDetails.data.blNo;
                  bookingNo = containerDetails.data.bookingNo;
                  refNo = containerDetails.data.refNo;
                  trackingNo = containerDetails.data.trackingNo;
                  vesselName = containerDetails.data.vesselName;
                  portOfTranshipment = containerDetails.data.portOfTranshipment;
                  portOfDischarge = containerDetails.data.portOfDischarge;
                  importingVesselName = containerDetails.data.importingVesselName;
                  dateOfTranshipment = containerDetails.data.dateOfTranshipment;
                  shippedOnboardDate = containerDetails.data.shippedOnboardDate;
                  dischargeDate = containerDetails.data.dischargeDate;
                  destinationDate = containerDetails.data.destinationDate;
                } else {
                  // throw new PlantInvoiceDetailsResponse(false, 9999, 'Containers data not found');
                  containerNo = undefined
                  linesealNo = undefined
                  eseal = undefined
                  scac = undefined
                  blNo = undefined
                  bookingNo = undefined
                  refNo = undefined
                  trackingNo = undefined,
                    vesselName = undefined,
                    portOfTranshipment = undefined,
                    portOfDischarge = undefined,
                    importingVesselName = undefined,
                    dateOfTranshipment = undefined,
                    shippedOnboardDate = undefined,
                    dischargeDate = undefined,
                    destinationDate = undefined
                }

                //To get currency details
                const currencyId = this.currencyRepository.getCurrencyById({ currencyId: getPaymnetsId.currency });
                if (!(await currencyId).status) {
                  throw new PlantInvoiceDetailsResponse(false, 9999, 'Currency data not found');
                }
                const currencyDetails = (await currencyId).data.currencyName;
                // const containerNo='';
                // const linesealNo='';
                // const eseal='';
                //To get detials from sale_order_items
                const saleOrderItemsData = await this.soItemRepo.getSaleOrderDetails(soId);
                for (const salesData of saleOrderItemsData) {

                  const taxDetails = await this.taxesService.getTaxForId({ taxId: salesData.taxId });
                  const foodTypeDetails = this.foodTypeRepository.getFoodTypeDataById({ foodTypeId: salesData.foodTypeId });
                  const productDetails = this.productRepository.getActiveProductById({ productId: salesData.itemId });
                  const variantDetails = this.skuCodesRepository.getSkuDataById({ skuCodeId: salesData.varientId });
                  const brandIdDetails = this.endCustomerRepository.getBrandsById({ brandId: salesData.brandId });
                  const displayBrandDetails = this.masterBrandsService.getDisplayBrandsById({brandId : salesData.masterBrandId})
                  const valueAdditionOneDetails = this.valueAddition1TypeService.getValAddDetails({ valueAdditionId: salesData.valueAdditionOneId });
                  const valueAdditiontwoDetails = this.valueAddition2TypeService.getValAddDetails({ valueAdditionId: salesData.valueAdditionTwoId });
                  const valueAdditionthreeDetails = this.valueAddition3TypeService.getValAddDetails({ valueAdditionId: salesData.valueAdditionThreeId });
                  const valueAdditionfourDetails = this.valueAddition4TypeService.getValAddDetails({ valueAdditionId: salesData.valueAdditionFourId });
                  const valueAdditionfiveDetails = this.valueAddition5TypeService.getValAddDetails({ valueAdditionId: salesData.valueAdditionFiveId });
                  const shippingTermsDetails = this.shippingRepository.getShippingTermsById({ shippingTermsId: SaleOrderResponse.SoInvDetailsInfo.shipmentTerms });
                  let hsnCodeDetails = await this.hsnCodeService.getHsnByFoodType({ foodTypeId: salesData.foodTypeId, valueAddOneId: salesData.valueAdditionOneId, valueAddTwoId: salesData.valueAdditionTwoId, valueAddThreeId: salesData.valueAdditionThreeId, valueAddFourId: salesData.valueAdditionFourId, valueAddFiveId: salesData.valueAdditionFiveId, productId: salesData.itemId });
                  let hsnCode = hsnCodeDetails.status ? hsnCodeDetails.data.hsnCode : "";
                  let innerBagSizeDetails = null;
                  let sizeNameDetails = '';
                  let taxName;
                  let taxPer;
                  let taxcCategory;

                  if (taxDetails.taxId != undefined) {
                    taxPer = taxDetails.taxPercentage;
                    taxName = taxDetails.taxName;
                    taxcCategory = taxDetails.taxCategory;
                  }
                  else {
                    taxPer = 0;
                    taxName = "";
                  }
                  if (salesData.innerBagSizeId) {
                    innerBagSizeDetails = await this.sizesService.getSizeDataById({ sizeId: salesData.innerBagSizeId });
                    sizeNameDetails = innerBagSizeDetails ? innerBagSizeDetails.sizeName : null;
                  }
                  //const sizeNameDetails = (await innerBagSizeDetails).sizeName;
                  await Promise.all([foodTypeDetails, productDetails, variantDetails, brandIdDetails, valueAdditionOneDetails, valueAdditiontwoDetails, valueAdditionthreeDetails, valueAdditionfourDetails, valueAdditionfiveDetails, shippingTermsDetails,displayBrandDetails]).then(res => {
                    const foodTypeDetails = res[0].status ? res[0].data.foodType : null;
                    const foodTypeHsnCode = res[0].status ? res[0].data.hsnCode : null;
                    const foodTypeCode = res[0].status ? res[0].data.foodTypeCode : null;
                    const productCodeDetails = res[1].status ? res[1].data.productCode : null;
                    const productNameDetails = res[1].status ? res[1].data.productName : null;
                    const productNameHsnCode = res[1].status ? res[1].data.hsnCode : null;
                    const variantCode = res[2].status ? res[2].data.variantCode : null;
                    const brandName = res[3].status ? res[3].data.brandName : null;
                    const valueAdditionOneName = res[4].status ? res[4].data.valueAdditionIdName : null;
                    const valueAdditionOneCode = res[4].status ? res[4].data.valueAdditionCode : null;
                    const valueAdditionTwoName = res[5].status ? res[5].data.valueAdditionIdName : null;
                    const valueAdditionTwoCode = res[5].status ? res[5].data.valueAdditionCode : null;
                    const valueAdditionThreeName = res[6].status ? res[6].data.valueAdditionIdName : null;
                    const valueAdditionThreeCode = res[6].status ? res[6].data.valueAdditionCode : null;
                    const valueAdditionFourName = res[7].status ? res[7].data.valueAdditionIdName : null;
                    const valueAdditionFourCode = res[7].status ? res[7].data.valueAdditionCode : null;
                    const valueAdditionFiveName = res[8].status ? res[8].data.valueAdditionIdName : null;
                    const valueAdditionFiveCode = res[8].status ? res[8].data.valueAdditionCode : null;
                    shippingTerms = res[9].status ? res[9].data.shippingTermsName : null;
                    const displayBrandName = res[10].status ? res[10].data.displayBrandName : null;
                    const saleOrderRes = new SaleOrderItemsDetails(salesData.saleOrderItemId,
                      salesData.saleOrderId,
                      salesData.itemId,
                      productNameDetails,
                      productCodeDetails,
                      salesData.minGrade,
                      salesData.maxGrade,
                      salesData.foodTypeId,
                      (foodTypeDetails === "NA" ? "" : foodTypeDetails === "Not Applicable" ? "" : foodTypeDetails),
                      salesData.valueAdditionOneId,
                      valueAdditionOneName,
                      (valueAdditionOneCode === "NA" ? "" : valueAdditionOneCode), salesData.valueAdditionTwoId,
                      (valueAdditionTwoName === "NA" ? "" : valueAdditionTwoName === "Not Applicable" ? "" : valueAdditionTwoName), (valueAdditionTwoCode === "NA" ? "" : valueAdditionTwoCode), salesData.valueAdditionThreeId,
                      (valueAdditionThreeName === "NA" ? "" : valueAdditionThreeName === "Not Applicable" ? "" : valueAdditionThreeName),
                      (valueAdditionThreeCode === "NA" ? "" : valueAdditionThreeCode),
                      salesData.valueAdditionFourId,
                      (valueAdditionFourName === "NA" ? "" : valueAdditionFourName === "Not Applicable" ? "" : valueAdditionFourName), (valueAdditionFourCode === "NA" ? "" : valueAdditionFourCode),
                      salesData.valueAdditionFiveId,
                      (valueAdditionFiveName === "NA" ? "" : valueAdditionFiveName === "Not Applicable" ? "" : valueAdditionFiveName), (valueAdditionFiveCode === "NA" ? "" : valueAdditionFiveCode),
                      salesData.varientId, variantCode, salesData.skewerSizeItemId, sizeNameDetails, salesData.innerBagSizeId, sizeNameDetails, salesData.invoicedCases, salesData.netAmount, salesData.unitPrice, salesData.pouches, salesData.innerBags, salesData.shrimpWeight, salesData.pouchWeight, salesData.caseWeight, salesData.categoryId, salesData.netWeight, salesData.uomId, salesData.minGlaze, salesData.MaxGlaze, salesData.soakingTime, salesData.soakingStyle, salesData.styleWeighment, salesData.hlPercentage, salesData.finalPercentage, salesData.brandId, brandName, salesData.reportedCases, salesData.invoicedQty, salesData.dispatchedQty, salesData.revisedUnitPrice, paymentTermsName, customerAddress, deliveryAddress, containerNo, linesealNo, eseal, destinationDetails, foodTypeHsnCode, productNameHsnCode, currencyDetails, blNo, scac, bookingNo, getPaymnetsId.currency, salesData.totalGrossWeight, hsnCode, taxName, taxPer, taxcCategory, salesData.invoicedCases, foodTypeCode, '', salesData.grossWeightPerKg,displayBrandName,salesData.invoiceAmount);
                    salOrderarray.push(saleOrderRes);
                  }).catch(error => {
                  });
                }
              }
              const allInvoiceData = new PlantInvoiceDetailsModel(data.invoiceId, data.saleOrderId, saleOrderNo, data.invoiceNumber, data.invoiceDate, data.exporterId, data.unitId, data.customerId, customerDetails.data.clientCode, customerDetails.data.clientName, countryName, data.endCustomerId, endCustomerCode, endCustomerName, data.flightNumber, data.status, data.exchangeRate, data.createdAt, data.totalAmount, data.total_INR_amount, isInvoiced, data.freightCharges, salOrderarray, "", "", 0, blNo == undefined ? "" : blNo, shippingTerms, buyerPo, custPo, edl, data.orderDate ? data.orderDate : null, refNo, trackingNo, vesselName, portOfTranshipment, portOfDischarge, importingVesselName, "", dateOfTranshipment, shippedOnboardDate, dischargeDate, destinationDate, data.isTaxApplicable, unitdata, invoicedPlant, lotNo, portofloading, data.saleCommission, data.insurance, data.finNumber,
                notifypartynameone, notifypartynametwo, notifypartynamethree, data.portOfDischarge, data.orderDate ? data.orderDate : "", "", undefined, notifypartynamefour, plantInvoiceData[0].placeOfReceipt, plantInvoiceData[0].invoiceCategory, data.etaDate, data.epcgLicenseNumber, data.epcgLicenseDate, data.epcgFobValue, data.exportObligation, data.remarks,consignee);
                console.log('allInvoiceDataaaaa&&&&&&& 1111',allInvoiceData)
              //allInvoiceData.push(modelInfoData);
              return new PlantInvoiceDetailsResponse(true, 1111, 'Plant Invoice Data Found Successfully', allInvoiceData);
            }
          }
        } else {
          const plantInvoiceData: SoInvoiceDetails[] = await this.soInvoiceDetails.find({ where: { saleOrderId: soId } });
          if (plantInvoiceData.length) {
            let shippingTerms;
            let refNo = ""
            let trackingNo
            let vesselName
            let portOfTranshipment
            let portOfDischarge
            let importingVesselName
            let dateOfTranshipment
            let shippedOnboardDate
            let dischargeDate
            let destinationDate
            for (const data of plantInvoiceData) {
              const invoicedPlant = (await this.unitcodeService.getPlantDetailsById({ unitcodeId: data.unit }))?.data;

              const salOrderarray: SaleOrderItemsDetails[] = [];
              let saleOrderNo = '';
              //To get customer and end customer details
              const customerDetails = await this.customerRepository.getCustomerDataById({ custId: data.customerId });

              const endCustomerDetails = await this.endCustomerRepository.getEndCustomerDataById({ endCustomerId: data.endCustomerId });

              const endCustomerCode = endCustomerDetails.data.endCustomerCode;
              const endCustomerName = endCustomerDetails.data.endCustomerName;
              const consignee = endCustomerDetails.data.consignee;
              //To get country Details
              const countryDetails = this.countryRepository.getCountryById({ countryId: SaleOrderResponse.SoInvDetailsInfo.country });
              const countryName = (await countryDetails).data.countryName;
              if (plantInvoiceDetailsRequest.saleOrderId > 0) {
                const soId = plantInvoiceDetailsRequest.saleOrderId;
                //To get saleordernumber
                const saleOrderNo = await this.soRepo.getSaleOrderNo(soId);
                //To get paymenterms Details
                const getPaymnetsId = await this.soInvoiceDetails.findOne({ where: { saleOrderId: soId } });
                // console.log("getPaymnetsIdgetPaymnetsId" + getPaymnetsId.payTermId);

                const getPaymentDetails = await this.paymentTermsRepository.getPaymentById({ paymentTermsId: getPaymnetsId.payTermId });
                const customerAddress = getPaymnetsId.cusAddress;
                const deliveryAddress = getPaymnetsId.delAddress;
                const paymentTermsName = getPaymentDetails.data.paymentTermsName;
                //To get destination
                const getdestinationDetails = this.destinationRepository.getDestinationById({ destinationId: getPaymnetsId.destination });

                const destinationDetails = (await getdestinationDetails).data.destinationName;
                //To get details from container service
                const containerDetails = await this.containerService.getContainerDeatils({ saleOrderId: soId });
                let containerNo
                let linesealNo
                let eseal
                let blNo
                let scac
                let bookingNo
                if (containerDetails.status) {
                  containerNo = containerDetails.data.containerNumber;
                  linesealNo = containerDetails.data.lineSeal;
                  eseal = containerDetails.data.eSeal;
                  blNo = containerDetails.data.blNo;
                  scac = containerDetails.data.scac;
                  bookingNo = containerDetails.data.bookingNo;
                  refNo = containerDetails.data.refNo;
                  trackingNo = containerDetails.data.trackingNo;
                  vesselName = containerDetails.data.vesselName;
                  portOfTranshipment = containerDetails.data.portOfTranshipment;
                  portOfDischarge = containerDetails.data.portOfDischarge;
                  importingVesselName = containerDetails.data.importingVesselName;
                  dateOfTranshipment = containerDetails.data.dateOfTranshipment;
                  shippedOnboardDate = containerDetails.data.shippedOnboardDate;
                  dischargeDate = containerDetails.data.dischargeDate;
                  destinationDate = containerDetails.data.destinationDate;
                  portOfDischarge = containerDetails.data.portOfDischarge;
                } else {
                  // throw new PlantInvoiceDetailsResponse(false, 9999, 'Containers data not found');
                  containerNo = undefined
                  linesealNo = undefined
                  eseal = undefined
                  blNo = undefined;
                  scac = undefined;
                  bookingNo = undefined;
                  refNo = undefined;
                  trackingNo = undefined;
                  vesselName = undefined;
                  portOfTranshipment = undefined;
                  portOfDischarge = undefined;
                  importingVesselName = undefined;
                  dateOfTranshipment = undefined;
                  shippedOnboardDate = undefined;
                  dischargeDate = undefined;
                  destinationDate = undefined;
                  portOfDischarge = undefined;
                }

                //To get currency details
                const currencyId = this.currencyRepository.getCurrencyById({ currencyId: getPaymnetsId.currency });
                let currencyDetails;
                if (!(await currencyId).status) {
                  currencyDetails = undefined
                  // throw new PlantInvoiceDetailsResponse(false, 9999, 'Currency data not found');
                } else {
                  currencyDetails = (await currencyId).data.currencyName;


                }
                // const containerNo='';
                // const linesealNo='';
                // const eseal='';
                //To get detials from sale_order_items
                const saleOrderItemsData = await this.soItemRepo.getSaleOrderDetails(soId);
                // console.log('saleOrderItemsData' + saleOrderItemsData);
                for (const salesData of saleOrderItemsData) {
                  const taxDetails = await this.taxesService.getTaxForId({ taxId: salesData.taxId });
                  const foodTypeDetails = this.foodTypeRepository.getFoodTypeDataById({ foodTypeId: salesData.foodTypeId });
                  const productDetails = this.productRepository.getActiveProductById({ productId: salesData.itemId });
                  const variantDetails = this.skuCodesRepository.getSkuDataById({ skuCodeId: salesData.varientId });
                  const brandIdDetails = this.endCustomerRepository.getBrandsById({ brandId: salesData.brandId });
                  // console.log('$$$$$$$$$$$$$$$$',brandIdDetails)
                  const valueAdditionOneDetails = this.valueAddition1TypeService.getValAddDetails({ valueAdditionId: salesData.valueAdditionOneId });
                  const valueAdditiontwoDetails = this.valueAddition2TypeService.getValAddDetails({ valueAdditionId: salesData.valueAdditionTwoId });
                  const valueAdditionthreeDetails = this.valueAddition3TypeService.getValAddDetails({ valueAdditionId: salesData.valueAdditionThreeId });
                  const valueAdditionfourDetails = this.valueAddition4TypeService.getValAddDetails({ valueAdditionId: salesData.valueAdditionFourId });
                  const valueAdditionfiveDetails = this.valueAddition5TypeService.getValAddDetails({ valueAdditionId: salesData.valueAdditionFiveId });
                  const shippingTermsDetails = this.shippingRepository.getShippingTermsById({ shippingTermsId: SaleOrderResponse.SoInvDetailsInfo.shipmentTerms });
                  const displayBrandDetails = this.masterBrandsService.getDisplayBrandsById({brandId : salesData.masterBrandId})
                  let hsnCodeDetails = await this.hsnCodeService.getHsnByFoodType({ foodTypeId: salesData.foodTypeId, valueAddOneId: salesData.valueAdditionOneId, valueAddTwoId: salesData.valueAdditionTwoId, valueAddThreeId: salesData.valueAdditionThreeId, valueAddFourId: salesData.valueAdditionFourId, valueAddFiveId: salesData.valueAdditionFiveId, productId: salesData.itemId });
                  let hsnCode = hsnCodeDetails.status ? hsnCodeDetails.data.hsnCode : "";

                  // const innerBagSizeDetails = this.sizesService.getSizeDataById({ sizeId: salesData.innerBagSizeId });
                  //const sizeNameDetails = (await innerBagSizeDetails).sizeName;
                  await Promise.all([foodTypeDetails, productDetails, variantDetails, brandIdDetails, valueAdditionOneDetails, valueAdditiontwoDetails, valueAdditionthreeDetails, valueAdditionfourDetails, valueAdditionfiveDetails, shippingTermsDetails,displayBrandDetails]).then(res => {
                    const foodTypeDetails = res[0].status ? res[0].data.foodType : null;
                    const foodTypeHsnCode = res[0].status ? res[0].data.hsnCode : null;
                    const foodTypeCode = res[0].status ? res[0].data.foodTypeCode : null;
                    const productCodeDetails = res[1].status ? res[1].data.productCode : null;
                    const productNameDetails = res[1].status ? res[1].data.productName : null;
                    const productNameHsnCode = res[1].status ? res[1].data.hsnCode : null;
                    const variantCode = res[2].status ? res[2].data.variantCode : null;
                    const brandName = res[3].status ? res[3].data.brandName : null;
                    const valueAdditionOneName = res[4].status ? res[4].data.valueAdditionIdName : null;
                    const valueAdditionOneCode = res[4].status ? res[4].data.valueAdditionCode : null;
                    const valueAdditionTwoName = res[5].status ? res[5].data.valueAdditionIdName : null;
                    const valueAdditionTwoCode = res[5].status ? res[5].data.valueAdditionCode : null;
                    const valueAdditionThreeName = res[6].status ? res[6].data.valueAdditionIdName : null;
                    const valueAdditionThreeCode = res[6].status ? res[6].data.valueAdditionCode : null;
                    const valueAdditionFourName = res[7].status ? res[7].data.valueAdditionIdName : null;
                    const valueAdditionFourCode = res[7].status ? res[7].data.valueAdditionCode : null;
                    const valueAdditionFiveName = res[8].status ? res[8].data.valueAdditionIdName : null;
                    const valueAdditionFiveCode = res[8].status ? res[8].data.valueAdditionCode : null;
                    shippingTerms = res[9].status ? res[9].data.shippingTermsName : null;
                    const displayBrandName = res[10].status ? res[10].data.displayBrandName : null;
                    
                    const sizeNameDetails = null;
                    let taxName;
                    let taxPer;
                    let taxCategory;

                    if (taxDetails.taxId != undefined) {
                      taxPer = taxDetails.taxPercentage;
                      taxName = taxDetails.taxName;
                      taxCategory = taxDetails.taxCategory;
                    }
                    else {
                      taxName = "";
                      taxPer = 0;
                      taxCategory = '';
                    }
                    const saleOrderRes = new SaleOrderItemsDetails(salesData.saleOrderItemId, salesData.saleOrderId, salesData.itemId, productNameDetails, productCodeDetails, salesData.minGrade, salesData.maxGrade, salesData.foodTypeId, (foodTypeDetails === "NA" ? "" : foodTypeDetails === "Not Applicable" ? "" : foodTypeDetails), salesData.valueAdditionOneId, (valueAdditionOneName === "NA" ? "" : valueAdditionOneName === "Not Applicable" ? "" : valueAdditionOneName), (valueAdditionOneCode === "NA" ? "" : valueAdditionOneCode === "Not Applicable" ? "" : valueAdditionOneCode), salesData.valueAdditionTwoId, (valueAdditionTwoName === "NA" ? "" : valueAdditionTwoName === "Not Applicable" ? "" : valueAdditionTwoName), (valueAdditionTwoCode === "NA" ? "" : valueAdditionTwoCode === "Not Applicable" ? "" : valueAdditionTwoCode), salesData.valueAdditionThreeId, (valueAdditionThreeName === "NA" ? "" : valueAdditionThreeName === "Not Applicable" ? "" : valueAdditionThreeName), (valueAdditionThreeCode === "NA" ? "" : valueAdditionThreeCode === "Not Applicable" ? "" : valueAdditionThreeCode), salesData.valueAdditionFourId, (valueAdditionFourName === "NA" ? "" : valueAdditionFourName === "Not Applicable" ? "" : valueAdditionFourName), (valueAdditionFourCode === "NA" ? "" : valueAdditionFourCode === "Not Applicable" ? "" : valueAdditionFourCode), salesData.valueAdditionFiveId, (valueAdditionFiveName === "NA" ? "" : valueAdditionFiveName === "Not Applicable" ? "" : valueAdditionFiveName), (valueAdditionFiveCode === "NA" ? "" : valueAdditionFiveCode === "Not Applicable" ? "" : valueAdditionFiveCode), salesData.varientId, variantCode, salesData.skewerSizeItemId, sizeNameDetails, salesData.innerBagSizeId, sizeNameDetails, salesData.cases, salesData.netAmount, salesData.unitPrice, salesData.pouches, salesData.innerBags, salesData.shrimpWeight, salesData.pouchWeight, salesData.caseWeight, salesData.categoryId, salesData.netWeight, salesData.uomId, salesData.minGlaze, salesData.MaxGlaze, salesData.soakingTime, salesData.soakingStyle, salesData.styleWeighment, salesData.hlPercentage, salesData.finalPercentage, salesData.brandId, brandName, salesData.reportedCases, salesData.invoicedQty, salesData.dispatchedQty, salesData.revisedUnitPrice, paymentTermsName, customerAddress, deliveryAddress, containerNo, linesealNo, eseal, destinationDetails, foodTypeHsnCode, productNameHsnCode, currencyDetails, blNo === undefined ? "" : blNo, scac, bookingNo, getPaymnetsId.currency, salesData.totalGrossWeight, hsnCode, taxName, taxPer, taxCategory, salesData.cases, foodTypeCode ,displayBrandName,salesData.invoiceAmount);
                    salOrderarray.push(saleOrderRes);
                    // console.log(salOrderarray);
                  }).catch(error => {
                    console.log(error);
                  });
                }
              }

              const allInvoiceData = new PlantInvoiceDetailsModel(undefined, soId, saleOrderNo, undefined, undefined, undefined, data.unit, data.customerId, customerDetails.data.clientCode, customerDetails.data.clientName, countryName, data.endCustomerId, endCustomerCode, endCustomerName, undefined, undefined, 1, data.createdAt, undefined, undefined, isInvoiced, undefined, salOrderarray, "", "", 0, blNo === undefined ? "" : blNo, shippingTerms, buyerPo, custPo, edl, actualEdl?.toString(), refNo, trackingNo, vesselName, portOfTranshipment, portOfDischarge, importingVesselName, "", dateOfTranshipment, shippedOnboardDate, dischargeDate, destinationDate, null, unitdata, invoicedPlant, lotNo, "", 0, 0, '', "", "", "", 0, "", portOfDischarge,undefined,'','',undefined,'','','',0,0,'',consignee);
              //allInvoiceData.push(modelInfoData);
              // console.log(allInvoiceData, 'isInv no');
              return new PlantInvoiceDetailsResponse(true, 1111, 'Plant Invoice Data Found Successfully', allInvoiceData);
            }
          }
        }
      }
      else {
        throw new PlantInvoiceDetailsResponse(false, 9999, 'No Data Found');
      }
    } catch (err) {
      console.log(err);
      throw err
    }
  }

  async updateContainerStatus(soContainerStatus: SoContainerStatusUpdate): Promise<boolean> {
    try {
      console.log(soContainerStatus);
      let prodStatus;
      let updateStatus;
      if (soContainerStatus.containerStatus === "LOADING") {
        prodStatus = InvoiceStatusEnum.IN_PROGRESS;
        updateStatus = await this.soTrackRepo.update({ saleOrderInfo: Raw(alias => `sale_order_id = '${soContainerStatus.saleOrderId}'`) }, { containerStatus: soContainerStatus.containerStatus, productionStatus: prodStatus, dispatchedDate: new Date() });
      }
      else if (soContainerStatus.containerStatus === "LOADED AND SEALED") {
        prodStatus = InvoiceStatusEnum.CLOSE;
        updateStatus = await this.soTrackRepo.update({ saleOrderInfo: Raw(alias => `sale_order_id = '${soContainerStatus.saleOrderId}'`) }, { containerStatus: soContainerStatus.containerStatus, productionStatus: prodStatus, isDispatched: true });
      }
      else {
        updateStatus = await this.soTrackRepo.update({ saleOrderInfo: Raw(alias => `sale_order_id = '${soContainerStatus.saleOrderId}'`) }, { containerStatus: soContainerStatus.containerStatus });
      }
      console.log(updateStatus);
      if (updateStatus.affected) {
        return true;
      } else {
        throw new ErrorResponse(9999, 'Something Went Wrong');
      }
    } catch (error) {
      return error
    }

  }

  async UpdateSoForPo(saleOrderId: number): Promise<CommonResponse> {
    const manager = new GenericTransactionManager();
    try {
      await manager.startTransaction();
      const soData: BomDetails[] = await manager.getCustomRepository(BomRepository).UpdateBomDetailsForSoInPO({ saleOrderId: saleOrderId });
      if (soData.length) {
        //   const saleOrderInfo = await this.soRepo.update({saleOrderId: saleOrderId},{status:SoStatusEnum.PARTIAL_PO});
        // }else{
        //   const saleOrderInfo = await this.soRepo.update({saleOrderId: saleOrderId},{status:SoStatusEnum.IN_PROGRESS});
        const saleOrderInfo = await manager.getCustomRepository(SoRepository).update({ saleOrderId: saleOrderId }, { status: SoStatusEnum.IN_PROGRESS });
        const saleTrackInfo = await manager.getCustomRepository(SoTrackRepository).update({ saleOrderInfo: Raw(alias => `sale_order_id = '${saleOrderId}'`) }, { pmStatus: PmStatusEnum.IN_PROGRESS });
        if (saleOrderInfo.affected && saleTrackInfo.affected) {
          manager.completeTransaction();
          return new CommonResponse(true, 1111, 'So&Packing Info Updated Successfully');
        } else {
          await manager.releaseTransaction();
          return new CommonResponse(false, 1111, "Update Failed, Please Try Again")
        }
      }
    } catch (error) {
      await manager.releaseTransaction();
      return error;
    }

  }

  /**
  * * Get the details for plant invoce grid view
  */
  // async getAllPlantInvoiceDetails(): Promise<GetAllInvoiceDetailsResponse> {
  //   try {

  //     const plantInvoiceData: SoCustomerInvoice[] = await this.customerInvoiceRepo.find({ relations: ['saleOrderInfo', 'saleOrderInfo.SoInvDetailsInfo'] });
  //     const InvoiceData: PlantInvoiceDetailsModel[] = [];

  //     for (const data of plantInvoiceData) {
  //       let currencyid = data.saleOrderInfo.SoInvDetailsInfo.currency;
  //       let poNumber = data.saleOrderInfo.SoInvDetailsInfo.poNumber;
  //       //To get customer and end customer details
  //       const customerDetails = await this.customerRepository.getCustomerDataById({ custId: data.customerId });
  //       const endCustomerDetails = await this.endCustomerRepository.getEndCustomerDataById({ endCustomerId: data.endCustomerId });
  //       const endCustomerCode = endCustomerDetails.data.endCustomerCode;
  //       const endCustomerName = endCustomerDetails.data.endCustomerName;
  //       //To get country Details
  //       const countryDetails = this.countryRepository.getCountryById({ countryId: data.saleOrderInfo.SoInvDetailsInfo.country });
  //       const countryName = (await countryDetails).data.countryName;
  //       const unitData = await this.unitcodeService.getPlantDetailsById({ unitcodeId: data.unitId })
  //       let unitName = '';
  //       if (unitData.status) {
  //         unitName = unitData.data.unitcodeName;
  //       }
  //       const destinationData = this.destinationRepository.getDestinationById({ destinationId: data.saleOrderInfo.SoInvDetailsInfo.destination });
  //       const destinationName = (await destinationData).data.destinationName;
  //       const saleOrderNo = await this.soRepo.getSaleOrderNo(data.saleOrderId);
  //       const modelInfoData = new PlantInvoiceDetailsModel(data.invoiceId, data.saleOrderId, saleOrderNo, data.invoiceNumber, data.invoiceDate, data.exporterId, data.unitId, data.customerId, customerDetails.data.clientCode, customerDetails.data.clientName, countryName, data.endCustomerId, endCustomerCode, endCustomerName, data.flightNumber, data.status, data.exchangeRate, data.createdAt, data.totalAmount, data.total_INR_amount, undefined, data.freightCharges, null, unitName, "customerDetails.data.currency", currencyid, '', '', '', poNumber, undefined, data.orderDate, '', '', '', '', '', '', '', undefined, undefined, undefined, undefined, '', null, null, '', '', 0, data.insurance, '', '', '', '', undefined, '', destinationName);
  //       InvoiceData.push(modelInfoData);
  //     }
  //     return new GetAllInvoiceDetailsResponse(true, 1111, 'Plant Invoice Data Found Successfully', InvoiceData);
  //   }
  //   catch (err) {
  //     console.log(err);
  //     throw err;
  //   }
  // }

  async getAllPlantInvoiceDetails(): Promise<GetAllInvoiceDetailsResponse> {
    try {

      const manager = getManager();
      const query = `SELECT ci.invoice_date AS invoiceDate , ci.invoice_number AS invoiceNumber ,sid.po_number AS custPoNo , c.client_name AS clientName ,ec.end_customer_name AS endCustomerName , co.country_name AS country , d.destination_name AS destinationName  , uc.unit_name AS unitName ,ci.total_amount AS totalAmount , cu.currency_id AS currency , ROUND(ci.exchange_rate) AS exchangeRate, ci.freight_charges AS freightCharges,ci.insurance AS insurance , ci.status AS status, ci.total_inr_amount AS totalInrAmount,ci.sale_order_id as saleOrderId FROM ` + appSettings.sales_db + `.customer_invoice ci 
       LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = ci.sale_order_id 
       LEFT JOIN ` + appSettings.masters_db + `.customers c ON c.cust_id = ci.customer_id 
       LEFT JOIN ` + appSettings.masters_db + `.end_customers ec ON ec.end_customer_id = ci.end_customer_id 
       LEFT JOIN ` + appSettings.masters_db + `.countries co ON co.country_id = sid.country_id
       LEFT JOIN ` + appSettings.masters_db + `.destination d ON d.destination_id = sid.destination 
       LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = ci.unit_id 
       LEFT JOIN ` + appSettings.masters_db + `.currencies cu ON cu.currency_id = sid.currency_id 
       WHERE ci.invoice_id > 0 `
      const InvoiceData = await manager.query(query)
      if (InvoiceData.length > 0) {
        return new GetAllInvoiceDetailsResponse(true, 1111, 'Plant Invoice Data Found Successfully', InvoiceData);
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async updateContainerStatusReadyToBook(containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
    const updateStatus = await this.soTrackRepo.update(
      {
        saleOrderInfo: Raw(
          (alias) => `sale_order_id = '${containerInfo.saleOrderId}'`
        ),
      },
      { containerStatus: ContainerStatusEnum.READY_TO_BOOK }
    );
    if (updateStatus) {
      return new ContainerDispatchedToPlantResponse(true, 1111, 'Updated to Ready To Book');
    } else {
      throw new ErrorResponse(9999, 'Failed to update');
    }
  }


  async getAllSoInspections(): Promise<SoAllInspectionsResponseModel> {
    try {
      const soInspectionDTO: SoAllInspectionsDto[] = [];
      const inspection = this.saleInspectionRepository
        .createQueryBuilder('SaleInspectionDetails')
        .select("soi.po_number as poNumber,SaleInspectionDetails.so_inspection_id AS soInspectionId,SaleInspectionDetails.sale_order_id AS saleOrderId, saleOrderInfo.sale_order_no AS saleOrderNumber, GROUP_CONCAT(inspection ORDER BY inspection ASC) AS inspectionName, GROUP_CONCAT(is_checked ORDER BY inspection ASC) AS isChecked, SaleInspectionDetails.initiation_date as initiationDate, SaleInspectionDetails.planned_date as plannedDate, SaleInspectionDetails.actual_date as actualDate, SaleInspectionDetails.expected_result_date as expectedResultDate, SaleInspectionDetails.is_sgs_tuv as isSgsTuv").leftJoin("sale_order", "saleOrderInfo", "saleOrderInfo.sale_order_id = SaleInspectionDetails.sale_order_id").leftJoin("so_invoice_details","soi","soi.sale_order_id = SaleInspectionDetails.sale_order_id").groupBy("SaleInspectionDetails.sale_order_id");
      const soInspectionDetails = await inspection.orderBy(
        'SaleInspectionDetails.SoInspectionId',
        'ASC'
      ).getRawMany();
      console.log('****************')
      console.log(soInspectionDetails);
      if (soInspectionDetails.length > 0) {
        for (const item of soInspectionDetails) {
          const inspection = (item.inspectionName).split(',');
          const isCheck = (item.isChecked).split(',');
          const sgsStatus = (item.isChecked).substring(0, isCheck);
          const tuvStatus = (item.isChecked).substring(isCheck + 1);
          const loadStatus = (item.isChecked).substring(isCheck + 1);

          const data = new SoAllInspectionsDto(item.soInspectionId,
            inspection[0] == 'Load Inspection' ? isCheck[0] : '-',
            inspection[0] == 'SGS Inspection' ? isCheck[0] : inspection[1] == 'SGS Inspection' ? isCheck[1] : '-',
            inspection[0] == 'TUV Inspection' ? isCheck[0] : inspection[1] == 'TUV Inspection' ? isCheck[1] : inspection[2] == 'TUV Inspection' ? isCheck[2] : '-', item.saleOrderId, item.saleOrderNumber, item.shipmentDate, item.initiationDate, item.plannedDate, item.actualDate, item.expectedResultDate, item.isSgsTuv,item.poNumber);
          soInspectionDTO.push(data);
        }
        console.log(soInspectionDTO)
        const response = new SoAllInspectionsResponseModel(true, 1, 'So Inspection Details retrieved successfully', soInspectionDTO);
        return response
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }

    } catch (err) {
      return err;
    }
  }



  async updateSoInspectionInfo(inspectionDto: UpdateSoInspectionInfo): Promise<SoInspectionUpdateResponse> {
    try {
      const updateStatus = await this.saleInspectionRepository.update(
        {
          saleOrderId: Raw(
            (alias) => `sale_order_id = '${inspectionDto.saleOrderId}'`
          ),
          inspectionName: Raw(
            (alias) => `inspection = '${inspectionDto.inspectionName}'`
          ),
        },
        { isChecked: inspectionDto.isChecked }
      );
      if (updateStatus) {
        return new SoInspectionUpdateResponse(true, 1111, 'Updated Successfully')
      } else {
        throw new ErrorResponse(9999, 'Failed to update');
      }

      // const convertedEntity = await this.saleInspectionAdapter.convertDtoToEntity(inspectionDto);
      // // const savedDoc = await manager.getCustomRepository(SaleInspectionDetailsRepository).save(convertedEntity);
      // const updateSo = await manager.getCustomRepository(SaleInspectionDetailsRepository).save(convertedEntity);
      // if(updateSo){
      //     await manager.completeTransaction();
      //     return new SoInspectionUpdateResponse(true, 1111, 'Updated Successfully')
      // }else{
      //     throw new ErrorResponse(9999, 'Failed to update So Inspection status')
      // }

    } catch (error) {
      return error
    }
  }


  async updateSGSTUVData(inspectionDto: SgsTuvData): Promise<SoInspectionUpdateResponse> {
    try {
      const updateStatus = await this.saleInspectionRepository.update(
        {
          saleOrderId: Raw(
            (alias) => `sale_order_id = '${inspectionDto.saleOrderId}'`
          )
        },
        { isSgsTuv: true, shipmentDate: inspectionDto.shipmentDate, initiationDate: inspectionDto.initiationDate, plannedDate: inspectionDto.plannedDate, actualDate: inspectionDto.actualDate, expectedResultDate: inspectionDto.expectedResultDate, inspectionStatus: inspectionDto.inspectionStatus }
      );
      if (updateStatus) {
        return new SoInspectionUpdateResponse(true, 1111, 'Updated Successfully')
      } else {
        throw new ErrorResponse(9999, 'Failed to update');
      }

    } catch (error) {
      return error
    }
  }

  async getRmBomData(req: RMFiltersRequest): Promise<RmBomResponse> {
    const manager = new GenericTransactionManager();
    try {
      const itemCategoryData = await this.itemCategoryService.getItemCategoryByName(new ItemCategoryNameRequest(ItemCategoriesEnum.RAW_MATERIAL));
      if (itemCategoryData) {
        const itemCategoryId = itemCategoryData.itemCategoryId;
        const currentDate = new Date();
        const below7ToDate = moment(currentDate).add(RmEtd.ETD, 'days').format('YYYY-MM-DD');
        const days7FromDate = moment(below7ToDate).add(1, 'days').format('YYYY-MM-DD');
        const days7ToDate = moment(currentDate).add((RmEtd.ETD + 7), 'days').format('YYYY-MM-DD');
        const days14FromDate = moment(days7ToDate).add(1, 'days').format('YYYY-MM-DD');
        const days14ToDate = moment(days14FromDate).add(7, 'days').format('YYYY-MM-DD');
        const days21FromDate = moment(days14ToDate).add(1, 'days').format('YYYY-MM-DD');
        const days21ToDate = moment(days21FromDate).add(15, 'days').format('YYYY-MM-DD');
        const days37FromDate = moment(days21ToDate).add(1, 'days').format('YYYY-MM-DD');
        let totalToBeProcuresQty = 0;
        let totalIndents = 0;
        let totalIndentQty = 0;
        let totalFarmers = 0;
        //to get total to be procured quantity
        const bomInfo = await this.bomRepo.getBomQty(itemCategoryId)
        if (bomInfo) {
          totalToBeProcuresQty = bomInfo.totalbomQty;
        }
        //getting indent information
        const indentQtyInfo = await this.indentService.getIndentQty();
        if (indentQtyInfo.status) {
          totalIndentQty = indentQtyInfo.data.expectedQty;
          totalIndents = indentQtyInfo.data.totalIndents;
        }
        //get total farmers 
        const farmersCount = await this.supplierService.getFarmersCount();
        if (farmersCount) {
          totalFarmers = farmersCount;
        }

        //pending GRN's
        let pendingGrnQty = 0;
        const pendingGrnQtyInfo = await this.indentService.getPendingGrnQty();
        if (indentQtyInfo.status) {
          pendingGrnQty = pendingGrnQtyInfo.data.expectedQty;
        }

        let productMap = new Map<number, String>();
        let countryMap = new Map<number, String>();
        let productBelow7days
        let product7days
        let product14days
        let product30days
        let product30Above
        let country

        //over all information 
        let bomIndentInfoBelow7days: BomIndentInfo[] = [];
        let bomIndentInfo7days: BomIndentInfo[] = [];
        let bomIndentInfo14days: BomIndentInfo[] = [];
        let bomIndentInfo30days: BomIndentInfo[] = [];
        let bomIndentInfoAbove30days: BomIndentInfo[] = [];
        let bomproduct7days;
        let bomproductBelow7days;
        let bomproduct14days;
        let bomproduct30days;
        let bomproductAbove30days;
        let indent7DaysQty = 0;
        let indentBelow7DaysQty = 0;
        let indent14DaysQty = 0;
        let indent30DaysQty = 0;
        let indentAbove30DaysQty = 0;

        const BomDataBelow7days = await this.rmbomRepo.getBomInfo(null, below7ToDate);
        console.log('blwouj7 fgtr')
        console.log(BomDataBelow7days)
        const BomData7days = await this.rmbomRepo.getBomInfo(days7FromDate, days7ToDate);
        console.log('7data dfgrtd')
        console.log(BomData7days)
        const BomData14days = await this.rmbomRepo.getBomInfo(days14FromDate, days14ToDate);
        const BomData30days = await this.rmbomRepo.getBomInfo(days21FromDate, days21ToDate);
        const BomDataAbove30days = await this.rmbomRepo.getBomInfo(days37FromDate, null);

        for (const BomDataBelow7daysRecord of BomDataBelow7days) {
          if (!(productMap.has(BomDataBelow7daysRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(BomDataBelow7daysRecord.productId))
            productMap.set(BomDataBelow7daysRecord.productId, productData.data.productName);
          }
          bomproductBelow7days = productMap.get(BomDataBelow7daysRecord.productId)
          // const indent7daysFromdate = moment(days7FromDate).subtract(5, 'days').format('YYYY-MM-DD');
          const indentBelow7daysTodate = moment(below7ToDate).subtract(12, 'days').format('YYYY-MM-DD');
          const indentData = await this.indentService.getProductCountWiseIndentQty(new IndentQuantityRequest(BomDataBelow7daysRecord.productId, BomDataBelow7daysRecord.count, null, indentBelow7daysTodate))
          if (indentData.status) {
            indentBelow7DaysQty = indentData.data.expectedQty;
          }
          const bomInfoObj = new BomIndentInfo(BomDataBelow7daysRecord.bomId, BomDataBelow7daysRecord.count, BomDataBelow7daysRecord.bomQty, bomproductBelow7days, indentBelow7DaysQty)
          bomIndentInfoBelow7days.push(bomInfoObj);
        }

        for (const BomData7daysRecord of BomData7days) {
          if (!(productMap.has(BomData7daysRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(BomData7daysRecord.productId))
            productMap.set(BomData7daysRecord.productId, productData.data.productName);
          }
          bomproduct7days = productMap.get(BomData7daysRecord.productId)
          const indent7daysFromdate = moment(days7FromDate).subtract(12, 'days').format('YYYY-MM-DD');
          const indent7daysTodate = moment(days7ToDate).subtract(12, 'days').format('YYYY-MM-DD');
          const indentData = await this.indentService.getProductCountWiseIndentQty(new IndentQuantityRequest(BomData7daysRecord.productId, BomData7daysRecord.count, indent7daysFromdate, indent7daysTodate))
          if (indentData.status) {
            indent7DaysQty = indentData.data.expectedQty;
          }
          const bomInfoObj = new BomIndentInfo(BomData7daysRecord.bomId, BomData7daysRecord.count, BomData7daysRecord.bomQty, bomproduct7days, indent7DaysQty)
          bomIndentInfo7days.push(bomInfoObj);
        }

        for (const BomData14daysRecord of BomData14days) {
          if (!(productMap.has(BomData14daysRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(BomData14daysRecord.productId))
            productMap.set(BomData14daysRecord.productId, productData.data.productName);
          }
          bomproduct14days = productMap.get(BomData14daysRecord.productId)
          const indent14daysFromdate = moment(days14FromDate).subtract(12, 'days').format('YYYY-MM-DD');
          const indent14daysTodate = moment(days14ToDate).subtract(12, 'days').format('YYYY-MM-DD');
          const indentData = await this.indentService.getProductCountWiseIndentQty(new IndentQuantityRequest(BomData14daysRecord.productId, BomData14daysRecord.count, indent14daysFromdate, indent14daysTodate))
          if (indentData.status) {
            indent14DaysQty = indentData.data.expectedQty;
          }
          const bomInfoObj = new BomIndentInfo(BomData14daysRecord.bomId, BomData14daysRecord.count, BomData14daysRecord.bomQty, bomproduct14days, indent14DaysQty)
          bomIndentInfo14days.push(bomInfoObj);
        }
        for (const BomData30daysRecord of BomData30days) {
          if (!(productMap.has(BomData30daysRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(BomData30daysRecord.productId))
            productMap.set(BomData30daysRecord.productId, productData.data.productName);
          }
          bomproduct30days = productMap.get(BomData30daysRecord.productId)
          const indent30daysFromdate = moment(days21FromDate).subtract(12, 'days').format('YYYY-MM-DD');
          const indent30daysTodate = moment(days21ToDate).subtract(12, 'days').format('YYYY-MM-DD');
          const indentData = await this.indentService.getProductCountWiseIndentQty(new IndentQuantityRequest(BomData30daysRecord.productId, BomData30daysRecord.count, indent30daysFromdate, indent30daysTodate))
          if (indentData.status) {
            indent30DaysQty = indentData.data.expectedQty;
          }
          const bomInfoObj = new BomIndentInfo(BomData30daysRecord.bomId, BomData30daysRecord.count, BomData30daysRecord.bomQty, bomproduct30days, indent30DaysQty)
          bomIndentInfo30days.push(bomInfoObj);
        }

        for (const BomDataAbovedaysRecord of BomDataAbove30days) {
          if (!(productMap.has(BomDataAbovedaysRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(BomDataAbovedaysRecord.productId))
            productMap.set(BomDataAbovedaysRecord.productId, productData.data.productName);
          }
          bomproductAbove30days = productMap.get(BomDataAbovedaysRecord.productId)
          const indentAbove30daysFromdate = moment(days37FromDate).subtract(12, 'days').format('YYYY-MM-DD');
          // const indentAbove30daysTodate = moment(days37ToDate).subtract(5, 'days').format('YYYY-MM-DD');
          const indentData = await this.indentService.getProductCountWiseIndentQty(new IndentQuantityRequest(BomDataAbovedaysRecord.productId, BomDataAbovedaysRecord.count, indentAbove30daysFromdate, null))
          if (indentData.status) {
            indentAbove30DaysQty = indentData.data.expectedQty;
          }
          const bomInfoObj = new BomIndentInfo(BomDataAbovedaysRecord.bomId, BomDataAbovedaysRecord.count, BomDataAbovedaysRecord.bomQty, bomproductAbove30days, indentAbove30DaysQty)
          bomIndentInfoAbove30days.push(bomInfoObj);
        }


        //po wise information
        const poWiseBelow7BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, null, below7ToDate, 'poWise', 'sale_order_no');
        const poWise7BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days7FromDate, days7ToDate, 'poWise', 'sale_order_no');
        const poWise14BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days14FromDate, days14ToDate, 'poWise', 'sale_order_no');
        const poWise30BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days21FromDate, days21ToDate, 'poWise', 'sale_order_no');
        const poWiseAbove30BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days37FromDate, null, 'poWise', 'sale_order_no');
        let poInfo7days: PoInfo[] = [];
        let poInfoBelow7days: PoInfo[] = [];
        let poInfo14days: PoInfo[] = [];
        let poInfo30days: PoInfo[] = [];
        let poInfoAbove30days: PoInfo[] = [];

        for (const poWiseBelow7BomDataRecord of poWiseBelow7BomData) {
          if (!(productMap.has(poWiseBelow7BomDataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(poWiseBelow7BomDataRecord.productId))
            productMap.set(poWiseBelow7BomDataRecord.productId, productData.data.productName);
          }
          productBelow7days = productMap.get(poWiseBelow7BomDataRecord.productId)
          const poInfoObj = new PoInfo(poWiseBelow7BomDataRecord.poNumber, poWiseBelow7BomDataRecord.count, poWiseBelow7BomDataRecord.bomQty, productBelow7days);
          poInfoBelow7days.push(poInfoObj);
        }

        for (const poWise7BomDataRecord of poWise7BomData) {
          if (!(productMap.has(poWise7BomDataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(poWise7BomDataRecord.productId))
            productMap.set(poWise7BomDataRecord.productId, productData.data.productName);
          }
          product7days = productMap.get(poWise7BomDataRecord.productId)
          const poInfoObj = new PoInfo(poWise7BomDataRecord.poNumber, poWise7BomDataRecord.count, poWise7BomDataRecord.bomQty, product7days);
          poInfo7days.push(poInfoObj);
        }
        for (const poWise14BomDataRecord of poWise14BomData) {
          if (!(productMap.has(poWise14BomDataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(poWise14BomDataRecord.productId))
            productMap.set(poWise14BomDataRecord.productId, productData.data.productName);
          }
          product14days = productMap.get(poWise14BomDataRecord.productId)
          const poInfoObj = new PoInfo(poWise14BomDataRecord.poNumber, poWise14BomDataRecord.count, poWise14BomDataRecord.bomQty, product14days);
          poInfo14days.push(poInfoObj);
        }
        for (const poWise30BomDataRecord of poWise30BomData) {
          if (!(productMap.has(poWise30BomDataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(poWise30BomDataRecord.productId))
            productMap.set(poWise30BomDataRecord.productId, productData.data.productName);
          }
          product30days = productMap.get(poWise30BomDataRecord.productId)
          const poInfoObj = new PoInfo(poWise30BomDataRecord.poNumber, poWise30BomDataRecord.count, poWise30BomDataRecord.bomQty, product30days);
          poInfo30days.push(poInfoObj);
        }

        for (const poWiseAbove30BomDataRecord of poWiseAbove30BomData) {
          if (!(productMap.has(poWiseAbove30BomDataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(poWiseAbove30BomDataRecord.productId))
            productMap.set(poWiseAbove30BomDataRecord.productId, productData.data.productName);
          }
          product30Above = productMap.get(poWiseAbove30BomDataRecord.productId)
          const poInfoObj = new PoInfo(poWiseAbove30BomDataRecord.poNumber, poWiseAbove30BomDataRecord.count, poWiseAbove30BomDataRecord.bomQty, product30Above);
          poInfoAbove30days.push(poInfoObj);
        }

        //country wise information
        const countryWiseBelow7BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, null, below7ToDate, 'countryWise', 'country_id');
        const countryWise7BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days7FromDate, days7ToDate, 'countryWise', 'country_id');
        const countryWise14BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days14FromDate, days14ToDate, 'countryWise', 'country_id');
        const countryWise30BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days21FromDate, days21ToDate, 'countryWise', 'country_id');
        const countryWiseAbove30BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days37FromDate, null, 'countryWise', 'country_id');

        let countryInfoBelow7days: CountryInfo[] = [];
        let countryInfo7days: CountryInfo[] = [];
        let countryInfo14days: CountryInfo[] = [];
        let countryInfo30days: CountryInfo[] = [];
        let countryInfoAbove30days: CountryInfo[] = [];

        let countryBelow7days
        let country7days
        let country14days
        let country30days
        let countryabove30

        let countryBelow7daysProduct
        let country7daysProduct
        let country14daysProduct
        let country30daysProduct
        let countryAbove30daysProduct

        for (const countryWiseBelow7DataRecord of countryWiseBelow7BomData) {
          if (!(countryMap.has(countryWiseBelow7DataRecord.countryId))) {
            const countryData = await this.countryRepository.getCountryById(new CountryRequest(countryWiseBelow7DataRecord.countryId))
            if (countryData) {
              countryMap.set(countryWiseBelow7DataRecord.countryId, countryData.data.countryName);
            }
          }
          countryBelow7days = countryMap.get(countryWiseBelow7DataRecord.countryId)
          if (!(productMap.has(countryWiseBelow7DataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countryWiseBelow7DataRecord.productId))
            productMap.set(countryWiseBelow7DataRecord.productId, productData.data.productName);
          }
          countryBelow7daysProduct = productMap.get(countryWiseBelow7DataRecord.productId)
          const countryInfoObj = new CountryInfo(countryBelow7days, countryWiseBelow7DataRecord.count, countryWiseBelow7DataRecord.bomQty, countryBelow7daysProduct);
          countryInfoBelow7days.push(countryInfoObj);
        }

        for (const countryWise7DataRecord of countryWise7BomData) {
          if (!(countryMap.has(countryWise7DataRecord.countryId))) {
            const countryData = await this.countryRepository.getCountryById(new CountryRequest(countryWise7DataRecord.countryId))
            if (countryData) {
              countryMap.set(countryWise7DataRecord.countryId, countryData.data.countryName);
            }
          }
          country7days = countryMap.get(countryWise7DataRecord.countryId)
          if (!(productMap.has(countryWise7DataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countryWise7DataRecord.productId))
            productMap.set(countryWise7DataRecord.productId, productData.data.productName);
          }
          country7daysProduct = productMap.get(countryWise7DataRecord.productId)
          const countryInfoObj = new CountryInfo(country7days, countryWise7DataRecord.count, countryWise7DataRecord.bomQty, country7daysProduct);
          countryInfo7days.push(countryInfoObj);
        }

        for (const countryWise14DataRecord of countryWise14BomData) {
          if (!(countryMap.has(countryWise14DataRecord.countryId))) {
            const countryData = await this.countryRepository.getCountryById(new CountryRequest(countryWise14DataRecord.countryId))
            if (countryData) {
              countryMap.set(countryWise14DataRecord.countryId, countryData.data.countryName);
            }

          }
          country14days = countryMap.get(countryWise14DataRecord.countryId)
          if (!(productMap.has(countryWise14DataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countryWise14DataRecord.productId))
            productMap.set(countryWise14DataRecord.productId, productData.data.productName);
          }
          country14daysProduct = productMap.get(countryWise14DataRecord.productId)
          const countryInfoObj = new CountryInfo(country14days, countryWise14DataRecord.count, countryWise14DataRecord.bomQty, country14daysProduct);
          countryInfo14days.push(countryInfoObj);
        }

        for (const countryWise30DataRecord of countryWise30BomData) {
          if (!(countryMap.has(countryWise30DataRecord.countryId))) {
            const countryData = await this.countryRepository.getCountryById(new CountryRequest(countryWise30DataRecord.countryId))
            if (countryData) {
              countryMap.set(countryWise30DataRecord.countryId, countryData.data.countryName);
            }
          }
          country30days = countryMap.get(countryWise30DataRecord.countryId)
          if (!(productMap.has(countryWise30DataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countryWise30DataRecord.productId))
            productMap.set(countryWise30DataRecord.productId, productData.data.productName);
          }
          country30daysProduct = productMap.get(countryWise30DataRecord.productId)
          const countryInfoObj = new CountryInfo(country30days, countryWise30DataRecord.count, countryWise30DataRecord.bomQty, country30daysProduct);
          countryInfo30days.push(countryInfoObj);
        }

        for (const countryWiseAbove30DataRecord of countryWiseAbove30BomData) {
          if (!(countryMap.has(countryWiseAbove30DataRecord.countryId))) {
            const countryData = await this.countryRepository.getCountryById(new CountryRequest(countryWiseAbove30DataRecord.countryId))
            if (countryData) {
              countryMap.set(countryWiseAbove30DataRecord.countryId, countryData.data.countryName);
            }
          }
          countryabove30 = countryMap.get(countryWiseAbove30DataRecord.countryId)
          if (!(productMap.has(countryWiseAbove30DataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countryWiseAbove30DataRecord.productId))
            productMap.set(countryWiseAbove30DataRecord.productId, productData.data.productName);
          }
          countryAbove30daysProduct = productMap.get(countryWiseAbove30DataRecord.productId)
          const countryInfoObj = new CountryInfo(countryabove30, countryWiseAbove30DataRecord.count, countryWiseAbove30DataRecord.bomQty, countryAbove30daysProduct);
          countryInfoAbove30days.push(countryInfoObj);
        }

        //rating wise information
        const ratingWiseBelow7BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, null, below7ToDate, 'ratingWise', 'rating');
        const ratingWise7BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days7FromDate, days7ToDate, 'ratingWise', 'rating');
        const ratingWise14BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days14FromDate, days14ToDate, 'ratingWise', 'rating');
        const ratingWise30BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days21FromDate, days21ToDate, 'ratingWise', 'rating');
        const ratingWiseAbove30BomData = await this.rmbomRepo.getdynamicBomdata(itemCategoryId, days37FromDate, null, 'ratingWise', 'rating');

        let ratingInfoBelow7days: RatingInfo[] = [];
        let ratingInfo7days: RatingInfo[] = [];
        let ratingInfo14days: RatingInfo[] = [];
        let ratingInfo30days: RatingInfo[] = [];
        let ratingInfoAbove30days: RatingInfo[] = [];

        let ratingWiseBelow7Product
        let ratingWise7Product
        let ratingWise14Product
        let ratingWise30Product
        let ratingWiseAbove30Product

        for (const ratingBelow7daydataRecord of ratingWiseBelow7BomData) {
          if (!(productMap.has(ratingBelow7daydataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(ratingBelow7daydataRecord.productId))
            productMap.set(ratingBelow7daydataRecord.productId, productData.data.productName);
          }
          ratingWiseBelow7Product = productMap.get(ratingBelow7daydataRecord.productId)
          const ratingInfoObj = new RatingInfo(ratingBelow7daydataRecord.rating, ratingBelow7daydataRecord.count, ratingBelow7daydataRecord.bomQty, ratingWiseBelow7Product);
          ratingInfoBelow7days.push(ratingInfoObj);
        }

        for (const rating7daydataRecord of ratingWise7BomData) {
          if (!(productMap.has(rating7daydataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(rating7daydataRecord.productId))
            productMap.set(rating7daydataRecord.productId, productData.data.productName);
          }
          ratingWise7Product = productMap.get(rating7daydataRecord.productId)
          const ratingInfoObj = new RatingInfo(rating7daydataRecord.rating, rating7daydataRecord.count, rating7daydataRecord.bomQty, ratingWise7Product);
          ratingInfo7days.push(ratingInfoObj);
        }
        for (const rating14daydataRecord of ratingWise14BomData) {
          if (!(productMap.has(rating14daydataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(rating14daydataRecord.productId))
            productMap.set(rating14daydataRecord.productId, productData.data.productName);
          }
          ratingWise14Product = productMap.get(rating14daydataRecord.productId)
          const ratingInfoObj = new RatingInfo(rating14daydataRecord.rating, rating14daydataRecord.count, rating14daydataRecord.bomQty, ratingWise14Product);
          ratingInfo14days.push(ratingInfoObj);
        }

        for (const rating30daydataRecord of ratingWise30BomData) {
          if (!(productMap.has(rating30daydataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(rating30daydataRecord.productId))
            productMap.set(rating30daydataRecord.productId, productData.data.productName);
          }
          ratingWise30Product = productMap.get(rating30daydataRecord.productId)
          const ratingInfoObj = new RatingInfo(rating30daydataRecord.rating, rating30daydataRecord.count, rating30daydataRecord.bomQty, ratingWise30Product);
          ratingInfo30days.push(ratingInfoObj);
        }

        for (const ratingAbove30dataRecord of ratingWiseAbove30BomData) {
          if (!(productMap.has(ratingAbove30dataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(ratingAbove30dataRecord.productId))
            productMap.set(ratingAbove30dataRecord.productId, productData.data.productName);
          }
          ratingWiseAbove30Product = productMap.get(ratingAbove30dataRecord.productId)
          const ratingInfoObj = new RatingInfo(ratingAbove30dataRecord.rating, ratingAbove30dataRecord.count, ratingAbove30dataRecord.bomQty, ratingWiseAbove30Product);
          ratingInfoAbove30days.push(ratingInfoObj);
        }

        //get product count range wise BOM data
        const productCountWiseBelow7daysData = await this.rmbomRepo.getProductCountWiseBomdata(null, below7ToDate);
        const productCountWise7daysData = await this.rmbomRepo.getProductCountWiseBomdata(days7FromDate, days7ToDate);
        const productCountWise14daysData = await this.rmbomRepo.getProductCountWiseBomdata(days14FromDate, days14ToDate);
        const productCountWise30daysData = await this.rmbomRepo.getProductCountWiseBomdata(days21FromDate, days21ToDate);
        const productCountWiseAbove30Data = await this.rmbomRepo.getProductCountWiseBomdata(days37FromDate, null);
        let countRangeBelow7daysProduct;
        let countRange7daysProduct;
        let countRange14daysProduct;
        let countRange30daysProduct;
        let countRangeAbove30daysProduct;
        let countRangeInfo7days: countRangeWiseInfo;
        let countRangeInfo14days: countRangeWiseInfo[] = [];
        let countRangeInfo30days: countRangeWiseInfo[] = [];
        let countRangeInfoAbove30days: countRangeWiseInfo[] = [];
        let seriesInfo7days: seriesInfo[] = [];
        let seriesInfoBelow7days: seriesInfo[] = [];
        let seriesInfo14days: seriesInfo[] = [];
        let seriesInfo30days: seriesInfo[] = [];
        let seriesInfoAbove30days: seriesInfo[] = [];
        let countRangeMapBelow7days = new Map<string, any[]>()
        let countRangeMap7days = new Map<string, any[]>()
        let dataExistingKeys = []


        for (const countRangeBelow7daysRecord of productCountWiseBelow7daysData) {
          Object.keys(countRangeBelow7daysRecord).forEach(function (key) {
            const dataArray: any[] = [];
            dataArray.push(Math.ceil(countRangeBelow7daysRecord[key] / 1000))
            if (key != 'productId' && key != 'bomId') {
              if (!(countRangeMapBelow7days.has(key))) {
                countRangeMapBelow7days.set(key, dataArray);
              } else {
                countRangeMapBelow7days.get(key).push(Math.ceil(countRangeBelow7daysRecord[key] / 1000))
              }
            }
          })
        }

        for (const countRangeBelow7daysRecord of productCountWiseBelow7daysData) {
          if (!(productMap.has(countRangeBelow7daysRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countRangeBelow7daysRecord.productId))
            productMap.set(countRangeBelow7daysRecord.productId, productData.data.productName);
          }
          countRangeBelow7daysProduct = productMap.get(countRangeBelow7daysRecord.productId);
          const countRangeArray: countRangeWiseInfo[] = [];
          // const dataArray :countRangeWiseInfo[]=[];
          Object.keys(countRangeBelow7daysRecord).forEach(function (key) {
            if (key != 'productId' && key != 'bomId') {

              if (countRangeBelow7daysRecord[key] == 0 && countRangeMapBelow7days.get(key).filter(x => x > 0).length >= 1) {
                countRangeArray.push(new countRangeWiseInfo(key, Math.ceil((countRangeBelow7daysRecord[key] + (countRangeBelow7daysRecord[key] * (3 / 100))) / 1000), `countRangeBelow7daysProduct${key}${countRangeBelow7daysProduct}`, countRangeBelow7daysProduct))
                dataExistingKeys.push(key);
              }
              if (countRangeBelow7daysRecord[key] > 0) {
                countRangeArray.push(new countRangeWiseInfo(key, Math.ceil(countRangeBelow7daysRecord[key] / 1000), `countRangeBelow7daysProduct${key}${countRangeBelow7daysProduct}`, countRangeBelow7daysProduct))
              }
            }
          })
          const seriesDataObj = new seriesInfo(countRangeArray);
          seriesInfoBelow7days.push(seriesDataObj);
        }
        for (const countRange7daysRecord of productCountWise7daysData) {
          Object.keys(countRange7daysRecord).forEach(function (key) {
            const dataArray: any[] = [];
            dataArray.push(Math.ceil(countRange7daysRecord[key] / 1000))
            if (key != 'productId' && key != 'bomId') {
              if (!(countRangeMap7days.has(key))) {
                countRangeMap7days.set(key, dataArray);
              } else {
                countRangeMap7days.get(key).push(Math.ceil(countRange7daysRecord[key] / 1000))
              }
            }
          })
        }

        for (const countRange7daysRecord of productCountWise7daysData) {
          if (!(productMap.has(countRange7daysRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countRange7daysRecord.productId))
            productMap.set(countRange7daysRecord.productId, productData.data.productName);
          }
          countRange7daysProduct = productMap.get(countRange7daysRecord.productId);
          const countRangeArray: countRangeWiseInfo[] = [];
          // const dataArray :countRangeWiseInfo[]=[];
          Object.keys(countRange7daysRecord).forEach(function (key) {
            if (key != 'productId' && key != 'bomId') {

              if (countRange7daysRecord[key] == 0 && countRangeMap7days.get(key).filter(x => x > 0).length >= 1) {
                countRangeArray.push(new countRangeWiseInfo(key, Math.ceil((countRange7daysRecord[key] + (countRange7daysRecord[key] * (3 / 100))) / 1000), `countRange7daysProduct${key}${countRange7daysProduct}`, countRange7daysProduct))
                dataExistingKeys.push(key);
              }
              if (countRange7daysRecord[key] > 0) {
                countRangeArray.push(new countRangeWiseInfo(key, Math.ceil(countRange7daysRecord[key] / 1000), `countRange7daysProduct${key}${countRange7daysProduct}`, countRange7daysProduct))
              }
            }
          })
          const seriesDataObj = new seriesInfo(countRangeArray);
          seriesInfo7days.push(seriesDataObj);
        }
        let countRangeMap14days = new Map<string, any[]>()

        for (const countRange14daysRecord of productCountWise14daysData) {
          Object.keys(countRange14daysRecord).forEach(function (key) {
            const dataArray: any[] = [];
            dataArray.push(Math.ceil(countRange14daysRecord[key] / 1000))
            if (key != 'productId' && key != 'bomId') {
              if (!(countRangeMap14days.has(key))) {
                countRangeMap14days.set(key, dataArray);
              } else {
                countRangeMap14days.get(key).push(Math.ceil(countRange14daysRecord[key] / 1000))
              }
            }
          })
        }
        for (const countRange14daysRecord of productCountWise14daysData) {
          if (!(productMap.has(countRange14daysRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countRange14daysRecord.productId))
            productMap.set(countRange14daysRecord.productId, productData.data.productName);
          }
          countRange14daysProduct = productMap.get(countRange14daysRecord.productId)
          const countRangeArray: countRangeWiseInfo[] = [];
          Object.keys(countRange14daysRecord).forEach(function (key) {
            if (key != 'productId' && key != 'bomId') {
              if (countRange14daysRecord[key] == 0 && countRangeMap14days.get(key).filter(x => x > 0).length >= 1) {
                countRangeArray.push(new countRangeWiseInfo(key, Math.ceil((countRange14daysRecord[key] + (countRange14daysRecord[key] * (3 / 100))) / 1000), `countRange14daysProduct${key}${countRange14daysProduct}`, countRange14daysProduct))
              }
              if (countRange14daysRecord[key] > 0) {
                countRangeArray.push(new countRangeWiseInfo(key, Math.ceil((countRange14daysRecord[key] + (countRange14daysRecord[key] * (3 / 100))) / 1000), `countRange14daysProduct${key}${countRange14daysProduct}`, countRange14daysProduct))
              }
            }
          })
          const seriesDataObj = new seriesInfo(countRangeArray);
          seriesInfo14days.push(seriesDataObj);
        }

        let countRangeMap30days = new Map<string, any[]>()

        for (const countRange30daysRecord of productCountWise30daysData) {
          Object.keys(countRange30daysRecord).forEach(function (key) {
            const dataArray: any[] = [];
            dataArray.push(Math.ceil(countRange30daysRecord[key] / 1000))
            if (key != 'productId' && key != 'bomId') {
              if (!(countRangeMap30days.has(key))) {
                countRangeMap30days.set(key, dataArray);
              } else {
                countRangeMap30days.get(key).push(Math.ceil(countRange30daysRecord[key] / 1000))
              }
            }
          })
        }

        for (const countRange30daysRecord of productCountWise30daysData) {
          if (!(productMap.has(countRange30daysRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countRange30daysRecord.productId))
            productMap.set(countRange30daysRecord.productId, productData.data.productName);
          }
          countRange30daysProduct = productMap.get(countRange30daysRecord.productId)
          const countRangeArray: countRangeWiseInfo[] = [];
          Object.keys(countRange30daysRecord).forEach(function (key) {
            if (key != 'productId' && key != 'bomId') {
              if (countRange30daysRecord[key] == 0 && countRangeMap30days.get(key).filter(x => x > 0).length >= 1) {
                countRangeArray.push(new countRangeWiseInfo(key, Math.ceil((countRange30daysRecord[key] + (countRange30daysRecord[key] * (3 / 100))) / 1000), `countRange30daysProduct${key}${countRange30daysProduct}`, countRange30daysProduct))
              }
              if (countRange30daysRecord[key] > 0) {
                countRangeArray.push(new countRangeWiseInfo(key, Math.ceil((countRange30daysRecord[key] + (countRange30daysRecord[key] * (3 / 100))) / 1000), `countRange30daysProduct${key}${countRange30daysProduct}`, countRange30daysProduct))
              }
            }
          })
          const seriesDataObj = new seriesInfo(countRangeArray);
          seriesInfo30days.push(seriesDataObj);
        }

        let countRangeMapAbove30days = new Map<string, any[]>()

        for (const countRangeAbove30daysRecord of productCountWiseAbove30Data) {
          Object.keys(countRangeAbove30daysRecord).forEach(function (key) {
            const dataArray: any[] = [];
            dataArray.push(Math.ceil(countRangeAbove30daysRecord[key] / 1000))
            if (key != 'productId' && key != 'bomId') {
              if (!(countRangeMapAbove30days.has(key))) {
                countRangeMapAbove30days.set(key, dataArray);
              } else {
                countRangeMapAbove30days.get(key).push(Math.ceil(countRangeAbove30daysRecord[key] / 1000))
              }
            }
          })
        }

        for (const countRangeAbove30Record of productCountWiseAbove30Data) {
          if (!(productMap.has(countRangeAbove30Record.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countRangeAbove30Record.productId))
            productMap.set(countRangeAbove30Record.productId, productData.data.productName);
          }
          countRangeAbove30daysProduct = productMap.get(countRangeAbove30Record.productId)
          const countRangeArray: countRangeWiseInfo[] = [];
          Object.keys(countRangeAbove30Record).forEach(function (key) {
            if (key != 'productId' && key != 'bomId') {
              if (countRangeAbove30Record[key] == 0 && countRangeMapAbove30days.get(key).filter(x => x > 0).length >= 1) {
                countRangeArray.push(new countRangeWiseInfo(key, Math.ceil((countRangeAbove30Record[key] + (countRangeAbove30Record[key] * (3 / 100))) / 1000), `countRangeAbove30daysProduct${key}${countRangeAbove30daysProduct}`, countRangeAbove30daysProduct))
              }
              if (countRangeAbove30Record[key] > 0) {
                countRangeArray.push(new countRangeWiseInfo(key, Math.ceil((countRangeAbove30Record[key] + (countRangeAbove30Record[key] * (3 / 100))) / 1000), `countRangeAbove30daysProduct${key}${countRangeAbove30daysProduct}`, countRangeAbove30daysProduct))
              }
            }
          })
          const seriesDataObj = new seriesInfo(countRangeArray);
          seriesInfo30days.push(seriesDataObj);
        }

        //get drilldown data for count ranges
        let countWiseProductBelow7days
        let countWiseProduct7days
        let countWiseProduct14days
        let countWiseProduct30days
        let countWiseProductAbove30days
        let seriesInfodrilldownBelow7days: DrilldownInfo[] = [];
        let seriesInfodrilldown7days: DrilldownInfo[] = [];
        let seriesInfodrilldown14days: DrilldownInfo[] = [];
        let seriesInfodrilldown30days: DrilldownInfo[] = [];
        let seriesInfodrilldownAbove30days: DrilldownInfo[] = [];
        const countWiseBelow7daysData = await this.rmbomRepo.getCountWiseBomdata(null, below7ToDate);
        const countWise7daysData = await this.rmbomRepo.getCountWiseBomdata(days7FromDate, days7ToDate);
        const countWise14daysData = await this.rmbomRepo.getCountWiseBomdata(days14FromDate, days14ToDate);
        const countWise30daysData = await this.rmbomRepo.getCountWiseBomdata(days21FromDate, days21ToDate);
        const countWiseAbove30daysData = await this.rmbomRepo.getCountWiseBomdata(days37FromDate, null);
        let countRangeQuantityMap7days = new Map<string, Map<string, any[]>>();
        let countRangeQuantityMapBelow7days = new Map<string, Map<string, any[]>>();
        for (const countWiseBelow7daysDataRecord of countWiseBelow7daysData) {
          const countRangeWiseArray: any[] = [];
          if (!(productMap.has(countWiseBelow7daysDataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countWiseBelow7daysDataRecord.productId))
            productMap.set(countWiseBelow7daysDataRecord.productId, productData.data.productName);
          }
          countWiseProductBelow7days = productMap.get(countWiseBelow7daysDataRecord.productId);
          let keyVal = '';
          Object.keys(countWiseBelow7daysDataRecord).forEach(function (key) {
            if (key != 'productId' && key != 'bomId' && key != 'count' && key != 'countRange') {
              if (key == countWiseBelow7daysDataRecord.countRange) {
                countRangeWiseArray.push(String(countWiseBelow7daysDataRecord.count), Math.ceil(countWiseBelow7daysDataRecord[key] / 1000))

                if (!countRangeQuantityMapBelow7days.has(key)) {
                  countRangeQuantityMapBelow7days.set(key, new Map<string, any[]>());
                  if (!(countRangeQuantityMapBelow7days.get(key).has(countWiseProductBelow7days))) {
                    countRangeQuantityMapBelow7days
                      .get(key)
                      .set(countWiseProductBelow7days, [countRangeWiseArray]);
                  }
                } else {
                  if (!(countRangeQuantityMapBelow7days.get(key).has(countWiseProductBelow7days))) {
                    countRangeQuantityMapBelow7days
                      .get(key)
                      .set(countWiseProductBelow7days, [countRangeWiseArray]);
                  } else {
                    countRangeQuantityMapBelow7days
                      .get(key).get(countWiseProductBelow7days).push(countRangeWiseArray)
                  }
                }



                keyVal = key;
              }
            }
          })

        }
        countRangeQuantityMapBelow7days.forEach((valueMap, countRange) => {
          valueMap.forEach((countData, product) => {
            const drilldowndataobj = new DrilldownInfo(countData, `countRangeBelow7daysProduct${countRange}${product}`, countRange, product);
            seriesInfodrilldownBelow7days.push(drilldowndataobj);
          });
        });
        for (const countWise7daysDataRecord of countWise7daysData) {
          const countRangeWiseArray: any[] = [];
          if (!(productMap.has(countWise7daysDataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countWise7daysDataRecord.productId))
            productMap.set(countWise7daysDataRecord.productId, productData.data.productName);
          }
          countWiseProduct7days = productMap.get(countWise7daysDataRecord.productId);
          let keyVal = '';
          Object.keys(countWise7daysDataRecord).forEach(function (key) {
            if (key != 'productId' && key != 'bomId' && key != 'count' && key != 'countRange') {
              if (key == countWise7daysDataRecord.countRange) {
                countRangeWiseArray.push(String(countWise7daysDataRecord.count), Math.ceil(countWise7daysDataRecord[key] / 1000))
                if (!countRangeQuantityMap7days.has(key)) {
                  countRangeQuantityMap7days.set(key, new Map<string, any[]>());
                  if (!(countRangeQuantityMap7days.get(key).has(countWiseProduct7days))) {
                    countRangeQuantityMap7days
                      .get(key)
                      .set(countWiseProduct7days, [countRangeWiseArray]);
                  }
                } else {
                  if (!(countRangeQuantityMap7days.get(key).has(countWiseProduct7days))) {
                    countRangeQuantityMap7days
                      .get(key)
                      .set(countWiseProduct7days, [countRangeWiseArray]);
                  } else {
                    countRangeQuantityMap7days
                      .get(key).get(countWiseProduct7days).push(countRangeWiseArray)
                  }
                }
                keyVal = key;
              }
            }
          })

        }

        countRangeQuantityMap7days.forEach((valueMap, countRange) => {
          valueMap.forEach((countData, product) => {
            const drilldowndataobj = new DrilldownInfo(countData, `countRange7daysProduct${countRange}${product}`, countRange, product);
            seriesInfodrilldown7days.push(drilldowndataobj);
          });
        });
        let countRangeQuantityMap14days = new Map<string, Map<string, any[]>>();

        for (const countWise14daysDataRecord of countWise14daysData) {
          const countRangeWiseArray = [];
          if (!(productMap.has(countWise14daysDataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countWise14daysDataRecord.productId))
            productMap.set(countWise14daysDataRecord.productId, productData.data.productName);
          }
          countWiseProduct14days = productMap.get(countWise14daysDataRecord.productId);
          let keyVal = '';
          Object.keys(countWise14daysDataRecord).forEach(function (key) {
            if (key != 'productId' && key != 'bomId' && key != 'count' && key != 'countRange') {
              if (key == countWise14daysDataRecord.countRange) {
                countRangeWiseArray.push(String(countWise14daysDataRecord.count), Math.ceil(countWise14daysDataRecord[key] / 1000))
                if (!countRangeQuantityMap14days.has(key)) {
                  countRangeQuantityMap14days.set(key, new Map<string, any[]>());
                  if (!(countRangeQuantityMap14days.get(key).has(countWiseProduct14days))) {
                    countRangeQuantityMap14days
                      .get(key)
                      .set(countWiseProduct14days, [countRangeWiseArray]);
                  }
                } else {
                  if (!(countRangeQuantityMap14days.get(key).has(countWiseProduct14days))) {
                    countRangeQuantityMap14days
                      .get(key)
                      .set(countWiseProduct14days, [countRangeWiseArray]);
                  } else {
                    countRangeQuantityMap14days
                      .get(key).get(countWiseProduct14days).push(countRangeWiseArray)
                  }
                }
                keyVal = key;
              }
            }
          })

        }

        countRangeQuantityMap14days.forEach((valueMap, countRange) => {
          valueMap.forEach((countData, product) => {
            const drilldowndataobj = new DrilldownInfo(countData, `countRange14daysProduct${countRange}${product}`, countRange, product);
            seriesInfodrilldown14days.push(drilldowndataobj);
          });
        });

        let countRangeQuantityMap30days = new Map<string, Map<string, any[]>>();
        for (const countWise30daysDataRecord of countWise30daysData) {
          const countRangeWiseArray = [];
          if (!(productMap.has(countWise30daysDataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countWise30daysDataRecord.productId))
            productMap.set(countWise30daysDataRecord.productId, productData.data.productName);
          }
          countWiseProduct30days = productMap.get(countWise30daysDataRecord.productId);
          let keyVal = '';
          Object.keys(countWise30daysDataRecord).forEach(function (key) {
            if (key != 'productId' && key != 'bomId' && key != 'count' && key != 'countRange') {
              if (key == countWise30daysDataRecord.countRange) {
                countRangeWiseArray.push(String(countWise30daysDataRecord.count), Math.ceil(countWise30daysDataRecord[key] / 1000))

                if (!countRangeQuantityMap30days.has(key)) {
                  countRangeQuantityMap30days.set(key, new Map<string, any[]>());
                  if (!(countRangeQuantityMap30days.get(key).has(countWiseProduct30days))) {
                    countRangeQuantityMap30days
                      .get(key)
                      .set(countWiseProduct30days, [countRangeWiseArray]);
                  }
                } else {
                  if (!(countRangeQuantityMap30days.get(key).has(countWiseProduct30days))) {
                    countRangeQuantityMap30days
                      .get(key)
                      .set(countWiseProduct30days, [countRangeWiseArray]);
                  } else {
                    countRangeQuantityMap30days
                      .get(key).get(countWiseProduct30days).push(countRangeWiseArray)
                  }
                }
                keyVal = key;
              }
            }
          })

        }

        countRangeQuantityMap30days.forEach((valueMap, countRange) => {
          valueMap.forEach((countData, product) => {
            const drilldowndataobj = new DrilldownInfo(countData, `countRange30daysProduct${countRange}${product}`, countRange, product);
            seriesInfodrilldown30days.push(drilldowndataobj);
          });
        });

        let countRangeQuantityMapAbove30days = new Map<string, Map<string, any[]>>();
        for (const countWiseAbove30daysDataRecord of countWiseAbove30daysData) {
          const countRangeWiseArray = [];
          if (!(productMap.has(countWiseAbove30daysDataRecord.productId))) {
            const productData = await this.productRepository.getActiveProductById(new ProductRequest(countWiseAbove30daysDataRecord.productId))
            productMap.set(countWiseAbove30daysDataRecord.productId, productData.data.productName);
          }
          countWiseProductAbove30days = productMap.get(countWiseAbove30daysDataRecord.productId);
          let keyVal = '';
          Object.keys(countWiseAbove30daysDataRecord).forEach(function (key) {
            if (key != 'productId' && key != 'bomId' && key != 'count' && key != 'countRange') {
              if (key == countWiseAbove30daysDataRecord.countRange) {
                countRangeWiseArray.push(String(countWiseAbove30daysDataRecord.count), Math.ceil(countWiseAbove30daysDataRecord[key] / 1000))
                if (!countRangeQuantityMapAbove30days.has(key)) {
                  countRangeQuantityMapAbove30days.set(key, new Map<string, any[]>());
                  if (!(countRangeQuantityMapAbove30days.get(key).has(countWiseProductAbove30days))) {
                    countRangeQuantityMapAbove30days
                      .get(key)
                      .set(countWiseProductAbove30days, [countRangeWiseArray]);
                  }
                } else {
                  if (!(countRangeQuantityMapAbove30days.get(key).has(countWiseProductAbove30days))) {
                    countRangeQuantityMapAbove30days
                      .get(key)
                      .set(countWiseProductAbove30days, [countRangeWiseArray]);
                  } else {
                    countRangeQuantityMapAbove30days
                      .get(key).get(countWiseProductAbove30days).push(countRangeWiseArray)
                  }
                }
                keyVal = key;
              }
            }
          })

        }

        countRangeQuantityMapAbove30days.forEach((valueMap, countRange) => {
          valueMap.forEach((countData, product) => {
            const drilldowndataobj = new DrilldownInfo(countData, `countRangeAbove30daysProduct${countRange}${product}`, countRange, product);
            seriesInfodrilldownAbove30days.push(drilldowndataobj);
          });
        });

        let belowSevenDaysdata: RmBomDto[] = [];
        let sevenDaysdata: RmBomDto[] = [];
        let fifteenDaysdata: RmBomDto[] = [];
        let thirtyDaysdata: RmBomDto[] = [];
        let aboveThirtyDaysdata: RmBomDto[] = [];

        const belowSevenDaysdataobj = new RmBomDto(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'Kg', new Date(2021 - 5 - 26), bomIndentInfoBelow7days, poInfoBelow7days, ratingInfoBelow7days, countryInfoBelow7days, seriesInfoBelow7days, seriesInfodrilldownBelow7days, dataExistingKeys);
        belowSevenDaysdata.push(belowSevenDaysdataobj);

        const sevenDaysdataobj = new RmBomDto(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'Kg', new Date(2021 - 5 - 26), bomIndentInfo7days, poInfo7days, ratingInfo7days, countryInfo7days, seriesInfo7days, seriesInfodrilldown7days, dataExistingKeys);
        sevenDaysdata.push(sevenDaysdataobj);

        const fifteenDaysdataobj = new RmBomDto(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'Kg', new Date(2021 - 5 - 26), bomIndentInfo14days, poInfo14days, ratingInfo14days, countryInfo14days, seriesInfo14days, seriesInfodrilldown14days);
        fifteenDaysdata.push(fifteenDaysdataobj);

        const thirtyDaysdataobj = new RmBomDto(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'Kg', new Date(2021 - 5 - 26), bomIndentInfo30days, poInfo30days, ratingInfo30days, countryInfo30days, seriesInfo30days, seriesInfodrilldown30days);
        thirtyDaysdata.push(thirtyDaysdataobj);

        const aboveThirtyDaysdataobj = new RmBomDto(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'Kg', new Date(2021 - 5 - 26), bomIndentInfoAbove30days, poInfoAbove30days, ratingInfoAbove30days, countryInfoAbove30days, seriesInfoAbove30days, seriesInfodrilldownAbove30days);
        aboveThirtyDaysdata.push(aboveThirtyDaysdataobj);
        const data: RmBomData = {
          belowSevenDays: belowSevenDaysdataobj,
          zeroToSevenDays: sevenDaysdataobj,
          sevenToFourteenDays: fifteenDaysdataobj,
          fifteenToThirtyDays: thirtyDaysdataobj,
          aboveThirtyDays: aboveThirtyDaysdataobj,
          totalToBeProcuredQty: totalToBeProcuresQty,
          totalIndentCount: totalIndents,
          totalIndentQty: totalIndentQty,
          totalFarmers: totalFarmers,
          totalPendingGrnCount: pendingGrnQty
        }

        if (data.zeroToSevenDays || data.sevenToFourteenDays || data.fifteenToThirtyDays || data.aboveThirtyDays || data.belowSevenDays) {
          const response = new RmBomResponse(true, 1225, 'Bom data retreived successfully', data);
          
          // const newLogDto = new LogsDto(1,'view', 'SaleOrder', 0, true, 'Bom data retreived successfully','')
          // let res = await this.logService.createLog(newLogDto);
          // console.log(res);
          return response;
        } else {
          return new RmBomResponse(false, 1111, 'No Records Found')
        }
      } else {
        return new RmBomResponse(false, 1111, 'No Items Found For Raw material')

      }

    } catch (error) {
      await manager.releaseTransaction();
      return error
    }
  }



  async updateRmBomQuantity(): Promise<GlobalResponseObject> {
    const manager = new GenericTransactionManager();
    try {

      const fgStockData = await this.fgService.getLotWiseReportedQuantity()
      const productionInvwipData = await this.productionInvService.getInventoryWipQuantity();
      console.log('productionInvwipData');
      console.log(productionInvwipData);
      if (productionInvwipData) {
        for (const productionInItem of productionInvwipData.data) {

          const soItemId = productionInItem.saleOrderItemId;
          // const reportedNetWeight = fgStockDataItem.netWeight;
          const soItemBomdata = await this.rmbomRepo.findOne({ select: ['saleOrderId', 'saleOrderItemId', 'ratio', 'quantity', 'cases', 'caseWeight', 'productId', 'count'], where: { saleOrderItemId: soItemId } });
          if (soItemBomdata) {

            const inputNetWeight = soItemBomdata.cases * soItemBomdata.caseWeight;

            const remainingNetWeight = productionInItem.wipQuantity;
            const reqQty = remainingNetWeight * soItemBomdata.ratio;
            await manager.startTransaction();

            const rmbomLogUpdateQty = await manager.getCustomRepository(RmBomLogRepository).update({ saleOrderItemId: soItemId }, { quantity: reqQty });

            if (rmbomLogUpdateQty.affected) {

              const bomLogItems = await this.rmbomRepo.getBomLogItemCombData(soItemBomdata.saleOrderId);
              if (bomLogItems) {
                let itemMap = new Map<number, Map<number, number>>();
                let itemId;
                let productId;
                let count;

                for (const bomLogItemsRecord of bomLogItems) {
                  if (!(itemMap.has(bomLogItemsRecord.itemId))) {

                    const itemData = await this.itemService.getRmItemForBom(
                      new RmBomItemRequest(
                        bomLogItemsRecord.productId, bomLogItemsRecord.count
                      )
                    )
                    if (itemData) {
                      itemMap.set(bomLogItemsRecord.productId, new Map<number, number>())
                      itemMap.get(bomLogItemsRecord.productId).set(bomLogItemsRecord.count, itemData.data.itemId)
                    } else {

                      return new GlobalResponseObject(false, 9999, 'No Item  found for the product and count');
                    }
                  } else {
                    itemMap.get(bomLogItemsRecord.productId)
                  }
                  itemMap.get(bomLogItemsRecord.productId).forEach((value, key) => {
                    count = key;
                    itemId = value;
                  })

                  const rmbomLogUpdateQty = await manager.getCustomRepository(BomRepository).update({ saleOrderId: soItemBomdata.saleOrderId, itemId: itemId }, { quantity: bomLogItems.quantity });
                  if (rmbomLogUpdateQty.affected) {
                    manager.completeTransaction();
                    return new GlobalResponseObject(true, 1111, 'BOM updated Successfully');
                  } else {
                    manager.releaseTransaction();
                    return new GlobalResponseObject(false, 9999, 'something went wrong');
                  }
                }
              } else {
                return new GlobalResponseObject(false, 9999, 'No Bom Items found for the saleorder');
              }
            } else {
              manager.releaseTransaction();
              return new GlobalResponseObject(false, 9999, 'Somethong went wrong in bom updation');
            }
          } else {
            return new GlobalResponseObject(false, 9999, 'No RM bom data found for the saleorder item');
          }

        }
      }
      if (fgStockData) {
        for (const fgStockDataItem of fgStockData) {

          const soItemId = fgStockDataItem.saleOrderItemId;
          const reportedNetWeight = fgStockDataItem.netWeight;
          const soItemBomdata = await this.rmbomRepo.findOne({ select: ['saleOrderId', 'saleOrderItemId', 'ratio', 'quantity', 'cases', 'caseWeight', 'productId', 'count'], where: { saleOrderItemId: soItemId } });
          if (soItemBomdata) {

            const inputNetWeight = soItemBomdata.cases * soItemBomdata.caseWeight;

            const remainingNetWeight = inputNetWeight - reportedNetWeight;
            const reqQty = remainingNetWeight * soItemBomdata.ratio;
            await manager.startTransaction();

            const rmbomLogUpdateQty = await manager.getCustomRepository(RmBomLogRepository).update({ saleOrderItemId: soItemId }, { quantity: reqQty });

            if (rmbomLogUpdateQty.affected) {

              const bomLogItems = await this.rmbomRepo.getBomLogItemCombData(soItemBomdata.saleOrderId);
              if (bomLogItems) {
                let itemMap = new Map<number, Map<number, number>>();
                let itemId;
                let productId;
                let count;

                for (const bomLogItemsRecord of bomLogItems) {
                  if (!(itemMap.has(bomLogItemsRecord.itemId))) {

                    const itemData = await this.itemService.getRmItemForBom(
                      new RmBomItemRequest(
                        bomLogItemsRecord.productId, bomLogItemsRecord.count
                      )
                    )
                    if (itemData) {
                      itemMap.set(bomLogItemsRecord.productId, new Map<number, number>())
                      itemMap.get(bomLogItemsRecord.productId).set(bomLogItemsRecord.count, itemData.data.itemId)
                    } else {

                      return new GlobalResponseObject(false, 9999, 'No Item  found for the product and count');
                    }
                  } else {
                    itemMap.get(bomLogItemsRecord.productId)
                  }
                  itemMap.get(bomLogItemsRecord.productId).forEach((value, key) => {
                    count = key;
                    itemId = value;
                  })

                  const rmbomLogUpdateQty = await manager.getCustomRepository(BomRepository).update({ saleOrderId: soItemBomdata.saleOrderId, itemId: itemId }, { quantity: bomLogItems.quantity });
                  if (rmbomLogUpdateQty.affected) {
                    manager.completeTransaction();
                    return new GlobalResponseObject(true, 1111, 'BOM updated Successfully');
                  } else {
                    manager.releaseTransaction();
                    return new GlobalResponseObject(false, 9999, 'something went wrong');
                  }
                }
              } else {
                manager.releaseTransaction();
                return new GlobalResponseObject(false, 9999, 'No Bom Items found for the saleorder');
              }
            } else {
              manager.releaseTransaction();
              return new GlobalResponseObject(false, 9999, 'Somethong went wrong in bom updation');
            }
          } else {
            return new GlobalResponseObject(false, 9999, 'No RM bom data found for the saleorder item');
          }

        }

      }


      // else{
      //   return new GlobalResponseObject(false,9999,'No Update Found');
      // }
    } catch (err) {
      await manager.releaseTransaction();
      return err;
    }
  }
  async getAllsaleordersBomdata(): Promise<SORmBomResponse> {
    try {
      const manager = getManager();
      const query = `SELECT soRM.sale_order_id as saleOrderId, DATE_FORMAT(inv.eda_date, "%Y-%m-%d") as etdDate,s.sale_order_no as saleOrderNumber,inv.po_number as poNumber,soRM.sale_order_item_id as saleOrderItemId, p.name as productName, soRM.min_grade as minGrade, soRM.max_grade as maxGrade, soRM.uom_id as uomId, soRM.hl_per as hlPercentage, soRM.final_per as finalPercentage, soRM.min_count as minCount, soRM.max_count as maxCount, soRM.count, soRM.case_weight as caseWeight, soRM.min_weight as oupPutMinWeight, soRM.max_weight as oupPutMaxWeight, soRM.cases, soRM.ratio, soRM.quantity, ec.end_customer_name as endCustomerName, u.unit_code_id as unitId, u.unit_name as unitName, soRM.bom_log_id as bomLogId
         FROM `+ appSettings.sales_db + `.rm_bom_log soRM 
        LEFT JOIN `+ appSettings.sales_db + `.sale_order s ON s.sale_order_id=soRM.sale_order_id
        LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=s.sale_order_id
        LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=soRM.product_id
        LEFT JOIN `+ appSettings.masters_db + `.end_customers ec ON ec.end_customer_id=inv.end_customer_id
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.unit_code_id=inv.factoryId group by soRM.bom_log_id order by soRM.sale_order_id desc`;
      const queryResult = await manager.query(query);
      if (queryResult.length > 0) {
        const response = new SORmBomResponse(true, 11111, 'data Retrived successfully', queryResult)
        return response;

      } else {
        return new SORmBomResponse(false, 9999, 'data Retrived successfully', null)

      }

    } catch (error) {
      return error;
    }
  }
  async getAllsaleordersBomdataOld(): Promise<SORmBomResponse> {
    try {
      const SORmbomData = await this.rmbomRepo.find({ order: { saleOrderId: 'DESC' } });
      let rmbomDetils: RmBomDetails[] = [];
      let soNumber;
      let etdDate;
      let productName;
      let endCustomerName;
      let endcustomerMap = new Map<number, string>();
      let productMap = new Map<number, string>();
      let soNumberMap = new Map<number, Map<string, Map<string, Date>>>();
      let span: boolean;
      for (const SORmbomDataRecord of SORmbomData) {
        if (!productMap.has(SORmbomDataRecord.productId)) {
          const productData = await this.productRepository.getActiveProductById(new ProductRequest(SORmbomDataRecord.productId))
          productMap.set(SORmbomDataRecord.productId, productData.data.productName);
        }
        productName = productMap.get(SORmbomDataRecord.productId);
        if (!soNumberMap.has(SORmbomDataRecord.saleOrderId)) {
          const soInfo = await this.soRepo.findOne({ where: { saleOrderId: SORmbomDataRecord.saleOrderId }, relations: ['SoInvDetailsInfo'] });
          const endCustomerData = await this.endCustomerRepository.getEndCustomerDataById(
            { endCustomerId: soInfo.SoInvDetailsInfo.endCustomerId }
          );
          soNumberMap.set(SORmbomDataRecord.saleOrderId, new Map<string, Map<string, Date>>())
          soNumberMap.get(SORmbomDataRecord.saleOrderId).set(soInfo.saleOrderNumber, new Map<string, Date>());
          soNumberMap.get(SORmbomDataRecord.saleOrderId).get(soInfo.saleOrderNumber).set(endCustomerData.data.endCustomerName, soInfo.SoInvDetailsInfo.edaDate);
          span = true;
        } else {
          soNumberMap.get(SORmbomDataRecord.saleOrderId);
          span = false;
        }
        soNumberMap.get(SORmbomDataRecord.saleOrderId).forEach((key, value) => {
          key.forEach((date, endCustomer) => {

            etdDate = date;
            endCustomerName = endCustomer;

          })
          soNumber = value;
        });

        const obj = new RmBomDetails(SORmbomDataRecord.saleOrderId, etdDate, soNumber, SORmbomDataRecord.saleOrderItemId, productName, SORmbomDataRecord.minGrade, SORmbomDataRecord.maxGrade, SORmbomDataRecord.uomId, SORmbomDataRecord.hlPercentage, SORmbomDataRecord.finalPercentage, SORmbomDataRecord.minCount, SORmbomDataRecord.maxCount, SORmbomDataRecord.count, SORmbomDataRecord.caseWeight, SORmbomDataRecord.oupPutMinWeight, SORmbomDataRecord.oupPutMaxWeight, SORmbomDataRecord.cases, SORmbomDataRecord.ratio, SORmbomDataRecord.quantity, endCustomerName, span);
        rmbomDetils.push(obj);

      }
      if (rmbomDetils.length > 0) {
        const response = new SORmBomResponse(true, 11111, 'data Retrived successfully', rmbomDetils)
        return response;

      } else {
        return new SORmBomResponse(false, 9999, 'data Retrived successfully', null)

      }
    } catch (error) {
      console.log(error)
    }
  }


  async getPackingStyleDetails(saleOrderItemRequest: SaleOrderItemRequest): Promise<CommonResponse> {
    const packstyle: SaleOrderItems = await this.soItemRepo.findOne({ saleOrderItemId: saleOrderItemRequest.saleOrderItemId });
    if (!packstyle) {
      throw new ErrorResponse(10000, 'PackStyle Details not found');
    }
    return new CommonResponse(true, 10000, 'PackStyle Details found', packstyle);
  }

  async getSaleOrderItemDetails(saleOrderItemRequest: SaleOrderItemRequest): Promise<AllSaleOrdersItemsDetailsResponseModel> {
    try {
      const manager = getManager();
      const response = await this.soItemRepo.findOne({ saleOrderId: saleOrderItemRequest.saleOrderId, saleOrderItemId: saleOrderItemRequest.saleOrderItemId });
      let uom = '';
      if (response.uomId === undefined) {
        uom = "";
      }
      else if (response.uomId === 1) {
        uom = 'KG';
      }
      else if (response.uomId === 2) {
        uom = 'LB';
      }
      else if (response.uomId === 3) {
        uom = 'OZ';
      }
      else if (response.uomId === 4) {
        uom = 'Gms';
      }
      const soResponse = 'Select GROUP_CONCAT(DISTINCT(pack_style_id)) AS packStyleIds from ' + appSettings.sales_db + '.sale_order_items where sale_order_id =' + saleOrderItemRequest.saleOrderId;
      const queryResult = await manager.query(soResponse);
      let maxPalletCapacity;
      if (saleOrderItemRequest.stockType === "dummy" || saleOrderItemRequest.stockType === "superDummy") {
        const getHighestPalletCapacity = "select MAX(max_pallet_capacity) AS maxPalletCapacity from " + appSettings.masters_db + ".packing_methods where packing_method_id IN (" + queryResult[0].packStyleIds + ")";
        let queryResponse = await manager.query(getHighestPalletCapacity);
        maxPalletCapacity = queryResponse[0].maxPalletCapacity != undefined ? queryResponse[0].maxPalletCapacity : 0;
      }
      else {
        const palletResponse = await this.packingMethodService.getPalletCapacityById({ pouchesPerRow: 0, noOfPouches: 0, uomId: 0, packingMethodId: response.packStyleId });
        maxPalletCapacity = palletResponse.status ? palletResponse.data.palletCapacity : 0;
      }

      const minGrade = await this.gradesRepository.getGradeById({
        gradeId: response.minGrade,
      });
      const maxGrade = await this.gradesRepository.getGradeById({
        gradeId: response.maxGrade,
      });
      const brandId = await this.endCustomerRepository.getBrandsById({
        brandId: response.brandId,
      });
      const productId = await this.productRepository.getActiveProductById({
        productId: response.itemId,
      });
      const variantId = await this.skuCodesRepository.getSkuDataById({
        skuCodeId: response.varientId,
      });

      const packStyleDetails = await this.packingMethodService.getPalletCapacityById({
        noOfPouches: 0, pouchesPerRow: 0, uomId: 0, packingMethodId: response.packStyleId
      });

      if (!response) {
        throw new ErrorResponse(10000, 'Sale Order Item Details not found');
      }
      else {
        const packstyle = response.pouches + '*' + response.pouchWeight;
        const manager = getManager();
        const query = `SELECT sum(total_cartons) AS reportedCases FROM ` + appSettings.warehouse_db + `.stock s 
          where s.sale_order_item_id=`+ response.saleOrderItemId + ` and s.status= "StockIn"`;
        console.log(query);
        const reportedCases = await manager.query(query);
        console.log(reportedCases);
        const data = new SaleOrderItemsDTO(response.saleOrderItemId, response.minGrade, response.maxGrade, response.brandId, brandId.data.brandName, response.varientId, variantId.data.variantCode, packstyle, response.cases, response.caseWeight, response.unitPrice, response.netWeight, response.netAmount, uom, response.styleWeighment, response.minGlaze, response.MaxGlaze, response.soakingTime, response.soakingStyle, response.shrimpWeight, response.innerBags, "", response.itemId, productId.data.productCode, response.pouches, response.pouchWeight, response.dispatchedQty, response.invoiceAmount, response.reportedCases, response.categoryId, response.finalPercentage, response.uomId, 0, 0, null, 0, "", 0, 0, 0, 0, 0, 0, 0, response.masterBrandId, 0, "", response.jobCases, response.packStyleId, maxPalletCapacity, 0, 0, "", 0, packStyleDetails.status ? packStyleDetails.data.palletCapacity : 0);
        return new AllSaleOrdersItemsDetailsResponseModel(true, 10000, 'Sale Order Item Details found', data);
      }
    } catch (err) {
      console.log(err);
      return err;

    }
  }


  async getVarientInfoForSoItem(req: SoItemRequest): Promise<SoItemVariantResponse> {
    try {
      const soItemInfo: SaleOrderItemInfo = await this.soItemRepo.getVariantInfoForSoItem(req.saleOrderItemId);
      if (soItemInfo) {
        const skuInfo = await this.skuCodesRepository.getSkuDataById({
          skuCodeId: soItemInfo.variantId,
        })

        const endCustomerData = await this.endCustomerRepository.getEndCustomerDataById(
          { endCustomerId: soItemInfo.endCustomerId }
        );
        if (endCustomerData.status) {
          soItemInfo.endCustomer = endCustomerData.data.endCustomerName
        } else {
          soItemInfo.endCustomer = ''
        }
        soItemInfo.variantCode = skuInfo.data.variantCode

        const productData = await this.productRepository.getActiveProductById(new ProductRequest(soItemInfo.productId))
        soItemInfo.product = productData.data.productName
        console.log(soItemInfo);
        return new SoItemVariantResponse(true, 1111, 'Varient Info Found So Item', soItemInfo);
      } else {
        return new SoItemVariantResponse(false, 9999, 'No data found for SO', null);

      }

    } catch (error) {
      return error;
    }
  }

  async getHlPercentage(req: SoItemRequest): Promise<HlPercentageInfo> {

    try {
      const getSoItemHlPercentage: SaleOrderItems = await this.soItemRepo.findOne({
        select: ['maxGrade', 'minGrade'],
        where: {
          saleOrderItemId: Raw((alias) => `sale_order_item_id = '${req.saleOrderItemId}'`),
        },
      });

      if (getSoItemHlPercentage) {
        const hlInfo = new HlPercentageInfo();
        hlInfo.maxGrade = getSoItemHlPercentage.maxGrade;
        hlInfo.minGrade = getSoItemHlPercentage.minGrade;
        const hlPercentagedata = await this.hlPerService.getHlPercentageByRange(
          new HlPercentageRangeRequest(
            getSoItemHlPercentage.maxGrade,
          )
        );
        let hlPercentage = 0;
        if (hlPercentagedata.status && hlPercentagedata.data.hlPercentage > 0) {

          hlInfo.hlPercentage = hlPercentagedata.data.hlPercentage;
        } else {
          throw new ErrorResponse(99998, 'No HL percentages found for selected Grade Range.');
        }
        return hlInfo
      } else {
        throw new ErrorResponse(99998, 'No HL percentages found for selected Grade Range.');
      }
    } catch (error) {
      return error;
    }
  }

  async getEndCustomerDetails(saleOrderIdRequest: SaleOrderIdRequest): Promise<CommonResponse> {
    const endCustomers = await this.soRepo.createQueryBuilder("SaleOrder")
      .select("SoInvDetailsInfo.end_customer_id as endCustomerId")
      .leftJoinAndSelect('SaleOrder.SoInvDetailsInfo', 'SoInvDetailsInfo')
      .where("SaleOrder.saleOrderId =" + saleOrderIdRequest.saleOrderId).getRawOne();
    console.log(endCustomers);
    if (!endCustomers) {
      throw new ErrorResponse(10000, 'End Customer Details not found');
    }
    return new CommonResponse(true, 10000, 'End Customer Details found', endCustomers.endCustomerId);
  }

  async getPoNumbers(): Promise<PoNumberDropDownResponse> {
    try {
      // const saleOrderDropDownDto: SaleOrderDropDownDto[] = [];
      //retrieves all companies
      // const soInvData: PONumbersDropDownDto[] = await this.soInvRepo.find({
      //   select: ['poNumber'],
      //   relations:['saleOrderInfo'],
      //   where:{saleOrderInfo:{status:In([SoStatusEnum.OPEN,SoStatusEnum.IN_PROGRESS])}}
      // });
      const soInvData = await this.soInvRepo.getPoNumbers()
      let poNumbersArray: PONumbersDropDownDto[] = []
      if (soInvData.length > 0) {
        soInvData.forEach(record => {
          const poNumberDto = new PONumbersDropDownDto(record.poNumber, record.saleOrderId);
          poNumbersArray.push(poNumberDto);
        });
        const response = new PoNumberDropDownResponse(true, 11208, "Products retrieved successfully", poNumbersArray);
        return response;
      } else {
        throw new ErrorResponse(99998, 'No Records Found');
      }
      // console.log(soInvData);
      if (soInvData) {
        // soInvDataDropDownDto.push(soInvData);
        const response = new PoNumberDropDownResponse(
          true,
          1,
          'Sale orders retrieved successfully',
          soInvData
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
async  getSaleOrdersCountAndQuantity(inputReq: CountRequest): Promise<BomWithCountAndQuantityResponse> {
  try{
    const manager = getManager();
    const query ='select rbm.quantity,rbm.count,rbm.hl_per,sk.variant_code as variantCode,so.sale_order_id,so.sale_order_no,saleOrderItemsInfo.sale_order_item_id ,SoInvDetailsInfo.po_number as poNumber,CEILING(rbm.count*(rbm.count/100)) as hlCount from '+appSettings.sales_db+'.sale_order so left join '+appSettings.sales_db+'.sale_order_items saleOrderItemsInfo on saleOrderItemsInfo.sale_order_id = so.sale_order_id left join '+appSettings.sales_db+'.so_invoice_details SoInvDetailsInfo on SoInvDetailsInfo.sale_order_id = so.sale_order_id left join '+appSettings.sales_db+'.rm_bom_log rbm on rbm.sale_order_id = so.sale_order_id and rbm.sale_order_item_id=saleOrderItemsInfo.sale_order_item_id left join '+appSettings.masters_db+'.sku_codes sk on  saleOrderItemsInfo.varient_id = sk.sku_code_id where so.status IN ("OPEN","INPROGRESS","PARTIAL_PO") and SoInvDetailsInfo.factoryId ='+inputReq.plantId+' order by so.sale_order_id asc'
   const data=await manager.query(query)
   if(data){
    return new BomWithCountAndQuantityResponse(true, 10000, 'SO details retreived successfully', data);
}else{
  return new BomWithCountAndQuantityResponse(false, 10000, 'SO details retreived successfully', data);

}
  }catch(err){
    return err;
  }
}

  // async getSaleOrdersCountAndQuantity(inputReq: CountRequest): Promise<BomWithCountAndQuantityResponse> {
 
  //   const saleorders = await this.soRepo.createQueryBuilder('so').select('so.sale_order_id,so.sale_order_no,saleOrderItemsInfo.sale_order_item_id ,SoInvDetailsInfo.po_number as poNumber')
  //     .leftJoin("sale_order_items", "saleOrderItemsInfo", "saleOrderItemsInfo.sale_order_id = so.sale_order_id")
  //     .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = so.sale_order_id")
  //     .where('so.status IN ("OPEN","INPROGRESS","PARTIAL_PO")')
  //     .andWhere('SoInvDetailsInfo.unit =' + inputReq.plantId)
  //     .orderBy('so.sale_order_id', 'ASC')
  //     .getRawMany();
  //   const rmbomDetils: BomWithCountAndQuantityModel[] = [];
  //   for (const record of saleorders) {
  //     const rmBomLog = await this.rmbomRepo.createQueryBuilder('rmbomlog')
  //       .select('quantity,count,hl_per')
  //       .where('rmbomlog.sale_order_id=' + record.sale_order_id + ' and rmbomlog.sale_order_item_id=' + record.sale_order_item_id)
  //       .getRawOne();
  //     if (rmBomLog) {
  //       const soItemInfo: SaleOrderItemInfo = await this.soItemRepo.getVariantInfoForSoItem(record.sale_order_item_id);
  //       const variantDetails = await this.skuCodesRepository.getSkuDataById({ skuCodeId: soItemInfo.variantId })
  //       rmbomDetils.push(new BomWithCountAndQuantityModel(record.sale_order_no, variantDetails.data.variantCode, rmBomLog.count, rmBomLog.quantity, Math.ceil(Number(rmBomLog.count) * (Number(rmBomLog.count) / 100)),record.poNumber));
  //     }
  //   }
  //   // if(data){
  //     return new BomWithCountAndQuantityResponse(true, 10000, 'SO details retreived successfully', rmbomDetils);
  // // }
  // }

  async getSaleOrdersForRMCount(inputReq: CountRequest): Promise<SoDropCntQtyResponse> {
    const saleorders = await this.soRepo.createQueryBuilder('so').select('so.sale_order_id,so.sale_order_no,saleOrderItemsInfo.sale_order_item_id,saleOrderItemsInfo.item_id,SoInvDetailsInfo.po_number')
      .leftJoin("sale_order_items", "saleOrderItemsInfo", "saleOrderItemsInfo.sale_order_id = so.sale_order_id")
      .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = so.sale_order_id")
      .where('so.status IN ("OPEN","INPROGRESS","PARTIAL_PO")')
      .andWhere('SoInvDetailsInfo.processing_unit =' + inputReq.plantId)
      .orderBy('so.sale_order_id', 'ASC')
      .getRawMany();
    if (saleorders.length === 0) {
      throw new ErrorResponse(10000, 'No sale orders found');
    }
    const saleOrdersArr: SaleOrderDropDownDto[] = [];
    const rmbomDetils: BomWithCountAndQuantityModel[] = [];
    let soIdarray: number[] = [];
    for (const soRecord of saleorders) {
      const rmBomLog = await this.rmbomRepo.createQueryBuilder('rmbomlog')
        .select('count,quantity,hl_per,min_grade,max_grade,min_count,max_count')
        .where('rmbomlog.sale_order_id=' + soRecord.sale_order_id + ' and rmbomlog.sale_order_item_id=' + soRecord.sale_order_item_id)
        .getRawOne();
      if (rmBomLog) {
        const soItemInfo: SaleOrderItemInfo = await this.soItemRepo.getVariantInfoForSoItem(soRecord.sale_order_item_id);
        const variantDetails = await this.skuCodesRepository.getSkuDataById({ skuCodeId: soItemInfo.variantId });
        const rmHeadOnMinCount = rmBomLog.min_count
        const rmHeadOnMaxCount = rmBomLog.max_count
        const avgCount = (rmHeadOnMinCount + rmHeadOnMaxCount) / 2
        // const headLessMingrade = Math.ceil(Number(rmBomLog.min_grade) * (Number(rmBomLog.hl_per) / 100));
        // const headLessMaxgrade = Math.ceil(Number(rmBomLog.max_grade) * (Number(rmBomLog.hl_per) / 100));
        // const avgCount = Math.ceil((headLessMingrade + headLessMaxgrade) / 2);
        if (inputReq.count >= Number(avgCount) && inputReq.count <= Number(rmHeadOnMaxCount)) {
          if (!(soIdarray.includes(soRecord.sale_order_id))) {
            saleOrdersArr.push(new SaleOrderDropDownDto(soRecord.sale_order_id, soRecord.sale_order_no, soRecord.po_number));
          }
          soIdarray.push(soRecord.sale_order_id);
          rmbomDetils.push(new BomWithCountAndQuantityModel(soRecord.sale_order_no, variantDetails.data.variantCode, rmBomLog.count, rmBomLog.quantity, Math.ceil(Number(rmBomLog.count) * (Number(rmBomLog.hl_per) / 100))));
        }
      }
    }
    return new SoDropCntQtyResponse(true, 1, 'Sale orders retrieved successfully', new SoDropCntQtyModel(saleOrdersArr, rmbomDetils));
  }
  async getSaleOrdersForCount(inputReq: CountRequest): Promise<SoDropCntQtyResponse> {
    const saleorders = await this.soRepo.createQueryBuilder('so').select('so.sale_order_id,so.sale_order_no,saleOrderItemsInfo.sale_order_item_id,saleOrderItemsInfo.item_id,SoInvDetailsInfo.po_number')
      .leftJoin("sale_order_items", "saleOrderItemsInfo", "saleOrderItemsInfo.sale_order_id = so.sale_order_id")
      .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = so.sale_order_id")
      .where('so.status IN ("OPEN","INPROGRESS","PARTIAL_PO")')
      .andWhere('SoInvDetailsInfo.unit =' + inputReq.plantId)
      .orderBy('so.sale_order_id', 'ASC')
      .getRawMany();
    if (saleorders.length === 0) {
      throw new ErrorResponse(10000, 'No sale orders found');
    }
    const saleOrdersArr: SaleOrderDropDownDto[] = [];
    const rmbomDetils: BomWithCountAndQuantityModel[] = [];
    let soIdarray: number[] = [];
    for (const soRecord of saleorders) {
      const rmBomLog = await this.rmbomRepo.createQueryBuilder('rmbomlog')
        .select('count,quantity,hl_per,min_grade,max_grade,min_count,max_count')
        .where('rmbomlog.sale_order_id=' + soRecord.sale_order_id + ' and rmbomlog.sale_order_item_id=' + soRecord.sale_order_item_id)
        .getRawOne();
      if (rmBomLog) {
        const soItemInfo: SaleOrderItemInfo = await this.soItemRepo.getVariantInfoForSoItem(soRecord.sale_order_item_id);
        const variantDetails = await this.skuCodesRepository.getSkuDataById({ skuCodeId: soItemInfo.variantId });
        const headLessMingrade = Math.ceil(Number(rmBomLog.min_grade) * (Number(rmBomLog.hl_per) / 100));
        const headLessMaxgrade = Math.ceil(Number(rmBomLog.max_grade) * (Number(rmBomLog.hl_per) / 100));
        const avgCount = Math.ceil((headLessMingrade + headLessMaxgrade) / 2);
        if (inputReq.count >= Number(avgCount) && inputReq.count <= Number(headLessMaxgrade)) {
          if (!(soIdarray.includes(soRecord.sale_order_id))) {
            saleOrdersArr.push(new SaleOrderDropDownDto(soRecord.sale_order_id, soRecord.sale_order_no, soRecord.po_number));
          }
          soIdarray.push(soRecord.sale_order_id);
          rmbomDetils.push(new BomWithCountAndQuantityModel(soRecord.sale_order_no, variantDetails.data.variantCode, rmBomLog.count, rmBomLog.quantity, Math.ceil(Number(rmBomLog.count) * (Number(rmBomLog.hl_per) / 100))));
        }
      }
    }
    return new SoDropCntQtyResponse(true, 1, 'Sale orders retrieved successfully', new SoDropCntQtyModel(saleOrdersArr, rmbomDetils));
  }

  async addSoItem(req: SaleOrderItemsInfo, isUpdate: boolean): Promise<CommonResponse> {
    console.log(req);
    try {
      console.log('req' + req.varientId,
        req.foodTypeId,
        req.soakingStyle);
      const percentageMap = new Map<number, Map<String, number>>();
      const yieldPercentages = await this.skuCodesRepository.getSkuPercentages(
        new SkuDataRequest(
          req.varientId,
          req.foodTypeId,
          req.soakingStyle
        )
      );
      if (yieldPercentages.status) {

        if (!percentageMap.has(req.varientId)) {
          percentageMap.set(req.varientId, new Map<String, number>());
          if (!percentageMap.get(req.varientId).has(req.soakingStyle)) {
            percentageMap
              .get(req.varientId)
              .set(req.soakingStyle, yieldPercentages.data.finalPercentage);
          }

          // }
        } else {
          if (!percentageMap.get(req.varientId).has(req.soakingStyle)) {
            percentageMap
              .get(req.varientId)
              .set(req.soakingStyle, yieldPercentages.data.finalPercentage);
          }
        }
      } else {
        throw new ErrorResponse(99998, 'No soaking percentages found for selected varient.');

      }
      let totSoItemsCount
      totSoItemsCount = await this.soItemRepo.count();
      totSoItemsCount = totSoItemsCount + 1
      const convertedItemEntity: SaleOrderItemsInfo = this.soItemsAdapter.convertDtoToEntity(req, isUpdate, percentageMap, totSoItemsCount);
      console.log("convertedItemEntityconvertedItemEntity" + convertedItemEntity);
      const savedItemEntity: SaleOrderItems = await this.saleOrderItemsRepository.save(convertedItemEntity);
      const savedItemDto: SaleOrderItemsInfo = this.soItemsAdapter.convertEntityToDto(savedItemEntity);
      if (savedItemDto) {
        return new CommonResponse(true, 1001, "Item Details Saved Successfully. ", savedItemDto);
      }
      else {
        return new CommonResponse(false, 1010, "something went wrong. ", savedItemDto);
      }
    }
    catch (err) {
      console.log(err)
      throw err
    }
  }

  async getCustInvoiceDetails(req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      const custInvoiceDetails = await this.customerInvoiceRepo.findOne({ where: { saleOrderId: req.saleOrderId } });
      if (custInvoiceDetails != undefined) {
        return new CommonResponse(true, 1001, "Customers invoice details retrived successfully.", custInvoiceDetails);
      }
      else {
        return new CommonResponse(false, 1010, "No data found",);
      }
    }
    catch (err) {
      return err
    }

  }
  async getDocumentApprovalStatus(req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      const DocApprovalDetails = await this.docApprovalRepo.findOne({ where: { saleOrderId: req.saleOrderId } });
      if (DocApprovalDetails != undefined) {
        return new CommonResponse(true, 1001, "Customers invoice details retrived successfully.", DocApprovalDetails);
      }
      else {
        return new CommonResponse(false, 1010, "No data found",);
      }
    }
    catch (err) {
      return err
    }

  }
  async getSoInspectionDetails(req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      const SoInspectionDetails = await this.saleInspectionRepository.findOne({ where: { saleOrderId: req.saleOrderId, inspectionName: "Load Inspection" } });
      if (SoInspectionDetails != undefined) {
        return new CommonResponse(true, 1001, "Inspection details retrived successfully.", SoInspectionDetails);
      }
      else {
        return new CommonResponse(false, 1010, "No data found",);
      }
    }
    catch (err) {
      return err
    }

  }

  async getSoInspectionData(req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      const SoInspectionDetails = await this.saleInspectionRepository.find({ where: { saleOrderId: req.saleOrderId } });
      if (SoInspectionDetails != undefined) {
        return new CommonResponse(true, 1001, "Inspection details retrived successfully.", SoInspectionDetails);
      }
      else {
        return new CommonResponse(false, 1010, "No data found",);
      }
    }
    catch (err) {
      return err
    }

  }

  async updateReproceesingQtyInBom(req: RmBomLogUpdateRequset): Promise<CommonResponse> {
    const rmbomLogUpdate = await this.rmbomRepo.updateReproceesingQtyInRmBom(req);
    if (rmbomLogUpdate) {
      const rmBomData = await this.rmbomRepo.findOne({ saleOrderItemId: req.saleOrderItemId });
      // for(const rmBomItem of rmBomData){
      const rmItemsData = await this.itemService.getRmItemForBom(
        new RmBomItemRequest(
          rmBomData.productId, rmBomData.count
        )
      );
      const rmbomLogUpdate = await this.bomRepo.updateBomAssignedQty(new BomUpdateRequest(rmItemsData.data.itemId, req.saleOrderId, req.assignedQty));
      if (!rmbomLogUpdate) {
        return new CommonResponse(false, 5555, 'updation of BOM failed')
      } else {
        return new CommonResponse(true, 1111, 'updated BOM')
      }
      // }
    } else {
      return new CommonResponse(false, 5555, 'updated BOM')
    }
  }

  async getNoOfRackPositionsForSO(req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      let manager = getManager();
      let soItemsQuery = `SELECT cases as cases, pouches as pouches, pouch_weight as pouchWeight,uom_id as uomId, pack_style_id as packStyleId, job_cases as jobCases FROM ` + appSettings.sales_db + `.sale_order_items soi where soi.sale_order_id = ${req.saleOrderId}`;
      let soData = await manager.query(soItemsQuery);
      console.log("soData");
      console.log(soData);
      let noOfLocations = 0;
      for (const soRecord of soData) {
        const checkPalletCapacity = await this.packingMethodService.getPalletCapacity({ noOfPouches: soRecord.pouches, pouchesPerRow: soRecord.pouchWeight, uomId: soRecord.uomId });
        console.log('**' + checkPalletCapacity.status)
        console.log("&&&&&" + checkPalletCapacity.data)
        if (checkPalletCapacity.status) {
          let capacity = checkPalletCapacity.data.palletCapacity != undefined ? checkPalletCapacity.data.palletCapacity : 0;
          let totalCases = soRecord.jobCases;
          noOfLocations = Number(noOfLocations) + Number(Math.ceil(totalCases / capacity));
          console.log(noOfLocations);
        }
        else {
          const checkPalletCapacity = await this.packingMethodService.getPalletCapacityById({ noOfPouches: soRecord.pouches, pouchesPerRow: soRecord.pouchWeight, uomId: soRecord.uomId, packingMethodId: soRecord.packStyleId });
          console.log('**' + checkPalletCapacity.status)
          console.log("&&&&&" + checkPalletCapacity.data)
          if (checkPalletCapacity.status) {
            let capacity = checkPalletCapacity.data.palletCapacity != undefined ? checkPalletCapacity.data.palletCapacity : 0;
            let totalCases = soRecord.jobCases;
            noOfLocations = Number(noOfLocations) + Number(Math.ceil(totalCases / capacity));
            console.log(noOfLocations);
          }
          else {
            return new CommonResponse(false, 10000, "Packing Method not found");
          }
        }
      }
      console.log(noOfLocations);
      return new CommonResponse(true, 1001, "No.of pallets retrived Successfully.", noOfLocations);
    }
    catch (err) {
      console.log(err);
      return err
    }
  }
  async getAllSaleOrderItemDetails(req: SaleOrderIdRequest): Promise<AllSoItemsResponseModel> {
    try {

      let saleorderIds: number[] = []
      let manager = getManager();
      let res = 'SELECT sale_order_id AS saleOrderId FROM ' + appSettings.sales_db + '.so_invoice_details WHERE po_number = "' + req.poNumber + '"'
      console.log('res', res)
      let Data = await manager.query(res);
      let id
      if (Data.length > 0) {
        for (const resp of Data) {
          console.log(resp, 'resss')
          id = resp?.saleOrderId
          saleorderIds.push(id)
        }
        console.log(saleorderIds, 'saleorderIdddd')
      }
      console.log(Data, 'data')
      let soItemsQuery = `SELECT job_type AS jobType,ROUND(production_percentage) AS productionPercentage,min_grade_id as minGrade,max_grade_id as maxGrade,soi.min_glaze,soi.max_glaze,soi.uom_id as uomId,soi.cases,job_cases as jobCases,soi.pouches,soi.soaking_time,soi.soaking_style as soakingStyle,style_weighment as styleWeighment,net_amount as netAmount,unitPrice,soi.pouch_weight as pouchWeight,soi.case_weight as caseWeight,soi.net_weight as netWeight,dispatched_qty as dispatchedQty,inv_amount as invAmount,b.brand_name as brand,soi.master_brand_id as masterBrandId,p.code as itemId,s.variant_code as varientId, soi.category as category,soi.requiredCount as rmCount,b.brand_id as brandId,soi.varient_id as variant,soi.final_percentage as finalPercentage,soi.sale_order_item_id as saleOrderItemId,soi.sale_order_id as saleOrderId, soi.shrimp_weight as netDrainedWeight,rbl.hl_per AS hlPercentage,sid.processing_unit as unitId,sz.size_name as variety FROM ` + appSettings.sales_db + `.sale_order_items soi
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_track st ON st.sale_order_id=soi.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.food_types f ON f.food_type_id=soi.food_type_id
      LEFT JOIN `+ appSettings.sales_db + `.rm_bom_log rbl ON rbl.sale_order_item_id=soi.sale_order_item_id
      LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id=soi.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.sku_codes s ON s.sku_code_id=soi.varient_id
      LEFT JOIN `+ appSettings.masters_db + `.sizes sz ON sz.size_id=soi.inner_bag_size_id
      LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=soi.item_id
      LEFT JOIN `+ appSettings.masters_db + `.brands b ON b.brand_id=soi.brand_id
      LEFT JOIN `+ appSettings.masters_db + `.value_addition_one_types va1 ON va1.value_addition_one_id=soi.value_addition_one_id
      LEFT JOIN `+ appSettings.masters_db + `.value_addition_two_types va2 ON va2.value_addition_two_id=soi.value_addition_two_id
      LEFT JOIN `+ appSettings.masters_db + `.value_addition_three_types va3 ON va3.value_addition_three_id=soi.value_addition_three_id
      LEFT JOIN `+ appSettings.masters_db + `.value_addition_four_types va4 ON va4.value_addition_four_id=soi.value_addition_four_id
      LEFT JOIN `+ appSettings.masters_db + `.value_addition_five_types va5 ON va5.value_addition_five_id=soi.value_addition_five_id
      where soi.sale_order_id IN (${saleorderIds}) `;
      let soData = await manager.query(soItemsQuery);
      for (const [index, soItem] of soData.entries()) {
        console.log(soItem)
        console.log(index)

        const convVariantsdata = await this.skuCodesRepository.getSkuConversions({ skuCodeId: soItem.variant })

        const reProcess = new ReProcessingDtoReq();
        reProcess.brand = undefined
        reProcess.product = undefined
        reProcess.minGrade = soItem.minGrade
        reProcess.maxGrade = soItem.maxGrade
        reProcess.finalPercentage = Number(soItem.finalPercentage)
        const reproceesedVarients = convVariantsdata.data
        reProcess.variantId = reproceesedVarients
        const reProcessingQty = await this.fgService.getReProcessingStock(reProcess);
        const rePack = new RepackingDtoRequest();
        rePack.brand = soItem.brandId
        rePack.brand = soItem.brandId
        rePack.product = undefined
        rePack.minGrade = undefined
        rePack.maxGrade = undefined
        rePack.category = undefined
        rePack.varient = soItem.variant
        rePack.soakingStyle = undefined
        rePack.soakingTime = undefined
        rePack.masterBrandId = soItem.masterBrandId
        rePack.unitId = soItem.unitId

        const rePackingQty = this.fgService.getRePackingStock(rePack);
        const finalFG = await manager.query("select SUM(stockin_qunatity) as finalFG from " + appSettings.warehouse_db + ".stock where stock.sale_order_item_id = " + soItem.saleOrderItemId + " and stock.stock_type ='saleOrder'");
        const dummyStock = await manager.query("select SUM(stockin_qunatity) as dummyStock from " + appSettings.warehouse_db + ".stock where stock.sale_order_item_id = " + soItem.saleOrderItemId + " and stock.stock_type IN ('SuperDummy','Anticipated') ");
        // console.log(finalFG,'final fg')
        // console.log(dummyStock,'dummy stock')
        soData[index].finalFG = finalFG[0].finalFG != null ? finalFG[0].finalFG : 0;
        soData[index].dummyStock = dummyStock[0].dummyStock != null ? dummyStock[0].dummyStock : 0;
        soData[index].balance = Number(soItem.jobCases) - (Number(finalFG[0].finalFG) + Number(dummyStock[0].dummyStock));

        await Promise.all([rePackingQty, reProcessingQty]).then(
          (res) => {
            const repackingQty = res[0].status ? res[0].data.profitReproceeQty : 0
            soData[index].rePackQty = repackingQty;
            const reprocessingQty = res[1].status ? res[1].data.profitReproceeQty : 0
            soData[index].reProcessQty = reprocessingQty;
          })
      };
      const response = new AllSoItemsResponseModel(true, 11108, 'Sale Order Details retrieved successfully', soData);
      return response;

    } catch (err) {
      return err
    }
  }
  async soCancel(req: SaleOrderIdRequest): Promise<CommonResponse> {
    let manager = new GenericTransactionManager();
    try {
      const cancelLofFlag = 0
      if (cancelLofFlag) {
        throw new ErrorResponse(5555, 'Already done this action')
      } else {
        const updateFlag = await this.soRepo.update({ saleOrderId: req.saleOrderId }, { cancelLogFlag: true })
      }
      await manager.startTransaction()
      const soStatusUpdate = await manager.getCustomRepository(SoRepository).update({ saleOrderId: req.saleOrderId }, { status: SoStatusEnum.CANCELLED });
      const getSubJob = await this.soInvRepo.findOne({ where: { poNumber: req.poNumber, saleOrderId: Not(req.saleOrderId) } })
      if (getSubJob) {
        const subsoStatusUpdate = await manager.getCustomRepository(SoRepository).update({ saleOrderId: getSubJob.saleOrderId }, { status: SoStatusEnum.CANCELLED });
      }
      if (soStatusUpdate.affected) {
        const soTrackUpdate = await manager.getCustomRepository(SoTrackRepository).update({
          saleOrderInfo: Raw(
            (alias) => `sale_order_id = '${req.saleOrderId}'`
          ),
        }, { saleOrderStatus: SaleOrderStatusEnum.CANCELLED })
        if (soTrackUpdate) {
          const PoexistWithSo = await this.purchaseOrderService.getPoItemDetailsForSaleId({ saleOrderId: req.saleOrderId })
          if (PoexistWithSo.status) {
            const updateFlag = await manager.getCustomRepository(SoRepository).update({ saleOrderId: req.saleOrderId }, { cancelLogFlag: false })
            if (updateFlag.affected) {
              await manager.completeTransaction()
              const result = new CommonResponse(true, 55555, 'Cancelled Successfully')

            //   const newLogDto = new LogsDto(1,'cancel', 'SaleOrder',req.saleOrderId , true, '','')
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
            return result

            } else {
              return new CommonResponse(false, 55555, 'something went wrong in cancellogflag updation ')
            }
          }
          else {
            const bomUpdate = await manager.getCustomRepository(BomRepository).update({ saleOrderId: req.saleOrderId }, { isActive: false })
            if (bomUpdate.affected) {
              const stockupdation = await this.stockService.cancelledSoStockUpdate({ saleOrderId: req.saleOrderId, plantId: req.plantId })
              console.log(stockupdation)
              const fgStockUpdate = await this.fgService.moveLeftOverQtytoDummy({ saleOrderId: req.saleOrderId, plantId: req.plantId });
              if (stockupdation.status) {
                await manager.completeTransaction();
                return new CommonResponse(true, 55555, 'Cancelled Successfully')

              } else {
                await manager.releaseTransaction()
                return new CommonResponse(false, 55555, 'left over Stock not Moved into bulk ')
              }
            } else {
              await manager.releaseTransaction()
              return new CommonResponse(false, 55555, 'BOM not updated')
            }
          }
        } else {
          await manager.releaseTransaction()
          return new CommonResponse(false, 55555, 'SO tracker not updated')
        }

      } else {
        await manager.releaseTransaction()
        return new CommonResponse(false, 55555, 'SO status not updated')
      }
    } catch (err) {
      await manager.releaseTransaction();
      throw err
    }
  }

  async getSoStatusBySoId(req: SaleOrderIdRequest): Promise<CommonResponse> {
    const soTrackData = await this.soTrackRepo.findOne({
      where: {
        saleOrderInfo: Raw(
          (alias) => `sale_order_id = '${req.saleOrderId}'`
        ),
      }
    })
    if (soTrackData.saleOrderStatus == SaleOrderStatusEnum.CANCELLED) {
      return new CommonResponse(true, 1111, 'so is cancelled')
    } else {
      return new CommonResponse(false, 1111, 'so is not cancelled')
    }
  }

  async getRmCountRanges(requiredCount: number): Promise<CommonResponse> {
    try {
      const manager = getManager();
      const query = `SELECT count_range_id as countRangeId FROM ` + countRangesTable + ` where min_value <= ` + requiredCount + ` and max_value >= ` + requiredCount
        ;
      const countRangesData = await manager.query(query);
      if (countRangesData) {
        return new CommonResponse(true, 5555, 'ranged retrived', countRangesData);
      } else {
        return new CommonResponse(false, 1111, 'No count ranges found')
      }

    } catch (err) {
      return new CommonResponse(false, 1111, err)
    }

  }
  async getSaleOrderDetailsBySaleNumber(
    saleOrderNumberRequest: SaleOrderNumberRequest,
    request: Request
  ): Promise<SaleOrderDetailViewInfoResponseModel> {
    const saleOrderEntities = await this.soRepo.findOne({ select: ['saleOrderId'], where: { saleOrderNumber: saleOrderNumberRequest.saleOrderNumber } });
    const saleOrderIdRequest = new SaleOrderIdRequest();
    saleOrderIdRequest.saleOrderId = saleOrderEntities.saleOrderId;
    saleOrderIdRequest.plantId = saleOrderNumberRequest.plantId;
    return this.getSaleOrderDetailsById(saleOrderIdRequest, request);
  }

  async transferSo(req: SOTransferDto): Promise<CommonResponse> {
    console.log(req);
    const manager = new GenericTransactionManager()
    try {
      await manager.startTransaction()
      const transferLogObj = new SOTransferLog();
      transferLogObj.saleOrderId = req.saleOrderId
      transferLogObj.fromUnit = req.fromUnit
      transferLogObj.toUnit = req.toUnit
      transferLogObj.fromProcessingUnit = req.fromProcessingUnit
      transferLogObj.toProcessingUnit = req.toProcessingUnit
      const savedLog = await manager.getCustomRepository(SOTransferLogRepository).save(transferLogObj);
      console.log(savedLog);
      console.log("savedLog");
      if (savedLog) {
        
        const updateSo = await manager.getCustomRepository(SoInvoiceRepository).update({ saleOrderId: req.saleOrderId }, { unit: req.toUnit, processingUnit: req.toProcessingUnit });

        let convertStockToDummy: boolean = false;
        if(req.fromUnit != req.toUnit && req.fromProcessingUnit == req.toProcessingUnit && req.stockConversionStatus == true){
          convertStockToDummy = true
        }
        if(req.fromUnit != req.toUnit && req.fromProcessingUnit == req.toProcessingUnit && req.stockConversionStatus == false){

          convertStockToDummy = false
        }
       
        if (updateSo.affected > 0 && req.fromUnit != req.toUnit) {

          const oldbomItems = await manager.getCustomRepository(BomRepository).find({ where: { saleOrderId: req.saleOrderId, packingCategory: Not(IsNull()) } });
          const oldpackingbomLogItems = await manager.getCustomRepository(PackingBomLogRepository).find({ where: { saleOrderId: req.saleOrderId } });
          for (const oldbomItemsData of oldbomItems) {
            console.log('oldbomItemsData0', oldbomItemsData)
            const itemDto = await this.itemService.getTotalItemDataById(new ItemRequest(oldbomItemsData.itemId, undefined, undefined));
            console.log('itemDto')
            console.log(itemDto.data)

            const BAPConsider = itemDto.data.bapNo;
            if (BAPConsider) {
              const itemDtobj = new ItemsDto(
                undefined,
                undefined,
                6,
                '',
                undefined,
                itemDto.data.packingCategory,
                itemDto.data.brandId,
                itemDto.data.varientId,
                itemDto.data.minGrade,
                itemDto.data.maxGrade,
                itemDto.data.pouches,
                itemDto.data.pouchWeight,
                itemDto.data.sizeId,
                undefined,
                undefined,
                true,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                itemDto.data.uomId,
                itemDto.data.itemSubCategoryId,
                ItemCategoriesEnum.PACKING,
                itemDto.data.productId,
                undefined,
                undefined,
                itemDto.data.bapNo,
                itemDto.data.foodTypeId,
                itemDto.data.valueAdditionOneId,
                itemDto.data.valueAdditionTwoId, itemDto.data.valueAdditionThreeId, itemDto.data.valueAdditionFourId, itemDto.data.valueAdditionFiveId

              );
              const updateBomDetails = await manager.getCustomRepository(BomRepository).update({ saleOrderId: req.saleOrderId, itemId: oldbomItemsData.itemId, packingCategory: Not(IsNull()) }, { isActive: false, });
              const unitData = await this.unitcodeService.getPlantDetailsById({ unitcodeId: req.toUnit })
              let trnasferedManUnitBap
              if (unitData) {
                trnasferedManUnitBap = unitData.data.bapNo
              } else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 11022, 'Unit Data not found FOR new BAP')
              }
              itemDtobj.bapNo = trnasferedManUnitBap;
              const newItemCreationData = await this.itemService.createItem(itemDtobj);
              let newItemId
              console.log('newItemCreationDataggg');
              console.log(newItemCreationData);
              console.log(newItemCreationData.data);
              // if(!newItemCreationData.status){
              newItemId = newItemCreationData.data.itemId
              // }else{
              // newItemId = newItemCreationData.data.itemId
              // }
              const bomObj = new BomDetails();
              bomObj.avilableQuantity = oldbomItemsData.avilableQuantity
              bomObj.isRequired = oldbomItemsData.isRequired
              bomObj.itemCategoryId = oldbomItemsData.itemCategoryId
              bomObj.itemId = newItemId
              bomObj.itemSubCategoryId = oldbomItemsData.itemSubCategoryId
              bomObj.packingCategory = oldbomItemsData.packingCategory
              bomObj.quantity = oldbomItemsData.quantity
              bomObj.requiredQuantity = oldbomItemsData.quantity
              bomObj.saleOrderId = oldbomItemsData.saleOrderId
              bomObj.size = oldbomItemsData.size
              bomObj.status = StatusEnum.OPEN;
              const BOMSaveWIthNEwBapItem = await manager.getCustomRepository(BomRepository).save(bomObj);



              console.log(bomObj)
              if (!BOMSaveWIthNEwBapItem) {
                await manager.releaseTransaction();
                return new CommonResponse(false, 11022, 'Something went wrong in saving BOM')
              }
            }
          }
          for (const record of oldpackingbomLogItems) {
            const itemDto = await this.itemService.getTotalItemDataById(new ItemRequest(record.itemId, undefined, undefined));
            console.log('itemDto')
            console.log(itemDto.data)

            const BAPConsider = itemDto.data.bapNo;
            if (BAPConsider) {
              const itemDtobj = new ItemsDto(
                undefined,
                undefined,
                6,
                '',
                undefined,
                itemDto.data.packingCategory,
                itemDto.data.brandId,
                itemDto.data.varientId,
                itemDto.data.minGrade,
                itemDto.data.maxGrade,
                itemDto.data.pouches,
                itemDto.data.pouchWeight,
                itemDto.data.sizeId,
                undefined,
                undefined,
                true,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                itemDto.data.uomId,
                itemDto.data.itemSubCategoryId,
                ItemCategoriesEnum.PACKING,
                itemDto.data.productId,
                undefined,
                undefined,
                itemDto.data.bapNo,
                itemDto.data.foodTypeId,
                itemDto.data.valueAdditionOneId,
                itemDto.data.valueAdditionTwoId, itemDto.data.valueAdditionThreeId, itemDto.data.valueAdditionFourId, itemDto.data.valueAdditionFiveId

              );
              const updateBomDetails = await manager.getCustomRepository(PackingBomLogRepository).update({ saleOrderId: req.saleOrderId, itemId: record.itemId }, { isActive: false, });
              const unitData = await this.unitcodeService.getPlantDetailsById({ unitcodeId: req.toUnit })
              let trnasferedManUnitBap
              if (unitData) {
                trnasferedManUnitBap = unitData.data.bapNo
              } else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 11022, 'Unit Data not found FOR new BAP')
              }
              itemDtobj.bapNo = trnasferedManUnitBap;
              const newItemCreationData = await this.itemService.createItem(itemDtobj);
              let newItemId
              console.log('newItemCreationDataggg');
              console.log(newItemCreationData);
              console.log(newItemCreationData.data);
              // if(!newItemCreationData.status){
              newItemId = newItemCreationData.data.itemId
              // }else{
              // newItemId = newItemCreationData.data.itemId
              // }
              let totCount
              totCount = await manager.getCustomRepository(PackingBomLogRepository).count()
              totCount = totCount + 1
              var refNumber = totCount + "";
              while (refNumber.length < 4) refNumber = "0" + refNumber;
              const packingbomlogObj = new PackingBomLog();
              packingbomlogObj.itemId = newItemId
              packingbomlogObj.refNumber = totCount
              packingbomlogObj.barcode = 'productBarcode/' + refNumber
              packingbomlogObj.saleOrderItemId = record.saleOrderItemId
              packingbomlogObj.itemSubCategoryId = record.itemSubCategoryId
              packingbomlogObj.quantity = record.quantity
              packingbomlogObj.saleOrderId = record.saleOrderId
              const packBOMLogSaveWIthNEwBapItem = await manager.getCustomRepository(PackingBomLogRepository).save(packingbomlogObj);

              console.log(packingbomlogObj)
              if (!packBOMLogSaveWIthNEwBapItem) {
                await manager.releaseTransaction();
                return new CommonResponse(false, 11022, 'Something went wrong in saving packing BOM Log')
              }
            }
          }
          //packing bom log itemscreation with new BAP

        }
        console.log(updateSo.affected +"-----------------"+ req.stockConversionStatus +"-----------------"+ req.fromProcessingUnit +"-----------------------------"+ req.toProcessingUnit)
        if (updateSo.affected > 0 && req.stockConversionStatus && req.fromProcessingUnit != req.toProcessingUnit) {
          let data = await this.fgService.moveLeftOverQtytoDummy({ saleOrderId: req.saleOrderId, plantId: req.fromProcessingUnit });
          convertStockToDummy = data.status;

        }

        // const queryManager = getManager()
        // const query = ' UPDATE ' + appSettings.sales_db + '.bom_details  SET `receiced_qty` = 0, `assigned_qty` = 0, `status` = "OPEN", `required_qty` = `quantity` WHERE `sale_order_id` = ' + req.saleOrderId + ' AND `packing_category` IS NOT NULL'
        const updateBomDetailsRaw = await manager.getCustomRepository(BomRepository).update({ saleOrderId: req.saleOrderId }, { receivedQuantity: 0, AssignedQuantity: 0, status: () => `"OPEN"`, requiredQuantity: () => `quantity` });

        let salereq = new SaleOrderIdRequest();
        salereq.saleOrderId = req.saleOrderId;
        const updateStocktoBulk = await this.stockService.updateStockToBulk(salereq);

        console.log(updateSo.affected +"------------------------"+ updateBomDetailsRaw.affected +"------------------------"+ updateStocktoBulk.status +"------------------------"+ convertStockToDummy +"------------------------"+ req.stockConversionStatus)
        if (updateSo.affected && updateBomDetailsRaw.affected && updateStocktoBulk.status && convertStockToDummy && req.stockConversionStatus) {
          await manager.completeTransaction();
          return new CommonResponse(true, 11116, 'Transferred Successfully');
          // const newLogDto = new LogsDto(1,name, 'Countries', savedCurrencyDto.countryId, true, '',savedCurrencyDto.createdUser)
          // let res = await this.logService.createLog(newLogDto);
          // console.log(res);
        }
        else if (updateSo.affected && convertStockToDummy==false && req.stockConversionStatus == false) {
          await manager.completeTransaction();
          return new CommonResponse(true, 11116, 'Transferred Successfully');
        }
        else{
          await manager.releaseTransaction();
          return new CommonResponse(false, 11116, 'Something went wrong');
        }


      } else {
        await manager.releaseTransaction()
        throw new ErrorResponse(555554, 'log Not saved');
      }
    } catch (err) {
      await manager.releaseTransaction()
      throw err;
    }

  }

  async getBomDataById(req: SaleOrderIdRequest): Promise<CommonResponse> {
    console.log('vvvvvvvv')
    console.log(req)
    const Bomdata = await this.bomRepo.findOne({
      where: { saleOrderId: req.saleOrderId, itemId: req.itemId }
    })
    console.log('fffffffffff')
    console.log(Bomdata)

    if (Bomdata) {
      console.log(Bomdata)
      console.log('Bomdatallll')

      return new CommonResponse(true, 1111, 'BOM data retrived', Bomdata)
    } else {
      return new CommonResponse(false, 1111, 'No BOM data found')
    }
  }

  async getProductForSoId(saleOrderIdRequest: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let trackerQuery
      trackerQuery = `SELECT si.sale_order_id as saleOrderId, si.varient_id as variantId,sc.variant_code as variantCode,concat(b.brand_name,'/',sc.variant_code,'/',pm.packing_method_name) as soItemName,si.sale_order_item_id as saleOrderItemId,reported_cases as reportedCases,job_cases as jobCases,sinv.processing_unit as processingUnitId FROM ` + appSettings.sales_db + `.sale_order_items si  
      left join  ${appSettings.sales_db}.so_invoice_details sinv on sinv.sale_order_id = si.sale_order_id 
      LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=si.varient_id
      left join ${appSettings.masters_db}.master_brands b on b.master_brand_id = si.master_brand_id
      left join ${appSettings.masters_db}.packing_methods pm on pm.packing_method_id = si.pack_style_id
      WHERE si.sale_order_id = ` + saleOrderIdRequest.saleOrderId

      const saleOrderDto = await manager.query(trackerQuery);

      const response = new CommonResponse(true, 11108, "Product for sale SO Id retrieved successfully", saleOrderDto);
      return response;
    }
    catch (error) {
      console.log(error);
      throw error;
    }
  }

  async updateReportedAndDispatchCases(req: UpdateCasesRequest): Promise<CommonResponse> {
    const manager = new GenericTransactionManager();
    try {
      console.log(req);
      await manager.startTransaction();
      if (req.reported < 0) {
        req.reported = 0;
      }
      if (req.dispatchStatus != "repacking") {
        const updateSaleqty = await manager.getCustomRepository(SoItemRepository).update({ saleOrderItemId: req.saleOrderItemId }, { reportedCases: req.reported, dispatchedQty: req.dispatch });
        console.log(updateSaleqty)
        if (updateSaleqty.affected > 0) {
          console.log("hii")
          await manager.completeTransaction();
          return new CommonResponse(true, 1001, "Reported & Dispatch Cases updated successfully. ");
        }
        else {
          console.log("hi")
          await manager.releaseTransaction();
          return new CommonResponse(false, 1010, "Something went wrong. ");
        }
      }
      else {
        return new CommonResponse(true, 1001, ". ");
      }
    } catch (error) {
      await manager.releaseTransaction();
      console.log(error)
      return error
    }
  }
  async getSaleOrdersForGradePattern(req: GradePatternRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      const query = `SELECT rm.sale_order_id as saleOrderId,rm.sale_order_item_id as saleOrderItemId,si.po_number as poNumber,si.processing_unit as plantId FROM ` + appSettings.sales_db + `.rm_bom_log rm LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id=rm.sale_order_id WHERE processing_unit = ` + req.plantId + ` AND rm.count BETWEEN ` + req.count + ` AND ` + req.maxCount
      const dropData = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new CommonResponse(true, 11108, "Sale Oreders for count retrieved successfully", dropData)
      } else {
        return new CommonResponse(true, 11108, "Something went wrong")

      }
    }
    catch (error) {
      return error
    }

  }

  async getTransferredSaleOrders(): Promise<CommonResponse> {
    try {
      const manager = getManager()
      const query = `SELECT st.created_at AS createdAt ,st.to_processing_unit as toProcessingUnit,st.sale_order_id as saleOrderId,si.po_number as poNumber FROM ` + appSettings.sales_db + `.so_transfer_log st
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = st.sale_order_id 
      WHERE st.so_transfer_log_id IN (SELECT MAX(so_transfer_log_id)  FROM  ` + appSettings.sales_db + `.so_transfer_log GROUP BY sale_order_id)`
      const transferData = await manager.query(query)
      if (transferData.length > 0) {
        return new CommonResponse(true, 11108, "transfer data retrived", transferData)
      }
      else {
        return new CommonResponse(false, 11108, "No data found",)
      }
    } catch (error) {
      return error
    }
  }
  async storeIssueDataMigration() {
    const manager = new GenericTransactionManager()
    try {

      await manager.startTransaction();
      let save1
      let save2
      let save3
      let saveFlag = new Set<boolean>()

      const soItemsData = await this.soItemRepo.find({ where: { saleOrderId: 339 } })
      for (const soItem of soItemsData) {
        const unitid = await (await this.soInvRepo.findOne({ where: { saleOrderId: soItem.saleOrderId } })).unit
        const unitData = await this.unitcodeService.getPlantDetailsById({ unitcodeId: unitid })
        // index = index+1;
        const brandsData = await this.masterBrandsService.getMasterBrandById({ brandId: soItem.masterBrandId })
        let itemPackingCategory = soItem.category;
        if (
          soItem.category ==
          PackTypeCategory.POUCH ||
          soItem.category ==
          PackTypeCategory.SKEWERS
        ) {
          itemPackingCategory = PackingCategoryEnum.POUCH;
        }
        if (
          soItem.category == PackTypeCategory.RING
        ) {
          itemPackingCategory = PackingCategoryEnum.RING;
        }
        if (
          soItem.category == PackTypeCategory.PLATTER
        ) {
          itemPackingCategory = PackingCategoryEnum.PLATTER;
        }
        let pouchBapNo = undefined
        let pouchMinGrade = undefined
        let pouchMaxGrade = undefined
        let pouchvariant = undefined
        let pouchProduct = undefined
        let pouchFoodType = undefined
        let pouchvalAddOne = undefined
        let pouchvalAddTwo = undefined
        let pouchvalAddThree = undefined
        let pouchvalAddFour = undefined
        let pouchvalAddFive = undefined
        let pouchBrand = undefined
        let pouches = undefined
        let pouchWeight = undefined
        let RingOrPlattersize = undefined
        let pouchuomId = undefined

        if (soItem.category ==
          PackTypeCategory.RING ||
          soItem.category ==
          PackTypeCategory.PLATTER) {
          RingOrPlattersize = soItem.skewerSizeItemId
        }
        if (soItem.category ==
          PackTypeCategory.POUCH ||
          soItem.category ==
          PackTypeCategory.SKEWERS) {
          pouchBrand = soItem.brandId
          pouches = soItem.pouches
          pouchWeight = soItem.pouchWeight
          pouchuomId = soItem.uomId

          if (brandsData.isPouchBapNoConsider) {
            pouchBapNo = unitData.data.bapNo
          }

          if (brandsData.isPouchGradeConsider) {
            pouchMinGrade = soItem.minGrade
            pouchMaxGrade = soItem.maxGrade
          }
          if (brandsData.isPouchProductConsider) {
            pouchProduct = soItem.itemId
          } if (brandsData.isPouchFoodTypeConsider) {
            pouchFoodType = soItem.foodTypeId
          } if (brandsData.isPouchValAddOneConsider) {
            pouchvalAddOne = soItem.valueAdditionOneId
          } if (brandsData.isPouchValAddTwoConsider) {
            pouchvalAddTwo = soItem.valueAdditionTwoId
          } if (brandsData.isPouchValAddThreeConsider) {
            pouchvalAddThree = soItem.valueAdditionThreeId
          } if (brandsData.isPouchValAddFourConsider) {
            pouchvalAddFour = soItem.valueAdditionFourId
          } if (brandsData.isPouchValAddFiveConsider) {
            pouchvalAddFive = soItem.valueAdditionFiveId
          }
        }
        // pouchitemResponse = await this.itemService.createItem(pouchItemDto);
        const eachItem = await this.itemService.getPouchItemForBom(
          new BomItemRequest(
            itemPackingCategory,
            pouchMinGrade,
            pouchMaxGrade,
            soItem.masterBrandId,
            pouchvariant,
            soItem.pouches,
            soItem.pouchWeight,
            soItem.uomId, RingOrPlattersize, brandsData, pouchFoodType, pouchvalAddOne, pouchvalAddTwo, pouchvalAddThree, pouchvalAddFour, pouchvalAddFive, pouchProduct, pouchBapNo
          )
        );


        let pouchitemResponse;
        if (eachItem) {
          const packBomLog = new PackingBomLog();
          packBomLog.saleOrderId = soItem.saleOrderId
          packBomLog.saleOrderItemId = soItem.saleOrderItemId
          packBomLog.itemId = eachItem.data.itemId
          packBomLog.itemSubCategoryId = eachItem.data.itemSubCategoryId
          packBomLog.quantity = soItem.cases * soItem.pouches
          save1 = await manager.getCustomRepository(PackingBomLogRepository).save(packBomLog);
        }
        // const soItemCartondata = soItemPouchdata
        let cartonBapNo = undefined
        let cartonMinGrade = undefined
        let cartonMaxGrade = undefined
        let cartonvariant = undefined
        let cartonProduct = undefined
        let cartonFoodType = undefined
        let cartonValAddOne = undefined
        let cartonValAddFive = undefined
        let cartonValAddTwo = undefined
        let cartonValAddThree = undefined
        let cartonValAddFour = undefined
        if (brandsData.isCartonBapNoConsider) {
          cartonBapNo = unitData.data.bapNo
        }
        if (brandsData.isCartonGradeConsider) {
          cartonMinGrade = soItem.minGrade
          cartonMaxGrade = soItem.maxGrade
        }
        if (brandsData.isCartonValAddOneConsider) {
          cartonValAddOne = soItem.valueAdditionOneId
        }
        if (brandsData.isCartonValAddTwoConsider) {
          cartonValAddTwo = soItem.valueAdditionTwoId
        }
        if (brandsData.isCartonValAddThreeConsider) {
          cartonValAddThree = soItem.valueAdditionThreeId
        }
        if (brandsData.isCartonValAddFourConsider) {
          cartonValAddFour = soItem.valueAdditionFourId
        }
        if (brandsData.isCartonValAddFiveConsider) {
          cartonValAddFive = soItem.valueAdditionFiveId
        }
        if (brandsData.isCartonFoodTypeConsider) {
          cartonFoodType = soItem.foodTypeId
        }
        if (brandsData.isCartonProductConsider) {
          cartonProduct = soItem.itemId
        }
        const eachCartonItem = await this.itemService.getPouchItemForBom(
          new BomItemRequest(
            PackingCategoryEnum.CARTON,
            cartonMinGrade,
            cartonMaxGrade,
            soItem.masterBrandId,
            cartonvariant,
            soItem.pouches,
            soItem.pouchWeight,
            soItem.uomId, undefined, brandsData, cartonFoodType, cartonValAddOne, cartonValAddTwo, cartonValAddThree, cartonValAddFour, cartonValAddFive, cartonProduct, cartonBapNo
          )
        );
        // console.log('eachCartonItem')
        // console.log(eachCartonItem)

        if (eachCartonItem) {
          const packCartonBomLog = new PackingBomLog();
          packCartonBomLog.saleOrderId = soItem.saleOrderId
          packCartonBomLog.saleOrderItemId = soItem.saleOrderItemId
          packCartonBomLog.itemId = eachCartonItem.data.itemId
          packCartonBomLog.itemSubCategoryId = eachCartonItem.data.itemSubCategoryId
          packCartonBomLog.quantity = soItem.cases
          save2 = await manager.getCustomRepository(PackingBomLogRepository).save(packCartonBomLog);

        }
        if (soItem.category == PackTypeCategory.SKEWERS) {
          // const skewerItem = soItemPouchdata;
          let skewerBapNo = undefined
          let skewerMinGrade = undefined
          let skewerMaxGrade = undefined
          let skewervariant = undefined
          let skewerProduct = undefined
          let skewerFoodType = undefined
          let skewerValaddOne = undefined
          let skewerValaddTwo = undefined
          let skewerValaddThree = undefined
          let skewerValaddFour = undefined
          let skewerValaddFive = undefined
          const itemDetails = await this.itemService.getPouchItemForBom(
            new BomItemRequest(
              PackingCategoryEnum.SKEWER,
              skewerMinGrade,
              skewerMaxGrade,
              soItem.masterBrandId,
              skewervariant,
              soItem.pouches,
              soItem.pouchWeight,
              soItem.uomId,
              soItem.skewerSizeItemId,
              brandsData, skewerFoodType, skewerValaddOne, skewerValaddTwo, skewerValaddThree, skewerValaddFour, skewerValaddFive, skewerProduct
            )
          );
          console.log('itemsssss' + itemDetails);

          if (itemDetails) {
            const packSkewerBomLog = new PackingBomLog();
            packSkewerBomLog.saleOrderId = soItem.saleOrderId
            packSkewerBomLog.saleOrderItemId = soItem.saleOrderItemId
            packSkewerBomLog.itemId = itemDetails.data.itemId
            packSkewerBomLog.itemSubCategoryId = itemDetails.data.itemSubCategoryId
            packSkewerBomLog.quantity = soItem.cases * soItem.cases * soItem.innerBags
            save3 = await manager.getCustomRepository(PackingBomLogRepository).save(packSkewerBomLog);

          }

        }
        if (save1 && save2) {
          saveFlag.add(true)
        } else {
          saveFlag.add(false)
        }

      }
      if (!saveFlag.has(false)) {
        manager.completeTransaction();
        return new CommonResponse(false, 1111, 'saved')

      } else {
        manager.releaseTransaction();
        return new CommonResponse(false, 1111, 'dontsave')

      }
    }
    catch (err) {
      manager.releaseTransaction();
      throw err
    }
  }
  @Cron('0 8 * * *')
  async getSkippedSoCount() {
    try {
      const manager = getManager();
      let skipData
      // let urlMsg = '*click the below👇👇 link for detail view*';
      let skippedUrl = appSettings.whatsapp_redirection_url + '/saleorder-abstract-report';
      let query = `SELECT SUM(IF(soi.processing_unit=1,1,0)) AS kkd,SUM(IF(soi.processing_unit=2,1,0)) AS unit1,SUM(IF(soi.processing_unit=3,1,0)) AS unit2 FROM ${appSettings.sales_db}.so_invoice_details soi 
      LEFT JOIN erpx_dev_sales.sale_order so ON soi.sale_order_id=so.sale_order_id
      WHERE so.status IN ('OPEN','INPROGRESS') AND soi.job_type!='Sub Job' AND so.so_process_type='MTO' and so.so_type = 'Dispatch' ORDER BY soi.invoice_date`;
      skipData = await manager.query(query);
      const time = moment().subtract(1, "days").format('MMMM Do, YYYY')
      const nowTime = moment().subtract(0, "days").format('MMMM Do, YYYY')
      // const mes = skipData.map(i => {
      //   console.log(i.skipped);
      //   return (" \n " + 'Kkd:' + i.kkd + " \n " + 'unit1:' + i.unit1 + " \n " + 'unit2:' + i.unit2 + "\n ")
      // })
      const parameters = [
        { "type": "text", "text": time },
        { "type": "text", "text": nowTime },
        { "type": "text", "text": skipData[0].unit1 >= 0 ? "*" + skipData[0].unit1 + "*" : "No Data" },
        { "type": "text", "text": skipData[0].unit2 >= 0 ? "*" + skipData[0].unit2 + "*" : "No Data" },
        { "type": "text", "text": skipData[0].kkd >= 0 ? "*" + skipData[0].kkd + "*" : "No Data" },
      ];
      console.log(parameters, 'parameters')
      const contacts = whatsApp.contacts;
      console.log(contacts, 'contacts')
      let statusFlag
      for (const contact of contacts) {
        console.log('skipped_so_count')

        const req = await new MessageParameters(contact, 'skipped_so_count', parameters, 'en_us')
        const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
        console.log(messageStatus, 'messageStatus')
        if (!messageStatus.status) {
          statusFlag = false
          break
        } else {
          statusFlag = true
          const whatsapplogDto = new WhatsAppLogDto(contact,'skipped_so_count','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.salemoduleId)
          await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
      
        }
      }
      //whatsapp broadcast API calling

      // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(7, 'Status Till ' + time + '\n' + 'Whatsapp Generated On : ' + nowTime + mes, [whatsApp.UsageReport]));
      // const message = await new MessageRequest(whatsApp.UsageReport, "Plant Wise Skipped So Count As On " + time, mes, "ERPX")
      // var messageStatus = await this.wpService.sendPersonalMessage(message);
      if (statusFlag) {
        return new CommonResponse(true, 11108, "Message Sent Sucessfully", statusFlag)
      }
    } catch (error) {
      console.log(error)
      return new CommonResponse(false, 11108, "Error while sending message")
    }
  }

  @Cron('0 8 * * *')
  async getSaleOrderLifeCycleStatus() {
    try {
      const manager = getManager();
      let statusCounts;
      let dataArry = []
      // let urlMsg = '*click the below👇👇 link for detail view*';
      let soLifeCycleUrl = appSettings.whatsapp_redirection_url + '/sale-otder-report';
      let allsttausvalues = Object.values(SoLifeCycleStatusEnum)
      for (const [index, allsttausvaluesItem] of allsttausvalues.entries()) {

        let saleOrderLifeCycleStatusQuery = `SELECT life_cycle_status as lifeCycleStatus, SUM(kakinada) as kakinada, SUM(Unit1) as unit1, SUM(Unit2) as unit2 ,processing_unit FROM (
      SELECT life_cycle_status,processing_unit,
      IF(soi.processing_unit=1,COUNT(1),0) AS kakinada,
      IF(soi.processing_unit=2,COUNT(1),0) AS Unit1,
      IF(soi.processing_unit=3,COUNT(1),0) AS Unit2 
      FROM sale_order so
      LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soi ON soi.sale_order_id = so.sale_order_id where life_cycle_status in('` + SoLifeCycleStatusEnum.Risk1 + `','` + SoLifeCycleStatusEnum.PARTIALLY_COMPLETED + `','` + SoLifeCycleStatusEnum.READY_FOR_INSPECTION + `','` + SoLifeCycleStatusEnum.PENDING_FOR_INSPECTION + `','` + SoLifeCycleStatusEnum.RISK2 + `','` + SoLifeCycleStatusEnum.EARLY_SHIPMENT + `') GROUP BY life_cycle_status,processing_unit
      ) AS sd group by life_cycle_status`
        statusCounts = await manager.query(saleOrderLifeCycleStatusQuery)
      }


      const time = moment().subtract(1, "days").format("MMMM Do, YYYY");
      const nowTime = moment().subtract(0, "days").format('MMMM Do, YYYY')
      // if (statusCounts.length > 0) {
      //   for (const sc of statusCounts) {
      //     statusCounts += sc.life_cycle_status + " :  *" + sc.processing_unit + "*\n";
      //   }
      // }

      const lifeCycleMeanings = [{ lifeCycle: SoLifeCycleStatusEnum.Risk1, meaning: '(SO ETD-Processing Days >PO EDD)' }, { lifeCycle: SoLifeCycleStatusEnum.PARTIALLY_COMPLETED, meaning: '(100% Quantity Not In W/H)' }, { lifeCycle: SoLifeCycleStatusEnum.READY_FOR_INSPECTION, meaning: '(70% Production Completed Inspection Not Triggered)' }, { lifeCycle: SoLifeCycleStatusEnum.PENDING_FOR_INSPECTION, meaning: '(70% Production Completed Inspection Not Done)' }, { lifeCycle: SoLifeCycleStatusEnum.RISK2, meaning: '(Lead Time 12 Days)' }, { lifeCycle: SoLifeCycleStatusEnum.EARLY_SHIPMENT, meaning: '(Shipped Before ETD)' }]

      console.log(statusCounts[0], '12121212')
      const mes = (statusCounts.map(i => {
        console.log(i.lifeCycleStatus)
        return ((" \\n*" + i.lifeCycleStatus + " :*\\n " + lifeCycleMeanings.find(j => j.lifeCycle == i.lifeCycleStatus)?.meaning + " \\n " + 'unit1:' + i.unit1 + " \\n " + 'unit2:' + i.unit2) + " \\n " + 'unit3:' + i.kakinada + " \\n")
      })) + "\\n"
      //whatsapp broadcast API calling to FaceBook
      const parameters = [
        { "type": "text", "text": time },
        { "type": "text", "text": nowTime },
        { "type": "text", "text": mes },
        { "type": "text", "text": soLifeCycleUrl },
      ];
      const contacts = whatsApp.contacts;
      let statusFlag
      for (const contact of contacts) {
        const req = await new MessageParameters(contact, 'so_life_cycle_status_report', parameters, 'en_us')
        const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
        console.log('messageStatus', messageStatus)
        if (!messageStatus.status) {
          statusFlag = false
        } else {
          statusFlag = true
          const whatsapplogDto = new WhatsAppLogDto(contact,'so_life_cycle_status_report','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.salemoduleId)
          await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
          
        }
      }
      //whatsapp broadcast API calling
      // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(8, 'Status Till ' + time + '\n' + 'Whatsapp Generated On : ' + nowTime + mes, [whatsApp.UsageReport]));
      // const message = await new MessageRequest(whatsApp.UsageReport, "So Life Cycle Status for" + time, mes, "ERPX")
      // var messageStatus = await this.wpService.sendPersonalMessage(message);
      if (statusFlag) {
        return new CommonResponse(true, 11108, "Message Sent Sucessfully", statusFlag)
      }
    } catch (error) {
      console.log(error)
      return new CommonResponse(false, 11108, error)
    }
  }


  @Cron('0 8 * * *')
  async getSaleOrderUsage() {
    try {
      const manager = getManager();
      let saleOrderQuery = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_sales.sale_order so 
      LEFT JOIN erpx_dev_sales.so_invoice_details soin ON soin.sale_order_id = so.sale_order_id
      LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = soin.processing_unit  WHERE so.so_process_type = 'MTO' AND DATE(soin.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY) 
      GROUP BY soin.processing_unit  ORDER BY soin.processing_unit`
      let poQuery = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_procurement.purchase_order po
      LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = po.unit_id WHERE DATE(po.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY) 
      GROUP BY po.unit_id ORDER BY po.unit_id `
      let grnQuery = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_procurement.grn g
      LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = g.unit_id WHERE DATE(g.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY) 
      GROUP BY g.unit_id ORDER BY g.unit_id `
      let storeConsumptionQuery = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_procurement.store_consumption sc
      LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = sc.unit_id WHERE DATE(sc.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY) 
      GROUP BY sc.unit_id ORDER BY sc.unit_id `
      let whStockInQuery = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_warehouse.reporting r 
      LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = r.unit_id  WHERE  DATE(r.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY)  and r.is_active = true
      GROUP BY r.unit_id  ORDER BY r.unit_id`
      let whStockOutQuery = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_warehouse.fork_lift_items f
      LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = f.unit_id  WHERE  DATE(f.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY) 
      GROUP BY f.unit_id  ORDER BY f.unit_id`
      let logisticsInvoicesQuery = `SELECT DATE(i.created_at) AS createdDate,COUNT(*)AS cnt,u.unit_id AS unitId,uc.unit_name  FROM erpx_dev_sales.customer_invoice i
      LEFT JOIN erpx_dev_ums.user u ON u.username = i.created_user
      LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = u.unit_id  WHERE  DATE(i.created_at)=DATE_SUB(CURDATE(), INTERVAL 1 DAY) 
      GROUP BY DATE(i.created_at)  ORDER BY u.unit_id`
      let rmQuery = `SELECT COUNT(*) AS cnt ,uc.unit_name FROM erpx_dev_rm_procurement.indent i
      LEFT JOIN erpx_dev_ums.user u ON u.username = i.created_user
      LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = u.unit_id
       WHERE DATE(i.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY) GROUP BY u.unit_id
       AND u.unit_id = 5 `
       let indentPending = ` SELECT COUNT(*) AS cnt,uc.unit_name FROM erpx_dev_rm_procurement.indent i
       LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = i.plant_id
       WHERE grn_completed = 0 AND harvesting_date = DATE_SUB(CURDATE(), INTERVAL 1 DAY) GROUP BY i.plant_id `
       let stockTransfers = `SELECT COUNT(transfer_id) AS cnt ,uc.unit_name FROM erpx_dev_procurement.transfer_material tm
       LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = tm.unit_id
       WHERE tm.transfer_method = 'INDENT' AND DATE(tm.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
       GROUP BY tm.unit_id ` 
       let locationAllocated = `SELECT COUNT(s.location_id) AS cnt, uc.unit_name  FROM erpx_dev_procurement.stock s
       LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = s.unit_id
       WHERE DATE(s.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
       GROUP BY s.unit_id `
       let prodIndents = `SELECT COUNT(indent_form_id) AS cnt,uc.unit_name FROM erpx_dev_procurement.packing_indent pi
       LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = pi.unit_id
       WHERE DATE(pi.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY) GROUP BY pi.unit_id `
       let materialRequisition = `SELECT COUNT(imp.indent_material_preparation_id) AS cnt, uc.unit_name FROM erpx_dev_procurement.indent_material_preparation imp
       LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = imp.unit_id
       WHERE  DATE(imp.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
       GROUP BY imp.unit_id `
       let materialPrepation = `SELECT COUNT(ps.prepared_stock_id) AS cnt , uc.unit_name FROM erpx_dev_procurement.prepared_stock ps 
       LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = ps.unit_id WHERE  DATE(ps.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
       GROUP BY ps.unit_id `
       let rmGrnQuery = `SELECT COUNT(g.grn_id) AS cnt ,uc.unit_name FROM erpx_dev_rm_procurement.grn g 
       LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = g.plant_id WHERE DATE(g.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
       GROUP BY g.plant_id `
      const salesData = await manager.query(saleOrderQuery);
      const poData = await manager.query(poQuery);
      const grndata = await manager.query(grnQuery);
      const scData = await manager.query(storeConsumptionQuery);
      const whStockInData = await manager.query(whStockInQuery);
      const whStockOutData = await manager.query(whStockOutQuery);
      const logisticsData = await manager.query(logisticsInvoicesQuery);
      const rmData = await manager.query(rmQuery);
      const indentPendingData = await manager.query(indentPending);
      const stockTransfersData = await manager.query(stockTransfers);
      const locationAllocatedData = await manager.query(locationAllocated);
      const prodIndentsData = await manager.query(prodIndents);
      const materialRequisitionData = await manager.query(materialRequisition);
      const materialPrepationData = await manager.query(materialPrepation);
      const rmGrnData = await manager.query(rmGrnQuery);

      let saleData = "";
      let purchaseData = "";
      let grnData = "";
      let storeconsumptionData = "";
      let stockInTransdata = "";
      let stockOutTransdata = "";
      let logisticsReport = "";
      let rmReport = "";
      let pendingReportData = "";
      let stockTransferReport = "";
      let locationAllocatedReport = "";
      let prodIndentsReport = "";
      let materialRequisitionReport = "";
      let materialPrepationReport = "";
      let rmGrnReportData = "";
      const time = moment().subtract(1, "days").format('MMMM Do, YYYY');
      const nowTime = moment().subtract(0, "days").format('MMMM Do, YYYY')
      if (salesData.length > 0) {
        for (const sd of salesData) {
          saleData += sd.unit_name + " :  *" + sd.cnt + "* ";
        }
      }
      if (poData.length > 0) {
        for (const sd of poData) {
          purchaseData += sd.unit_name + "  : *" + sd.cnt + "* ";
        }
      }
      if (grndata.length > 0) {
        for (const sd of grndata) {
          grnData += sd.unit_name + " :  *" + sd.cnt + "* ";
        }
      }
      if (scData.length > 0) {
        for (const sd of scData) {
          storeconsumptionData += sd.unit_name + " : *" + sd.cnt + "* ";
        }
      }
      if (whStockInData.length > 0) {
        for (const sd of whStockInData) {
          stockInTransdata += sd.unit_name + " :  *" + sd.cnt + "* ";
        }
      }
      if (whStockOutData.length > 0) {
        for (const sd of whStockOutData) {
          stockOutTransdata += sd.unit_name + "  : *" + sd.cnt + "* ";
        }
      }
      if (logisticsData.length > 0) {
        for (const ld of logisticsData) {
          logisticsReport += ld.unit_name + " : *" + ld.cnt + "* ";
        }
      }
      if(rmData.length > 0){
        for(const rd of rmData){
          rmReport += rd.unit_name + " : *" + rd.cnt + "* "
        }
      }
      if(indentPendingData.length > 0){
        for(const ip of indentPendingData){
          pendingReportData += ip.unit_name + " : *" + ip.cnt + "* "
        }
      }
      if(stockTransfersData.length > 0){
        for(const st of stockTransfersData){
          stockTransferReport += st.unit_name + " : *" + st.cnt + "* "
        }
      }
      if(locationAllocatedData.length > 0){
        for(const la of locationAllocatedData){
          locationAllocatedReport += la.unit_name + " : *" + la.cnt + "* "
        }
      }
      if(prodIndentsData.length > 0){
        for(const pi of prodIndentsData){
          prodIndentsReport += pi.unit_name + " : *" + pi.cnt + "* "
        }
      }
      if(materialRequisitionData.length > 0){
        for(const mr of materialRequisitionData){
          materialRequisitionReport += mr.unit_name + " : *" + mr.cnt + "* "
        }
      }
      if(materialPrepationData.length > 0){
        for(const mp of materialPrepationData){
          materialPrepationReport += mp.unit_name + " : *" + mp.cnt + "* "
        }
      }
      if(rmGrnData.length > 0){
        for(const rg of rmGrnData){
          rmGrnReportData += rg.unit_name + " : *" + rg.cnt + "* "
        }
      }
      const text = 'Whatsapp Generated On : ' + nowTime + " \n*Sale Data :*\n" + (salesData.length > 0 ? saleData : 'No Data\n');
      "\n*PO Data :*\n" + (poData.length > 0 ? purchaseData : 'No Data\n') +
        "\n*GRN Data :*\n" + (grndata.length > 0 ? grnData : 'No Data\n') +
        "\n*Store Consumption :*\n" + (scData.length > 0 ? storeconsumptionData : "No Data\n") +
        "\n*WH-Stock In :*\n" + (whStockInData.length > 0 ? stockInTransdata : "No Data\n") +
        "\n*WH-Stock Out :*\n" + (whStockOutData.length > 0 ? stockOutTransdata : "No Data\n") +
        "\n*Logistics Invoice :*\n" + (logisticsData.length > 0 ? logisticsReport : "No Data\n")
      // const message = await new BroadCastMessageRequest(6,time+'\n'+ text ,[whatsApp.UsageReport])
      // var messageStatus = await this.wpService.sendPersonalMessage(message);
      //whatsapp broadcast API calling
      // const sendMessage = await this.sendMessage(text)
      const parameters = [
        { "type": "text", "text": salesData.length > 0 ? saleData : "No Data" },
        { "type": "text", "text": poData.length > 0 ? purchaseData : "No Data" },
        { "type": "text", "text": grndata.length > 0 ? grnData : "No Data" },
        { "type": "text", "text": scData.length > 0 ? storeconsumptionData : "No Data" },
        { "type": "text", "text": whStockInData.length > 0 ? stockInTransdata : "No Data" },
        { "type": "text", "text": whStockOutData.length > 0 ? stockOutTransdata : "No Data" },
        { "type": "text", "text": logisticsData.length > 0 ? logisticsReport : "No Data" },
        { "type": "text", "text": rmData.length > 0 ? rmReport : "No Data"},
        { "type": "text", "text": indentPendingData.length > 0 ? pendingReportData : "No Data"},
        { "type": "text", "text": time + ` (${whatsApp.server})` }, 
        { "type": "text", "text": stockTransfersData.length > 0 ? stockTransferReport : "No Data"},
        { "type": "text", "text": locationAllocatedData.length > 0 ? locationAllocatedReport : "No Data"},
        { "type": "text", "text": prodIndentsData.length > 0 ? prodIndentsReport : "No Data"},
        { "type": "text", "text": materialRequisitionData.length > 0 ? materialRequisitionReport : "No Data"},
        { "type": "text", "text": materialPrepationData.length > 0 ? materialPrepationReport : "No Data"},
        { "type": "text", "text": rmGrnData.length > 0 ? materialPrepationReport : "No Data"}
      ]
       console.log('---parameter--',parameters)
      const contacts = whatsApp.contacts 
      let statusFlag = true
      for (const contact of contacts) {
        const req = await new MessageParameters(contact, 'global_usage_report', parameters, 'en_us')
        const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
        console.log(messageStatus)
        if (!messageStatus.status) {
          statusFlag = false
        }else{
          statusFlag = true
          const whatsapplogDto = new WhatsAppLogDto(contact,'global_usage_report','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.salemoduleId)
              await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
        }
      }
      if (statusFlag) {
        return new CommonResponse(true, 11108, "Message Sent Sucessfully")
      }
    } catch (error) {
      console.log(error)
      return new CommonResponse(false, 11108, "Error while sending message")
    }
  }
  @Cron('0 8 * * *')
  async getLogisticsUsage() {
    try {
      const manager = getManager();
      let SnBData;
      let OblData;
      let invData;
      let DocData;
      let ShippedNdBookedCount = `SELECT SUM(kakinada) AS kakinada, SUM(Unit1) AS unit1, SUM(Unit2) AS unit2 ,SUM(HeadOffice) AS HeadOffice
      FROM (
             SELECT c.status,c.unit_id,
             IF(c.unit_id=1,COUNT(1),0) AS kakinada,
             IF(c.unit_id=2,COUNT(1),0) AS Unit1,
             IF(c.unit_id=3,COUNT(1),0) AS Unit2,
             IF(c.unit_id=5,COUNT(1),0) AS HeadOffice
             FROM erpx_dev_logistics.container c
             WHERE c.status IN ('SHIPPED','BOOKED') AND c.unit_id>0
             GROUP BY c.status,c.unit_id
            ) AS sd GROUP BY sd.status`
      let OblStatus = `SELECT sd.bl_status AS blstatus, SUM(kakinada) AS kakinada, SUM(Unit1) AS unit1, SUM(Unit2) AS unit2 ,SUM(HeadOffice) AS HeadOffice
      FROM (
                  SELECT c.bl_status,c.unit_id,
                  IF(c.unit_id=1,COUNT(1),0) AS kakinada,
                  IF(c.unit_id=2,COUNT(1),0) AS Unit1,
                  IF(c.unit_id=3,COUNT(1),0) AS Unit2,
                  IF(c.unit_id=5,COUNT(1),0) AS HeadOffice
                  FROM erpx_dev_logistics.container c
                  WHERE c.bl_status='RECEIVED AND SHARED' AND c.unit_id>0
                  GROUP BY c.bl_status,c.unit_id
                  ) AS sd GROUP BY sd.bl_status`
      let Invoice = `SELECT COUNT(*)AS invoiceCount,uc.unit_name AS unitName FROM erpx_dev_sales.customer_invoice i
      LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id=i.unit_id 
      WHERE i.unit_id>0 
      GROUP BY i.unit_id`
      let DocApprovalPending = `SELECT COUNT(*) docApproval,u.unit_name AS unitName FROM sale_order so
      LEFT JOIN erpx_dev_sales.so_invoice_details soi ON soi.sale_order_id=so.sale_order_id
      LEFT JOIN erpx_dev_logistics.container cn ON cn.sale_order_id=so.sale_order_id
      LEFT JOIN erpx_dev_masters.unitcodes u ON u.unit_code_id=cn.unit_id
      WHERE cn.status = 'SHIPPED' AND cn.unit_id>0 GROUP BY cn.unit_id`
      SnBData = await manager.query(ShippedNdBookedCount);
      OblData = await manager.query(OblStatus);
      invData = await manager.query(Invoice);
      DocData = await manager.query(DocApprovalPending);
      console.log('------SnBData-----',SnBData)
      console.log('------OblData-----',OblData)
      console.log('------invData-----',invData)
      console.log('------DocData-----',DocData)

      const time = moment().subtract(1, "days").format('MMMM Do, YYYY');
      const newTime = moment().subtract(0, "days").format('MMMM Do, YYYY')

      const parameters = [
          {"type" : "text","text" : time},
          {"type" : "text","text" : SnBData[0].kakinada},
          {"type" : "text","text" : SnBData[0].unit1},
          {"type" : "text","text" : SnBData[0].unit2},
          {"type" : "text","text" : SnBData[0].HeadOffice}, //shipped data

          {"type" : "text","text" : OblData[0].kakinada},
          {"type" : "text","text" : OblData[0].unit1},
          {"type" : "text","text" : OblData[0].unit2},
          {"type" : "text","text" : OblData[0].HeadOffice},//RECEIVED AND SHARED

          {"type" : "text","text" : invData[0].invoiceCount},
          {"type" : "text","text" : invData[1].invoiceCount},
          {"type" : "text","text" : invData[2].invoiceCount},
          {"type" : "text","text" : invData[3].invoiceCount}, 
          {"type" : "text","text" : invData[4].invoiceCount},//inv count

          {"type" : "text","text" : DocData[0].docApproval},
          {"type" : "text","text" : DocData[1].docApproval},
          {"type" : "text","text" : DocData[2].docApproval},
          {"type" : "text","text" : DocData[3].docApproval}, //doc approval

          
      ]
      console.log('***parameters*************',parameters)
      const contacts = whatsApp.contacts;
        let statusFlag = true;

        for (const contact of contacts) {
          const req = await new MessageParameters(contact, 'logistics_uasage_report', parameters, 'en_us')
            const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            console.log(messageStatus)
            if (!messageStatus.status) {
              statusFlag = false
            }else{
              statusFlag = true
              const whatsapplogDto = new WhatsAppLogDto(contact,'logistics_uasage_report','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.salemoduleId)
              await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
            }
        }
      
        if (statusFlag) {
          return new CommonResponse(true, 11108, "Message Sent Sucessfully")
        }
      }catch (error) {
          return new CommonResponse(false, 11508, "Error while sending message")
        }
    //   var messageStatus = await this.wpService.sendPersonalMessage(message); 
    //   if (messageStatus.status) {
    //     return new CommonResponse(true, 11108, "Message Sent Sucessfully", messageStatus)
    //   }

    // } catch (error) {
    //   return new CommonResponse(false, 11508, "Error while sending message")
    // }
  }

  async getPackingSaleOrders(): Promise<SaleOrderDropDownResponseModel> {
    try {
      const manager = getManager();
      // const saleOrderDropDownDto: SaleOrderDropDownDto[] = [];
      //retrieves all companies
      let query = `SELECT si.sale_order_id AS saleOrderId,si.po_number AS poNumber  FROM ` + appSettings.sales_db + `.so_invoice_details si WHERE si.sale_order_id IN(SELECT saleorder_id FROM ` + appSettings.procure_db + `.stock WHERE saleorder_id>0 AND physical_quantity>0) order by si.po_number`;
      const SaleOrder: SaleOrderDropDownDto[] = await manager.query(query);
      // console.log(SaleOrder);
      if (SaleOrder) {
        // saleOrderDropDownDto.push(SaleOrder);
        const response = new SaleOrderDropDownResponseModel(true, 1, 'Sale orders retrieved successfully', SaleOrder);
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }
  async getSaleOrdersCounDetail(reqObj: UserDateRequest): Promise<SoCountDetailResponse> {
    try {
      const manager = getManager();
      const query = `SELECT YEAR(invoice_date) AS finYear,MONTH(invoice_date) AS finMonth,u.plant_code, SUM(IF(so.status='OPEN' OR so.status='INPROGRESS',1,0)) AS openSos,SUM(IF(so.status='CLOSED',1,0)) AS closesSos,SUM(IF(so.status='CANCELLED',1,0)) AS cancelledSos FROM ${appSettings.sales_db}.so_invoice_details soi LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id=soi.processing_unit LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id=soi.sale_order_id WHERE soi.job_type!='Sub Job' AND so.so_process_type='MTO'  AND  DATE(invoice_date) BETWEEN '${reqObj.fromDate}' AND '${reqObj.toDate}' GROUP BY soi.processing_unit,YEAR(invoice_date),MONTH(invoice_date) ORDER BY YEAR(invoice_date),MONTH(invoice_date),soi.processing_unit`;
      const dropData: SoCountDetail[] = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new SoCountDetailResponse(true, 11108, "Sale Oreders for count retrieved successfully", dropData)
      } else {
        return new SoCountDetailResponse(true, 11108, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }

  }

  async getSaleOrdersQtyDetail(reqObj: UserDateRequest): Promise<SoQntDetailResponse> {
    try {
      const manager = getManager();
      const query = `SELECT YEAR(invoice_date) AS finYear,MONTH(invoice_date) AS finMonth,u.plant_code, 
      ROUND(SUM(IF(so.status='OPEN' OR so.status='INPROGRESS',IF(si.uom_id=1  OR si.uom_id=4,si.net_weight*si.cases*2.20462,si.net_weight*si.cases),0))*0.0005,0) AS openSos,ROUND(SUM(IF(so.status='CLOSED',IF(si.uom_id=1 OR si.uom_id=4,si.net_weight*si.cases*2.20462,si.net_weight),0))*0.0005,0) AS closesSos,ROUND(SUM(IF(so.status='CANCELLED',IF(si.uom_id=1 OR si.uom_id=4,si.net_weight*si.cases*2.20462,si.net_weight),0))*0.0005,0) AS cancelledSos FROM ${appSettings.sales_db}.sale_order_items si LEFT JOIN ${appSettings.sales_db}.so_invoice_details soi ON soi.sale_order_id=si.sale_order_id LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id=soi.processing_unit LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id=soi.sale_order_id WHERE soi.job_type!='Sub Job' AND so.so_process_type='MTO' AND DATE(invoice_date) BETWEEN '${reqObj.fromDate}' AND '${reqObj.toDate}' GROUP BY soi.processing_unit,YEAR(invoice_date),MONTH(invoice_date) ORDER BY YEAR(invoice_date),MONTH(invoice_date),soi.processing_unit`;


      const dropData: SoQntDetail[] = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new SoQntDetailResponse(true, 12108, "Sale Oreders for quantity retrieved successfully", dropData)
      } else {
        return new SoQntDetailResponse(true, 12108, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }

  async getLongRunSaleOrdersDetail(reqObj: UserDateRequest): Promise<SoLongRunResponse> {
    try {
      const manager = getManager();
      const query = `SELECT soi.po_number AS poNumber,DATE(soi.invoice_date) AS invoiceDate, DATE(soi.act_edl_date) AS actEdlDate FROM ${appSettings.sales_db}.so_invoice_details soi LEFT JOIN erpx_dev_sales.sale_order so ON soi.sale_order_id=so.sale_order_id WHERE so.status IN ('OPEN','INPROGRESS') AND soi.job_type!='Sub Job' AND so.so_process_type='MTO' and so.so_type = 'Dispatch' ORDER BY soi.invoice_date LIMIT 0,5`;

      const dropData: SoLongRunDetails[] = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new SoLongRunResponse(true, 14408, "Sale Oreders for long run sale orders retrieved successfully", dropData)
      } else {
        return new SoLongRunResponse(true, 11508, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }
  async getLongRunSoCount(reqObj: UserDateRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      const query = `SELECT COUNT(soi.po_number) AS poNumber FROM ${appSettings.sales_db}.so_invoice_details soi 
      LEFT JOIN erpx_dev_sales.sale_order so ON soi.sale_order_id=so.sale_order_id
      WHERE so.status IN ('OPEN','INPROGRESS') AND soi.job_type!='Sub Job' AND so.so_process_type='MTO' and so.so_type = 'Dispatch' ORDER BY soi.invoice_date`;
      const poCountData: SoLongRunDetails[] = await manager.query(query);
      if (poCountData) {
        return new CommonResponse(true, 14408, "Sale Oreders for long run sale orders retrieved successfully", poCountData)
      } else {
        return new CommonResponse(true, 11508, "Something went wrong")
      }
    } catch (error) {
      return error
    }
  }
  async getTopFiveSaleOrdersDetail(reqObj: UserDateRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      // const query = `SELECT soi.po_number AS poNumber,DATE(soi.invoice_date) AS invoiceDate, DATE(soi.act_edl_date) AS actEdlDate FROM ${appSettings.sales_db}.so_invoice_details soi LEFT JOIN erpx_dev_sales.sale_order so ON soi.sale_order_id=so.sale_order_id WHERE so.status IN ('CLOSED') AND soi.job_type!='Sub Job' AND so.so_process_type='MTO' ORDER BY soi.invoice_date LIMIT 0,5`;
      const query = `SELECT concat(pr.name,' ',if(fd.food_type!="N/A",fd.food_type,''),' ',if(vone.name!="N/A",vone.name,''),' ',if(vtwo.name!="N/A",vtwo.name,''),' ',if(vthree.name!="N/A",vthree.name,''),' ',if(vfour.name!="N/A",vfour.name,''),' ',if(vfive.name!="N/A",vfive.name,'')) as variantCode,COUNT(varient_id) as count,varient_id,variant_code as variant FROM ${appSettings.sales_db}.sale_order_items si
    LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.sku_code_id = si.varient_id
    LEFT JOIN ${appSettings.masters_db}.products pr ON pr.product_id=sku.product_id
    LEFT JOIN ${appSettings.masters_db}.food_types fd ON fd.food_type_id=sku.food_type_id
    LEFT JOIN ${appSettings.masters_db}.value_addition_one_types vone ON vone.value_addition_one_id=sku.value_addition_one_id
    LEFT JOIN ${appSettings.masters_db}.value_addition_two_types vtwo ON vtwo.value_addition_two_id=sku.value_addition_two_id
    LEFT JOIN ${appSettings.masters_db}.value_addition_four_types vfour ON vfour.value_addition_four_id=sku.value_addition_four_id
    LEFT JOIN ${appSettings.masters_db}.value_addition_three_types vthree ON vthree.value_addition_three_id=sku.value_addition_three_id
    LEFT JOIN ${appSettings.masters_db}.value_addition_five_types vfive ON vfive.value_addition_five_id=sku.value_addition_five_id
    GROUP BY varient_id HAVING COUNT(varient_id) >1 ORDER BY COUNT(varient_id) DESC LIMIT 0,5 `

      const dropData = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new CommonResponse(true, 14408, "Sale Oreders for fast moving products retrieved successfully", dropData)
      } else {
        return new CommonResponse(true, 11508, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }

  async getSaleOrdersComparisonDetail(reqObj: UserDateRequest): Promise<SoComparisonDetailsResponse> {
    try {
      const manager = getManager();
      const query = `SELECT YEAR(act_edl_date) AS finYear,MONTH(act_edl_date) AS finMonth,u.plant_code AS plantCode,ROUND(SUM(IF(so.status='OPEN' OR so.status='INPROGRESS',IF(si.uom_id=1 OR si.uom_id=4,si.net_weight*2.20462,si.net_weight),0))*0.0005,0) AS openSos,ROUND(SUM(IF(so.status='CLOSED',IF(si.uom_id=1 OR si.uom_id=4,si.net_weight*2.20462,si.net_weight),0))*0.0005,0) AS closesSos,ROUND(SUM(IF(so.status='CANCELLED',IF(si.uom_id=1 OR si.uom_id=4,si.net_weight*2.20462,si.net_weight),0))*0.0005,0) AS cancelledSos FROM ${appSettings.sales_db}.sale_order_items si LEFT JOIN ${appSettings.sales_db}.so_invoice_details soi ON soi.sale_order_id=si.sale_order_id LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id=soi.processing_unit
      LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id=soi.sale_order_id WHERE soi.job_type!='Sub Job' AND so.so_process_type='MTO' AND so.so_type='Dispatch'  AND  DATE(invoice_date) BETWEEN '${reqObj.fromDate}' AND '${reqObj.toDate}' GROUP BY soi.processing_unit,YEAR(act_edl_date),MONTH(act_edl_date) ORDER BY YEAR(act_edl_date),MONTH(act_edl_date),soi.processing_unit`;

      const dropData: SoComparisonDetails[] = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new SoComparisonDetailsResponse(true, 11608, "Sale Oreders for comparison retrieved successfully", dropData)
      } else {
        return new SoComparisonDetailsResponse(true, 16108, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }

  async getSaleOrdersDeadStockDetail(reqObj: UserDateRequest): Promise<SoDeadStockDetailsResponse> {
    try {
      const manager = getManager();
      const query = `SELECT concat(pr.name,' ',if(fd.food_type!="N/A",fd.food_type,''),' ',if(vone.name!="N/A",vone.name,''),' ',if(vtwo.name!="N/A",vtwo.name,''),' ',if(vthree.name!="N/A",vthree.name,''),' ',if(vfour.name!="N/A",vfour.name,''),' ',if(vfive.name!="N/A",vfive.name,'')) as variantCode,sc.variant_code AS variante,ROUND(SUM(IF(uom_id=1 OR uom_id=4,pouches*pouch_weight*2.20462,pouches*pouch_weight))) AS weightInLbs,DATE(DATE) AS date,DATEDIFF(DATE(NOW()),DATE(DATE)) AS days FROM ${appSettings.warehouse_db}.stock s LEFT JOIN ${appSettings.masters_db}.sku_codes sc ON sc.sku_code_id=s.varient_id
    LEFT JOIN ${appSettings.masters_db}.products pr ON pr.product_id=sc.product_id
    LEFT JOIN ${appSettings.masters_db}.food_types fd ON fd.food_type_id=sc.food_type_id
    LEFT JOIN ${appSettings.masters_db}.value_addition_one_types vone ON vone.value_addition_one_id=sc.value_addition_one_id
    LEFT JOIN ${appSettings.masters_db}.value_addition_two_types vtwo ON vtwo.value_addition_two_id=sc.value_addition_two_id
    LEFT JOIN ${appSettings.masters_db}.value_addition_four_types vfour ON vfour.value_addition_four_id=sc.value_addition_four_id
    LEFT JOIN ${appSettings.masters_db}.value_addition_three_types vthree ON vthree.value_addition_three_id=sc.value_addition_three_id
    LEFT JOIN ${appSettings.masters_db}.value_addition_five_types vfive ON vfive.value_addition_five_id=sc.value_addition_five_id
     WHERE total_cartons>0 AND stock_type='dummy' GROUP BY varient_id HAVING days>100 AND weightInLbs>500 ORDER BY DATE(DATE) LIMIT 0, 5`;

      const dropData: SoDeadStockDetails[] = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new SoDeadStockDetailsResponse(true, 11608, "Sale Oreders for dead stock retrieved successfully", dropData)
      } else {
        return new SoDeadStockDetailsResponse(true, 11608, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }

  async getSaleOrderYearWisePlannedDetail(reqObj: UserDateReq): Promise<SoYearWisePlanningDetailsResponse> {
    try {
      const manager = getManager();
      const query = `SELECT YEAR(act_edl_date) AS finYear,MONTH(act_edl_date) AS finMonth,u.plant_code AS plantCode, SUM(IF(so.status='OPEN' OR so.status='INPROGRESS',1,0)) AS openSos,SUM(IF(so.status='CLOSED',1,0)) AS closesSos, SUM(IF(so.status='CANCELLED',1,0)) AS cancelledSos FROM ${appSettings.sales_db}.so_invoice_details soi LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id=soi.processing_unit LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id=soi.sale_order_id WHERE soi.job_type!='Sub Job' AND so.so_process_type='MTO' AND  DATE(act_edl_date) BETWEEN '${reqObj.fromDate}' AND '${reqObj.toDate}' GROUP BY soi.processing_unit,YEAR(act_edl_date),MONTH(act_edl_date) ORDER BY YEAR(act_edl_date),MONTH(act_edl_date),soi.processing_unit`;

      const dropData: SoYearWisePlanningDetails[] = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new SoYearWisePlanningDetailsResponse(true, 116008, "Sale Oreders for planned retrieved successfully", dropData)
      } else {
        return new SoYearWisePlanningDetailsResponse(true, 116008, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }

  async getSaleOrderYearWiseShippedDetail(reqObj: UserDateRequest): Promise<SoYearWiseShippedDetailsResponse> {
    try {
      const manager = getManager();
      const query = `SELECT YEAR(dispatched_date) AS finYear,MONTH(dispatched_date) AS finMonth,u.plant_code plantCode,COUNT(*) AS dispatchCount FROM ${appSettings.sales_db}.so_invoice_details soi LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id=soi.processing_unit LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id=soi.sale_order_id LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id=soi.sale_order_id WHERE soi.job_type!='Sub Job' AND so.so_process_type='MTO' AND sot.is_dispatched=TRUE AND  DATE(dispatched_date) BETWEEN '${reqObj.fromDate}' AND '${reqObj.toDate}' GROUP BY soi.processing_unit,YEAR(dispatched_date),MONTH(dispatched_date) ORDER BY YEAR(dispatched_date),MONTH(dispatched_date),soi.processing_unit`;
      console.log(query);
      const dropData: SoYearWiseShippedDetails[] = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new SoYearWiseShippedDetailsResponse(true, 12608, "Sale Oreders for shipped retrieved successfully", dropData)
      } else {
        return new SoYearWiseShippedDetailsResponse(true, 12408, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }

  async getSaleOrderProductionStatusDetail(reqObj: UserDateRequest): Promise<SoProductionStatusDetailsResponse> {
    try {
      const manager = getManager();
      let query = `SELECT soi.po_number AS poNumber,soi.sale_order_id,si.created_at,SUM(job_cases) AS orderCases,SUM(COALESCE(reported_cases,0)) AS fgCases, ROUND(SUM(COALESCE(reported_cases,0))/SUM(job_cases)*100,2) AS completedPercentage FROM ${appSettings.sales_db}.so_invoice_details soi LEFT JOIN ${appSettings.sales_db}.sale_order_items si ON soi.sale_order_id=si.sale_order_id LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id=soi.sale_order_id WHERE so.so_process_type='MTO' AND so.status IN('OPEN','INPROGRESS') `;

      if (reqObj.fromDate != undefined) {
        query = query + ' and date(si.created_at) >= "' + reqObj.fromDate + '" and  date(si.created_at) <= "' + reqObj.toDate + '"';
      }

      query = query + ` GROUP BY si.sale_order_id ORDER BY ROUND(SUM(COALESCE(reported_cases,0))/SUM(job_cases)*100,2) DESC `;

      const dropData: SoProductionStatusDetails[] = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new SoProductionStatusDetailsResponse(true, 11678, "Sale Oreders for production status retrieved successfully", dropData)
      } else {
        return new SoProductionStatusDetailsResponse(true, 11678, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }

  async getSoProductionCompleteNotShippedDetail(reqObj: UserDateRequest): Promise<SoProductCompleteNotShippedResponse> {
    try {
      const manager = getManager();
      const query = `SELECT soi.po_number AS poNumbr,soi.sale_order_id,SUM(job_cases) AS orderCases,SUM(COALESCE(reported_cases,0)) AS fgCases, ROUND(SUM(COALESCE(reported_cases,0))/SUM(job_cases)*100,2) AS completedPercentage FROM ${appSettings.sales_db}.so_invoice_details soi LEFT JOIN ${appSettings.sales_db}.sale_order_items si ON soi.sale_order_id=si.sale_order_id LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id=soi.sale_order_id WHERE so.so_process_type='MTO' AND so.status IN('OPEN','INPROGRESS') GROUP BY si.sale_order_id HAVING completedPercentage>=100 ORDER BY ROUND(SUM(COALESCE(reported_cases,0))/SUM(job_cases)*100,2) DESC limit 0, 5`;

      const dropData: SoProductCompleteNotShipped[] = await manager.query(query);
      console.log(dropData)
      if (dropData) {
        return new SoProductCompleteNotShippedResponse(true, 71678, "Sale Oreders for production status retrieved successfully", dropData)
      } else {
        return new SoProductCompleteNotShippedResponse(true, 1678, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }

  async getSOContainerStatus(req: SoRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let containerStatus = 'Select container_status from ' + appSettings.sales_db + '.sale_order_track where sale_order_id =' + req.saleOrderId;
      const statusRes: any = await manager.query(containerStatus);
      if (statusRes) {
        const response = new CommonResponse(true, 1001, 'SO Container Status retrieved successfully. ', statusRes);
        return response;
      } else {
        const response = new CommonResponse(false, 1010, 'Status not found. ', statusRes);
        return response;
      }
    } catch (err) {
      return err;
    }
  }

  async getPackStyleForSoItem(req: SaleOrderItemRequest): Promise<CommonResponse> {
    const packstyleId: SaleOrderItems = await this.soItemRepo.findOne({ select: ['packStyleId'], where: { saleOrderItemId: req.saleOrderItemId } });
    console.log(packstyleId)
    const manager = getManager();
    const query = 'select p.packing_method_id as packingMethodId,p.packing_method_name as packStyle from ' + appSettings.masters_db + `.packing_methods p where p.packing_method_id = ` + packstyleId.packStyleId
    const packstyle = await manager.query(query)
    if (!packstyleId) {
      throw new ErrorResponse(10000, 'PackStyle Details not found');
    }
    return new CommonResponse(true, 10000, 'PackStyle Details found', packstyle);
  }

  async getTotalJobCases(req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      let manager = getManager();
      let soItemsQuery = `SELECT SUM(cases) as totCases, SUM(job_cases) as totJobCases FROM ` + appSettings.sales_db + `.sale_order_items soi where soi.sale_order_id = ${req.saleOrderId}`;
      let soData = await manager.query(soItemsQuery);
      if (soData) {
        return new CommonResponse(true, 1001, "Total cases retrived successfully. ", soData[0].totCases, soData[0].totJobCases);
      }
      else {
        return new CommonResponse(false, 1010, "no data found. ",);
      }
    }
    catch (err) {
      console.log(err);
      return err
    }
  }
  async updateSOStatus(req: SoIdRequest): Promise<CommonResponse> {
    try {
      let manager = getManager();
      const updateSaleqty = await manager.getCustomRepository(SoRepository).update({ saleOrderId: req.saleOrderId }, { status: req.status });
      if (updateSaleqty.affected > 0) {
        return new CommonResponse(true, 1001, "SO status updated successfully. ",);
      }
      else {
        return new CommonResponse(false, 1010, "something went wrong. ",);
      }
    }
    catch (error) {
      throw error
    }
  }
  async subJobReverse(req: SaleOrderIdRequest): Promise<CommonResponse> {
    const manager = new GenericTransactionManager();
    try {

      const SaleOrderResponse = await this.soRepo.findOne({
        where: {
          saleOrderId: Raw((alias) => `sale_order_id = '${req.saleOrderId}'`),
        },
      });
      await manager.startTransaction();
      if (SaleOrderResponse.status === SoStatusEnum.OPEN || SaleOrderResponse.status === SoStatusEnum.IN_PROGRESS) {
        const getMainJob = await this.soInvRepo.findOne({ where: { poNumber: req.poNumber, saleOrderId: Not(req.saleOrderId) } });
        console.log(getMainJob);
        const cancelSubJob = await manager.getCustomRepository(SoRepository).update({ saleOrderId: req.saleOrderId }, { status: SoStatusEnum.CANCELLED });
        console.log(cancelSubJob);
        if (cancelSubJob.affected > 0) {
          let getSubJobCases = await this.soItemRepo.find({ saleOrderId: req.saleOrderId });
          let getMainJobCases = await this.soItemRepo.find({ saleOrderId: getMainJob.saleOrderId });
          let flag: boolean = false;
          for (const ress of getSubJobCases) {
            let updateJobCases = await this.soItemRepo.update({ saleOrderId: getMainJob.saleOrderId, mainSoItemId: ress.mainSoItemId }, { jobCases: () => `job_cases+${ress.jobCases}` })
            console.log(updateJobCases)
            if (updateJobCases.affected > 0) {
              flag = true;
            }
            else {
              manager.releaseTransaction();
              return new CommonResponse(false, 1001, "Job cases not updated,something went wrong. ",)
            }
          }
          if (flag) {
            const mainJobBom = await manager.getCustomRepository(BomRepository).findOne({ saleOrderId: getMainJob.saleOrderId, packingCategory: null });
            const subJobBom = await manager.getCustomRepository(BomRepository).findOne({ saleOrderId: req.saleOrderId, packingCategory: null });
            const subJobRMBomLog = await manager.getCustomRepository(BomRepository).findOne({ saleOrderId: req.saleOrderId });


            const subJobRMBomLogUpdate = await manager.getCustomRepository(RmBomLogRepository).update({ saleOrderId: req.saleOrderId }, { isActive: false });
            const subJobRMBomLogQtyUpdate = await manager.getCustomRepository(BomRepository).update({ saleOrderId: getMainJob.saleOrderId }, { quantity: () => `quantity+${subJobRMBomLog.quantity}` });
            const subJobBomUpdate = await manager.getCustomRepository(BomRepository).update({ saleOrderId: req.saleOrderId }, { status: StatusEnum.CANCELLED, isActive: false });
            const mainJobBomUpdate = await manager.getCustomRepository(BomRepository).update({ saleOrderId: getMainJob.saleOrderId }, { requiredQuantity: () => `required_qty+${subJobBom.requiredQuantity}`, quantity: () => `quantity+${subJobBom.quantity}` });

            if (subJobRMBomLogUpdate.affected > 0 && subJobRMBomLogQtyUpdate.affected > 0 && subJobBomUpdate.affected > 0 && mainJobBomUpdate.affected > 0) {
              await manager.completeTransaction();
              const resp = new CommonResponse(true, 1001, "Sub Job reversed successfully. ",)
              // const newLogDto = new LogsDto(1,'sub job reversed', 'sale order', SaleOrderResponse.saleOrderId, true, '',SaleOrderResponse.createdUser)
              // let res = await this.logService.createLog(newLogDto);
              // console.log(res);
              return resp
            }
          }
          else {
            await manager.releaseTransaction();
            return new CommonResponse(false, 1010, "Item Job cases not updated, something went wrong. ",)
          }

        }
        else {
          await manager.releaseTransaction();
          return new CommonResponse(false, 1010, "Sub job reverse,something went wrong. ",)
        }
      }
      else {
        return new CommonResponse(false, 1010, "sub job not updated, something went wrong. ",);
      }
    }
    catch (error) {
      await manager.releaseTransaction();
      throw error
    }
  }

  //cron job service to dump sale sand saleorderitems into analytics db
  async saledataDump(): Promise<CommonResponse> {
    let manager = getManager();
    try {


      var mysql = require('mysql');

      var con = mysql.createConnection({
        host: "206.189.138.212",
        user: "sa_dev_user",
        password: "R@ms1905",
        // database: "erpx_dev_sales"
      });


      let soIds = []

      // const delsoItemsDataqry = `truncate TABLE `+appSettings.analytics_db +`.sale_order_items`;
      // const delsoData =  await manager.query(delsoItemsDataqry)
      // const delsoDataqry = `truncate TABLE `+appSettings.analytics_db +`.sale_order`;
      // const delsoItemsData =  await manager.query(delsoDataqry)
      // const noSalesDataQry = `Select sale_order_id from ` + appSettings.analytics_db +`.sale_order`;
      // const soData = await manager.query(noSalesDataQry)
      // for(const item of soData){
      //   soIds.push(item.sale_order_id)
      // }
      console.log('soIds');
      console.log(soIds);
      const notExistedIds = con.query("select *,uc.unit_name as manfacturingUnit,puc.unit_name as processingUnit from erpx_dev_sales.sale_order so left join erpx_dev_sales.so_invoice_details soi on so.sale_order_id = soi.sale_order_id left join erpx_dev_sales.so_po_details sopo on so.sale_order_id = sopo.sale_order_id left join erpx_dev_sales.sale_order_track sot on so.sale_order_id = sot.sale_order_id left join erpx_dev_masters.delivery_terms det on det.delivery_terms_id = soi.del_terms left join erpx_dev_masters.end_customers ec on ec.end_customer_id = soi.end_customer_id left join erpx_dev_masters.customers cs on cs.cust_id = soi.customer_id left join erpx_dev_masters.countries c on c.country_id = soi.country_id left join erpx_dev_masters.certificates ct on ct.certificate_id = sopo.certification_id left join erpx_dev_masters.destination d on d.destination_id = soi.destination left join erpx_dev_masters.payment_terms pt on pt.payment_terms_id = soi.pay_terms_id left join erpx_dev_masters.shipping_terms st on st.shipping_term_id = soi.shipment_terms left join erpx_dev_masters.employee_details ed on ed.employee_id = soi.emp_id left join erpx_dev_masters.currencies cc on cc.currency_id = soi.currency_id left join erpx_dev_masters.unitcodes uc on uc.unit_code_id = soi.factoryId left join erpx_dev_masters.unitcodes puc on puc.unit_code_id = soi.processing_unit ", async function (err, result, fields) {
        if (err) throw err;
        console.log('resultddd');
        console.log(result);
        let setFlag = new Set<boolean>();
        for (const idData of result) {
          const socreatedAt = idData.created_at ? "'" + moment(idData.created_at).format('YYYY-MM-DD hh:mm:ss') + "'" : null
          const updatedAt = idData.updated_at ? "'" + moment(idData.updated_at).format('YYYY-MM-DD hh:mm:ss') + "'" : null
          const invDate = idData.invoice_date ? "'" + moment(idData.invoice_date).format('YYYY-MM-DD') + "'" : null
          const edaDate = idData.eda_date ? "'" + moment(idData.eda_date).format('YYYY-MM-DD') + "'" : null
          const actEdlDate = idData.act_edl_date ? "'" + moment(idData.act_edl_date).format('YYYY-MM-DD') + "'" : null
          const edlDate = idData.edl_date ? "'" + moment(idData.edl_date).format('YYYY-MM-DD') + "'" : null
          const dispatchDate = idData.dispatchDate ? "'" + moment(idData.dispatchDate).format('YYYY-MM-DD hh:mm:ss') + "'" : null
          const stockReportedDate = idData.stockReportedDate ? "'" + moment(idData.stockReportedDate).format('YYYY-MM-DD hh:mm:ss') + "'" : null
          const prodCompletionDate = idData.prodCompletionDate ? "'" + moment(idData.prodCompletionDate).format('YYYY-MM-DD hh:mm:ss') + "'" : null

          const insertqry = `INSERT INTO ` + appSettings.analytics_db + `. sale_order(sale_order_id,sale_order_no,is_active,created_at,created_user,updated_at,updated_user,version_flag,status,is_invoiced,so_process_type,so_type,po_number,invoice_date,eda_date,act_edl_date,edl_date,cus_address,category,del_address,buyer_po_number,stock_reported_date,job_type,is_sub_contract,reserved_per,port_of_entry,delivery_terms,end_customer,customer,country,destination_name,pay_terms,shipping_terms,emp_name,currency,manufacturing_unit,processing_unit,rating,brand_type,lab_inspection,laod_inpection,lotCode,is_brand_approved,is_certified,additional_note,certification,container_status,bl_status,doc_status,so_status,qc_status,pm_status,invoice_status,rm_status,fg_status,production_status,is_dispatched,dispatched_date,production_completed,prod_completed_date,production_percentage) values(${idData.sale_order_id},'${idData.sale_order_no}',${idData.is_active},${socreatedAt},'${idData.created_user}',${updatedAt},'${idData.updated_user}',${idData.version_flag},'${idData.status}','${idData.is_invoiced}','${idData.so_process_type}','${idData.so_type}','${idData.po_number}',${invDate},${edaDate},${actEdlDate},${edlDate},"${idData.cus_address}",'${idData.category}',"${idData.del_address}",'${idData.buyer_po_number}',${stockReportedDate},'${idData.job_type}','${idData.is_sub_contract}',${idData.reserved_per},${idData.port_of_entry},'${idData.delivery_terms_name}','${idData.end_customer_name}','${idData.client_name}','${idData.county_name}','${idData.destination_name}','${idData.payment_terms_name}','${idData.shipping_term_name}','${idData.employee_name}','${idData.currency_name}','${idData.manfacturingUnit}','${idData.processingUnit}',${idData.rating},'${idData.brandType}','${idData.labInspection}',${idData.laod_inpection},'${idData.lotCode}','${idData.is_brand_approved}','${idData.is_certified}',"${idData.additional_note}",'${idData.certificate_name}','${idData.container_status}','${idData.bl_status}','${idData.doc_status}','${idData.so_status}','${idData.qc_status}','${idData.pm_status}','${idData.invoice_status}','${idData.rm_status}','${idData.fg_status}','${idData.production_status}','${idData.is_dispatched}',${dispatchDate},${idData.production_completed},${prodCompletionDate},${idData.production_percentage})`
          const insertData = await manager.query(insertqry)
          console.log(insertData);
          if (insertData.affectedRows > 0) {
            setFlag.add(true)
          } else {
            setFlag.add(false)
            break;
          }
        }
        if (!setFlag.has(false)) {
          const soitemsData = con.query("select soi.*,p.name as product,ft.food_type,vone.name as vonename,vtwo.name as vtwoname,vthree.name as vthreename,vfour.name as vfourname,vfive.name as vfivename,sk.variant_code,um.uom_name,b.brand_name,mb.brand_name as masterBrand,s.size_name,pm.packing_method_name from erpx_dev_sales.sale_order_items soi left join erpx_dev_masters.products p on p.product_id = soi.item_id left join erpx_dev_masters.food_types ft on ft.food_type_id = soi.food_type_id left join erpx_dev_masters.value_addition_one_types vone on vone.value_addition_one_id = soi.value_addition_one_id left join erpx_dev_masters.value_addition_two_types vtwo on vtwo.value_addition_two_id = soi.value_addition_two_id left join erpx_dev_masters.value_addition_three_types vthree on vthree.value_addition_three_id = soi.value_addition_three_id left join erpx_dev_masters.value_addition_four_types vfour on vfour.value_addition_four_id = soi.value_addition_four_id left join erpx_dev_masters.value_addition_five_types vfive on vfive.value_addition_five_id = soi.value_addition_five_id left join erpx_dev_masters.sku_codes sk on sk.sku_code_id = soi.varient_id left join erpx_dev_masters.uoms um on um.uom_id = soi.uom_id left join erpx_dev_masters.brands b on b.brand_id = soi.brand_id left join erpx_dev_masters.master_brands mb on mb.master_brand_id = soi.master_brand_id left join erpx_dev_masters.sizes s on s.size_id = soi.inner_bag_size_id left join erpx_dev_masters.packing_methods pm on pm.packing_method_id = soi.pack_style_id", async function (err, results, fields) {
            console.log(results)
            if (err) throw err
            let soitemFlagSet = new Set<boolean>()
            for (const soItem of results) {
              const soItemcreatedAt = soItem.created_at ? "'" + moment(soItem.created_at).format('YYYY-MM-DD hh:mm:ss') + "'" : null
              const soItemupdatedAt = soItem.updated_at ? "'" + moment(soItem.updated_at).format('YYYY-MM-DD hh:mm:ss') + "'" : null
              const reportedDate = soItem.reported_date ? "'" + moment(soItem.reported_date).format('YYYY-MM-DD hh:mm:ss') + "'" : null
              const insertSoItemsQry = `insert into ` + appSettings.analytics_db + `.sale_order_items(sale_order_item_id,sale_order_id,max_grade,min_grade,cases,pouches,min_glaze,max_glaze,soaking_time,soaking_style,style_weighment,hl_per,is_active,created_at,created_user,updated_at,updated_user,version_flag,final_percentage,inner_bags,shrimp_weight,net_amount,unitPrice,pouch_weight,case_weight,net_weight,reported_cases,dispatched_qty,invoiced_qty,revised_price,inv_amount,invoicedCases,reported_date,gross_weight_per_kg,total_gross_weight,requiredCount,category,job_cases,main_so_item_id,product,food_type,val_addition_one,val_addition_two,val_addition_three,val_addition_four,val_addition_five,variant,uom,brand,master_brand,pack_style,inner_bag_size,pallet_capacity) values(${soItem.sale_order_item_id},${soItem.sale_order_id},${soItem.max_grade_id},${soItem.min_grade_id},${soItem.cases},${soItem.pouches},${soItem.min_glaze},${soItem.max_glaze},'${soItem.soaking_time}','${soItem.soaking_style}','${soItem.style_weighment}',${soItem.hl_per},${soItem.is_active},${soItemcreatedAt},'${soItem.created_user}',${soItemupdatedAt},'${soItem.updated_user}',${soItem.version_flag},${soItem.final_percentage},${soItem.inner_bags},${soItem.shrimp_weight},${soItem.net_amount},${soItem.unitPrice},${soItem.pouch_weight},${soItem.case_weight},${soItem.net_weight},${soItem.reported_cases},${soItem.dispatched_qty},${soItem.invoiced_qty},${soItem.revised_price},${soItem.inv_amount},${soItem.invoicedCases},${reportedDate},${soItem.gross_weight_per_kg},${soItem.total_gross_weight},${soItem.requiredCount},'${soItem.category}',${soItem.job_cases},${soItem.main_so_item_id},'${soItem.product}','${soItem.food_type}','${soItem.vonename}','${soItem.vtwoname}','${soItem.vthreename}','${soItem.vfourname}','${soItem.vfivename}','${soItem.variant_code}','${soItem.uom_name}',"${soItem.brand_name}","${soItem.brand_name}",'${soItem.packing_method_name}','${soItem.size_name}',${soItem.pallet_capacity})`
              const insertSoItems = await manager.query(insertSoItemsQry)
              if (insertSoItems.affectedRows > 0) {
                soitemFlagSet.add(true)
              } else {
                soitemFlagSet.add(false)
                break;
              }
            }
            if (!soitemFlagSet.has(false)) {
              return new CommonResponse(true, 555, 'success')
            } else {
              await manager.release()
              return new CommonResponse(false, 123, 'fail in so items insertion')
            }
          })
        } else {
          await manager.release()
          return new CommonResponse(true, 555, 'fail in so insertion')
        }

      })
    } catch (err) {
      await manager.release()
      return new CommonResponse(false, 334, err)

    }
  }


  //cron job service to update sales life cycle status in sales table
  async updateSalesLifeCycleStatus(): Promise<CommonResponse> {
    const manager = new GenericTransactionManager();
    try {
      await manager.startTransaction();
      //workinprogress when Packing PO created or stock assigned or RM procured
      const soData = await manager.getCustomRepository(SoRepository).find({ relations: ["SoInvDetailsInfo", "SoPoDetailsInfo", "soTrackData"]})
      console.log('soData')
      console.log(soData)
      let updateFlag = new Set<boolean>()
      for (const [index, item] of soData.entries()) {
        const PoexistWithSo = await this.purchaseOrderService.getPoItemDetailsForSaleId({ saleOrderId: item.saleOrderId })
        const saleOrderIdRequest = new SaleOrderIdRequest();
        saleOrderIdRequest.saleOrderId = item.saleOrderId
        saleOrderIdRequest.plantId = null
        saleOrderIdRequest.itemId = null
        saleOrderIdRequest.poNumber = null
        saleOrderIdRequest.stockType = null
        const isQtyassigned = await this.bomRepo.isStockAssignedForSO(saleOrderIdRequest)
        console.log('isQtyassigned')
        console.log(isQtyassigned)
        let saleStatus = SoLifeCycleStatusEnum.OPEN
        if (PoexistWithSo.status || isQtyassigned.status) {
          saleStatus = SoLifeCycleStatusEnum.WORK_IN_PROGRESS
        }
        //need to include rm done or not after implementation of production

        if (PoexistWithSo.status == false && isQtyassigned.status == false) {
          saleStatus = SoLifeCycleStatusEnum.NOT_STARTED
        }

        //partially completed status when 100% shipment not in W/H
        const soItemData = await this.getProductForSoId(saleOrderIdRequest)
        if (soItemData.status) {
          let stockflag = new Set<boolean>()
          for (const item of soItemData.data) {
            if (item.reportedCases < item.jobCases) {
              stockflag.add(false)
              break;
            } else {
              stockflag.add(true)
            }
          }
          if (stockflag.has(false)) {
            saleStatus = SoLifeCycleStatusEnum.PARTIALLY_COMPLETED;
          }

          //shipment pending status when 100% Stock in W/H but not shipped
          if (!stockflag.has(false) && item.soTrackData.containerStatus != ContainerStatusEnum.SHIPPED) {
            saleStatus = SoLifeCycleStatusEnum.SHIPMENT_PENDINGS;
          }

          
          //pending for container status when 70% of production completed, Container not booked
          if (item.soTrackData.productionPercentage >= 70 && item.soTrackData.containerStatus != ContainerStatusEnum.BOOKED) {
            saleStatus = SoLifeCycleStatusEnum.PENDING_FOR_CONTAINER_SLOT;
          }
          //ready for container slot when 70% of production completed, Container booked
          if (item.soTrackData.productionPercentage >= 70 && item.soTrackData.containerStatus == ContainerStatusEnum.BOOKED) {
            saleStatus = SoLifeCycleStatusEnum.WAITING_FOR_CONTAINER;
          }
          if (item.soTrackData.containerStatus == ContainerStatusEnum.LOADED_AND_SEALED) {
            saleStatus = SoLifeCycleStatusEnum.LOADED_AND_SEALED;
          }
          //status when Shipped but not closed
          if (item.soTrackData.containerStatus == ContainerStatusEnum.SHIPPED && item.status != SoStatusEnum.CLOSED) {
            saleStatus = SoLifeCycleStatusEnum.SHIPPED_BUT_NOT_CLOSED;
          }
          //inspection status
          const inspectiondata = await this.getSoInspectionData(saleOrderIdRequest)
          if (inspectiondata.status) {
            let inspectionFalg = new Set<string>()
            for (const inspectiondataItem of inspectiondata.data) {
              if (inspectiondataItem.inspectionStatus == InspectionStatusEnum.OPEN) {
                inspectionFalg.add('Open')
              } else if (inspectiondataItem.inspectionStatus == InspectionStatusEnum.INITIATED) {
                inspectionFalg.add('initiated')
                break
              } else {
                inspectionFalg.add('done')
              }
            }
            //ready for inspection when 70% of production completed, inspection not triggered  
            if (inspectionFalg.has('open') && item.soTrackData.productionPercentage >= 70) {
              saleStatus = SoLifeCycleStatusEnum.READY_FOR_INSPECTION
            }
            //ready for inspection when 70% of production completed, inspection not done 
            if (inspectionFalg.has('initiated') && item.soTrackData.productionPercentage >= 70) {
              saleStatus = SoLifeCycleStatusEnum.PENDING_FOR_INSPECTION
            }
            if (inspectionFalg.has('open') && item.soTrackData.productionPercentage >= 70 && item.soTrackData.productionPercentage >= 70 && item.soTrackData.containerStatus != ContainerStatusEnum.BOOKED) {
              saleStatus = SoLifeCycleStatusEnum.READY_FOR_INSPECTION_AND_PENDING_FOR_CONTAINER_SLOT
            }
            if (inspectionFalg.has('initiated') && item.soTrackData.productionPercentage >= 70 && item.soTrackData.productionPercentage >= 70 && item.soTrackData.containerStatus == ContainerStatusEnum.BOOKED) {
              saleStatus = SoLifeCycleStatusEnum.PENDING_FOR_INSPECTION_AND_CONTAINER_BOOKED;
            }
            // //insidePlant
            // if (item.soTrackData.productionPercentage >= 70 && (item.soTrackData.productionPercentage >= 70 && (item.soTrackData.containerStatus == ContainerStatusEnum.OPEN ||item.soTrackData.containerStatus == ContainerStatusEnum.READY_TO_BOOK || item.soTrackData.containerStatus == ContainerStatusEnum.BOOKED || item.soTrackData.containerStatus == ContainerStatusEnum.DISPATCHED_TO_PLANT  ))) {
            //   saleStatus = SoLifeCycleStatusEnum.INSIDE_PLANT;
            // }
          }

        } else {
          throw new ErrorResponse(9994, 'reported cases not retrived')
        }
        //risk1 when Lead time 12 days
        let saleETD = item.SoInvDetailsInfo.actualEdldate ? new Date("'" + item.SoInvDetailsInfo.actualEdldate + "'") : null;
        if (saleETD) {
          // if(item.soTrackData.dispatchedDate){
          //   console.log('saleETDddd')
          //   console.log(moment(saleETD).format('YYYY-MM-DD'))
          //   console.log(moment(item.soTrackData.dispatchedDate).format('YYYY-MM-DD'))
          //   if(moment(saleETD).format('YYYY-MM-DD') > moment(item.soTrackData.dispatchedDate).format('YYYY-MM-DD')){
          //     console.log('greater')
          //   }
          //   if(moment(saleETD).format('YYYY-MM-DD') == moment(item.soTrackData.dispatchedDate).format('YYYY-MM-DD')){
          //     console.log('equal')
          //   }
          //   if(moment(saleETD).format('YYYY-MM-DD') < moment(item.soTrackData.dispatchedDate).format('YYYY-MM-DD')){
          //     console.log('less')
          //   }
          // }
          const currentDate = new Date();
          var diffTime = Math.abs(saleETD.getTime() - currentDate.getTime());
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays <= 12 && item.status != SoStatusEnum.CLOSED && item.soTrackData.productionPercentage == 0) {
            saleStatus = SoLifeCycleStatusEnum.Risk1
          }
          //early shipped when shipped before ETD
          if (item.soTrackData.dispatchedDate && (moment(item.soTrackData.dispatchedDate).format('YYYY-MM-DD') < moment(saleETD).format('YYYY-MM-DD')) && item.status != SoStatusEnum.CLOSED && item.soTrackData.containerStatus == ContainerStatusEnum.SHIPPED) {
            saleStatus = SoLifeCycleStatusEnum.EARLY_SHIPMENT;
          }

          //ontime shipped when shipped on ETD
          console.log()
          if (item.soTrackData.dispatchedDate && (moment(item.soTrackData.dispatchedDate).format('YYYY-MM-DD') == moment(saleETD).format('YYYY-MM-DD')) && item.status != SoStatusEnum.CLOSED && item.soTrackData.containerStatus == ContainerStatusEnum.SHIPPED) {
            saleStatus = SoLifeCycleStatusEnum.ON_TIME_SHIPMENT;
          }

          //delay shipped when shipped after ETD
          if (item.soTrackData.dispatchedDate && (moment(item.soTrackData.dispatchedDate).format('YYYY-MM-DD') > moment(saleETD).format('YYYY-MM-DD')) && item.status != SoStatusEnum.CLOSED && item.soTrackData.containerStatus == ContainerStatusEnum.SHIPPED) {
            saleStatus = SoLifeCycleStatusEnum.DELAY_SHIPMENT;
          }
        }
        //
        if (item.status == SoStatusEnum.CLOSED) {
          saleStatus = SoLifeCycleStatusEnum.CLOSED;
        }
        const updateSO = await manager.getCustomRepository(SoRepository).update({ saleOrderId: item.saleOrderId }, { lifeCyclestatus: saleStatus })

        if (updateSO.affected) {
          updateFlag.add(true)
        } else {
          updateFlag.add(false)
          break
        }
      }
      if (!updateFlag.has(false)) {
        await manager.completeTransaction()
        return new CommonResponse(true, 999, 'updated')
      } else {
        await manager.releaseTransaction()
        return new CommonResponse(false, 111, 'update failed')
      }
    } catch (err) {
      await manager.releaseTransaction()
      return new CommonResponse(false, 522, err)
    }
  }

  async getSoLifeCycleStatusCount(req: UnitRequest): Promise<CommonResponse> {
    let manager = getManager();
    let allsttausvalues = Object.values(SoLifeCycleStatusEnum)
    let dataArry = []
    for (const [index, allsttausvaluesItem] of allsttausvalues.entries()) {
      let saleDataQry = `SELECT life_cycle_status, SUM(kakinada) as kakinada, SUM(Unit1) as unit1, SUM(Unit2) as unit2 ,processing_unit FROM (
      SELECT life_cycle_status,processing_unit,
      IF(soi.processing_unit=1,COUNT(1),0) AS kakinada,
      IF(soi.processing_unit=2,COUNT(1),0) AS Unit1,
      IF(soi.processing_unit=3,COUNT(1),0) AS Unit2 
      FROM sale_order so
      LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soi ON soi.sale_order_id = so.sale_order_id GROUP BY life_cycle_status,processing_unit
      ) AS sd where life_cycle_status = '`+ allsttausvaluesItem + `'`;
      if (req.unitId && req.unitId != 5) {
        saleDataQry += ` and sd.processing_unit=` + req.unitId;
      }
      // saleDataQry +=  ` GROUP BY life_cycle_status`;
      const statusCounts = await manager.query(saleDataQry)
      if (!statusCounts[0].life_cycle_status) {
        statusCounts[0].life_cycle_status = allsttausvaluesItem
        statusCounts[0].kakinada = 0
        statusCounts[0].unit1 = 0
        statusCounts[0].unit2 = 0
      }
      dataArry.push(statusCounts[0])
    }
    if (dataArry.length > 0) {
      return new CommonResponse(true, 5555, 'data retrived', dataArry)
    } else {
      return new CommonResponse(false, 5555, 'data not found')
    }
  }

  async endcustomerWiseMonthlySOCount(req?: EndCustomerReq): Promise<CommonResponse> {
    console.log(req)
    const fromDate = moment(req.fromDate).format('YYYY-MM-DD')
    const toDate = moment(req.toDate).format('YYYY-MM-DD')
    console.log(fromDate)
    // resArray = []
    let manager = getManager();
    let query
    query = `SELECT SUM(IF(MONTH(act_edl_date) = 1,1,0)) AS Jan, SUM(IF(MONTH(act_edl_date) = 2,1,0)) AS Feb,
    SUM(IF(MONTH(act_edl_date) = 3,1,0)) AS Mar, SUM(IF(MONTH(act_edl_date) = 4,1,0)) AS Apl,
    SUM(IF(MONTH(act_edl_date) = 5,1,0)) AS May, SUM(IF(MONTH(act_edl_date) = 6,1,0)) AS Jun,
    SUM(IF(MONTH(act_edl_date) = 7,1,0)) AS Jul, SUM(IF(MONTH(act_edl_date) = 8,1,0)) AS Aug,
    SUM(IF(MONTH(act_edl_date) = 9,1,0)) AS Sep, SUM(IF(MONTH(act_edl_date) = 10,1,0)) AS Oct,
    SUM(IF(MONTH(act_edl_date) = 11,1,0)) AS Nov, SUM(IF(MONTH(act_edl_date) = 12,1,0)) AS Decm
     FROM `+ appSettings.sales_db + `.so_invoice_details soi
    left join ` + appSettings.sales_db + `.sale_order so on so.sale_order_id = soi.sale_order_id  WHERE so.status != 'CANCELLED' `
    if (req.unitId) {
      query = query + ` and soi.processing_unit = ` + req.unitId
    }
    if (req.endCustomerId) {
      query = query + ` and soi.end_customer_id = ` + req.endCustomerId;
    }
    if (req.fromDate && req.toDate) {
      query = query + ' and date(soi.act_edl_date) between "' + fromDate + '" and "' + toDate + '"';
    }

    const data = await manager.query(query);

    if (data.length > 0) {
      return new CommonResponse(true, 5555, 'data retrived', data)
    } else {
      return new CommonResponse(false, 5555, 'data not found')
    }
  }

  async getSoDropForSubJob(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT si.sale_order_id AS saleOrderId ,si.po_number AS poNumber,si.job_type AS subjob ,si.processing_unit AS unit FROM ` + appSettings.sales_db + `.so_invoice_details si 
    WHERE si.job_type = 'Sub Job' AND si.sale_order_id> 0 and si.processing_unit > 0` ;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and si.processing_unit = ' + req.unitId;
    }
    query = query + ` GROUP BY si.po_number  ORDER BY poNumber `;
    console.log(query);
    const data = await manager.query(query);
    if (data) {
      const result = new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
      // const newLogDto = new LogsDto(1,'view', 'Countries', 0, true, '','')
      //       let res = await this.logService.createLog(newLogDto);
      //       console.log(res);
            return result
    } else {
      return new CommonResponse(false, 1111, 'No data')
    }
  }
  async editSubJob(req: SubJobRequest): Promise<CommonResponse> {
    console.log(req, 'reqsubjob')
    const manager = new GenericTransactionManager()
    try {
      await manager.startTransaction();
      if (req.itemDetails.length > 0) {
        let saveFlag = new Set<boolean>()
        let msg:string = ''
        for (const subJobDataItem of req.itemDetails) {
          if (subJobDataItem.operationType == 'Add') {
            const updatesubJobQty = await manager.getCustomRepository(SoItemRepository).update({ saleOrderItemId: subJobDataItem.soItemId }, { jobCases: () => `job_cases+${subJobDataItem.cases}` })
            if (updatesubJobQty.affected) {

              const updatemainJobQty = await manager.getCustomRepository(SoItemRepository).update({ mainSoItemId: subJobDataItem.mainSoItemId, saleOrderItemId: Not(subJobDataItem.soItemId) }, { jobCases: () => `job_cases-${subJobDataItem.cases}` })
              if (updatemainJobQty.affected) {
                console.log('tracecodes')
                console.log(util.inspect(req.traceCodesData, false, null, true));
                // const codeListUpdate = await this.codeListService.updateCodeListFromSubJobRevision(new SubJobReviseRequest(req.traceCodesData, req.createdUser));
                // if (codeListUpdate.status) {
                //   saveFlag.add(true)
                //   msg = 'updated successfully'
                //   // await manager.completeTransaction();
                //   // return new CommonResponse(true, 2222, 'updated successfully')
                // } else {
                //   saveFlag.add(false)
                //   msg = 'something went wrong in update code list'
                //   break

                //   // await manager.releaseTransaction();
                //   // return new CommonResponse(false, 2222, 'something went wrong in update code list')
                // }
              } else {
                saveFlag.add(false)
                msg = 'something went wrong in update main job'
                  break
                // await manager.releaseTransaction();
                // return new CommonResponse(false, 2222, 'something went wrong in update main job')
              }
            } else {
              saveFlag.add(false)
              msg = 'something went wrong in update sub job'
              break
              // await manager.releaseTransaction();
              // return new CommonResponse(false, 2222, 'something went wrong in update sub job')
            }
          }
          if (subJobDataItem.operationType == 'Substraction') {
            const updatesubJobQty = await manager.getCustomRepository(SoItemRepository).update({ saleOrderItemId: subJobDataItem.soItemId }, { jobCases: () => `job_cases-${subJobDataItem.cases}` })
            if (updatesubJobQty.affected) {
              const updatemainJobQty = await manager.getCustomRepository(SoItemRepository).update({ mainSoItemId: subJobDataItem.mainSoItemId, saleOrderItemId: Not(subJobDataItem.soItemId) }, { jobCases: () => `job_cases+${subJobDataItem.cases}` })
              if (updatemainJobQty.affected) {
                // const codeListUpdate = await this.codeListService.updateCodeListFromSubJobRevision(new SubJobReviseRequest(req.traceCodesData, req.createdUser));
                // if (codeListUpdate.status) {
                //   saveFlag.add(true)
                //   msg = 'updated successfully'

                //   // await manager.completeTransaction();
                //   // return new CommonResponse(true, 2222, 'updated successfully')
                // } else {
                //   saveFlag.add(false)
                //   msg = 'something went wrong in update code list'
                //   break
                //   // await manager.releaseTransaction();
                //   // return new CommonResponse(false, 2222, 'something went wrong in update code list')
                // }
              } else {
                saveFlag.add(false)
                msg = 'something went wrong in update main job'
                  break
                // await manager.releaseTransaction();
                // return new CommonResponse(false, 2222, 'something went wrong in update main job')
              }
            } else {
              saveFlag.add(false)
              msg = 'something went wrong in update sub job'
              break
              // await manager.releaseTransaction();
              // return new CommonResponse(false, 2222, 'something went wrong in update sub job')
            }
          }
        }
        if(!saveFlag.has(false)){
          const codeListUpdate = await this.codeListService.updateCodeListFromSubJobRevision(new SubJobReviseRequest(req.traceCodesData, req.createdUser));
          if(codeListUpdate.status){
            await manager.completeTransaction();
            return new CommonResponse(true, 2222,msg)
          }else{
            await manager.releaseTransaction();
            return new CommonResponse(true, 2222,'something went wrong in code list update' )
          }
        }else{
          await manager.releaseTransaction();
          return new CommonResponse(true, 2222,msg)
        }
      }
    } catch (err) {
      await manager.releaseTransaction();
      return new CommonResponse(false, 2222, err)
    }
  }
  async getBrandsForSoId(req: SaleOrderIdRequest): Promise<CommonResponse> {
    let manager = getManager();
    try {
      let query = "Select mb.master_brand_id AS masterBrandId, mb.brand_name AS brandName, si.sale_order_item_id AS saleOrderItemId from " + appSettings.sales_db + ".sale_order_items si left join " + appSettings.masters_db + ".master_brands mb on mb.master_brand_id = si.master_brand_id where si.sale_order_id =" + req.saleOrderId + " group by mb.master_brand_id";
      const data = await manager.query(query);
      if (data.length > 0) {
        return new CommonResponse(true, 1001, 'data retrived', data)
      }
      else {
        return new CommonResponse(false, 1010, 'no data found',)
      }
    }
    catch (err) {
      await manager.release();
      return new CommonResponse(false, 2222, err)
    }
  }

  async stockAdjustmentReport(): Promise<CommonResponse> {
    try {
      let manager = getManager();
      const itemWiseBomQry = `SELECT pb.sale_order_id,soi.act_edl_date,pb.sale_order_item_id,pb.item_id,soi.po_number,soit.varient_id,sk.variant_code,it.item_name,po_quantity,assigned_quantity,
      IF((quantity-po_quantity-assigned_quantity)>0,(quantity-po_quantity-assigned_quantity),0) AS requiredQty
       FROM `+ appSettings.sales_db + `.packing_bom_log pb
      LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details soi ON soi.sale_order_id = pb.sale_order_id
      LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON so.sale_order_id = pb.sale_order_id
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_items soit ON pb.sale_order_id = soit.sale_order_id and pb.sale_order_item_id = soit.sale_order_item_id
      LEFT JOIN `+ appSettings.masters_db + `.sku_codes sk ON soit.varient_id = sk.sku_code_id
      LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = pb.item_id
      where soi.act_edl_date is not null
      ORDER BY so.so_type,soi.act_edl_date`;
      const itemWiseBom = await manager.query(itemWiseBomQry)
      console.log('itemWiseBom')
      console.log(itemWiseBom)
      for (const dataItem of itemWiseBom) {

      }

    } catch (err) {
      return new CommonResponse(false, 2222, err)
    }
  }

  async getShipmentsCount(): Promise<CommonResponse> {
    try {
      const manager = getManager()
      const shippedOrdersCount = `select * count(sale_order_id) as count from ` + appSettings.sales_db + `.sale_order_track WHERE so_status = 'SHIPPED'`
      const data = await manager.query(shippedOrdersCount);

      return data
    } catch (error) {
      return error
    }
  }


  async getSaleOrderItemDetailsBySoId(req: SaleOrderIdRequest): Promise<SaleOrderItemsDetailsResponseModel> {
    try {
      const response = await this.soItemRepo.find({ saleOrderId: req.saleOrderId });
      const soInvData = await this.soInvRepo.find({ saleOrderId: req.saleOrderId });
      let brandIdMap = new Map<number, String>();
      let productIdMap = new Map<number, String>();
      let variantIdMap = new Map<number, String>();


      console.log(response)
      let responseData: SaleOrderItemsDTO[] = [];
      const manager = getManager();
      for (const item of response) {

        let uom = '';
        let maxPalletCapacity;
        if (item.uomId === undefined) {
          uom = "";
        }
        else if (item.uomId === 1) {
          uom = 'KG';
        }
        else if (item.uomId === 2) {
          uom = 'LB';
        }
        else if (item.uomId === 3) {
          uom = 'OZ';
        }
        else if (item.uomId === 4) {
          uom = 'Gms';
        }

        let brand;
        let product;
        let variant;

        const soResponse = 'Select GROUP_CONCAT(DISTINCT(pack_style_id)) AS packStyleIds from ' + appSettings.sales_db + '.sale_order_items where sale_order_id =' + req.saleOrderId;
        const queryResult = await manager.query(soResponse);
        if (req.stockType === "dummy" || req.stockType === "superDummy") {
          const getHighestPalletCapacity = "select MAX(max_pallet_capacity) AS maxPalletCapacity from " + appSettings.masters_db + ".packing_methods where packing_method_id IN (" + queryResult[0].packStyleIds + ")";
          let queryResponse = await manager.query(getHighestPalletCapacity);
          maxPalletCapacity = queryResponse[0].maxPalletCapacity != undefined ? queryResponse[0].maxPalletCapacity : 0;
        }
        else {
          const palletResponse = await this.packingMethodService.getPalletCapacityById({ pouchesPerRow: 0, noOfPouches: 0, uomId: 0, packingMethodId: item.packStyleId });
          maxPalletCapacity = palletResponse.status ? palletResponse.data.palletCapacity : 0;
        }

        if (!(brandIdMap.has(item.brandId))) {
          const brandId = await this.endCustomerRepository.getBrandsById({
            brandId: item.brandId,
          });
          brandIdMap.set(brandId.data.brandId, brandId.data.brandName);
        }
        brand = brandIdMap.get(item.brandId)

        if (!(productIdMap.has(item.itemId))) {
          const productId = await this.productRepository.getActiveProductById({
            productId: item.itemId,
          });
          productIdMap.set(productId.data.productId, productId.data.productName);
        }

        product = productIdMap.get(item.itemId)

        if (!(variantIdMap.has(item.itemId))) {
          const variantId = await this.skuCodesRepository.getSkuDataById({
            skuCodeId: item.varientId,
          });
          variantIdMap.set(variantId.data.skuCodeId, variantId.data.variantCode);
        }
        variant = variantIdMap.get(item.varientId)


        const packstyle = item.pouches + '*' + item.pouchWeight;
        const query = `SELECT sum(total_cartons) AS reportedCases FROM ` + appSettings.warehouse_db + `.stock s 
            where s.sale_order_item_id=`+ item.saleOrderItemId + ` and s.status= "StockIn"`;
        // console.log(query);
        const reportedCases = await manager.query(query);
        // console.log(reportedCases);
        const data = new SaleOrderItemsDTO(item.saleOrderItemId, item.minGrade, item.maxGrade, item.brandId, brand, item.varientId, variant, packstyle, item.cases, item.caseWeight, item.unitPrice, item.netWeight, item.netAmount, uom, item.styleWeighment, item.minGlaze, item.MaxGlaze, item.soakingTime, item.soakingStyle, item.shrimpWeight, item.innerBags, "", item.itemId, product, item.pouches, item.pouchWeight, item.dispatchedQty, item.invoiceAmount, item.reportedCases, item.categoryId, item.finalPercentage, item.uomId, 0, 0, null, 0, "", 0, 0, 0, 0, 0, 0, 0, item.masterBrandId, 0, "", item.jobCases, item.packStyleId, maxPalletCapacity, soInvData[0].endCustomerId);
        console.log(data);
        responseData.push(data);
      }
      return new SaleOrderItemsDetailsResponseModel(true, 10000, 'Sale Order Item Details found', responseData);
    } catch (err) {
      console.log(err);
      return err;

    }
  }

  saleOrderId: number;
  saleOrderNumber: string;
  poNumber?: string;
  status?: string;

  async getSaleOrderDropDownInvoiceDone(req: PlantIdRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      const manager = getManager();
      let soQuery = "Select soi.sale_order_id AS saleOrderId, so.sale_order_no AS saleOrderNumber, soi.po_number AS poNumber from " + appSettings.sales_db + ".so_invoice_details soi left join " + appSettings.sales_db + ".sale_order so on so.sale_order_id = soi.sale_order_id where so.is_invoiced = 'yes' and soi.factoryId = " + req.unitcodeId + " order by soi.po_number ASC";
      let data = await manager.query(soQuery);
      if (data.length > 0) {
        return new CommonResponse(true, 1001, 'data retrived', data);
      }
      else {
        return new CommonResponse(false, 1010, 'No data retrieved');
      }
    } catch (err) {
      console.log(err);
      return err;

    }
  }

  async getTransferredSosReport(req?: TransferredSosFilterDto): Promise<CommonResponse> {
    try {
      const manager = getManager()
      let query
      query = `select st.sale_order_id as saleOrderId,sid.po_number poNumber,sid.buyer_po_number as buyerPoNumber,c.client_name as customer,st.from_unit as fromMfgUnitId,fu.unit_name as fromMfgUnit,st.to_unit as toMfgUnitId,tu.unit_name as toMfgUnit,st.to_processing_unit as toProcessingUnitId,ptu.unit_name as toProcessingUnitName,st.from_processing_unit as fromProcessingUnitId,pfu.unit_name as fromProcessingUnitName   from ` + appSettings.sales_db + `.so_transfer_log st 
      left join ` + appSettings.sales_db + `.so_invoice_details sid on sid.sale_order_id = st.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes tu ON tu.unit_code_id = st.to_unit
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes fu ON fu.unit_code_id = st.from_unit
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes ptu ON ptu.unit_code_id = st.to_processing_unit
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes pfu ON pfu.unit_code_id = st.from_processing_unit
      LEFT JOIN ` + appSettings.masters_db + `.customers c on c.cust_id = sid.customer_id 
      left join ` + appSettings.masters_db + `.end_customers ec on  ec.end_customer_id = sid.end_customer_id  where st.sale_order_id > 0 `

      if (req.bapUnit) {
        query = query + ' and st.from_unit = ' + req.bapUnit;
      }
      if (req.createdFromDate != undefined) {
        query = query + ' and DATE(st.created_at) >=  "' + req.createdFromDate + '" and DATE(st.created_at) <="' + req.createdToDate + '"';
      }
      if (req.endCustomer) {
        query = query + 'and sid.end_customer_id = ' + req.endCustomer
      }
      const data = await manager.query(query)
      if (data.length > 0) {
        return new CommonResponse(true, 1001, 'data retrived', data)
      }
      else {
        return new CommonResponse(false, 1010, 'no data found',)
      }
    }
    catch (err) {
      return new CommonResponse(false, 2222, err)
    }
  }

  async getSoItemDetailsForInProgress(req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      const manager = getManager()
      let query
      query = ` SELECT soi.sale_order_id as saleOrderId ,soi.sale_order_item_id , b.brand_name as brand , soi.min_grade_id as minGrade,soi.max_grade_id as maxGrade,s.variant_code as varientId,p.name as product ,soi.net_weight as netWeight,sp.lotCode as lotNo,rb.min_count as minCount,rb.max_count as maxCount , rb.count as actualCount FROM ` + appSettings.sales_db + `.sale_order_items soi 
      LEFT JOIN ` + appSettings.masters_db + `.brands b ON b.brand_id = soi.brand_id 
      LEFT JOIN ` + appSettings.masters_db + `.sku_codes s ON s.sku_code_id=soi.varient_id
      LEFT JOIN ` + appSettings.masters_db + `.products p ON p.product_id = s.product_id
      LEFT JOIN ` + appSettings.sales_db + `.so_po_details sp ON sp.sale_order_id = soi.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.rm_bom_log rb ON rb.sale_order_id = soi.sale_order_id 
       WHERE soi.sale_order_id = ${req.saleOrderId} `
      query = query + ` GROUP BY soi.sale_order_item_id`
      const data = await manager.query(query)
      console.log('*********', data)
      if (data.length > 0) {
        return new CommonResponse(true, 1001, 'data retrived', data)
      }
      else {
        return new CommonResponse(false, 1010, 'no data found',)
      }
    }
    catch (err) {
      return new CommonResponse(false, 2222, err)
    }
  }

  async getSoItemDetailsForBackLog(req: SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      const manager = getManager()
      let query
      query = ` SELECT soi.sale_order_id as saleOrderId ,soi.sale_order_item_id , b.brand_name as brand , soi.min_grade_id as minGrade,soi.max_grade_id as maxGrade,s.variant_code as varientId,p.name as product ,soi.net_weight as netWeight,sp.lotCode as lotNo,rb.min_count as minCount,rb.max_count as maxCount , rb.count as actualCount,soi.cases as cases FROM ` + appSettings.sales_db + `.sale_order_items soi 
      LEFT JOIN ` + appSettings.masters_db + `.brands b ON b.brand_id = soi.brand_id 
      LEFT JOIN ` + appSettings.masters_db + `.sku_codes s ON s.sku_code_id=soi.varient_id
      LEFT JOIN ` + appSettings.masters_db + `.products p ON p.product_id = s.product_id
      LEFT JOIN ` + appSettings.sales_db + `.so_po_details sp ON sp.sale_order_id = soi.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.rm_bom_log rb ON rb.sale_order_id = soi.sale_order_id 
       WHERE soi.sale_order_id = ${req.saleOrderId} `
      query = query + ` GROUP BY soi.sale_order_item_id`
      const data = await manager.query(query)
      console.log('*********', data)
      if (data.length > 0) {
        return new CommonResponse(true, 1001, 'data retrived', data)
      }
      else {
        return new CommonResponse(false, 1010, 'no data found',)
      }
    }
    catch (err) {
      return new CommonResponse(false, 2222, err)
    }
  }

  async getSaleordersAbstractReport(saleOrderTrackFilters: SaleOrderTrackFilters): Promise<CommonResponse> {
    try {
      const manager = getManager()
      let soQuery;
      soQuery = `SELECT so.sale_order_id AS saleOrderId,so.sale_order_no AS saleOrderNumber,c.client_name AS customer,inv.invoice_date AS orderedDate,inv.end_customer_id as endCustomerId,inv.act_edl_date AS expectedEndDate,SUM(si.net_weight) AS orderQty,SUM(si.net_amount) AS cost,d.destination_name AS destination,so.status AS status,so.life_cycle_status as lifeCyclestatus,st.pm_status AS packing,st.qc_status AS qualityAssurance,st.container_status AS logistics,st.doc_status AS doc,inv.factoryId AS unit, inv.invoice_date AS poDate,inv.po_number AS poNumber,inv.buyer_po_number AS buyerPONo,e.end_customer_name AS endCustomername,SUM(si.net_weight) AS totnetWeight, IF(count(si.sale_order_item_id)>1, 0, 1) AS loadType, cur.currency_id AS currencyId,cur.currency_name AS currency,si.uom_id AS uom,so.is_invoiced AS isInvoiced,so.so_type AS soType,so.so_process_type AS soProcessType,inv.act_edl_date AS actualEtd,cn.country_name as countryName,inv.category as product,uc.unit_name as unit, st.production_status AS prodStatus,inv.processing_unit as processingUnitId,inv.factoryId as unitId, pu.unit_name as processingUnitName, inv.job_type as jobType,st.is_dispatched AS dispatchStatus,SUM(si.reported_cases) as fgStock,inv.is_sub_contract as isSubContract
      FROM `+ appSettings.sales_db + `.so_invoice_details inv
      LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON so.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.customers c ON c.cust_id=inv.customer_id
      LEFT JOIN `+ appSettings.masters_db + `.destination d ON d.destination_id=inv.destination
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_track st ON st.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.sales_db + `.sale_order_items si ON si.sale_order_id=inv.sale_order_id
      LEFT JOIN `+ appSettings.masters_db + `.end_customers e ON e.end_customer_id=inv.end_customer_id
      LEFT JOIN `+ appSettings.masters_db + `.countries cn ON cn.country_id=inv.country_id
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=inv.factoryId
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes pu ON pu.unit_code_id=inv.processing_unit
      LEFT JOIN `+ appSettings.masters_db + `.currencies cur ON cur.currency_id=inv.currency_id where so.sale_order_id>0 `;
      if (saleOrderTrackFilters.unit > 0) {
        soQuery = soQuery + ' and inv.factoryId = ' + saleOrderTrackFilters.unit;
      }
      if (saleOrderTrackFilters.prodUnit > 0 && saleOrderTrackFilters.prodUnit != 5) {
        soQuery = soQuery + ' and inv.processing_unit = ' + saleOrderTrackFilters.prodUnit;
      }
      if(saleOrderTrackFilters.mainCategory != undefined && saleOrderTrackFilters.lifeCycleStatus == undefined){
        var quotedAndCommaSeparated = "'" + saleOrderTrackFilters.mainCategory.join("','") + "'";   
        let category =`SELECT group_concat(CONCAT("'",sub_category,"'")) AS subCategory FROM life_cycle_categories WHERE main_category IN (`+quotedAndCommaSeparated+`)`;
        let lifecylceData = await manager.query(category)
        console.log(lifecylceData,'lifecylceData')
        soQuery = soQuery + ' and so.life_cycle_status in('+lifecylceData[0].subCategory+')'
      }
       if(saleOrderTrackFilters.mainCategory != undefined && saleOrderTrackFilters.lifeCycleStatus != undefined){
        soQuery = soQuery + ' and so.life_cycle_status in  ("' + saleOrderTrackFilters.lifeCycleStatus + '")';
      }
      if (saleOrderTrackFilters.mainCategory == undefined && saleOrderTrackFilters.lifeCycleStatus != undefined) {
        soQuery = soQuery + ' and so.life_cycle_status = "' + saleOrderTrackFilters.lifeCycleStatus + '"';
      }

      if (saleOrderTrackFilters.saleOrderStatus != undefined) {
        var quotedAndCommaSeparated = "'" + saleOrderTrackFilters.saleOrderStatus.join("','") + "'";
        soQuery = soQuery + ' and so.status in (' + quotedAndCommaSeparated + ')';
      }

      if (saleOrderTrackFilters.selectedEstimatedFromDate != undefined) {
        soQuery = soQuery + ' and inv.invoice_date >= "' + saleOrderTrackFilters.selectedEstimatedFromDate + '" and  soin.invoice_date <= "' + saleOrderTrackFilters.selectedEstimatedToDate + '"';
      }
      if (saleOrderTrackFilters.selectedCreatedFromDate != undefined) {
        soQuery = soQuery + ' and date(si.created_at) >= "' + saleOrderTrackFilters.selectedCreatedFromDate + '" and  date(si.created_at) <= "' + saleOrderTrackFilters.selectedCreatedToDate + '"';
      }
      if (saleOrderTrackFilters.cardType && saleOrderTrackFilters.cardType == 'skipped-saleorders') {
        soQuery = soQuery + 'so.status IN ("OPEN","INPROGRESS") AND soi.job_type!="Sub Job" AND so.so_process_type="MTO" and so.so_type = "Dispatch" ORDER BY soi.invoice_date'
      }

      soQuery = soQuery + ` GROUP BY so.sale_order_id ORDER By inv.act_edl_date`;
      console.log(soQuery)
      let soData = await manager.query(soQuery);

      const response = new AllSaleOrdersTrackResponseModel(true, 11108, 'Sale Order Details retrieved successfully', soData);
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }

  }

  async getCustomersDataForCustomerId(req: EndCustomerIdReq): Promise<CommonResponse> {
    const manager = getManager();
    try {
      const query = `select si.buyer_po_number as buyerPoNo,si.invoice_date as invoiceDate,si.eda_date as eta,si.edl_date as etd,si.cus_address  as customerAddress,si.del_address  as deliveryAddress from ` + appSettings.sales_db + `.so_invoice_details si where si.end_customer_id == ` + req.endCustomerId
      const data = await manager.query(query)
      if (data.length > 0) {

        return new CommonResponse(true, 1111, 'Data Retreived sucessfully', data)
      } else {
        return new CommonResponse(true, 1111, 'No data found')

      }

    } catch (error) {
      throw error
    }
  }
  async getProductBarcode(req: ProductBarcodeRequest): Promise<CommonResponse> {
    const productBarcode = await this.soItemRepo.findOne({ where: { saleOrderId: req.saleOrderId, saleOrderItemId: req.saleOrderItemId } })
    let data = productBarcode.barcode
    if (productBarcode) {
      return new CommonResponse(true, 1111, 'data retrieved', data)
    } else {
      return new CommonResponse(false, 9999, 'No data', undefined)
    }
  }

  async getSoPoBrandDropDownList(req?: UnitRequest): Promise<CommonResponse> {
    const manger = getManager();
    try {
      const query = 'SELECT so.sale_order_id AS saleOrderId,po_number AS poNumber ,sale_order_item_id AS saleOrderItemId,brand_name AS brandName,variant_code AS variantCode ,ROUND(production_percentage)FROM `erpx_dev_sales`.`sale_order_items` so LEFT JOIN `erpx_dev_sales`.`so_invoice_details` sd ON sd.sale_order_id=so.sale_order_id LEFT JOIN `erpx_dev_masters`.`brands` b ON b.brand_id=so.brand_id LEFT JOIN `erpx_dev_masters`.`sku_codes` sk ON sk.sku_code_id=so.varient_id LEFT JOIN `erpx_dev_sales`.`sale_order_track` st ON st.sale_order_id=so.sale_order_id  WHERE is_sub_contract="NO" AND job_type NOT IN("Sub Job") AND sd.processing_unit=' + req.unitId + ' GROUP BY po_number ORDER BY po_number DESC';
      const data = await manger.query(query)
      if (data.length > 0) {
        return new CommonResponse(true, 1111, 'Data Retreived sucessfully', data)
      } else {
        return new CommonResponse(true, 1111, 'No data found')
      }

    }
    catch (error) {
      throw error
    }
  }

  async updateEdlDateInInvoiceDetail(req: EtdWiseDTO[]): Promise<CommonResponse> {
    const manager = new GenericTransactionManager()

    try {
      await manager.startTransaction()
      const validationFlag = new Set()
      for (const record of req) {
        const updateEDl = await manager.getCustomRepository(SoInvoiceRepository).update({ saleOrderId: record.saleOrderId }, { actualEdldate: new Date(record.revisedEdaDate) })
        if (updateEDl.affected) {
          validationFlag.add(true);
        } else {
          validationFlag.add(false);
        }
      }
      if (validationFlag.has(false)) {
        await manager.releaseTransaction()
        return new CommonResponse(false, 1111, 'Error while updating')
      } else {
        await manager.completeTransaction()
        return new CommonResponse(true, 1111, 'Error while updating')
      }
    } catch (err) {
      console.log(err)
      await manager.releaseTransaction()
      throw new ErrorResponse(11111, 'Error occured')
    }
  }
  //   async getSoPoBrandDropDownList(): Promise<CommonResponse> {
  //     const manger = getManager();
  //     try {
  //       const query = ' SELECT so.sale_order_id AS saleOrderId,po_number AS poNumber ,brand_name AS brandName,variant_code AS variantCode ,ROUND(production_percentage)FROM `erpx_dev_sales`.`sale_order_items` so LEFT JOIN `so_invoice_details` sd ON sd.sale_order_id=so.sale_order_id LEFT JOIN `erpx_dev_masters`.`brands` b ON b.brand_id=so.brand_id LEFT JOIN `erpx_dev_masters`.`sku_codes` sk ON sk.sku_code_id=so.varient_id LEFT JOIN `erpx_dev_sales`.`sale_order_track` st ON st.sale_order_id=so.sale_order_id  WHERE is_sub_contract="NO" AND job_type NOT IN("Sub Job")  GROUP BY po_number ORDER BY po_number DESC';
  //       const data = await manger.query(query)
  //       if (data.length > 0) {
  //         return new CommonResponse(true, 1111, 'Data Retreived sucessfully', data)
  //       } else {
  //         return new CommonResponse(true, 1111, 'No data found')

  //       }

  //     }
  // }

  async getCurrentMonthSaleordersForIndentForm(req: SoProcessTypeReq): Promise<CommonResponse> {
    try {
      const manager = getManager()

      var nextMonth = moment().add(1, 'months').calendar()
      let productsData
      productsData = `select si.sale_order_item_id as soItemId,si.pack_style_id,si.sale_order_id as saleOrderId,concat(sinv.po_number,'/',b.brand_name,'/',sc.variant_code,'/',pm.packing_method_name) as productName,si.barcode as barcode from ` + appSettings.sales_db + `.sale_order_items si
    left join ` + appSettings.masters_db + `.sku_codes sc on sc.sku_code_id = si.varient_id
    left join ` + appSettings.masters_db + `.master_brands b on b.master_brand_id = si.master_brand_id
    left join ` + appSettings.masters_db + `.packing_methods pm on pm.packing_method_id = si.pack_style_id
    left join ` + appSettings.sales_db + `.so_invoice_details sinv ON  sinv.sale_order_id = si.sale_order_id
    left join ` + appSettings.sales_db + `.sale_order so on so.sale_order_id = si.sale_order_id
    where  sinv.processing_unit = ${req.unitId} and sc.is_active=1 `
      if (req.soProcessType) {
        productsData = productsData + ` and so.so_process_type = "${req.soProcessType}"`

      }
      if (req.barcode) {
        productsData = productsData + ` and si.barcode = ${req.barcode}`
      }
      else {
        if (req.soProcessType == SoProcessTypesEnum.MTO) {
          productsData = productsData + ` and sinv.act_edl_date between DATE('${moment().format('YYYY-MM-DD')}') and DATE('${moment(nextMonth).format('YYYY-MM-DD')}')`
        }
      }

      const data = await manager.query(productsData)
      if (data && data.length) {
        return new CommonResponse(true, 1111, "Data retreived sucessfully", data)
      } else {
        return new CommonResponse(false, 1010, 'No data Found')
      }

    } catch (error) {
      console.log(error)
      return new CommonResponse(false, 1010, 'error occured')

    }
  }

  async getPackingItemsFormSoItem(req: SoItemRequest): Promise<CommonResponse> {
    try {
      const manager = getManager()
      const mainSoIdQurey = 'SELECT main_so_item_id AS mainsoItem FROM '+appSettings.sales_db+'.sale_order_items WHERE sale_order_item_id ='+req.saleOrderItemId
      const mainSoId = await manager.query(mainSoIdQurey)
      const query = 'SELECT pb.item_id AS itemId,i.item_name AS itemName FROM  '+appSettings.sales_db+'.packing_bom_log pb LEFT JOIN '+appSettings.masters_db+'.items i ON i.item_id = pb.item_id WHERE pb.sale_order_item_id = '+req.saleOrderItemId+' UNION SELECT b.item_id as itemId ,i.item_name AS itemName FROM '+appSettings.sales_db+'.bom_details b LEFT JOIN '+appSettings.masters_db+'.items i ON i.item_id = b.item_id LEFT JOIN '+appSettings.sales_db+'.`sale_order_items` si ON b.sale_order_id=si.sale_order_id WHERE si.sale_order_item_id = '+mainSoId[0].mainsoItem+' AND b.packing_category IS NOT NULL'
      // const query = `select pb.item_id as itemId,i.item_name as itemName from ` + appSettings.sales_db + `.packing_bom_log pb left join ` + appSettings.masters_db + `.items i on i.item_id = pb.item_id     where pb.sale_order_item_id = ${req.saleOrderItemId} `
      const data = await manager.query(query)
      if (data && data.length) {
        return new CommonResponse(true, 1111, "Data retreived sucessfully", data)
      } else {
        return new CommonResponse(false, 1010, 'No data Found')
      }
    } catch {
      return new CommonResponse(false, 1010, 'error occured')
    }
  }

  async getAllSoForAssignSo(req: SoTypeReq): Promise<CommonResponse> {
    const manager = getManager();
    try {
      // let query = `SELECT si.sale_order_id AS saleOrderId, so.sale_order_no AS saleOrderNo, si.po_number AS poNumber,si.act_edl_date AS aclEdlDate , si.processing_unit AS unit ,so.sale_order_no as saleOrderNo, so.status FROM ` + appSettings.sales_db + `.so_invoice_details si
      // LEFT JOIN ` + appSettings.sales_db + `.sale_order so  ON si.sale_order_id = so.sale_order_id
      // WHERE (act_edl_date BETWEEN CURRENT_DATE() AND DATE_ADD(CURRENT_DATE(), INTERVAL 30 DAY)) AND so.status NOT IN( 'CANCELLED','CLOSED' )`;
      let query = ' SELECT CONCAT(si.po_number,"-",b.brand_name,"-",pk.packing_method_name,"-",sk.variant_code) AS item,b.brand_name AS brandname,pk.packing_method_name,sk.variant_code AS vCode,soi.pack_style_id,soi.brand_id,soi.varient_id,soi.sale_order_item_id AS saleOrderItemId,soi.item_id,si.sale_order_id AS saleOrderId, so.sale_order_no AS saleOrderNo, si.po_number AS poNumber,si.act_edl_date AS aclEdlDate ,si.processing_unit AS unit , so.status FROM erpx_dev_sales.so_invoice_details si LEFT JOIN erpx_dev_sales.sale_order so  ON si.sale_order_id = so.sale_order_id LEFT JOIN erpx_dev_sales.sale_order_items soi ON soi.sale_order_id=so.sale_order_id LEFT JOIN erpx_dev_masters.brands b ON b.brand_id=soi.brand_id LEFT JOIN erpx_dev_masters.sku_codes sk ON sk.sku_code_id=soi.varient_id LEFT JOIN erpx_dev_masters.packing_methods pk ON pk.packing_method_id=soi.pack_style_id WHERE si.sale_order_id > 0  and so.so_process_type = "' + req.soType + '"  and sk.is_active=1'
      if(req.soType == SoProcessTypesEnum.MTO){
        query =  query + ' and (act_edl_date BETWEEN CURRENT_DATE() AND DATE_ADD(CURRENT_DATE(), INTERVAL 30 DAY)) AND so.status NOT IN( "CANCELLED","CLOSED" ) '
      }
      if (req.unitId && req.unitId != 5) {
        query = query + ' and si.processing_unit = ' + req.unitId;
      }
      const data = await manager.query(query)
      if (data.length > 0) {
        return new CommonResponse(true, 2255, 'Data Retreived sucessfilly', data)
      }
    } catch (error) {
      throw error
    }
  }

  async getSubSoData(req: SoItemRequest): Promise<CommonResponse> {
    const data = await this.soItemRepo.findOne({ where: { mainSoItemId: req.saleOrderItemId, saleOrderItemId: Not(req.saleOrderItemId) } })
    if (data) {
      return new CommonResponse(true, 111, 'sub so data', data)
    } else {
      return new CommonResponse(false, 111, 'sub so data')
    }
  }
  async sendMessage(msg): Promise<any> {
    var test = '+917702621117';
    return await axios.post('https://graph.facebook.com/v15.0/102194172756615/messages', {
      "messaging_product": "whatsapp",
      "to": "917036045967",
      "type": "template",
      "template": {
        "name": "daily_usage",
        "language": {
          "code": "en_US"
        },
        "components": [
          {
            "type": "body",
            "parameters": [
              {
                "type": "text",
                "text": 20
              },
              {
                "type": "text",
                "text": 21
              },
            ]
          }
        ]
      }
    }, {
      headers: {
        'Authorization': `Bearer EAAMPZAswUgD4BAOUwlRXgVhMgpFW4eXT3z2ZBcVlIPnTtixguAqc74xFS1ydBrTuCD55njvOS7B9ZB4ZAZB3pvFQ4ySYEMZChD1OkKv5RUQ6wZBwOZCfiOB1F3KZCbqL8CHcDReQSOcjGHAZAzX7oy7ylsmaNpTgacI1aUQ8LydnFXR4PMHMZBDH8ZAz`,
      },
    }).then(res => {
      console.log(res)
      return res.data;
    }).catch(err => {
      return err
    }

    )

  }


  async getSubJobRevisionCodeListData(req: SubJobSoRequest): Promise<CommonResponse> {
    console.log('req')
    console.log(req)
    const manager = getManager();
    const query = `SELECT clmi.sale_order_item_id as saleOrderItemId ,clmi.code_list_main_id as codelistmainId,clmi.cartons as cartons , cl.traceability_code as traceabilityCode,uc.unit_name as unitName , CONCAT(pm.packing_method_name,' - ',sk.variant_code) AS soItem,clmi.unit_id as unitId, clmi.tracebility_code_id as tracebilityCodeId,clmi.created_user as updatedUser,clmi.code_list_main_items_id as codelistmainItemId,soi.main_so_item_id as mainSoItemId FROM ` + appSettings.planning_db + `.code_list_main_items clmi 
       LEFT JOIN ` + appSettings.planning_db + `.code_list_main clm ON clm.code_list_main_id = clmi.code_list_main_id 
       LEFT JOIN ` + appSettings.planning_db + `.code_list cl ON cl.code_list_id = clmi.tracebility_code_id  LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = clmi.unit_id  
       LEFT JOIN ` + appSettings.sales_db + `.sale_order_items soi ON soi.sale_order_item_id = clmi.sale_order_item_id 
       LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=soi.varient_id 
       LEFT JOIN ` + appSettings.masters_db + `.packing_methods pm ON packing_method_id = soi.pack_style_id 
       WHERE clmi.sale_order_item_id IN(${req.soId}) `

    const data = await manager.query(query)
    if (data.length > 0) {
      const rsp = new CommonResponse(true, 2255, 'Data Retreived sucessfilly', data)
      // const newLogDto = new LogsDto(1,'code list data', 'sale order', ndata.saleOrderItemId, true, '',data.createdUser)
      //       let res = await this.logService.createLog(newLogDto);
      //       console.log(res);
      return rsp
    }
    else {
      return new CommonResponse(false, 1010, 'No data Found')
    }
  }
  async testWhatsappService(): Promise<any> {
    var test = '+917702621117';
    return await axios.post('https://graph.facebook.com/v15.0/102194172756615/messages', {
      "messaging_product": "whatsapp",
      "to": "917702621117",
      "type": "template",
      "template": {
        "name": "daily_usage",
        "language": {
          "code": "en_US"
        },
        "components": [
          {
            "type": "body",
            "parameters": [
              {
                "type": "text",
                "text": "Welcome to Whatsapp Message" + test
              },

            ]
          }
        ]
      }
    }, {
      headers: {
        'Authorization': `Bearer EAAMPZAswUgD4BAOUwlRXgVhMgpFW4eXT3z2ZBcVlIPnTtixguAqc74xFS1ydBrTuCD55njvOS7B9ZB4ZAZB3pvFQ4ySYEMZChD1OkKv5RUQ6wZBwOZCfiOB1F3KZCbqL8CHcDReQSOcjGHAZAzX7oy7ylsmaNpTgacI1aUQ8LydnFXR4PMHMZBDH8ZAz`,
      },
    }).then(res => {
      return res.data;
    }).catch(err => {
      return err
    }

    )
  }
  async testWhatsapp(req: any): Promise<CommonResponse> {
    const msgReply = await this.testWhatsappService()
    console.log('msgReply')
    console.log(msgReply)
    return
  }

  async getAllActiveSaleOrdersForCodeList(unitId: number): Promise<SaleOrderDropDownResponseModel> {
    try {
      const saleOrderDropDownDto: SaleOrderDropDownDto[] = [];
      let SaleOrder;
      if (unitId != 5) {
        SaleOrder = this.soRepo
          .createQueryBuilder('SaleOrder')
          .select([
            'SaleOrder.sale_order_id AS saleOrderId',
            'sale_order_no AS saleOrderNumber',
            'SoInvDetailsInfo.po_number AS poNumber',
            'SoInvDetailsInfo.processingUnit AS processingUnitId'
          ])
          .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
          .where('SaleOrder.status IN ("OPEN","INPROGRESS") ')
          .andWhere('SoInvDetailsInfo.processing_unit =' + unitId + ' and SoInvDetailsInfo.job_type = "Main Job"')
          .orderBy('sale_order_no', 'ASC');
      }else{
        SaleOrder = this.soRepo
        .createQueryBuilder('SaleOrder')
        .select([
          'SaleOrder.sale_order_id AS saleOrderId',
          'sale_order_no AS saleOrderNumber',
          'SoInvDetailsInfo.po_number AS poNumber',
          'SoInvDetailsInfo.processingUnit AS processingUnitId'
        ])
        .leftJoin("so_invoice_details", "SoInvDetailsInfo", "SoInvDetailsInfo.sale_order_id = SaleOrder.sale_order_id")
        .where('SaleOrder.status IN ("OPEN","INPROGRESS") ')
        .andWhere('SoInvDetailsInfo.job_type = "Main Job"')
        .orderBy('sale_order_no', 'ASC');
      }
      const saleOrderData = await SaleOrder.getRawMany();

      for (const eachItem of saleOrderData) {
        const data = new SaleOrderDropDownDto(
          eachItem.saleOrderId,
          eachItem.poNumber,
          eachItem.poNumber,
          eachItem.processingUnitId
        );
        saleOrderDropDownDto.push(data);
      }

      console.log(saleOrderData);
      if (SaleOrder) {
        // saleOrderDropDownDto.push(SaleOrder);
        const response = new SaleOrderDropDownResponseModel(
          true,
          1,
          'Sale orders retrieved successfully',
          saleOrderDropDownDto
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }

  async updateCodeListStatusInSoTrack(saleOrderId: number): Promise<CommonResponse> {
    try {
      const response = await this.soTrackRepo.update({ saleOrderInfo: Raw(alias => `sale_order_id = '${saleOrderId}'`) }, { isCodeListAllocated: true });
      if (response && response.affected) {
        return new CommonResponse(true, 1111, "Updated Sucessfully")
      }
    } catch {
      return new CommonResponse(false, 1111, "Error while updating")

    }
  }

  async getsoitemforIndent(req: UnitRequest): Promise<CommonResponse> {
    const manger = getManager();
    try {
      const query = ' SELECT sale_order_item_id AS saleOrderItemId,bd.item_sub_category_id as itemsubcategoryId,bd.sale_order_id AS saleOrderId,bd.item_category_id AS itemCategoryId,bd.item_id AS itemId,packing_method_id,varient_id,po_number AS poNumber,b.brand_name AS brandName,variant_code AS variantCode,packing_method_name AS packmethodName,processing_unit AS unitId,CONCAT(po_number,"-",b.brand_name,"/",variant_code,"/",packing_method_name) AS soItem FROM `erpx_dev_sales`.`bom_details` bd LEFT JOIN `erpx_dev_sales`.`so_invoice_details` sd ON sd.sale_order_id=bd.sale_order_id LEFT JOIN `erpx_dev_sales`.`sale_order_items` so ON so.sale_order_id=bd.sale_order_id LEFT JOIN `erpx_dev_masters`.`brands` b ON b.brand_id=so.brand_id LEFT JOIN `erpx_dev_masters`.`sku_codes` sk ON sk.sku_code_id=so.varient_id LEFT JOIN `erpx_dev_masters`.`packing_methods` p ON p.packing_method_id=so.pack_style_id  LEFT JOIN `erpx_dev_sales`.`sale_order` sl ON sl.sale_order_id=bd.sale_order_id WHERE processing_unit=' + req.unitId + ' AND sl.status IN("OPEN","INPROGRESS") AND sk.is_active = 1 GROUP BY sale_order_item_id';

      const data = await manger.query(query)
      if (data.length > 0) {
        return new CommonResponse(true, 1111, 'Data Retreived sucessfully', data)
      } else {
        return new CommonResponse(true, 1111, 'No data found')
      }

    }
    catch (error) {
      throw error
    }
  }
  async getTrimsItemsForSo(req: SaleOrderIdRequest): Promise<CommonResponse> {
    const manager = getManager();
    const bomDetails = `select item_id as itemId,sale_order_id as saleOrderId,packing_category as packingCategory from bom_details where sale_order_id = ${req.saleOrderId} and packing_category = '${PackingCategoryEnum.TRIM}'`;
    const trimItems = await manager.query(bomDetails)
    console.log(trimItems, 'trimItems')
    if (trimItems.length > 0) {
      return new CommonResponse(true, 5555, 'trim items retriebd', trimItems)
    } else {
      return new CommonResponse(false, 4444, 'No trim Items')
    }
  }

  async updateBomPo(req:SaleOrderIdRequest):Promise<CommonResponse>{
    const manager = new GenericTransactionManager();
    await manager.startTransaction();
    const bomdata = await manager.getCustomRepository(BomRepository).findOne({saleOrderId:req.saleOrderId,itemId:req.itemId})
      let toBeupdateQty = 0
      let bomstatus
      if(Number(bomdata.poQty) > Number(req.poQuantity)){
        toBeupdateQty =Number(bomdata.poQty) - Number(req.poQuantity) 
        bomstatus = StatusEnum.PO

      }else{
        toBeupdateQty = 0
        bomstatus = StatusEnum.OPEN
      }
      const BOMPoQtyUpdate = await manager.getCustomRepository(BomRepository).update({saleOrderId: req.saleOrderId,itemId:req.itemId},{poQty:toBeupdateQty,status:bomstatus})
      if(BOMPoQtyUpdate.affected){
        manager.completeTransaction()
        return new CommonResponse(true,222,'updated')
      }else{
        manager.releaseTransaction()
        return new CommonResponse(false,222,'something went wrong in PO quantity update')

      }
    // return
  }

  async GetSoLifeCycleStatusForCategory(req?:SolifeCycleCategoryReq): Promise<CommonResponse> {
    const manager = getManager();
    let query
    if(req.mainCategory){
      var quotedAndCommaSeparated = "'" + req.mainCategory.join("','") + "'";
      console.log(quotedAndCommaSeparated,'data')
       query =`SELECT life_cycle_id AS lifeCycleId,main_category AS mainCategory,sub_category AS subCategory FROM `+appSettings.sales_db+`.life_cycle_categories WHERE main_category IN (`+quotedAndCommaSeparated+`)`;
    }else{
      query ='SELECT life_cycle_id AS lifeCycleId,main_category AS mainCategory,sub_category AS subCategory FROM '+appSettings.sales_db+'.life_cycle_categories'
    }
    const data = await manager.query(query)
    console.log(data, 'data')
    if (data.length > 0) {
      return new CommonResponse(true, 5555, 'So lifecylce data retrivedd', data)
    } else {
      return new CommonResponse(false, 4444, 'No lifecylce data found')
    }
  }

  async updateProductConversionQty(req: ProductConversionReq): Promise<CommonResponse> {
    const manager = new GenericTransactionManager()
    console.log('herereqqq',req)
      await manager.startTransaction()
        let updateToBom
        let updateFRomSoBom
        let saveFlag = new Set<boolean>()
        if(req.soStatus != SoStatusEnum.CLOSED){
          updateFRomSoBom = await manager.getCustomRepository(BomRepository).update({ saleOrderId: req.saleOrderId, itemId: req.itemId,receivedQuantity:MoreThan(req.qty) },{status:StatusEnum.OPEN,requiredQuantity: () => `required_qty+${req.qty}` })   
            const fromsoTrackPmStatusUpdate = await manager.getCustomRepository(SoTrackRepository).update({saleOrderInfo:{saleOrderId:req.saleOrderId}},{pmStatus:PmStatusEnum.IN_PROGRESS})
            if(fromsoTrackPmStatusUpdate.affected){
              saveFlag.add(true)
            }else{
              saveFlag.add(false)
            }   
        }
        if (req.conversionType == ConversionType.saleorder_to_saleorder) {
            updateToBom = await manager.getCustomRepository(BomRepository).update({ saleOrderId: req.toSaleOrderId, itemId: req.itemId }, { AssignedQuantity: () => `assigned_qty+${req.qty}` ,status:StatusEnum.ASSIGNED,requiredQuantity: () => `required_qty-${req.qty}`}) 
            if(updateToBom.affected){
              saveFlag.add(true)
            }else{
              saveFlag.add(false)
            }      
            // if (updateFRomSoBom.affected && updateToBom.affected) {
                const soTrackPmStatusUpdate = await manager.getCustomRepository(SoTrackRepository).update({saleOrderInfo:{saleOrderId:req.toSaleOrderId}},{pmStatus:PmStatusEnum.IN_PROGRESS})
                if(soTrackPmStatusUpdate.affected){
                  saveFlag.add(true)
                }else{
                  saveFlag.add(false)
                }    
        } 
        if(!(saveFlag.has(false))){
          await manager.completeTransaction()
          return new CommonResponse(true, 1111, 'Update sucessfully')
        } else {
            await manager.releaseTransaction()
            return new CommonResponse(false, 1141, 'Failed to update')
        }
  }

  async getEditedSoItemData(req):Promise<CommonResponse>{
    console.log(req)
    const manager = getManager();
    const soItemData = `select sinv.sale_order_id as saleOrderid,sale_order_item_id as soItemId from sale_order_items soi left join so_invoice_details sinv on soi.sale_order_id = sinv.sale_order_id where sinv.processing_unit = ${req.unitId} and soi.main_so_item_id = ${req.mainSoItemId}`
    const soItemInfo = await manager.query(soItemData)
    console.log(soItemInfo,'soItemInfolll')
    if(soItemInfo.length > 1){

    }
    if(soItemInfo.length > 0 && soItemInfo.length == 1){
      return new CommonResponse(true,7777,'data retrived',soItemInfo[0])
    }
    return
  }

  async getSaleOrderItemsForGradingAssignSo(saleOrderIdRequest: SaleOrderIdRequest): Promise<SaleOrderItemsForSoDropDownResponseModel> {
    try {
      const itemsDetails: ItemsDetails[] = [];
      const manager = getManager()
      let itemDataQuery 
      itemDataQuery= "Select si.sale_order_item_id AS saleOrderItemId,so.sale_order_id as saleOrderId,concat(mb.brand_name , '/' ,pd.name , '/' ,si.min_grade_id ,'-' , si.max_grade_id , '/' ,pm.packing_method_name) AS item, concat(pm.packing_method_name , '/' ,sku.variant_code) AS varient, sku.sku_code_id AS variantId, sid.end_customer_id AS endCustomerId, si.pack_style_id AS packStyleId from " + appSettings.sales_db + ".sale_order_items si left join " + appSettings.sales_db + ".sale_order so on so.sale_order_id = si.sale_order_id left join " + appSettings.masters_db + ".sku_codes sku on sku.sku_code_id = si.varient_id left join " + appSettings.masters_db + ".master_brands mb on mb.master_brand_id = si.master_brand_id left join " + appSettings.masters_db + ".products pd on pd.product_id = si.item_id left join " + appSettings.masters_db + ".packing_methods pm on pm.packing_method_id = si.pack_style_id  left join " + appSettings.masters_db + ".uoms u on u.uom_id = si.uom_id left join " + appSettings.sales_db + ".so_invoice_details sid on sid.sale_order_id = si.sale_order_id where si.sale_order_id = " + saleOrderIdRequest.saleOrderId;
      if (saleOrderIdRequest.plantId != undefined && saleOrderIdRequest.plantId != 0) {
        itemDataQuery = itemDataQuery + " and sid.processing_unit = " + saleOrderIdRequest.plantId;
      }
      const itemDetails = await manager.query(itemDataQuery);
     
      if (itemDetails && itemDetails.length > 0) {
        // saleOrderDropDownDto.push(SaleOrder);
        const response = new SaleOrderItemsForSoDropDownResponseModel(
          true,
          1101,
          'Sale Order Items  retrieved successfully',
          itemDetails
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      return err;
    }
  }

  


}

